/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + "031b23808b9e9968b0f9" + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	__webpack_require__(168);
	module.exports = __webpack_require__(183);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(4);
	var ReactDOMServer = __webpack_require__(148);
	var ReactIsomorphic = __webpack_require__(152);
	
	var assign = __webpack_require__(39);
	var deprecated = __webpack_require__(157);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactDOMTextComponent = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(71);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(54);
	var ReactVersion = __webpack_require__(146);
	
	var findDOMNode = __webpack_require__(91);
	var renderSubtreeIntoContainer = __webpack_require__(147);
	var warning = __webpack_require__(25);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  var ExecutionEnvironment = __webpack_require__(9);
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(7);
	var DOMPropertyOperations = __webpack_require__(22);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactMount = __webpack_require__(28);
	
	var assign = __webpack_require__(39);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var setTextContent = __webpack_require__(20);
	var validateDOMNesting = __webpack_require__(70);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(8);
	var ReactMultiChildUpdateTypes = __webpack_require__(16);
	var ReactPerf = __webpack_require__(18);
	
	var setInnerHTML = __webpack_require__(19);
	var setTextContent = __webpack_require__(20);
	var invariant = __webpack_require__(13);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(10);
	var emptyFunction = __webpack_require__(15);
	var getMarkupWrap = __webpack_require__(14);
	var invariant = __webpack_require__(13);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (({"ENV":"production"}).NODE_ENV !== 'production') {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(11);
	var getMarkupWrap = __webpack_require__(14);
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(12);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(19);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ReactPerf = __webpack_require__(18);
	
	var quoteAttributeValueForBrowser = __webpack_require__(24);
	var warning = __webpack_require__(25);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	  ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (({"ENV":"production"}).NODE_ENV !== 'production') {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName: ({"ENV":"production"}).NODE_ENV !== 'production' ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(21);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(27);
	var ReactMount = __webpack_require__(28);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(7);
	var DOMPropertyOperations = __webpack_require__(22);
	var ReactMount = __webpack_require__(28);
	var ReactPerf = __webpack_require__(18);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactDOMFeatureFlags = __webpack_require__(41);
	var ReactElement = __webpack_require__(42);
	var ReactEmptyComponentRegistry = __webpack_require__(44);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactMarkupChecksum = __webpack_require__(48);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdateQueue = __webpack_require__(53);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var containsNode = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(62);
	var invariant = __webpack_require__(13);
	var setInnerHTML = __webpack_require__(19);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var validateDOMNesting = __webpack_require__(70);
	var warning = __webpack_require__(25);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // This will throw on the next line; give an early warning
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (({"ENV":"production"}).NODE_ENV !== 'production') {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (({"ENV":"production"}).NODE_ENV !== 'production') {
	          ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	var EventPluginRegistry = __webpack_require__(32);
	var ReactEventEmitterMixin = __webpack_require__(37);
	var ReactPerf = __webpack_require__(18);
	var ViewportMetrics = __webpack_require__(38);
	
	var assign = __webpack_require__(39);
	var isEventSupported = __webpack_require__(40);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(32);
	var EventPluginUtils = __webpack_require__(33);
	var ReactErrorUtils = __webpack_require__(34);
	
	var accumulateInto = __webpack_require__(35);
	var forEachAccumulated = __webpack_require__(36);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	  ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var ReactErrorUtils = __webpack_require__(34);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(31);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	
	var assign = __webpack_require__(39);
	var canDefineProperty = __webpack_require__(43);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(46);
	
	var invariant = __webpack_require__(13);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(49);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(51);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(52);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(55);
	var PooledClass = __webpack_require__(56);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(60);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(61);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(63);
	var ReactEmptyComponent = __webpack_require__(68);
	var ReactNativeComponent = __webpack_require__(69);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactPerf = __webpack_require__(18);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdateQueue = __webpack_require__(53);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var warning = __webpack_require__(25);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	            ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactEmptyComponentRegistry = __webpack_require__(44);
	var ReactReconciler = __webpack_require__(50);
	
	var assign = __webpack_require__(39);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(25);
	
	var validateDOMNesting = emptyFunction;
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(72);
	var ChangeEventPlugin = __webpack_require__(80);
	var ClientReactRootIndex = __webpack_require__(83);
	var DefaultEventPluginOrder = __webpack_require__(84);
	var EnterLeaveEventPlugin = __webpack_require__(85);
	var ExecutionEnvironment = __webpack_require__(9);
	var HTMLDOMPropertyConfig = __webpack_require__(89);
	var ReactBrowserComponentMixin = __webpack_require__(90);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactDefaultBatchingStrategy = __webpack_require__(92);
	var ReactDOMComponent = __webpack_require__(93);
	var ReactDOMTextComponent = __webpack_require__(6);
	var ReactEventListener = __webpack_require__(118);
	var ReactInjection = __webpack_require__(121);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactReconcileTransaction = __webpack_require__(125);
	var SelectEventPlugin = __webpack_require__(130);
	var ServerReactRootIndex = __webpack_require__(131);
	var SimpleEventPlugin = __webpack_require__(132);
	var SVGDOMPropertyConfig = __webpack_require__(141);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = __webpack_require__(142);
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(74);
	var SyntheticCompositionEvent = __webpack_require__(76);
	var SyntheticInputEvent = __webpack_require__(78);
	
	var keyOf = __webpack_require__(79);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	
	var warning = __webpack_require__(25);
	
	var accumulateInto = __webpack_require__(35);
	var forEachAccumulated = __webpack_require__(36);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var getTextContentAccessor = __webpack_require__(75);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(54);
	var SyntheticEvent = __webpack_require__(77);
	
	var getEventTarget = __webpack_require__(81);
	var isEventSupported = __webpack_require__(40);
	var isTextInputElement = __webpack_require__(82);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(79);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var SyntheticMouseEvent = __webpack_require__(86);
	
	var ReactMount = __webpack_require__(28);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	var ViewportMetrics = __webpack_require__(38);
	
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	var getEventTarget = __webpack_require__(81);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(47);
	
	var findDOMNode = __webpack_require__(91);
	var warning = __webpack_require__(25);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactMount = __webpack_require__(28);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(54);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(94);
	var CSSPropertyOperations = __webpack_require__(96);
	var DOMProperty = __webpack_require__(23);
	var DOMPropertyOperations = __webpack_require__(22);
	var EventConstants = __webpack_require__(30);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactDOMButton = __webpack_require__(104);
	var ReactDOMInput = __webpack_require__(105);
	var ReactDOMOption = __webpack_require__(109);
	var ReactDOMSelect = __webpack_require__(112);
	var ReactDOMTextarea = __webpack_require__(113);
	var ReactMount = __webpack_require__(28);
	var ReactMultiChild = __webpack_require__(114);
	var ReactPerf = __webpack_require__(18);
	var ReactUpdateQueue = __webpack_require__(53);
	
	var assign = __webpack_require__(39);
	var canDefineProperty = __webpack_require__(43);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var invariant = __webpack_require__(13);
	var isEventSupported = __webpack_require__(40);
	var keyOf = __webpack_require__(79);
	var setInnerHTML = __webpack_require__(19);
	var setTextContent = __webpack_require__(20);
	var shallowEqual = __webpack_require__(117);
	var validateDOMNesting = __webpack_require__(70);
	var warning = __webpack_require__(25);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    var component = this._reactInternalComponent;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    var component = this._reactInternalComponent;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	  ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    if (voidElementTags[component._tag]) {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (({"ENV":"production"}).NODE_ENV !== 'production') {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (({"ENV":"production"}).NODE_ENV !== 'production') {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(28);
	
	var findDOMNode = __webpack_require__(91);
	var focusNode = __webpack_require__(95);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactPerf = __webpack_require__(18);
	
	var camelizeStyleName = __webpack_require__(98);
	var dangerousStyleValue = __webpack_require__(100);
	var hyphenateStyleName = __webpack_require__(101);
	var memoizeStringOnly = __webpack_require__(103);
	var warning = __webpack_require__(25);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(99);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(97);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(102);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(27);
	var LinkedValueUtils = __webpack_require__(106);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(107);
	var ReactPropTypeLocations = __webpack_require__(65);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	
	var emptyFunction = __webpack_require__(15);
	var getIteratorFn = __webpack_require__(108);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactDOMSelect = __webpack_require__(112);
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	var ReactElement = __webpack_require__(42);
	
	var emptyFunction = __webpack_require__(15);
	var traverseAllChildren = __webpack_require__(111);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceHandles = __webpack_require__(45);
	
	var getIteratorFn = __webpack_require__(108);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (({"ENV":"production"}).NODE_ENV !== 'production') {
	          ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(106);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(106);
	var ReactDOMIDOperations = __webpack_require__(27);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactMultiChildUpdateTypes = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactReconciler = __webpack_require__(50);
	var ReactChildReconciler = __webpack_require__(115);
	
	var flattenChildren = __webpack_require__(116);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(50);
	
	var instantiateReactComponent = __webpack_require__(62);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var traverseAllChildren = __webpack_require__(111);
	var warning = __webpack_require__(25);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(111);
	var warning = __webpack_require__(25);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(56);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var getEventTarget = __webpack_require__(81);
	var getUnboundedScrollPosition = __webpack_require__(120);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var EventPluginHub = __webpack_require__(31);
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactClass = __webpack_require__(122);
	var ReactEmptyComponent = __webpack_require__(68);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactNativeComponent = __webpack_require__(69);
	var ReactPerf = __webpack_require__(18);
	var ReactRootIndex = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(54);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(123);
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactNoopUpdateQueue = __webpack_require__(124);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var keyMirror = __webpack_require__(17);
	var keyOf = __webpack_require__(79);
	var warning = __webpack_require__(25);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (({"ENV":"production"}).NODE_ENV !== 'production') {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (({"ENV":"production"}).NODE_ENV !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(124);
	
	var canDefineProperty = __webpack_require__(43);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(25);
	
	function warnTDZ(publicInstance, callerName) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(55);
	var PooledClass = __webpack_require__(56);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactDOMFeatureFlags = __webpack_require__(41);
	var ReactInputSelection = __webpack_require__(126);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(127);
	
	var containsNode = __webpack_require__(59);
	var focusNode = __webpack_require__(95);
	var getActiveElement = __webpack_require__(129);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(128);
	var getTextContentAccessor = __webpack_require__(75);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInputSelection = __webpack_require__(126);
	var SyntheticEvent = __webpack_require__(77);
	
	var getActiveElement = __webpack_require__(129);
	var isTextInputElement = __webpack_require__(82);
	var keyOf = __webpack_require__(79);
	var shallowEqual = __webpack_require__(117);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventListener = __webpack_require__(119);
	var EventPropagators = __webpack_require__(73);
	var ReactMount = __webpack_require__(28);
	var SyntheticClipboardEvent = __webpack_require__(133);
	var SyntheticEvent = __webpack_require__(77);
	var SyntheticFocusEvent = __webpack_require__(134);
	var SyntheticKeyboardEvent = __webpack_require__(135);
	var SyntheticMouseEvent = __webpack_require__(86);
	var SyntheticDragEvent = __webpack_require__(138);
	var SyntheticTouchEvent = __webpack_require__(139);
	var SyntheticUIEvent = __webpack_require__(87);
	var SyntheticWheelEvent = __webpack_require__(140);
	
	var emptyFunction = __webpack_require__(15);
	var getEventCharCode = __webpack_require__(136);
	var invariant = __webpack_require__(13);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	var getEventCharCode = __webpack_require__(136);
	var getEventKey = __webpack_require__(137);
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(136);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(86);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(86);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ReactDefaultPerfAnalysis = __webpack_require__(143);
	var ReactMount = __webpack_require__(28);
	var ReactPerf = __webpack_require__(18);
	
	var performanceNow = __webpack_require__(144);
	
	function roundFloat(val) {
	  return Math.floor(val * 100) / 100;
	}
	
	function addValue(obj, key, val) {
	  obj[key] = (obj[key] || 0) + val;
	}
	
	var ReactDefaultPerf = {
	  _allMeasurements: [], // last item in the list is the current one
	  _mountStack: [0],
	  _injected: false,
	
	  start: function () {
	    if (!ReactDefaultPerf._injected) {
	      ReactPerf.injection.injectMeasure(ReactDefaultPerf.measure);
	    }
	
	    ReactDefaultPerf._allMeasurements.length = 0;
	    ReactPerf.enableMeasure = true;
	  },
	
	  stop: function () {
	    ReactPerf.enableMeasure = false;
	  },
	
	  getLastMeasurements: function () {
	    return ReactDefaultPerf._allMeasurements;
	  },
	
	  printExclusive: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getExclusiveSummary(measurements);
	    console.table(summary.map(function (item) {
	      return {
	        'Component class name': item.componentName,
	        'Total inclusive time (ms)': roundFloat(item.inclusive),
	        'Exclusive mount time (ms)': roundFloat(item.exclusive),
	        'Exclusive render time (ms)': roundFloat(item.render),
	        'Mount time per instance (ms)': roundFloat(item.exclusive / item.count),
	        'Render time per instance (ms)': roundFloat(item.render / item.count),
	        'Instances': item.count
	      };
	    }));
	    // TODO: ReactDefaultPerfAnalysis.getTotalTime() does not return the correct
	    // number.
	  },
	
	  printInclusive: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements);
	    console.table(summary.map(function (item) {
	      return {
	        'Owner > component': item.componentName,
	        'Inclusive time (ms)': roundFloat(item.time),
	        'Instances': item.count
	      };
	    }));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  getMeasurementsSummaryMap: function (measurements) {
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements, true);
	    return summary.map(function (item) {
	      return {
	        'Owner > component': item.componentName,
	        'Wasted time (ms)': item.time,
	        'Instances': item.count
	      };
	    });
	  },
	
	  printWasted: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    console.table(ReactDefaultPerf.getMeasurementsSummaryMap(measurements));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  printDOM: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getDOMSummary(measurements);
	    console.table(summary.map(function (item) {
	      var result = {};
	      result[DOMProperty.ID_ATTRIBUTE_NAME] = item.id;
	      result.type = item.type;
	      result.args = JSON.stringify(item.args);
	      return result;
	    }));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  _recordWrite: function (id, fnName, totalTime, args) {
	    // TODO: totalTime isn't that useful since it doesn't count paints/reflows
	    var writes = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].writes;
	    writes[id] = writes[id] || [];
	    writes[id].push({
	      type: fnName,
	      time: totalTime,
	      args: args
	    });
	  },
	
	  measure: function (moduleName, fnName, func) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var totalTime;
	      var rv;
	      var start;
	
	      if (fnName === '_renderNewRootComponent' || fnName === 'flushBatchedUpdates') {
	        // A "measurement" is a set of metrics recorded for each flush. We want
	        // to group the metrics for a given flush together so we can look at the
	        // components that rendered and the DOM operations that actually
	        // happened to determine the amount of "wasted work" performed.
	        ReactDefaultPerf._allMeasurements.push({
	          exclusive: {},
	          inclusive: {},
	          render: {},
	          counts: {},
	          writes: {},
	          displayNames: {},
	          totalTime: 0,
	          created: {}
	        });
	        start = performanceNow();
	        rv = func.apply(this, args);
	        ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].totalTime = performanceNow() - start;
	        return rv;
	      } else if (fnName === '_mountImageIntoNode' || moduleName === 'ReactBrowserEventEmitter' || moduleName === 'ReactDOMIDOperations' || moduleName === 'CSSPropertyOperations' || moduleName === 'DOMChildrenOperations' || moduleName === 'DOMPropertyOperations') {
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (fnName === '_mountImageIntoNode') {
	          var mountID = ReactMount.getID(args[1]);
	          ReactDefaultPerf._recordWrite(mountID, fnName, totalTime, args[0]);
	        } else if (fnName === 'dangerouslyProcessChildrenUpdates') {
	          // special format
	          args[0].forEach(function (update) {
	            var writeArgs = {};
	            if (update.fromIndex !== null) {
	              writeArgs.fromIndex = update.fromIndex;
	            }
	            if (update.toIndex !== null) {
	              writeArgs.toIndex = update.toIndex;
	            }
	            if (update.textContent !== null) {
	              writeArgs.textContent = update.textContent;
	            }
	            if (update.markupIndex !== null) {
	              writeArgs.markup = args[1][update.markupIndex];
	            }
	            ReactDefaultPerf._recordWrite(update.parentID, update.type, totalTime, writeArgs);
	          });
	        } else {
	          // basic format
	          var id = args[0];
	          if (typeof id === 'object') {
	            id = ReactMount.getID(args[0]);
	          }
	          ReactDefaultPerf._recordWrite(id, fnName, totalTime, Array.prototype.slice.call(args, 1));
	        }
	        return rv;
	      } else if (moduleName === 'ReactCompositeComponent' && (fnName === 'mountComponent' || fnName === 'updateComponent' || // TODO: receiveComponent()?
	      fnName === '_renderValidatedComponent')) {
	
	        if (this._currentElement.type === ReactMount.TopLevelWrapper) {
	          return func.apply(this, args);
	        }
	
	        var rootNodeID = fnName === 'mountComponent' ? args[0] : this._rootNodeID;
	        var isRender = fnName === '_renderValidatedComponent';
	        var isMount = fnName === 'mountComponent';
	
	        var mountStack = ReactDefaultPerf._mountStack;
	        var entry = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1];
	
	        if (isRender) {
	          addValue(entry.counts, rootNodeID, 1);
	        } else if (isMount) {
	          entry.created[rootNodeID] = true;
	          mountStack.push(0);
	        }
	
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (isRender) {
	          addValue(entry.render, rootNodeID, totalTime);
	        } else if (isMount) {
	          var subMountTime = mountStack.pop();
	          mountStack[mountStack.length - 1] += totalTime;
	          addValue(entry.exclusive, rootNodeID, totalTime - subMountTime);
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        } else {
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        }
	
	        entry.displayNames[rootNodeID] = {
	          current: this.getName(),
	          owner: this._currentElement._owner ? this._currentElement._owner.getName() : '<root>'
	        };
	
	        return rv;
	      } else {
	        return func.apply(this, args);
	      }
	    };
	  }
	};
	
	module.exports = ReactDefaultPerf;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerfAnalysis
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	
	// Don't try to save users less than 1.2ms (a number I made up)
	var DONT_CARE_THRESHOLD = 1.2;
	var DOM_OPERATION_TYPES = {
	  '_mountImageIntoNode': 'set innerHTML',
	  INSERT_MARKUP: 'set innerHTML',
	  MOVE_EXISTING: 'move',
	  REMOVE_NODE: 'remove',
	  SET_MARKUP: 'set innerHTML',
	  TEXT_CONTENT: 'set textContent',
	  'setValueForProperty': 'update attribute',
	  'setValueForAttribute': 'update attribute',
	  'deleteValueForProperty': 'remove attribute',
	  'setValueForStyles': 'update styles',
	  'replaceNodeWithMarkup': 'replace',
	  'updateTextContent': 'set textContent'
	};
	
	function getTotalTime(measurements) {
	  // TODO: return number of DOM ops? could be misleading.
	  // TODO: measure dropped frames after reconcile?
	  // TODO: log total time of each reconcile and the top-level component
	  // class that triggered it.
	  var totalTime = 0;
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    totalTime += measurement.totalTime;
	  }
	  return totalTime;
	}
	
	function getDOMSummary(measurements) {
	  var items = [];
	  measurements.forEach(function (measurement) {
	    Object.keys(measurement.writes).forEach(function (id) {
	      measurement.writes[id].forEach(function (write) {
	        items.push({
	          id: id,
	          type: DOM_OPERATION_TYPES[write.type] || write.type,
	          args: write.args
	        });
	      });
	    });
	  });
	  return items;
	}
	
	function getExclusiveSummary(measurements) {
	  var candidates = {};
	  var displayName;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	
	    for (var id in allIDs) {
	      displayName = measurement.displayNames[id].current;
	
	      candidates[displayName] = candidates[displayName] || {
	        componentName: displayName,
	        inclusive: 0,
	        exclusive: 0,
	        render: 0,
	        count: 0
	      };
	      if (measurement.render[id]) {
	        candidates[displayName].render += measurement.render[id];
	      }
	      if (measurement.exclusive[id]) {
	        candidates[displayName].exclusive += measurement.exclusive[id];
	      }
	      if (measurement.inclusive[id]) {
	        candidates[displayName].inclusive += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[displayName].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (displayName in candidates) {
	    if (candidates[displayName].exclusive >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[displayName]);
	    }
	  }
	
	  arr.sort(function (a, b) {
	    return b.exclusive - a.exclusive;
	  });
	
	  return arr;
	}
	
	function getInclusiveSummary(measurements, onlyClean) {
	  var candidates = {};
	  var inclusiveKey;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	    var cleanComponents;
	
	    if (onlyClean) {
	      cleanComponents = getUnchangedComponents(measurement);
	    }
	
	    for (var id in allIDs) {
	      if (onlyClean && !cleanComponents[id]) {
	        continue;
	      }
	
	      var displayName = measurement.displayNames[id];
	
	      // Inclusive time is not useful for many components without knowing where
	      // they are instantiated. So we aggregate inclusive time with both the
	      // owner and current displayName as the key.
	      inclusiveKey = displayName.owner + ' > ' + displayName.current;
	
	      candidates[inclusiveKey] = candidates[inclusiveKey] || {
	        componentName: inclusiveKey,
	        time: 0,
	        count: 0
	      };
	
	      if (measurement.inclusive[id]) {
	        candidates[inclusiveKey].time += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[inclusiveKey].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (inclusiveKey in candidates) {
	    if (candidates[inclusiveKey].time >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[inclusiveKey]);
	    }
	  }
	
	  arr.sort(function (a, b) {
	    return b.time - a.time;
	  });
	
	  return arr;
	}
	
	function getUnchangedComponents(measurement) {
	  // For a given reconcile, look at which components did not actually
	  // render anything to the DOM and return a mapping of their ID to
	  // the amount of time it took to render the entire subtree.
	  var cleanComponents = {};
	  var dirtyLeafIDs = Object.keys(measurement.writes);
	  var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	
	  for (var id in allIDs) {
	    var isDirty = false;
	    // For each component that rendered, see if a component that triggered
	    // a DOM op is in its subtree.
	    for (var i = 0; i < dirtyLeafIDs.length; i++) {
	      if (dirtyLeafIDs[i].indexOf(id) === 0) {
	        isDirty = true;
	        break;
	      }
	    }
	    // check if component newly created
	    if (measurement.created[id]) {
	      isDirty = true;
	    }
	    if (!isDirty && measurement.counts[id] > 0) {
	      cleanComponents[id] = true;
	    }
	  }
	  return cleanComponents;
	}
	
	var ReactDefaultPerfAnalysis = {
	  getExclusiveSummary: getExclusiveSummary,
	  getInclusiveSummary: getInclusiveSummary,
	  getDOMSummary: getDOMSummary,
	  getTotalTime: getTotalTime
	};
	
	module.exports = ReactDefaultPerfAnalysis;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */
	
	'use strict';
	
	var performance = __webpack_require__(145);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function () {
	    return performance.now();
	  };
	} else {
	  performanceNow = function () {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.8';

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(28);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(71);
	var ReactServerRendering = __webpack_require__(149);
	var ReactVersion = __webpack_require__(146);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(92);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMarkupChecksum = __webpack_require__(48);
	var ReactServerBatchingStrategy = __webpack_require__(150);
	var ReactServerRenderingTransaction = __webpack_require__(151);
	var ReactUpdates = __webpack_require__(54);
	
	var emptyObject = __webpack_require__(58);
	var instantiateReactComponent = __webpack_require__(62);
	var invariant = __webpack_require__(13);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 150 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	var CallbackQueue = __webpack_require__(55);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactComponent = __webpack_require__(123);
	var ReactClass = __webpack_require__(122);
	var ReactDOMFactories = __webpack_require__(153);
	var ReactElement = __webpack_require__(42);
	var ReactElementValidator = __webpack_require__(154);
	var ReactPropTypes = __webpack_require__(107);
	var ReactVersion = __webpack_require__(146);
	
	var assign = __webpack_require__(39);
	var onlyChild = __webpack_require__(156);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (({"ENV":"production"}).NODE_ENV !== 'production') {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactElementValidator = __webpack_require__(154);
	
	var mapObject = __webpack_require__(155);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactCurrentOwner = __webpack_require__(5);
	
	var canDefineProperty = __webpack_require__(43);
	var getIteratorFn = __webpack_require__(108);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	  ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	        ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (({"ENV":"production"}).NODE_ENV !== 'production') {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ? ({"ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (({"ENV":"production"}).NODE_ENV !== 'production') {
	    var newFn = function () {
	      ({"ENV":"production"}).NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 *
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 * * Neither the name of Poly2Tri nor the names of its contributors may be
	 *   used to endorse or promote products derived from this software without specific
	 *   prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	 * PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	"use strict";
	
	/**
	 * Public API for poly2tri.js
	 * @module poly2tri
	 */
	
	
	/**
	 * If you are not using a module system (e.g. CommonJS, RequireJS), you can access this library
	 * as a global variable <code>poly2tri</code> i.e. <code>window.poly2tri</code> in a browser.
	 * @name poly2tri
	 * @global
	 * @public
	 * @type {module:poly2tri}
	 */
	var previousPoly2tri = global.poly2tri;
	/**
	 * For Browser + &lt;script&gt; :
	 * reverts the {@linkcode poly2tri} global object to its previous value,
	 * and returns a reference to the instance called.
	 *
	 * @example
	 *              var p = poly2tri.noConflict();
	 * @public
	 * @return {module:poly2tri} instance called
	 */
	// (this feature is not automatically provided by browserify).
	exports.noConflict = function() {
	    global.poly2tri = previousPoly2tri;
	    return exports;
	};
	
	/**
	 * poly2tri library version
	 * @public
	 * @const {string}
	 */
	exports.VERSION = __webpack_require__(169).version;
	
	/**
	 * Exports the {@linkcode PointError} class.
	 * @public
	 * @typedef {PointError} module:poly2tri.PointError
	 * @function
	 */
	exports.PointError = __webpack_require__(170);
	/**
	 * Exports the {@linkcode Point} class.
	 * @public
	 * @typedef {Point} module:poly2tri.Point
	 * @function
	 */
	exports.Point = __webpack_require__(172);
	/**
	 * Exports the {@linkcode Triangle} class.
	 * @public
	 * @typedef {Triangle} module:poly2tri.Triangle
	 * @function
	 */
	exports.Triangle = __webpack_require__(173);
	/**
	 * Exports the {@linkcode SweepContext} class.
	 * @public
	 * @typedef {SweepContext} module:poly2tri.SweepContext
	 * @function
	 */
	exports.SweepContext = __webpack_require__(174);
	
	
	// Backward compatibility
	var sweep = __webpack_require__(175);
	/**
	 * @function
	 * @deprecated use {@linkcode SweepContext#triangulate} instead
	 */
	exports.triangulate = sweep.triangulate;
	/**
	 * @deprecated use {@linkcode SweepContext#triangulate} instead
	 * @property {function} Triangulate - use {@linkcode SweepContext#triangulate} instead
	 */
	exports.sweep = {Triangulate: sweep.triangulate};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 169 */
/***/ function(module, exports) {

	module.exports = {
		"version": "1.3.5"
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	"use strict";
	
	/*
	 * Class added in the JavaScript version (was not present in the c++ version)
	 */
	
	var xy = __webpack_require__(171);
	
	/**
	 * Custom exception class to indicate invalid Point values
	 * @constructor
	 * @public
	 * @extends Error
	 * @struct
	 * @param {string=} message - error message
	 * @param {Array.<XY>=} points - invalid points
	 */
	var PointError = function(message, points) {
	    this.name = "PointError";
	    /**
	     * Invalid points
	     * @public
	     * @type {Array.<XY>}
	     */
	    this.points = points = points || [];
	    /**
	     * Error message
	     * @public
	     * @type {string}
	     */
	    this.message = message || "Invalid Points!";
	    for (var i = 0; i < points.length; i++) {
	        this.message += " " + xy.toString(points[i]);
	    }
	};
	PointError.prototype = new Error();
	PointError.prototype.constructor = PointError;
	
	
	module.exports = PointError;


/***/ },
/* 171 */
/***/ function(module, exports) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	"use strict";
	
	/**
	 * The following functions operate on "Point" or any "Point like" object with {x,y},
	 * as defined by the {@link XY} type
	 * ([duck typing]{@link http://en.wikipedia.org/wiki/Duck_typing}).
	 * @module
	 * @private
	 */
	
	/**
	 * poly2tri.js supports using custom point class instead of {@linkcode Point}.
	 * Any "Point like" object with <code>{x, y}</code> attributes is supported
	 * to initialize the SweepContext polylines and points
	 * ([duck typing]{@link http://en.wikipedia.org/wiki/Duck_typing}).
	 *
	 * poly2tri.js might add extra fields to the point objects when computing the
	 * triangulation : they are prefixed with <code>_p2t_</code> to avoid collisions
	 * with fields in the custom class.
	 *
	 * @example
	 *      var contour = [{x:100, y:100}, {x:100, y:300}, {x:300, y:300}, {x:300, y:100}];
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *
	 * @typedef {Object} XY
	 * @property {number} x - x coordinate
	 * @property {number} y - y coordinate
	 */
	
	
	/**
	 * Point pretty printing : prints x and y coordinates.
	 * @example
	 *      xy.toStringBase({x:5, y:42})
	 *      // → "(5;42)"
	 * @protected
	 * @param {!XY} p - point object with {x,y}
	 * @returns {string} <code>"(x;y)"</code>
	 */
	function toStringBase(p) {
	    return ("(" + p.x + ";" + p.y + ")");
	}
	
	/**
	 * Point pretty printing. Delegates to the point's custom "toString()" method if exists,
	 * else simply prints x and y coordinates.
	 * @example
	 *      xy.toString({x:5, y:42})
	 *      // → "(5;42)"
	 * @example
	 *      xy.toString({x:5,y:42,toString:function() {return this.x+":"+this.y;}})
	 *      // → "5:42"
	 * @param {!XY} p - point object with {x,y}
	 * @returns {string} <code>"(x;y)"</code>
	 */
	function toString(p) {
	    // Try a custom toString first, and fallback to own implementation if none
	    var s = p.toString();
	    return (s === '[object Object]' ? toStringBase(p) : s);
	}
	
	
	/**
	 * Compare two points component-wise. Ordered by y axis first, then x axis.
	 * @param {!XY} a - point object with {x,y}
	 * @param {!XY} b - point object with {x,y}
	 * @return {number} <code>&lt; 0</code> if <code>a &lt; b</code>,
	 *         <code>&gt; 0</code> if <code>a &gt; b</code>, 
	 *         <code>0</code> otherwise.
	 */
	function compare(a, b) {
	    if (a.y === b.y) {
	        return a.x - b.x;
	    } else {
	        return a.y - b.y;
	    }
	}
	
	/**
	 * Test two Point objects for equality.
	 * @param {!XY} a - point object with {x,y}
	 * @param {!XY} b - point object with {x,y}
	 * @return {boolean} <code>True</code> if <code>a == b</code>, <code>false</code> otherwise.
	 */
	function equals(a, b) {
	    return a.x === b.x && a.y === b.y;
	}
	
	
	module.exports = {
	    toString: toString,
	    toStringBase: toStringBase,
	    compare: compare,
	    equals: equals
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	"use strict";
	
	
	/*
	 * Note
	 * ====
	 * the structure of this JavaScript version of poly2tri intentionally follows
	 * as closely as possible the structure of the reference C++ version, to make it 
	 * easier to keep the 2 versions in sync.
	 */
	
	var xy = __webpack_require__(171);
	
	// ------------------------------------------------------------------------Point
	/**
	 * Construct a point
	 * @example
	 *      var point = new poly2tri.Point(150, 150);
	 * @public
	 * @constructor
	 * @struct
	 * @param {number=} x    coordinate (0 if undefined)
	 * @param {number=} y    coordinate (0 if undefined)
	 */
	var Point = function(x, y) {
	    /**
	     * @type {number}
	     * @expose
	     */
	    this.x = +x || 0;
	    /**
	     * @type {number}
	     * @expose
	     */
	    this.y = +y || 0;
	
	    // All extra fields added to Point are prefixed with _p2t_
	    // to avoid collisions if custom Point class is used.
	
	    /**
	     * The edges this point constitutes an upper ending point
	     * @private
	     * @type {Array.<Edge>}
	     */
	    this._p2t_edge_list = null;
	};
	
	/**
	 * For pretty printing
	 * @example
	 *      "p=" + new poly2tri.Point(5,42)
	 *      // → "p=(5;42)"
	 * @returns {string} <code>"(x;y)"</code>
	 */
	Point.prototype.toString = function() {
	    return xy.toStringBase(this);
	};
	
	/**
	 * JSON output, only coordinates
	 * @example
	 *      JSON.stringify(new poly2tri.Point(1,2))
	 *      // → '{"x":1,"y":2}'
	 */
	Point.prototype.toJSON = function() {
	    return { x: this.x, y: this.y };
	};
	
	/**
	 * Creates a copy of this Point object.
	 * @return {Point} new cloned point
	 */
	Point.prototype.clone = function() {
	    return new Point(this.x, this.y);
	};
	
	/**
	 * Set this Point instance to the origo. <code>(0; 0)</code>
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.set_zero = function() {
	    this.x = 0.0;
	    this.y = 0.0;
	    return this; // for chaining
	};
	
	/**
	 * Set the coordinates of this instance.
	 * @param {number} x   coordinate
	 * @param {number} y   coordinate
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.set = function(x, y) {
	    this.x = +x || 0;
	    this.y = +y || 0;
	    return this; // for chaining
	};
	
	/**
	 * Negate this Point instance. (component-wise)
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.negate = function() {
	    this.x = -this.x;
	    this.y = -this.y;
	    return this; // for chaining
	};
	
	/**
	 * Add another Point object to this instance. (component-wise)
	 * @param {!Point} n - Point object.
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.add = function(n) {
	    this.x += n.x;
	    this.y += n.y;
	    return this; // for chaining
	};
	
	/**
	 * Subtract this Point instance with another point given. (component-wise)
	 * @param {!Point} n - Point object.
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.sub = function(n) {
	    this.x -= n.x;
	    this.y -= n.y;
	    return this; // for chaining
	};
	
	/**
	 * Multiply this Point instance by a scalar. (component-wise)
	 * @param {number} s   scalar.
	 * @return {Point} this (for chaining)
	 */
	Point.prototype.mul = function(s) {
	    this.x *= s;
	    this.y *= s;
	    return this; // for chaining
	};
	
	/**
	 * Return the distance of this Point instance from the origo.
	 * @return {number} distance
	 */
	Point.prototype.length = function() {
	    return Math.sqrt(this.x * this.x + this.y * this.y);
	};
	
	/**
	 * Normalize this Point instance (as a vector).
	 * @return {number} The original distance of this instance from the origo.
	 */
	Point.prototype.normalize = function() {
	    var len = this.length();
	    this.x /= len;
	    this.y /= len;
	    return len;
	};
	
	/**
	 * Test this Point object with another for equality.
	 * @param {!XY} p - any "Point like" object with {x,y}
	 * @return {boolean} <code>true</code> if same x and y coordinates, <code>false</code> otherwise.
	 */
	Point.prototype.equals = function(p) {
	    return this.x === p.x && this.y === p.y;
	};
	
	
	// -----------------------------------------------------Point ("static" methods)
	
	/**
	 * Negate a point component-wise and return the result as a new Point object.
	 * @param {!XY} p - any "Point like" object with {x,y}
	 * @return {Point} the resulting Point object.
	 */
	Point.negate = function(p) {
	    return new Point(-p.x, -p.y);
	};
	
	/**
	 * Add two points component-wise and return the result as a new Point object.
	 * @param {!XY} a - any "Point like" object with {x,y}
	 * @param {!XY} b - any "Point like" object with {x,y}
	 * @return {Point} the resulting Point object.
	 */
	Point.add = function(a, b) {
	    return new Point(a.x + b.x, a.y + b.y);
	};
	
	/**
	 * Subtract two points component-wise and return the result as a new Point object.
	 * @param {!XY} a - any "Point like" object with {x,y}
	 * @param {!XY} b - any "Point like" object with {x,y}
	 * @return {Point} the resulting Point object.
	 */
	Point.sub = function(a, b) {
	    return new Point(a.x - b.x, a.y - b.y);
	};
	
	/**
	 * Multiply a point by a scalar and return the result as a new Point object.
	 * @param {number} s - the scalar
	 * @param {!XY} p - any "Point like" object with {x,y}
	 * @return {Point} the resulting Point object.
	 */
	Point.mul = function(s, p) {
	    return new Point(s * p.x, s * p.y);
	};
	
	/**
	 * Perform the cross product on either two points (this produces a scalar)
	 * or a point and a scalar (this produces a point).
	 * This function requires two parameters, either may be a Point object or a
	 * number.
	 * @param  {XY|number} a - Point object or scalar.
	 * @param  {XY|number} b - Point object or scalar.
	 * @return {Point|number} a Point object or a number, depending on the parameters.
	 */
	Point.cross = function(a, b) {
	    if (typeof(a) === 'number') {
	        if (typeof(b) === 'number') {
	            return a * b;
	        } else {
	            return new Point(-a * b.y, a * b.x);
	        }
	    } else {
	        if (typeof(b) === 'number') {
	            return new Point(b * a.y, -b * a.x);
	        } else {
	            return a.x * b.y - a.y * b.x;
	        }
	    }
	};
	
	
	// -----------------------------------------------------------------"Point-Like"
	/*
	 * The following functions operate on "Point" or any "Point like" object 
	 * with {x,y} (duck typing).
	 */
	
	Point.toString = xy.toString;
	Point.compare = xy.compare;
	Point.cmp = xy.compare; // backward compatibility
	Point.equals = xy.equals;
	
	/**
	 * Peform the dot product on two vectors.
	 * @public
	 * @param {!XY} a - any "Point like" object with {x,y}
	 * @param {!XY} b - any "Point like" object with {x,y}
	 * @return {number} The dot product
	 */
	Point.dot = function(a, b) {
	    return a.x * b.x + a.y * b.y;
	};
	
	
	// ---------------------------------------------------------Exports (public API)
	
	module.exports = Point;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 *
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	/* jshint maxcomplexity:10 */
	
	"use strict";
	
	
	/*
	 * Note
	 * ====
	 * the structure of this JavaScript version of poly2tri intentionally follows
	 * as closely as possible the structure of the reference C++ version, to make it 
	 * easier to keep the 2 versions in sync.
	 */
	
	var xy = __webpack_require__(171);
	
	
	// ---------------------------------------------------------------------Triangle
	/**
	 * Triangle class.<br>
	 * Triangle-based data structures are known to have better performance than
	 * quad-edge structures.
	 * See: J. Shewchuk, "Triangle: Engineering a 2D Quality Mesh Generator and
	 * Delaunay Triangulator", "Triangulations in CGAL"
	 *
	 * @constructor
	 * @struct
	 * @param {!XY} pa  point object with {x,y}
	 * @param {!XY} pb  point object with {x,y}
	 * @param {!XY} pc  point object with {x,y}
	 */
	var Triangle = function(a, b, c) {
	    /**
	     * Triangle points
	     * @private
	     * @type {Array.<XY>}
	     */
	    this.points_ = [a, b, c];
	
	    /**
	     * Neighbor list
	     * @private
	     * @type {Array.<Triangle>}
	     */
	    this.neighbors_ = [null, null, null];
	
	    /**
	     * Has this triangle been marked as an interior triangle?
	     * @private
	     * @type {boolean}
	     */
	    this.interior_ = false;
	
	    /**
	     * Flags to determine if an edge is a Constrained edge
	     * @private
	     * @type {Array.<boolean>}
	     */
	    this.constrained_edge = [false, false, false];
	
	    /**
	     * Flags to determine if an edge is a Delauney edge
	     * @private
	     * @type {Array.<boolean>}
	     */
	    this.delaunay_edge = [false, false, false];
	};
	
	var p2s = xy.toString;
	/**
	 * For pretty printing ex. <code>"[(5;42)(10;20)(21;30)]"</code>.
	 * @public
	 * @return {string}
	 */
	Triangle.prototype.toString = function() {
	    return ("[" + p2s(this.points_[0]) + p2s(this.points_[1]) + p2s(this.points_[2]) + "]");
	};
	
	/**
	 * Get one vertice of the triangle.
	 * The output triangles of a triangulation have vertices which are references
	 * to the initial input points (not copies): any custom fields in the
	 * initial points can be retrieved in the output triangles.
	 * @example
	 *      var contour = [{x:100, y:100, id:1}, {x:100, y:300, id:2}, {x:300, y:300, id:3}];
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.triangulate();
	 *      var triangles = swctx.getTriangles();
	 *      typeof triangles[0].getPoint(0).id
	 *      // → "number"
	 * @param {number} index - vertice index: 0, 1 or 2
	 * @public
	 * @returns {XY}
	 */
	Triangle.prototype.getPoint = function(index) {
	    return this.points_[index];
	};
	
	/**
	 * For backward compatibility
	 * @function
	 * @deprecated use {@linkcode Triangle#getPoint} instead
	 */
	Triangle.prototype.GetPoint = Triangle.prototype.getPoint;
	
	/**
	 * Get all 3 vertices of the triangle as an array
	 * @public
	 * @return {Array.<XY>}
	 */
	// Method added in the JavaScript version (was not present in the c++ version)
	Triangle.prototype.getPoints = function() {
	    return this.points_;
	};
	
	/**
	 * @private
	 * @param {number} index
	 * @returns {?Triangle}
	 */
	Triangle.prototype.getNeighbor = function(index) {
	    return this.neighbors_[index];
	};
	
	/**
	 * Test if this Triangle contains the Point object given as parameter as one of its vertices.
	 * Only point references are compared, not values.
	 * @public
	 * @param {XY} point - point object with {x,y}
	 * @return {boolean} <code>True</code> if the Point object is of the Triangle's vertices,
	 *         <code>false</code> otherwise.
	 */
	Triangle.prototype.containsPoint = function(point) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    return (point === points[0] || point === points[1] || point === points[2]);
	};
	
	/**
	 * Test if this Triangle contains the Edge object given as parameter as its
	 * bounding edges. Only point references are compared, not values.
	 * @private
	 * @param {Edge} edge
	 * @return {boolean} <code>True</code> if the Edge object is of the Triangle's bounding
	 *         edges, <code>false</code> otherwise.
	 */
	Triangle.prototype.containsEdge = function(edge) {
	    return this.containsPoint(edge.p) && this.containsPoint(edge.q);
	};
	
	/**
	 * Test if this Triangle contains the two Point objects given as parameters among its vertices.
	 * Only point references are compared, not values.
	 * @param {XY} p1 - point object with {x,y}
	 * @param {XY} p2 - point object with {x,y}
	 * @return {boolean}
	 */
	Triangle.prototype.containsPoints = function(p1, p2) {
	    return this.containsPoint(p1) && this.containsPoint(p2);
	};
	
	/**
	 * Has this triangle been marked as an interior triangle?
	 * @returns {boolean}
	 */
	Triangle.prototype.isInterior = function() {
	    return this.interior_;
	};
	
	/**
	 * Mark this triangle as an interior triangle
	 * @private
	 * @param {boolean} interior
	 * @returns {Triangle} this
	 */
	Triangle.prototype.setInterior = function(interior) {
	    this.interior_ = interior;
	    return this;
	};
	
	/**
	 * Update neighbor pointers.
	 * @private
	 * @param {XY} p1 - point object with {x,y}
	 * @param {XY} p2 - point object with {x,y}
	 * @param {Triangle} t Triangle object.
	 * @throws {Error} if can't find objects
	 */
	Triangle.prototype.markNeighborPointers = function(p1, p2, t) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if ((p1 === points[2] && p2 === points[1]) || (p1 === points[1] && p2 === points[2])) {
	        this.neighbors_[0] = t;
	    } else if ((p1 === points[0] && p2 === points[2]) || (p1 === points[2] && p2 === points[0])) {
	        this.neighbors_[1] = t;
	    } else if ((p1 === points[0] && p2 === points[1]) || (p1 === points[1] && p2 === points[0])) {
	        this.neighbors_[2] = t;
	    } else {
	        throw new Error('poly2tri Invalid Triangle.markNeighborPointers() call');
	    }
	};
	
	/**
	 * Exhaustive search to update neighbor pointers
	 * @private
	 * @param {!Triangle} t
	 */
	Triangle.prototype.markNeighbor = function(t) {
	    var points = this.points_;
	    if (t.containsPoints(points[1], points[2])) {
	        this.neighbors_[0] = t;
	        t.markNeighborPointers(points[1], points[2], this);
	    } else if (t.containsPoints(points[0], points[2])) {
	        this.neighbors_[1] = t;
	        t.markNeighborPointers(points[0], points[2], this);
	    } else if (t.containsPoints(points[0], points[1])) {
	        this.neighbors_[2] = t;
	        t.markNeighborPointers(points[0], points[1], this);
	    }
	};
	
	
	Triangle.prototype.clearNeighbors = function() {
	    this.neighbors_[0] = null;
	    this.neighbors_[1] = null;
	    this.neighbors_[2] = null;
	};
	
	Triangle.prototype.clearDelaunayEdges = function() {
	    this.delaunay_edge[0] = false;
	    this.delaunay_edge[1] = false;
	    this.delaunay_edge[2] = false;
	};
	
	/**
	 * Returns the point clockwise to the given point.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 */
	Triangle.prototype.pointCW = function(p) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if (p === points[0]) {
	        return points[2];
	    } else if (p === points[1]) {
	        return points[0];
	    } else if (p === points[2]) {
	        return points[1];
	    } else {
	        return null;
	    }
	};
	
	/**
	 * Returns the point counter-clockwise to the given point.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 */
	Triangle.prototype.pointCCW = function(p) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if (p === points[0]) {
	        return points[1];
	    } else if (p === points[1]) {
	        return points[2];
	    } else if (p === points[2]) {
	        return points[0];
	    } else {
	        return null;
	    }
	};
	
	/**
	 * Returns the neighbor clockwise to given point.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 */
	Triangle.prototype.neighborCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.neighbors_[1];
	    } else if (p === this.points_[1]) {
	        return this.neighbors_[2];
	    } else {
	        return this.neighbors_[0];
	    }
	};
	
	/**
	 * Returns the neighbor counter-clockwise to given point.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 */
	Triangle.prototype.neighborCCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.neighbors_[2];
	    } else if (p === this.points_[1]) {
	        return this.neighbors_[0];
	    } else {
	        return this.neighbors_[1];
	    }
	};
	
	Triangle.prototype.getConstrainedEdgeCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.constrained_edge[1];
	    } else if (p === this.points_[1]) {
	        return this.constrained_edge[2];
	    } else {
	        return this.constrained_edge[0];
	    }
	};
	
	Triangle.prototype.getConstrainedEdgeCCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.constrained_edge[2];
	    } else if (p === this.points_[1]) {
	        return this.constrained_edge[0];
	    } else {
	        return this.constrained_edge[1];
	    }
	};
	
	// Additional check from Java version (see issue #88)
	Triangle.prototype.getConstrainedEdgeAcross = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.constrained_edge[0];
	    } else if (p === this.points_[1]) {
	        return this.constrained_edge[1];
	    } else {
	        return this.constrained_edge[2];
	    }
	};
	
	Triangle.prototype.setConstrainedEdgeCW = function(p, ce) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        this.constrained_edge[1] = ce;
	    } else if (p === this.points_[1]) {
	        this.constrained_edge[2] = ce;
	    } else {
	        this.constrained_edge[0] = ce;
	    }
	};
	
	Triangle.prototype.setConstrainedEdgeCCW = function(p, ce) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        this.constrained_edge[2] = ce;
	    } else if (p === this.points_[1]) {
	        this.constrained_edge[0] = ce;
	    } else {
	        this.constrained_edge[1] = ce;
	    }
	};
	
	Triangle.prototype.getDelaunayEdgeCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.delaunay_edge[1];
	    } else if (p === this.points_[1]) {
	        return this.delaunay_edge[2];
	    } else {
	        return this.delaunay_edge[0];
	    }
	};
	
	Triangle.prototype.getDelaunayEdgeCCW = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.delaunay_edge[2];
	    } else if (p === this.points_[1]) {
	        return this.delaunay_edge[0];
	    } else {
	        return this.delaunay_edge[1];
	    }
	};
	
	Triangle.prototype.setDelaunayEdgeCW = function(p, e) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        this.delaunay_edge[1] = e;
	    } else if (p === this.points_[1]) {
	        this.delaunay_edge[2] = e;
	    } else {
	        this.delaunay_edge[0] = e;
	    }
	};
	
	Triangle.prototype.setDelaunayEdgeCCW = function(p, e) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        this.delaunay_edge[2] = e;
	    } else if (p === this.points_[1]) {
	        this.delaunay_edge[0] = e;
	    } else {
	        this.delaunay_edge[1] = e;
	    }
	};
	
	/**
	 * The neighbor across to given point.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 * @returns {Triangle}
	 */
	Triangle.prototype.neighborAcross = function(p) {
	    // Here we are comparing point references, not values
	    if (p === this.points_[0]) {
	        return this.neighbors_[0];
	    } else if (p === this.points_[1]) {
	        return this.neighbors_[1];
	    } else {
	        return this.neighbors_[2];
	    }
	};
	
	/**
	 * @private
	 * @param {!Triangle} t Triangle object.
	 * @param {XY} p - point object with {x,y}
	 */
	Triangle.prototype.oppositePoint = function(t, p) {
	    var cw = t.pointCW(p);
	    return this.pointCW(cw);
	};
	
	/**
	 * Legalize triangle by rotating clockwise around oPoint
	 * @private
	 * @param {XY} opoint - point object with {x,y}
	 * @param {XY} npoint - point object with {x,y}
	 * @throws {Error} if oPoint can not be found
	 */
	Triangle.prototype.legalize = function(opoint, npoint) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if (opoint === points[0]) {
	        points[1] = points[0];
	        points[0] = points[2];
	        points[2] = npoint;
	    } else if (opoint === points[1]) {
	        points[2] = points[1];
	        points[1] = points[0];
	        points[0] = npoint;
	    } else if (opoint === points[2]) {
	        points[0] = points[2];
	        points[2] = points[1];
	        points[1] = npoint;
	    } else {
	        throw new Error('poly2tri Invalid Triangle.legalize() call');
	    }
	};
	
	/**
	 * Returns the index of a point in the triangle. 
	 * The point *must* be a reference to one of the triangle's vertices.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 * @returns {number} index 0, 1 or 2
	 * @throws {Error} if p can not be found
	 */
	Triangle.prototype.index = function(p) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if (p === points[0]) {
	        return 0;
	    } else if (p === points[1]) {
	        return 1;
	    } else if (p === points[2]) {
	        return 2;
	    } else {
	        throw new Error('poly2tri Invalid Triangle.index() call');
	    }
	};
	
	/**
	 * @private
	 * @param {XY} p1 - point object with {x,y}
	 * @param {XY} p2 - point object with {x,y}
	 * @return {number} index 0, 1 or 2, or -1 if errror
	 */
	Triangle.prototype.edgeIndex = function(p1, p2) {
	    var points = this.points_;
	    // Here we are comparing point references, not values
	    if (p1 === points[0]) {
	        if (p2 === points[1]) {
	            return 2;
	        } else if (p2 === points[2]) {
	            return 1;
	        }
	    } else if (p1 === points[1]) {
	        if (p2 === points[2]) {
	            return 0;
	        } else if (p2 === points[0]) {
	            return 2;
	        }
	    } else if (p1 === points[2]) {
	        if (p2 === points[0]) {
	            return 1;
	        } else if (p2 === points[1]) {
	            return 0;
	        }
	    }
	    return -1;
	};
	
	/**
	 * Mark an edge of this triangle as constrained.
	 * @private
	 * @param {number} index - edge index
	 */
	Triangle.prototype.markConstrainedEdgeByIndex = function(index) {
	    this.constrained_edge[index] = true;
	};
	/**
	 * Mark an edge of this triangle as constrained.
	 * @private
	 * @param {Edge} edge instance
	 */
	Triangle.prototype.markConstrainedEdgeByEdge = function(edge) {
	    this.markConstrainedEdgeByPoints(edge.p, edge.q);
	};
	/**
	 * Mark an edge of this triangle as constrained.
	 * This method takes two Point instances defining the edge of the triangle.
	 * @private
	 * @param {XY} p - point object with {x,y}
	 * @param {XY} q - point object with {x,y}
	 */
	Triangle.prototype.markConstrainedEdgeByPoints = function(p, q) {
	    var points = this.points_;
	    // Here we are comparing point references, not values        
	    if ((q === points[0] && p === points[1]) || (q === points[1] && p === points[0])) {
	        this.constrained_edge[2] = true;
	    } else if ((q === points[0] && p === points[2]) || (q === points[2] && p === points[0])) {
	        this.constrained_edge[1] = true;
	    } else if ((q === points[1] && p === points[2]) || (q === points[2] && p === points[1])) {
	        this.constrained_edge[0] = true;
	    }
	};
	
	
	// ---------------------------------------------------------Exports (public API)
	
	module.exports = Triangle;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	/* jshint maxcomplexity:6 */
	
	"use strict";
	
	
	/*
	 * Note
	 * ====
	 * the structure of this JavaScript version of poly2tri intentionally follows
	 * as closely as possible the structure of the reference C++ version, to make it 
	 * easier to keep the 2 versions in sync.
	 */
	
	var PointError = __webpack_require__(170);
	var Point = __webpack_require__(172);
	var Triangle = __webpack_require__(173);
	var sweep = __webpack_require__(175);
	var AdvancingFront = __webpack_require__(177);
	var Node = AdvancingFront.Node;
	
	
	// ------------------------------------------------------------------------utils
	
	/**
	 * Initial triangle factor, seed triangle will extend 30% of
	 * PointSet width to both left and right.
	 * @private
	 * @const
	 */
	var kAlpha = 0.3;
	
	
	// -------------------------------------------------------------------------Edge
	/**
	 * Represents a simple polygon's edge
	 * @constructor
	 * @struct
	 * @private
	 * @param {Point} p1
	 * @param {Point} p2
	 * @throw {PointError} if p1 is same as p2
	 */
	var Edge = function(p1, p2) {
	    this.p = p1;
	    this.q = p2;
	
	    if (p1.y > p2.y) {
	        this.q = p1;
	        this.p = p2;
	    } else if (p1.y === p2.y) {
	        if (p1.x > p2.x) {
	            this.q = p1;
	            this.p = p2;
	        } else if (p1.x === p2.x) {
	            throw new PointError('poly2tri Invalid Edge constructor: repeated points!', [p1]);
	        }
	    }
	
	    if (!this.q._p2t_edge_list) {
	        this.q._p2t_edge_list = [];
	    }
	    this.q._p2t_edge_list.push(this);
	};
	
	
	// ------------------------------------------------------------------------Basin
	/**
	 * @constructor
	 * @struct
	 * @private
	 */
	var Basin = function() {
	    /** @type {Node} */
	    this.left_node = null;
	    /** @type {Node} */
	    this.bottom_node = null;
	    /** @type {Node} */
	    this.right_node = null;
	    /** @type {number} */
	    this.width = 0.0;
	    /** @type {boolean} */
	    this.left_highest = false;
	};
	
	Basin.prototype.clear = function() {
	    this.left_node = null;
	    this.bottom_node = null;
	    this.right_node = null;
	    this.width = 0.0;
	    this.left_highest = false;
	};
	
	// --------------------------------------------------------------------EdgeEvent
	/**
	 * @constructor
	 * @struct
	 * @private
	 */
	var EdgeEvent = function() {
	    /** @type {Edge} */
	    this.constrained_edge = null;
	    /** @type {boolean} */
	    this.right = false;
	};
	
	// ----------------------------------------------------SweepContext (public API)
	/**
	 * SweepContext constructor option
	 * @typedef {Object} SweepContextOptions
	 * @property {boolean=} cloneArrays - if <code>true</code>, do a shallow copy of the Array parameters
	 *                  (contour, holes). Points inside arrays are never copied.
	 *                  Default is <code>false</code> : keep a reference to the array arguments,
	 *                  who will be modified in place.
	 */
	/**
	 * Constructor for the triangulation context.
	 * It accepts a simple polyline (with non repeating points), 
	 * which defines the constrained edges.
	 *
	 * @example
	 *          var contour = [
	 *              new poly2tri.Point(100, 100),
	 *              new poly2tri.Point(100, 300),
	 *              new poly2tri.Point(300, 300),
	 *              new poly2tri.Point(300, 100)
	 *          ];
	 *          var swctx = new poly2tri.SweepContext(contour, {cloneArrays: true});
	 * @example
	 *          var contour = [{x:100, y:100}, {x:100, y:300}, {x:300, y:300}, {x:300, y:100}];
	 *          var swctx = new poly2tri.SweepContext(contour, {cloneArrays: true});
	 * @constructor
	 * @public
	 * @struct
	 * @param {Array.<XY>} contour - array of point objects. The points can be either {@linkcode Point} instances,
	 *          or any "Point like" custom class with <code>{x, y}</code> attributes.
	 * @param {SweepContextOptions=} options - constructor options
	 */
	var SweepContext = function(contour, options) {
	    options = options || {};
	    this.triangles_ = [];
	    this.map_ = [];
	    this.points_ = (options.cloneArrays ? contour.slice(0) : contour);
	    this.edge_list = [];
	
	    // Bounding box of all points. Computed at the start of the triangulation, 
	    // it is stored in case it is needed by the caller.
	    this.pmin_ = this.pmax_ = null;
	
	    /**
	     * Advancing front
	     * @private
	     * @type {AdvancingFront}
	     */
	    this.front_ = null;
	
	    /**
	     * head point used with advancing front
	     * @private
	     * @type {Point}
	     */
	    this.head_ = null;
	
	    /**
	     * tail point used with advancing front
	     * @private
	     * @type {Point}
	     */
	    this.tail_ = null;
	
	    /**
	     * @private
	     * @type {Node}
	     */
	    this.af_head_ = null;
	    /**
	     * @private
	     * @type {Node}
	     */
	    this.af_middle_ = null;
	    /**
	     * @private
	     * @type {Node}
	     */
	    this.af_tail_ = null;
	
	    this.basin = new Basin();
	    this.edge_event = new EdgeEvent();
	
	    this.initEdges(this.points_);
	};
	
	
	/**
	 * Add a hole to the constraints
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      var hole = [
	 *          new poly2tri.Point(200, 200),
	 *          new poly2tri.Point(200, 250),
	 *          new poly2tri.Point(250, 250)
	 *      ];
	 *      swctx.addHole(hole);
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.addHole([{x:200, y:200}, {x:200, y:250}, {x:250, y:250}]);
	 * @public
	 * @param {Array.<XY>} polyline - array of "Point like" objects with {x,y}
	 */
	SweepContext.prototype.addHole = function(polyline) {
	    this.initEdges(polyline);
	    var i, len = polyline.length;
	    for (i = 0; i < len; i++) {
	        this.points_.push(polyline[i]);
	    }
	    return this; // for chaining
	};
	
	/**
	 * For backward compatibility
	 * @function
	 * @deprecated use {@linkcode SweepContext#addHole} instead
	 */
	SweepContext.prototype.AddHole = SweepContext.prototype.addHole;
	
	
	/**
	 * Add several holes to the constraints
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      var holes = [
	 *          [ new poly2tri.Point(200, 200), new poly2tri.Point(200, 250), new poly2tri.Point(250, 250) ],
	 *          [ new poly2tri.Point(300, 300), new poly2tri.Point(300, 350), new poly2tri.Point(350, 350) ]
	 *      ];
	 *      swctx.addHoles(holes);
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      var holes = [
	 *          [{x:200, y:200}, {x:200, y:250}, {x:250, y:250}],
	 *          [{x:300, y:300}, {x:300, y:350}, {x:350, y:350}]
	 *      ];
	 *      swctx.addHoles(holes);
	 * @public
	 * @param {Array.<Array.<XY>>} holes - array of array of "Point like" objects with {x,y}
	 */
	// Method added in the JavaScript version (was not present in the c++ version)
	SweepContext.prototype.addHoles = function(holes) {
	    var i, len = holes.length;
	    for (i = 0; i < len; i++) {
	        this.initEdges(holes[i]);
	    }
	    this.points_ = this.points_.concat.apply(this.points_, holes);
	    return this; // for chaining
	};
	
	
	/**
	 * Add a Steiner point to the constraints
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      var point = new poly2tri.Point(150, 150);
	 *      swctx.addPoint(point);
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.addPoint({x:150, y:150});
	 * @public
	 * @param {XY} point - any "Point like" object with {x,y}
	 */
	SweepContext.prototype.addPoint = function(point) {
	    this.points_.push(point);
	    return this; // for chaining
	};
	
	/**
	 * For backward compatibility
	 * @function
	 * @deprecated use {@linkcode SweepContext#addPoint} instead
	 */
	SweepContext.prototype.AddPoint = SweepContext.prototype.addPoint;
	
	
	/**
	 * Add several Steiner points to the constraints
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      var points = [
	 *          new poly2tri.Point(150, 150),
	 *          new poly2tri.Point(200, 250),
	 *          new poly2tri.Point(250, 250)
	 *      ];
	 *      swctx.addPoints(points);
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.addPoints([{x:150, y:150}, {x:200, y:250}, {x:250, y:250}]);
	 * @public
	 * @param {Array.<XY>} points - array of "Point like" object with {x,y}
	 */
	// Method added in the JavaScript version (was not present in the c++ version)
	SweepContext.prototype.addPoints = function(points) {
	    this.points_ = this.points_.concat(points);
	    return this; // for chaining
	};
	
	
	/**
	 * Triangulate the polygon with holes and Steiner points.
	 * Do this AFTER you've added the polyline, holes, and Steiner points
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.triangulate();
	 *      var triangles = swctx.getTriangles();
	 * @public
	 */
	// Shortcut method for sweep.triangulate(SweepContext).
	// Method added in the JavaScript version (was not present in the c++ version)
	SweepContext.prototype.triangulate = function() {
	    sweep.triangulate(this);
	    return this; // for chaining
	};
	
	
	/**
	 * Get the bounding box of the provided constraints (contour, holes and 
	 * Steinter points). Warning : these values are not available if the triangulation 
	 * has not been done yet.
	 * @public
	 * @returns {{min:Point,max:Point}} object with 'min' and 'max' Point
	 */
	// Method added in the JavaScript version (was not present in the c++ version)
	SweepContext.prototype.getBoundingBox = function() {
	    return {min: this.pmin_, max: this.pmax_};
	};
	
	/**
	 * Get result of triangulation.
	 * The output triangles have vertices which are references
	 * to the initial input points (not copies): any custom fields in the
	 * initial points can be retrieved in the output triangles.
	 * @example
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.triangulate();
	 *      var triangles = swctx.getTriangles();
	 * @example
	 *      var contour = [{x:100, y:100, id:1}, {x:100, y:300, id:2}, {x:300, y:300, id:3}];
	 *      var swctx = new poly2tri.SweepContext(contour);
	 *      swctx.triangulate();
	 *      var triangles = swctx.getTriangles();
	 *      typeof triangles[0].getPoint(0).id
	 *      // → "number"
	 * @public
	 * @returns {array<Triangle>}   array of triangles
	 */
	SweepContext.prototype.getTriangles = function() {
	    return this.triangles_;
	};
	
	/**
	 * For backward compatibility
	 * @function
	 * @deprecated use {@linkcode SweepContext#getTriangles} instead
	 */
	SweepContext.prototype.GetTriangles = SweepContext.prototype.getTriangles;
	
	
	// ---------------------------------------------------SweepContext (private API)
	
	/** @private */
	SweepContext.prototype.front = function() {
	    return this.front_;
	};
	
	/** @private */
	SweepContext.prototype.pointCount = function() {
	    return this.points_.length;
	};
	
	/** @private */
	SweepContext.prototype.head = function() {
	    return this.head_;
	};
	
	/** @private */
	SweepContext.prototype.setHead = function(p1) {
	    this.head_ = p1;
	};
	
	/** @private */
	SweepContext.prototype.tail = function() {
	    return this.tail_;
	};
	
	/** @private */
	SweepContext.prototype.setTail = function(p1) {
	    this.tail_ = p1;
	};
	
	/** @private */
	SweepContext.prototype.getMap = function() {
	    return this.map_;
	};
	
	/** @private */
	SweepContext.prototype.initTriangulation = function() {
	    var xmax = this.points_[0].x;
	    var xmin = this.points_[0].x;
	    var ymax = this.points_[0].y;
	    var ymin = this.points_[0].y;
	
	    // Calculate bounds
	    var i, len = this.points_.length;
	    for (i = 1; i < len; i++) {
	        var p = this.points_[i];
	        /* jshint expr:true */
	        (p.x > xmax) && (xmax = p.x);
	        (p.x < xmin) && (xmin = p.x);
	        (p.y > ymax) && (ymax = p.y);
	        (p.y < ymin) && (ymin = p.y);
	    }
	    this.pmin_ = new Point(xmin, ymin);
	    this.pmax_ = new Point(xmax, ymax);
	
	    var dx = kAlpha * (xmax - xmin);
	    var dy = kAlpha * (ymax - ymin);
	    this.head_ = new Point(xmax + dx, ymin - dy);
	    this.tail_ = new Point(xmin - dx, ymin - dy);
	
	    // Sort points along y-axis
	    this.points_.sort(Point.compare);
	};
	
	/** @private */
	SweepContext.prototype.initEdges = function(polyline) {
	    var i, len = polyline.length;
	    for (i = 0; i < len; ++i) {
	        this.edge_list.push(new Edge(polyline[i], polyline[(i + 1) % len]));
	    }
	};
	
	/** @private */
	SweepContext.prototype.getPoint = function(index) {
	    return this.points_[index];
	};
	
	/** @private */
	SweepContext.prototype.addToMap = function(triangle) {
	    this.map_.push(triangle);
	};
	
	/** @private */
	SweepContext.prototype.locateNode = function(point) {
	    return this.front_.locateNode(point.x);
	};
	
	/** @private */
	SweepContext.prototype.createAdvancingFront = function() {
	    var head;
	    var middle;
	    var tail;
	    // Initial triangle
	    var triangle = new Triangle(this.points_[0], this.tail_, this.head_);
	
	    this.map_.push(triangle);
	
	    head = new Node(triangle.getPoint(1), triangle);
	    middle = new Node(triangle.getPoint(0), triangle);
	    tail = new Node(triangle.getPoint(2));
	
	    this.front_ = new AdvancingFront(head, tail);
	
	    head.next = middle;
	    middle.next = tail;
	    middle.prev = head;
	    tail.prev = middle;
	};
	
	/** @private */
	SweepContext.prototype.removeNode = function(node) {
	    // do nothing
	    /* jshint unused:false */
	};
	
	/** @private */
	SweepContext.prototype.mapTriangleToNodes = function(t) {
	    for (var i = 0; i < 3; ++i) {
	        if (!t.getNeighbor(i)) {
	            var n = this.front_.locatePoint(t.pointCW(t.getPoint(i)));
	            if (n) {
	                n.triangle = t;
	            }
	        }
	    }
	};
	
	/** @private */
	SweepContext.prototype.removeFromMap = function(triangle) {
	    var i, map = this.map_, len = map.length;
	    for (i = 0; i < len; i++) {
	        if (map[i] === triangle) {
	            map.splice(i, 1);
	            break;
	        }
	    }
	};
	
	/**
	 * Do a depth first traversal to collect triangles
	 * @private
	 * @param {Triangle} triangle start
	 */
	SweepContext.prototype.meshClean = function(triangle) {
	    // New implementation avoids recursive calls and use a loop instead.
	    // Cf. issues # 57, 65 and 69.
	    var triangles = [triangle], t, i;
	    /* jshint boss:true */
	    while (t = triangles.pop()) {
	        if (!t.isInterior()) {
	            t.setInterior(true);
	            this.triangles_.push(t);
	            for (i = 0; i < 3; i++) {
	                if (!t.constrained_edge[i]) {
	                    triangles.push(t.getNeighbor(i));
	                }
	            }
	        }
	    }
	};
	
	// ----------------------------------------------------------------------Exports
	
	module.exports = SweepContext;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	/* jshint latedef:nofunc, maxcomplexity:9 */
	
	"use strict";
	
	/**
	 * This 'Sweep' module is present in order to keep this JavaScript version
	 * as close as possible to the reference C++ version, even though almost all
	 * functions could be declared as methods on the {@linkcode module:sweepcontext~SweepContext} object.
	 * @module
	 * @private
	 */
	
	/*
	 * Note
	 * ====
	 * the structure of this JavaScript version of poly2tri intentionally follows
	 * as closely as possible the structure of the reference C++ version, to make it 
	 * easier to keep the 2 versions in sync.
	 */
	
	var assert = __webpack_require__(176);
	var PointError = __webpack_require__(170);
	var Triangle = __webpack_require__(173);
	var Node = __webpack_require__(177).Node;
	
	
	// ------------------------------------------------------------------------utils
	
	var utils = __webpack_require__(178);
	
	/** @const */
	var EPSILON = utils.EPSILON;
	
	/** @const */
	var Orientation = utils.Orientation;
	/** @const */
	var orient2d = utils.orient2d;
	/** @const */
	var inScanArea = utils.inScanArea;
	/** @const */
	var isAngleObtuse = utils.isAngleObtuse;
	
	
	// ------------------------------------------------------------------------Sweep
	
	/**
	 * Triangulate the polygon with holes and Steiner points.
	 * Do this AFTER you've added the polyline, holes, and Steiner points
	 * @private
	 * @param {!SweepContext} tcx - SweepContext object
	 */
	function triangulate(tcx) {
	    tcx.initTriangulation();
	    tcx.createAdvancingFront();
	    // Sweep points; build mesh
	    sweepPoints(tcx);
	    // Clean up
	    finalizationPolygon(tcx);
	}
	
	/**
	 * Start sweeping the Y-sorted point set from bottom to top
	 * @param {!SweepContext} tcx - SweepContext object
	 */
	function sweepPoints(tcx) {
	    var i, len = tcx.pointCount();
	    for (i = 1; i < len; ++i) {
	        var point = tcx.getPoint(i);
	        var node = pointEvent(tcx, point);
	        var edges = point._p2t_edge_list;
	        for (var j = 0; edges && j < edges.length; ++j) {
	            edgeEventByEdge(tcx, edges[j], node);
	        }
	    }
	}
	
	/**
	 * @param {!SweepContext} tcx - SweepContext object
	 */
	function finalizationPolygon(tcx) {
	    // Get an Internal triangle to start with
	    var t = tcx.front().head().next.triangle;
	    var p = tcx.front().head().next.point;
	    while (!t.getConstrainedEdgeCW(p)) {
	        t = t.neighborCCW(p);
	    }
	
	    // Collect interior triangles constrained by edges
	    tcx.meshClean(t);
	}
	
	/**
	 * Find closes node to the left of the new point and
	 * create a new triangle. If needed new holes and basins
	 * will be filled to.
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param {!XY} point   Point
	 */
	function pointEvent(tcx, point) {
	    var node = tcx.locateNode(point);
	    var new_node = newFrontTriangle(tcx, point, node);
	
	    // Only need to check +epsilon since point never have smaller
	    // x value than node due to how we fetch nodes from the front
	    if (point.x <= node.point.x + (EPSILON)) {
	        fill(tcx, node);
	    }
	
	    //tcx.AddNode(new_node);
	
	    fillAdvancingFront(tcx, new_node);
	    return new_node;
	}
	
	function edgeEventByEdge(tcx, edge, node) {
	    tcx.edge_event.constrained_edge = edge;
	    tcx.edge_event.right = (edge.p.x > edge.q.x);
	
	    if (isEdgeSideOfTriangle(node.triangle, edge.p, edge.q)) {
	        return;
	    }
	
	    // For now we will do all needed filling
	    // TODO: integrate with flip process might give some better performance
	    //       but for now this avoid the issue with cases that needs both flips and fills
	    fillEdgeEvent(tcx, edge, node);
	    edgeEventByPoints(tcx, edge.p, edge.q, node.triangle, edge.q);
	}
	
	function edgeEventByPoints(tcx, ep, eq, triangle, point) {
	    if (isEdgeSideOfTriangle(triangle, ep, eq)) {
	        return;
	    }
	
	    var p1 = triangle.pointCCW(point);
	    var o1 = orient2d(eq, p1, ep);
	    if (o1 === Orientation.COLLINEAR) {
	        // TODO integrate here changes from C++ version
	        // (C++ repo revision 09880a869095 dated March 8, 2011)
	        throw new PointError('poly2tri EdgeEvent: Collinear not supported!', [eq, p1, ep]);
	    }
	
	    var p2 = triangle.pointCW(point);
	    var o2 = orient2d(eq, p2, ep);
	    if (o2 === Orientation.COLLINEAR) {
	        // TODO integrate here changes from C++ version
	        // (C++ repo revision 09880a869095 dated March 8, 2011)
	        throw new PointError('poly2tri EdgeEvent: Collinear not supported!', [eq, p2, ep]);
	    }
	
	    if (o1 === o2) {
	        // Need to decide if we are rotating CW or CCW to get to a triangle
	        // that will cross edge
	        if (o1 === Orientation.CW) {
	            triangle = triangle.neighborCCW(point);
	        } else {
	            triangle = triangle.neighborCW(point);
	        }
	        edgeEventByPoints(tcx, ep, eq, triangle, point);
	    } else {
	        // This triangle crosses constraint so lets flippin start!
	        flipEdgeEvent(tcx, ep, eq, triangle, point);
	    }
	}
	
	function isEdgeSideOfTriangle(triangle, ep, eq) {
	    var index = triangle.edgeIndex(ep, eq);
	    if (index !== -1) {
	        triangle.markConstrainedEdgeByIndex(index);
	        var t = triangle.getNeighbor(index);
	        if (t) {
	            t.markConstrainedEdgeByPoints(ep, eq);
	        }
	        return true;
	    }
	    return false;
	}
	
	/**
	 * Creates a new front triangle and legalize it
	 * @param {!SweepContext} tcx - SweepContext object
	 */
	function newFrontTriangle(tcx, point, node) {
	    var triangle = new Triangle(point, node.point, node.next.point);
	
	    triangle.markNeighbor(node.triangle);
	    tcx.addToMap(triangle);
	
	    var new_node = new Node(point);
	    new_node.next = node.next;
	    new_node.prev = node;
	    node.next.prev = new_node;
	    node.next = new_node;
	
	    if (!legalize(tcx, triangle)) {
	        tcx.mapTriangleToNodes(triangle);
	    }
	
	    return new_node;
	}
	
	/**
	 * Adds a triangle to the advancing front to fill a hole.
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param node - middle node, that is the bottom of the hole
	 */
	function fill(tcx, node) {
	    var triangle = new Triangle(node.prev.point, node.point, node.next.point);
	
	    // TODO: should copy the constrained_edge value from neighbor triangles
	    //       for now constrained_edge values are copied during the legalize
	    triangle.markNeighbor(node.prev.triangle);
	    triangle.markNeighbor(node.triangle);
	
	    tcx.addToMap(triangle);
	
	    // Update the advancing front
	    node.prev.next = node.next;
	    node.next.prev = node.prev;
	
	
	    // If it was legalized the triangle has already been mapped
	    if (!legalize(tcx, triangle)) {
	        tcx.mapTriangleToNodes(triangle);
	    }
	
	    //tcx.removeNode(node);
	}
	
	/**
	 * Fills holes in the Advancing Front
	 * @param {!SweepContext} tcx - SweepContext object
	 */
	function fillAdvancingFront(tcx, n) {
	    // Fill right holes
	    var node = n.next;
	    while (node.next) {
	        // TODO integrate here changes from C++ version
	        // (C++ repo revision acf81f1f1764 dated April 7, 2012)
	        if (isAngleObtuse(node.point, node.next.point, node.prev.point)) {
	            break;
	        }
	        fill(tcx, node);
	        node = node.next;
	    }
	
	    // Fill left holes
	    node = n.prev;
	    while (node.prev) {
	        // TODO integrate here changes from C++ version
	        // (C++ repo revision acf81f1f1764 dated April 7, 2012)
	        if (isAngleObtuse(node.point, node.next.point, node.prev.point)) {
	            break;
	        }
	        fill(tcx, node);
	        node = node.prev;
	    }
	
	    // Fill right basins
	    if (n.next && n.next.next) {
	        if (isBasinAngleRight(n)) {
	            fillBasin(tcx, n);
	        }
	    }
	}
	
	/**
	 * The basin angle is decided against the horizontal line [1,0].
	 * @param {Node} node
	 * @return {boolean} true if angle < 3*π/4
	 */
	function isBasinAngleRight(node) {
	    var ax = node.point.x - node.next.next.point.x;
	    var ay = node.point.y - node.next.next.point.y;
	    assert(ay >= 0, "unordered y");
	    return (ax >= 0 || Math.abs(ax) < ay);
	}
	
	/**
	 * Returns true if triangle was legalized
	 * @param {!SweepContext} tcx - SweepContext object
	 * @return {boolean}
	 */
	function legalize(tcx, t) {
	    // To legalize a triangle we start by finding if any of the three edges
	    // violate the Delaunay condition
	    for (var i = 0; i < 3; ++i) {
	        if (t.delaunay_edge[i]) {
	            continue;
	        }
	        var ot = t.getNeighbor(i);
	        if (ot) {
	            var p = t.getPoint(i);
	            var op = ot.oppositePoint(t, p);
	            var oi = ot.index(op);
	
	            // If this is a Constrained Edge or a Delaunay Edge(only during recursive legalization)
	            // then we should not try to legalize
	            if (ot.constrained_edge[oi] || ot.delaunay_edge[oi]) {
	                t.constrained_edge[i] = ot.constrained_edge[oi];
	                continue;
	            }
	
	            var inside = inCircle(p, t.pointCCW(p), t.pointCW(p), op);
	            if (inside) {
	                // Lets mark this shared edge as Delaunay
	                t.delaunay_edge[i] = true;
	                ot.delaunay_edge[oi] = true;
	
	                // Lets rotate shared edge one vertex CW to legalize it
	                rotateTrianglePair(t, p, ot, op);
	
	                // We now got one valid Delaunay Edge shared by two triangles
	                // This gives us 4 new edges to check for Delaunay
	
	                // Make sure that triangle to node mapping is done only one time for a specific triangle
	                var not_legalized = !legalize(tcx, t);
	                if (not_legalized) {
	                    tcx.mapTriangleToNodes(t);
	                }
	
	                not_legalized = !legalize(tcx, ot);
	                if (not_legalized) {
	                    tcx.mapTriangleToNodes(ot);
	                }
	                // Reset the Delaunay edges, since they only are valid Delaunay edges
	                // until we add a new triangle or point.
	                // XXX: need to think about this. Can these edges be tried after we
	                //      return to previous recursive level?
	                t.delaunay_edge[i] = false;
	                ot.delaunay_edge[oi] = false;
	
	                // If triangle have been legalized no need to check the other edges since
	                // the recursive legalization will handles those so we can end here.
	                return true;
	            }
	        }
	    }
	    return false;
	}
	
	/**
	 * <b>Requirement</b>:<br>
	 * 1. a,b and c form a triangle.<br>
	 * 2. a and d is know to be on opposite side of bc<br>
	 * <pre>
	 *                a
	 *                +
	 *               / \
	 *              /   \
	 *            b/     \c
	 *            +-------+
	 *           /    d    \
	 *          /           \
	 * </pre>
	 * <b>Fact</b>: d has to be in area B to have a chance to be inside the circle formed by
	 *  a,b and c<br>
	 *  d is outside B if orient2d(a,b,d) or orient2d(c,a,d) is CW<br>
	 *  This preknowledge gives us a way to optimize the incircle test
	 * @param pa - triangle point, opposite d
	 * @param pb - triangle point
	 * @param pc - triangle point
	 * @param pd - point opposite a
	 * @return {boolean} true if d is inside circle, false if on circle edge
	 */
	function inCircle(pa, pb, pc, pd) {
	    var adx = pa.x - pd.x;
	    var ady = pa.y - pd.y;
	    var bdx = pb.x - pd.x;
	    var bdy = pb.y - pd.y;
	
	    var adxbdy = adx * bdy;
	    var bdxady = bdx * ady;
	    var oabd = adxbdy - bdxady;
	    if (oabd <= 0) {
	        return false;
	    }
	
	    var cdx = pc.x - pd.x;
	    var cdy = pc.y - pd.y;
	
	    var cdxady = cdx * ady;
	    var adxcdy = adx * cdy;
	    var ocad = cdxady - adxcdy;
	    if (ocad <= 0) {
	        return false;
	    }
	
	    var bdxcdy = bdx * cdy;
	    var cdxbdy = cdx * bdy;
	
	    var alift = adx * adx + ady * ady;
	    var blift = bdx * bdx + bdy * bdy;
	    var clift = cdx * cdx + cdy * cdy;
	
	    var det = alift * (bdxcdy - cdxbdy) + blift * ocad + clift * oabd;
	    return det > 0;
	}
	
	/**
	 * Rotates a triangle pair one vertex CW
	 *<pre>
	 *       n2                    n2
	 *  P +-----+             P +-----+
	 *    | t  /|               |\  t |
	 *    |   / |               | \   |
	 *  n1|  /  |n3           n1|  \  |n3
	 *    | /   |    after CW   |   \ |
	 *    |/ oT |               | oT \|
	 *    +-----+ oP            +-----+
	 *       n4                    n4
	 * </pre>
	 */
	function rotateTrianglePair(t, p, ot, op) {
	    var n1, n2, n3, n4;
	    n1 = t.neighborCCW(p);
	    n2 = t.neighborCW(p);
	    n3 = ot.neighborCCW(op);
	    n4 = ot.neighborCW(op);
	
	    var ce1, ce2, ce3, ce4;
	    ce1 = t.getConstrainedEdgeCCW(p);
	    ce2 = t.getConstrainedEdgeCW(p);
	    ce3 = ot.getConstrainedEdgeCCW(op);
	    ce4 = ot.getConstrainedEdgeCW(op);
	
	    var de1, de2, de3, de4;
	    de1 = t.getDelaunayEdgeCCW(p);
	    de2 = t.getDelaunayEdgeCW(p);
	    de3 = ot.getDelaunayEdgeCCW(op);
	    de4 = ot.getDelaunayEdgeCW(op);
	
	    t.legalize(p, op);
	    ot.legalize(op, p);
	
	    // Remap delaunay_edge
	    ot.setDelaunayEdgeCCW(p, de1);
	    t.setDelaunayEdgeCW(p, de2);
	    t.setDelaunayEdgeCCW(op, de3);
	    ot.setDelaunayEdgeCW(op, de4);
	
	    // Remap constrained_edge
	    ot.setConstrainedEdgeCCW(p, ce1);
	    t.setConstrainedEdgeCW(p, ce2);
	    t.setConstrainedEdgeCCW(op, ce3);
	    ot.setConstrainedEdgeCW(op, ce4);
	
	    // Remap neighbors
	    // XXX: might optimize the markNeighbor by keeping track of
	    //      what side should be assigned to what neighbor after the
	    //      rotation. Now mark neighbor does lots of testing to find
	    //      the right side.
	    t.clearNeighbors();
	    ot.clearNeighbors();
	    if (n1) {
	        ot.markNeighbor(n1);
	    }
	    if (n2) {
	        t.markNeighbor(n2);
	    }
	    if (n3) {
	        t.markNeighbor(n3);
	    }
	    if (n4) {
	        ot.markNeighbor(n4);
	    }
	    t.markNeighbor(ot);
	}
	
	/**
	 * Fills a basin that has formed on the Advancing Front to the right
	 * of given node.<br>
	 * First we decide a left,bottom and right node that forms the
	 * boundaries of the basin. Then we do a reqursive fill.
	 *
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param node - starting node, this or next node will be left node
	 */
	function fillBasin(tcx, node) {
	    if (orient2d(node.point, node.next.point, node.next.next.point) === Orientation.CCW) {
	        tcx.basin.left_node = node.next.next;
	    } else {
	        tcx.basin.left_node = node.next;
	    }
	
	    // Find the bottom and right node
	    tcx.basin.bottom_node = tcx.basin.left_node;
	    while (tcx.basin.bottom_node.next && tcx.basin.bottom_node.point.y >= tcx.basin.bottom_node.next.point.y) {
	        tcx.basin.bottom_node = tcx.basin.bottom_node.next;
	    }
	    if (tcx.basin.bottom_node === tcx.basin.left_node) {
	        // No valid basin
	        return;
	    }
	
	    tcx.basin.right_node = tcx.basin.bottom_node;
	    while (tcx.basin.right_node.next && tcx.basin.right_node.point.y < tcx.basin.right_node.next.point.y) {
	        tcx.basin.right_node = tcx.basin.right_node.next;
	    }
	    if (tcx.basin.right_node === tcx.basin.bottom_node) {
	        // No valid basins
	        return;
	    }
	
	    tcx.basin.width = tcx.basin.right_node.point.x - tcx.basin.left_node.point.x;
	    tcx.basin.left_highest = tcx.basin.left_node.point.y > tcx.basin.right_node.point.y;
	
	    fillBasinReq(tcx, tcx.basin.bottom_node);
	}
	
	/**
	 * Recursive algorithm to fill a Basin with triangles
	 *
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param node - bottom_node
	 */
	function fillBasinReq(tcx, node) {
	    // if shallow stop filling
	    if (isShallow(tcx, node)) {
	        return;
	    }
	
	    fill(tcx, node);
	
	    var o;
	    if (node.prev === tcx.basin.left_node && node.next === tcx.basin.right_node) {
	        return;
	    } else if (node.prev === tcx.basin.left_node) {
	        o = orient2d(node.point, node.next.point, node.next.next.point);
	        if (o === Orientation.CW) {
	            return;
	        }
	        node = node.next;
	    } else if (node.next === tcx.basin.right_node) {
	        o = orient2d(node.point, node.prev.point, node.prev.prev.point);
	        if (o === Orientation.CCW) {
	            return;
	        }
	        node = node.prev;
	    } else {
	        // Continue with the neighbor node with lowest Y value
	        if (node.prev.point.y < node.next.point.y) {
	            node = node.prev;
	        } else {
	            node = node.next;
	        }
	    }
	
	    fillBasinReq(tcx, node);
	}
	
	function isShallow(tcx, node) {
	    var height;
	    if (tcx.basin.left_highest) {
	        height = tcx.basin.left_node.point.y - node.point.y;
	    } else {
	        height = tcx.basin.right_node.point.y - node.point.y;
	    }
	
	    // if shallow stop filling
	    if (tcx.basin.width > height) {
	        return true;
	    }
	    return false;
	}
	
	function fillEdgeEvent(tcx, edge, node) {
	    if (tcx.edge_event.right) {
	        fillRightAboveEdgeEvent(tcx, edge, node);
	    } else {
	        fillLeftAboveEdgeEvent(tcx, edge, node);
	    }
	}
	
	function fillRightAboveEdgeEvent(tcx, edge, node) {
	    while (node.next.point.x < edge.p.x) {
	        // Check if next node is below the edge
	        if (orient2d(edge.q, node.next.point, edge.p) === Orientation.CCW) {
	            fillRightBelowEdgeEvent(tcx, edge, node);
	        } else {
	            node = node.next;
	        }
	    }
	}
	
	function fillRightBelowEdgeEvent(tcx, edge, node) {
	    if (node.point.x < edge.p.x) {
	        if (orient2d(node.point, node.next.point, node.next.next.point) === Orientation.CCW) {
	            // Concave
	            fillRightConcaveEdgeEvent(tcx, edge, node);
	        } else {
	            // Convex
	            fillRightConvexEdgeEvent(tcx, edge, node);
	            // Retry this one
	            fillRightBelowEdgeEvent(tcx, edge, node);
	        }
	    }
	}
	
	function fillRightConcaveEdgeEvent(tcx, edge, node) {
	    fill(tcx, node.next);
	    if (node.next.point !== edge.p) {
	        // Next above or below edge?
	        if (orient2d(edge.q, node.next.point, edge.p) === Orientation.CCW) {
	            // Below
	            if (orient2d(node.point, node.next.point, node.next.next.point) === Orientation.CCW) {
	                // Next is concave
	                fillRightConcaveEdgeEvent(tcx, edge, node);
	            } else {
	                // Next is convex
	                /* jshint noempty:false */
	            }
	        }
	    }
	}
	
	function fillRightConvexEdgeEvent(tcx, edge, node) {
	    // Next concave or convex?
	    if (orient2d(node.next.point, node.next.next.point, node.next.next.next.point) === Orientation.CCW) {
	        // Concave
	        fillRightConcaveEdgeEvent(tcx, edge, node.next);
	    } else {
	        // Convex
	        // Next above or below edge?
	        if (orient2d(edge.q, node.next.next.point, edge.p) === Orientation.CCW) {
	            // Below
	            fillRightConvexEdgeEvent(tcx, edge, node.next);
	        } else {
	            // Above
	            /* jshint noempty:false */
	        }
	    }
	}
	
	function fillLeftAboveEdgeEvent(tcx, edge, node) {
	    while (node.prev.point.x > edge.p.x) {
	        // Check if next node is below the edge
	        if (orient2d(edge.q, node.prev.point, edge.p) === Orientation.CW) {
	            fillLeftBelowEdgeEvent(tcx, edge, node);
	        } else {
	            node = node.prev;
	        }
	    }
	}
	
	function fillLeftBelowEdgeEvent(tcx, edge, node) {
	    if (node.point.x > edge.p.x) {
	        if (orient2d(node.point, node.prev.point, node.prev.prev.point) === Orientation.CW) {
	            // Concave
	            fillLeftConcaveEdgeEvent(tcx, edge, node);
	        } else {
	            // Convex
	            fillLeftConvexEdgeEvent(tcx, edge, node);
	            // Retry this one
	            fillLeftBelowEdgeEvent(tcx, edge, node);
	        }
	    }
	}
	
	function fillLeftConvexEdgeEvent(tcx, edge, node) {
	    // Next concave or convex?
	    if (orient2d(node.prev.point, node.prev.prev.point, node.prev.prev.prev.point) === Orientation.CW) {
	        // Concave
	        fillLeftConcaveEdgeEvent(tcx, edge, node.prev);
	    } else {
	        // Convex
	        // Next above or below edge?
	        if (orient2d(edge.q, node.prev.prev.point, edge.p) === Orientation.CW) {
	            // Below
	            fillLeftConvexEdgeEvent(tcx, edge, node.prev);
	        } else {
	            // Above
	            /* jshint noempty:false */
	        }
	    }
	}
	
	function fillLeftConcaveEdgeEvent(tcx, edge, node) {
	    fill(tcx, node.prev);
	    if (node.prev.point !== edge.p) {
	        // Next above or below edge?
	        if (orient2d(edge.q, node.prev.point, edge.p) === Orientation.CW) {
	            // Below
	            if (orient2d(node.point, node.prev.point, node.prev.prev.point) === Orientation.CW) {
	                // Next is concave
	                fillLeftConcaveEdgeEvent(tcx, edge, node);
	            } else {
	                // Next is convex
	                /* jshint noempty:false */
	            }
	        }
	    }
	}
	
	function flipEdgeEvent(tcx, ep, eq, t, p) {
	    var ot = t.neighborAcross(p);
	    assert(ot, "FLIP failed due to missing triangle!");
	
	    var op = ot.oppositePoint(t, p);
	
	    // Additional check from Java version (see issue #88)
	    if (t.getConstrainedEdgeAcross(p)) {
	        var index = t.index(p);
	        throw new PointError("poly2tri Intersecting Constraints",
	                [p, op, t.getPoint((index + 1) % 3), t.getPoint((index + 2) % 3)]);
	    }
	
	    if (inScanArea(p, t.pointCCW(p), t.pointCW(p), op)) {
	        // Lets rotate shared edge one vertex CW
	        rotateTrianglePair(t, p, ot, op);
	        tcx.mapTriangleToNodes(t);
	        tcx.mapTriangleToNodes(ot);
	
	        // XXX: in the original C++ code for the next 2 lines, we are
	        // comparing point values (and not pointers). In this JavaScript
	        // code, we are comparing point references (pointers). This works
	        // because we can't have 2 different points with the same values.
	        // But to be really equivalent, we should use "Point.equals" here.
	        if (p === eq && op === ep) {
	            if (eq === tcx.edge_event.constrained_edge.q && ep === tcx.edge_event.constrained_edge.p) {
	                t.markConstrainedEdgeByPoints(ep, eq);
	                ot.markConstrainedEdgeByPoints(ep, eq);
	                legalize(tcx, t);
	                legalize(tcx, ot);
	            } else {
	                // XXX: I think one of the triangles should be legalized here?
	                /* jshint noempty:false */
	            }
	        } else {
	            var o = orient2d(eq, op, ep);
	            t = nextFlipTriangle(tcx, o, t, ot, p, op);
	            flipEdgeEvent(tcx, ep, eq, t, p);
	        }
	    } else {
	        var newP = nextFlipPoint(ep, eq, ot, op);
	        flipScanEdgeEvent(tcx, ep, eq, t, ot, newP);
	        edgeEventByPoints(tcx, ep, eq, t, p);
	    }
	}
	
	/**
	 * After a flip we have two triangles and know that only one will still be
	 * intersecting the edge. So decide which to contiune with and legalize the other
	 *
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param o - should be the result of an orient2d( eq, op, ep )
	 * @param t - triangle 1
	 * @param ot - triangle 2
	 * @param p - a point shared by both triangles
	 * @param op - another point shared by both triangles
	 * @return returns the triangle still intersecting the edge
	 */
	function nextFlipTriangle(tcx, o, t, ot, p, op) {
	    var edge_index;
	    if (o === Orientation.CCW) {
	        // ot is not crossing edge after flip
	        edge_index = ot.edgeIndex(p, op);
	        ot.delaunay_edge[edge_index] = true;
	        legalize(tcx, ot);
	        ot.clearDelaunayEdges();
	        return t;
	    }
	
	    // t is not crossing edge after flip
	    edge_index = t.edgeIndex(p, op);
	
	    t.delaunay_edge[edge_index] = true;
	    legalize(tcx, t);
	    t.clearDelaunayEdges();
	    return ot;
	}
	
	/**
	 * When we need to traverse from one triangle to the next we need
	 * the point in current triangle that is the opposite point to the next
	 * triangle.
	 */
	function nextFlipPoint(ep, eq, ot, op) {
	    var o2d = orient2d(eq, op, ep);
	    if (o2d === Orientation.CW) {
	        // Right
	        return ot.pointCCW(op);
	    } else if (o2d === Orientation.CCW) {
	        // Left
	        return ot.pointCW(op);
	    } else {
	        throw new PointError("poly2tri [Unsupported] nextFlipPoint: opposing point on constrained edge!", [eq, op, ep]);
	    }
	}
	
	/**
	 * Scan part of the FlipScan algorithm<br>
	 * When a triangle pair isn't flippable we will scan for the next
	 * point that is inside the flip triangle scan area. When found
	 * we generate a new flipEdgeEvent
	 *
	 * @param {!SweepContext} tcx - SweepContext object
	 * @param ep - last point on the edge we are traversing
	 * @param eq - first point on the edge we are traversing
	 * @param {!Triangle} flip_triangle - the current triangle sharing the point eq with edge
	 * @param t
	 * @param p
	 */
	function flipScanEdgeEvent(tcx, ep, eq, flip_triangle, t, p) {
	    var ot = t.neighborAcross(p);
	    assert(ot, "FLIP failed due to missing triangle");
	
	    var op = ot.oppositePoint(t, p);
	
	    if (inScanArea(eq, flip_triangle.pointCCW(eq), flip_triangle.pointCW(eq), op)) {
	        // flip with new edge op.eq
	        flipEdgeEvent(tcx, eq, op, ot, op);
	    } else {
	        var newP = nextFlipPoint(ep, eq, ot, op);
	        flipScanEdgeEvent(tcx, ep, eq, flip_triangle, ot, newP);
	    }
	}
	
	
	// ----------------------------------------------------------------------Exports
	
	exports.triangulate = triangulate;


/***/ },
/* 176 */
/***/ function(module, exports) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 *
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 *
	 * All rights reserved.
	 *
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	"use strict";
	
	/*
	 * Function added in the JavaScript version (was not present in the c++ version)
	 */
	
	/**
	 * assert and throw an exception.
	 *
	 * @private
	 * @param {boolean} condition   the condition which is asserted
	 * @param {string} message      the message which is display is condition is falsy
	 */
	function assert(condition, message) {
	    if (!condition) {
	        throw new Error(message || "Assert Failed");
	    }
	}
	module.exports = assert;
	
	


/***/ },
/* 177 */
/***/ function(module, exports) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	/* jshint maxcomplexity:11 */
	
	"use strict";
	
	
	/*
	 * Note
	 * ====
	 * the structure of this JavaScript version of poly2tri intentionally follows
	 * as closely as possible the structure of the reference C++ version, to make it 
	 * easier to keep the 2 versions in sync.
	 */
	
	
	// -------------------------------------------------------------------------Node
	
	/**
	 * Advancing front node
	 * @constructor
	 * @private
	 * @struct
	 * @param {!XY} p - Point
	 * @param {Triangle=} t triangle (optional)
	 */
	var Node = function(p, t) {
	    /** @type {XY} */
	    this.point = p;
	
	    /** @type {Triangle|null} */
	    this.triangle = t || null;
	
	    /** @type {Node|null} */
	    this.next = null;
	    /** @type {Node|null} */
	    this.prev = null;
	
	    /** @type {number} */
	    this.value = p.x;
	};
	
	// ---------------------------------------------------------------AdvancingFront
	/**
	 * @constructor
	 * @private
	 * @struct
	 * @param {Node} head
	 * @param {Node} tail
	 */
	var AdvancingFront = function(head, tail) {
	    /** @type {Node} */
	    this.head_ = head;
	    /** @type {Node} */
	    this.tail_ = tail;
	    /** @type {Node} */
	    this.search_node_ = head;
	};
	
	/** @return {Node} */
	AdvancingFront.prototype.head = function() {
	    return this.head_;
	};
	
	/** @param {Node} node */
	AdvancingFront.prototype.setHead = function(node) {
	    this.head_ = node;
	};
	
	/** @return {Node} */
	AdvancingFront.prototype.tail = function() {
	    return this.tail_;
	};
	
	/** @param {Node} node */
	AdvancingFront.prototype.setTail = function(node) {
	    this.tail_ = node;
	};
	
	/** @return {Node} */
	AdvancingFront.prototype.search = function() {
	    return this.search_node_;
	};
	
	/** @param {Node} node */
	AdvancingFront.prototype.setSearch = function(node) {
	    this.search_node_ = node;
	};
	
	/** @return {Node} */
	AdvancingFront.prototype.findSearchNode = function(/*x*/) {
	    // TODO: implement BST index
	    return this.search_node_;
	};
	
	/**
	 * @param {number} x value
	 * @return {Node}
	 */
	AdvancingFront.prototype.locateNode = function(x) {
	    var node = this.search_node_;
	
	    /* jshint boss:true */
	    if (x < node.value) {
	        while (node = node.prev) {
	            if (x >= node.value) {
	                this.search_node_ = node;
	                return node;
	            }
	        }
	    } else {
	        while (node = node.next) {
	            if (x < node.value) {
	                this.search_node_ = node.prev;
	                return node.prev;
	            }
	        }
	    }
	    return null;
	};
	
	/**
	 * @param {!XY} point - Point
	 * @return {Node}
	 */
	AdvancingFront.prototype.locatePoint = function(point) {
	    var px = point.x;
	    var node = this.findSearchNode(px);
	    var nx = node.point.x;
	
	    if (px === nx) {
	        // Here we are comparing point references, not values
	        if (point !== node.point) {
	            // We might have two nodes with same x value for a short time
	            if (point === node.prev.point) {
	                node = node.prev;
	            } else if (point === node.next.point) {
	                node = node.next;
	            } else {
	                throw new Error('poly2tri Invalid AdvancingFront.locatePoint() call');
	            }
	        }
	    } else if (px < nx) {
	        /* jshint boss:true */
	        while (node = node.prev) {
	            if (point === node.point) {
	                break;
	            }
	        }
	    } else {
	        while (node = node.next) {
	            if (point === node.point) {
	                break;
	            }
	        }
	    }
	
	    if (node) {
	        this.search_node_ = node;
	    }
	    return node;
	};
	
	
	// ----------------------------------------------------------------------Exports
	
	module.exports = AdvancingFront;
	module.exports.Node = Node;
	


/***/ },
/* 178 */
/***/ function(module, exports) {

	/*
	 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
	 * http://code.google.com/p/poly2tri/
	 * 
	 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
	 * https://github.com/r3mi/poly2tri.js
	 * 
	 * All rights reserved.
	 * 
	 * Distributed under the 3-clause BSD License, see LICENSE.txt
	 */
	
	"use strict";
	
	/**
	 * Precision to detect repeated or collinear points
	 * @private
	 * @const {number}
	 * @default
	 */
	var EPSILON = 1e-12;
	exports.EPSILON = EPSILON;
	
	/**
	 * @private
	 * @enum {number}
	 * @readonly
	 */
	var Orientation = {
	    "CW": 1,
	    "CCW": -1,
	    "COLLINEAR": 0
	};
	exports.Orientation = Orientation;
	
	
	/**
	 * Formula to calculate signed area<br>
	 * Positive if CCW<br>
	 * Negative if CW<br>
	 * 0 if collinear<br>
	 * <pre>
	 * A[P1,P2,P3]  =  (x1*y2 - y1*x2) + (x2*y3 - y2*x3) + (x3*y1 - y3*x1)
	 *              =  (x1-x3)*(y2-y3) - (y1-y3)*(x2-x3)
	 * </pre>
	 *
	 * @private
	 * @param {!XY} pa  point object with {x,y}
	 * @param {!XY} pb  point object with {x,y}
	 * @param {!XY} pc  point object with {x,y}
	 * @return {Orientation}
	 */
	function orient2d(pa, pb, pc) {
	    var detleft = (pa.x - pc.x) * (pb.y - pc.y);
	    var detright = (pa.y - pc.y) * (pb.x - pc.x);
	    var val = detleft - detright;
	    if (val > -(EPSILON) && val < (EPSILON)) {
	        return Orientation.COLLINEAR;
	    } else if (val > 0) {
	        return Orientation.CCW;
	    } else {
	        return Orientation.CW;
	    }
	}
	exports.orient2d = orient2d;
	
	
	/**
	 *
	 * @private
	 * @param {!XY} pa  point object with {x,y}
	 * @param {!XY} pb  point object with {x,y}
	 * @param {!XY} pc  point object with {x,y}
	 * @param {!XY} pd  point object with {x,y}
	 * @return {boolean}
	 */
	function inScanArea(pa, pb, pc, pd) {
	    var oadb = (pa.x - pb.x) * (pd.y - pb.y) - (pd.x - pb.x) * (pa.y - pb.y);
	    if (oadb >= -EPSILON) {
	        return false;
	    }
	
	    var oadc = (pa.x - pc.x) * (pd.y - pc.y) - (pd.x - pc.x) * (pa.y - pc.y);
	    if (oadc <= EPSILON) {
	        return false;
	    }
	    return true;
	}
	exports.inScanArea = inScanArea;
	
	
	/**
	 * Check if the angle between (pa,pb) and (pa,pc) is obtuse i.e. (angle > π/2 || angle < -π/2)
	 *
	 * @private
	 * @param {!XY} pa  point object with {x,y}
	 * @param {!XY} pb  point object with {x,y}
	 * @param {!XY} pc  point object with {x,y}
	 * @return {boolean} true if angle is obtuse
	 */
	function isAngleObtuse(pa, pb, pc) {
	    var ax = pb.x - pa.x;
	    var ay = pb.y - pa.y;
	    var bx = pc.x - pa.x;
	    var by = pc.y - pa.y;
	    return (ax * bx + ay * by) < 0;
	}
	exports.isAngleObtuse = isAngleObtuse;
	


/***/ },
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//there is a weird bug for clipper.js if putting box2dweb at the beginning
	// which will make .AddPolygons become undefined
	window['Box2D'] = __webpack_require__(184);
	
	//needed for global reference to the Clipper lib
	//not quite understand how this works
	//http://stackoverflow.com/questions/12709074/how-do-you-explicitly-set-a-new-property-on-window-in-typescript
	window['ClipperLib'] = __webpack_require__(185);
	
	//var poly2tri = require('poly2tri');

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";/*
	* Copyright (c) 2006-2007 Erin Catto http://www.gphysics.com
	*
	* This software is provided 'as-is', without any express or implied
	* warranty.  In no event will the authors be held liable for any damages
	* arising from the use of this software.
	* Permission is granted to anyone to use this software for any purpose,
	* including commercial applications, and to alter it and redistribute it
	* freely, subject to the following restrictions:
	* 1. The origin of this software must not be misrepresented; you must not
	* claim that you wrote the original software. If you use this software
	* in a product, an acknowledgment in the product documentation would be
	* appreciated but is not required.
	* 2. Altered source versions must be plainly marked as such, and must not be
	* misrepresented as being the original software.
	* 3. This notice may not be removed or altered from any source distribution.
	*/var Box2D={};module.exports=Box2D;(function(a2j,undefined){/*
	  * The following commented out code is probably for old browsers
	  * but will mess up implementation of newer browsers and cause
	  * extraneous behavior on other libraries that depend on
	  * the prototype chain implementation
	  *///  if(!(Object.prototype.defineProperty instanceof Function)
	//     && Object.prototype.__defineGetter__ instanceof Function
	//     && Object.prototype.__defineSetter__ instanceof Function)
	//  {
	//     Object.defineProperty = function(obj, p, cfg) {
	//        if(cfg.get instanceof Function)
	//           obj.__defineGetter__(p, cfg.get);
	//        if(cfg.set instanceof Function)
	//           obj.__defineSetter__(p, cfg.set);
	//     }
	//  }
	function emptyFn(){};a2j.inherit=function(cls,base){var tmpCtr=cls;emptyFn.prototype=base.prototype;cls.prototype=new emptyFn();cls.prototype.constructor=tmpCtr;};a2j.generateCallback=function generateCallback(context,cb){return function(){cb.apply(context,arguments);};};a2j.NVector=function NVector(length){if(length===undefined)length=0;var tmp=new Array(length||0);for(var i=0;i<length;++i){tmp[i]=0;}return tmp;};a2j.is=function is(o1,o2){if(o1===null)return false;if(o2 instanceof Function&&o1 instanceof o2)return true;if(o1.constructor.__implements!=undefined&&o1.constructor.__implements[o2])return true;return false;};a2j.parseUInt=function(v){return Math.abs(parseInt(v));};})(Box2D);//#TODO remove assignments from global namespace
	var Vector=Array;var Vector_a2j_Number=Box2D.NVector;//package structure
	if(typeof Box2D==="undefined")Box2D={};if(typeof Box2D.Collision==="undefined")Box2D.Collision={};if(typeof Box2D.Collision.Shapes==="undefined")Box2D.Collision.Shapes={};if(typeof Box2D.Common==="undefined")Box2D.Common={};if(typeof Box2D.Common.Math==="undefined")Box2D.Common.Math={};if(typeof Box2D.Dynamics==="undefined")Box2D.Dynamics={};if(typeof Box2D.Dynamics.Contacts==="undefined")Box2D.Dynamics.Contacts={};if(typeof Box2D.Dynamics.Controllers==="undefined")Box2D.Dynamics.Controllers={};if(typeof Box2D.Dynamics.Joints==="undefined")Box2D.Dynamics.Joints={};//pre-definitions
	(function(){Box2D.Collision.IBroadPhase='Box2D.Collision.IBroadPhase';function b2AABB(){b2AABB.b2AABB.apply(this,arguments);};Box2D.Collision.b2AABB=b2AABB;function b2Bound(){b2Bound.b2Bound.apply(this,arguments);};Box2D.Collision.b2Bound=b2Bound;function b2BoundValues(){b2BoundValues.b2BoundValues.apply(this,arguments);if(this.constructor===b2BoundValues)this.b2BoundValues.apply(this,arguments);};Box2D.Collision.b2BoundValues=b2BoundValues;function b2Collision(){b2Collision.b2Collision.apply(this,arguments);};Box2D.Collision.b2Collision=b2Collision;function b2ContactID(){b2ContactID.b2ContactID.apply(this,arguments);if(this.constructor===b2ContactID)this.b2ContactID.apply(this,arguments);};Box2D.Collision.b2ContactID=b2ContactID;function b2ContactPoint(){b2ContactPoint.b2ContactPoint.apply(this,arguments);};Box2D.Collision.b2ContactPoint=b2ContactPoint;function b2Distance(){b2Distance.b2Distance.apply(this,arguments);};Box2D.Collision.b2Distance=b2Distance;function b2DistanceInput(){b2DistanceInput.b2DistanceInput.apply(this,arguments);};Box2D.Collision.b2DistanceInput=b2DistanceInput;function b2DistanceOutput(){b2DistanceOutput.b2DistanceOutput.apply(this,arguments);};Box2D.Collision.b2DistanceOutput=b2DistanceOutput;function b2DistanceProxy(){b2DistanceProxy.b2DistanceProxy.apply(this,arguments);};Box2D.Collision.b2DistanceProxy=b2DistanceProxy;function b2DynamicTree(){b2DynamicTree.b2DynamicTree.apply(this,arguments);if(this.constructor===b2DynamicTree)this.b2DynamicTree.apply(this,arguments);};Box2D.Collision.b2DynamicTree=b2DynamicTree;function b2DynamicTreeBroadPhase(){b2DynamicTreeBroadPhase.b2DynamicTreeBroadPhase.apply(this,arguments);};Box2D.Collision.b2DynamicTreeBroadPhase=b2DynamicTreeBroadPhase;function b2DynamicTreeNode(){b2DynamicTreeNode.b2DynamicTreeNode.apply(this,arguments);};Box2D.Collision.b2DynamicTreeNode=b2DynamicTreeNode;function b2DynamicTreePair(){b2DynamicTreePair.b2DynamicTreePair.apply(this,arguments);};Box2D.Collision.b2DynamicTreePair=b2DynamicTreePair;function b2Manifold(){b2Manifold.b2Manifold.apply(this,arguments);if(this.constructor===b2Manifold)this.b2Manifold.apply(this,arguments);};Box2D.Collision.b2Manifold=b2Manifold;function b2ManifoldPoint(){b2ManifoldPoint.b2ManifoldPoint.apply(this,arguments);if(this.constructor===b2ManifoldPoint)this.b2ManifoldPoint.apply(this,arguments);};Box2D.Collision.b2ManifoldPoint=b2ManifoldPoint;function b2Point(){b2Point.b2Point.apply(this,arguments);};Box2D.Collision.b2Point=b2Point;function b2RayCastInput(){b2RayCastInput.b2RayCastInput.apply(this,arguments);if(this.constructor===b2RayCastInput)this.b2RayCastInput.apply(this,arguments);};Box2D.Collision.b2RayCastInput=b2RayCastInput;function b2RayCastOutput(){b2RayCastOutput.b2RayCastOutput.apply(this,arguments);};Box2D.Collision.b2RayCastOutput=b2RayCastOutput;function b2Segment(){b2Segment.b2Segment.apply(this,arguments);};Box2D.Collision.b2Segment=b2Segment;function b2SeparationFunction(){b2SeparationFunction.b2SeparationFunction.apply(this,arguments);};Box2D.Collision.b2SeparationFunction=b2SeparationFunction;function b2Simplex(){b2Simplex.b2Simplex.apply(this,arguments);if(this.constructor===b2Simplex)this.b2Simplex.apply(this,arguments);};Box2D.Collision.b2Simplex=b2Simplex;function b2SimplexCache(){b2SimplexCache.b2SimplexCache.apply(this,arguments);};Box2D.Collision.b2SimplexCache=b2SimplexCache;function b2SimplexVertex(){b2SimplexVertex.b2SimplexVertex.apply(this,arguments);};Box2D.Collision.b2SimplexVertex=b2SimplexVertex;function b2TimeOfImpact(){b2TimeOfImpact.b2TimeOfImpact.apply(this,arguments);};Box2D.Collision.b2TimeOfImpact=b2TimeOfImpact;function b2TOIInput(){b2TOIInput.b2TOIInput.apply(this,arguments);};Box2D.Collision.b2TOIInput=b2TOIInput;function b2WorldManifold(){b2WorldManifold.b2WorldManifold.apply(this,arguments);if(this.constructor===b2WorldManifold)this.b2WorldManifold.apply(this,arguments);};Box2D.Collision.b2WorldManifold=b2WorldManifold;function ClipVertex(){ClipVertex.ClipVertex.apply(this,arguments);};Box2D.Collision.ClipVertex=ClipVertex;function Features(){Features.Features.apply(this,arguments);};Box2D.Collision.Features=Features;function b2CircleShape(){b2CircleShape.b2CircleShape.apply(this,arguments);if(this.constructor===b2CircleShape)this.b2CircleShape.apply(this,arguments);};Box2D.Collision.Shapes.b2CircleShape=b2CircleShape;function b2EdgeChainDef(){b2EdgeChainDef.b2EdgeChainDef.apply(this,arguments);if(this.constructor===b2EdgeChainDef)this.b2EdgeChainDef.apply(this,arguments);};Box2D.Collision.Shapes.b2EdgeChainDef=b2EdgeChainDef;function b2EdgeShape(){b2EdgeShape.b2EdgeShape.apply(this,arguments);if(this.constructor===b2EdgeShape)this.b2EdgeShape.apply(this,arguments);};Box2D.Collision.Shapes.b2EdgeShape=b2EdgeShape;function b2MassData(){b2MassData.b2MassData.apply(this,arguments);};Box2D.Collision.Shapes.b2MassData=b2MassData;function b2PolygonShape(){b2PolygonShape.b2PolygonShape.apply(this,arguments);if(this.constructor===b2PolygonShape)this.b2PolygonShape.apply(this,arguments);};Box2D.Collision.Shapes.b2PolygonShape=b2PolygonShape;function b2Shape(){b2Shape.b2Shape.apply(this,arguments);if(this.constructor===b2Shape)this.b2Shape.apply(this,arguments);};Box2D.Collision.Shapes.b2Shape=b2Shape;Box2D.Common.b2internal='Box2D.Common.b2internal';function b2Color(){b2Color.b2Color.apply(this,arguments);if(this.constructor===b2Color)this.b2Color.apply(this,arguments);};Box2D.Common.b2Color=b2Color;function b2Settings(){b2Settings.b2Settings.apply(this,arguments);};Box2D.Common.b2Settings=b2Settings;function b2Mat22(){b2Mat22.b2Mat22.apply(this,arguments);if(this.constructor===b2Mat22)this.b2Mat22.apply(this,arguments);};Box2D.Common.Math.b2Mat22=b2Mat22;function b2Mat33(){b2Mat33.b2Mat33.apply(this,arguments);if(this.constructor===b2Mat33)this.b2Mat33.apply(this,arguments);};Box2D.Common.Math.b2Mat33=b2Mat33;function b2Math(){b2Math.b2Math.apply(this,arguments);};Box2D.Common.Math.b2Math=b2Math;function b2Sweep(){b2Sweep.b2Sweep.apply(this,arguments);};Box2D.Common.Math.b2Sweep=b2Sweep;function b2Transform(){b2Transform.b2Transform.apply(this,arguments);if(this.constructor===b2Transform)this.b2Transform.apply(this,arguments);};Box2D.Common.Math.b2Transform=b2Transform;function b2Vec2(){b2Vec2.b2Vec2.apply(this,arguments);if(this.constructor===b2Vec2)this.b2Vec2.apply(this,arguments);};Box2D.Common.Math.b2Vec2=b2Vec2;function b2Vec3(){b2Vec3.b2Vec3.apply(this,arguments);if(this.constructor===b2Vec3)this.b2Vec3.apply(this,arguments);};Box2D.Common.Math.b2Vec3=b2Vec3;function b2Body(){b2Body.b2Body.apply(this,arguments);if(this.constructor===b2Body)this.b2Body.apply(this,arguments);};Box2D.Dynamics.b2Body=b2Body;function b2BodyDef(){b2BodyDef.b2BodyDef.apply(this,arguments);if(this.constructor===b2BodyDef)this.b2BodyDef.apply(this,arguments);};Box2D.Dynamics.b2BodyDef=b2BodyDef;function b2ContactFilter(){b2ContactFilter.b2ContactFilter.apply(this,arguments);};Box2D.Dynamics.b2ContactFilter=b2ContactFilter;function b2ContactImpulse(){b2ContactImpulse.b2ContactImpulse.apply(this,arguments);};Box2D.Dynamics.b2ContactImpulse=b2ContactImpulse;function b2ContactListener(){b2ContactListener.b2ContactListener.apply(this,arguments);};Box2D.Dynamics.b2ContactListener=b2ContactListener;function b2ContactManager(){b2ContactManager.b2ContactManager.apply(this,arguments);if(this.constructor===b2ContactManager)this.b2ContactManager.apply(this,arguments);};Box2D.Dynamics.b2ContactManager=b2ContactManager;function b2DebugDraw(){b2DebugDraw.b2DebugDraw.apply(this,arguments);if(this.constructor===b2DebugDraw)this.b2DebugDraw.apply(this,arguments);};Box2D.Dynamics.b2DebugDraw=b2DebugDraw;function b2DestructionListener(){b2DestructionListener.b2DestructionListener.apply(this,arguments);};Box2D.Dynamics.b2DestructionListener=b2DestructionListener;function b2FilterData(){b2FilterData.b2FilterData.apply(this,arguments);};Box2D.Dynamics.b2FilterData=b2FilterData;function b2Fixture(){b2Fixture.b2Fixture.apply(this,arguments);if(this.constructor===b2Fixture)this.b2Fixture.apply(this,arguments);};Box2D.Dynamics.b2Fixture=b2Fixture;function b2FixtureDef(){b2FixtureDef.b2FixtureDef.apply(this,arguments);if(this.constructor===b2FixtureDef)this.b2FixtureDef.apply(this,arguments);};Box2D.Dynamics.b2FixtureDef=b2FixtureDef;function b2Island(){b2Island.b2Island.apply(this,arguments);if(this.constructor===b2Island)this.b2Island.apply(this,arguments);};Box2D.Dynamics.b2Island=b2Island;function b2TimeStep(){b2TimeStep.b2TimeStep.apply(this,arguments);};Box2D.Dynamics.b2TimeStep=b2TimeStep;function b2World(){b2World.b2World.apply(this,arguments);if(this.constructor===b2World)this.b2World.apply(this,arguments);};Box2D.Dynamics.b2World=b2World;function b2CircleContact(){b2CircleContact.b2CircleContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2CircleContact=b2CircleContact;function b2Contact(){b2Contact.b2Contact.apply(this,arguments);if(this.constructor===b2Contact)this.b2Contact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2Contact=b2Contact;function b2ContactConstraint(){b2ContactConstraint.b2ContactConstraint.apply(this,arguments);if(this.constructor===b2ContactConstraint)this.b2ContactConstraint.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactConstraint=b2ContactConstraint;function b2ContactConstraintPoint(){b2ContactConstraintPoint.b2ContactConstraintPoint.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactConstraintPoint=b2ContactConstraintPoint;function b2ContactEdge(){b2ContactEdge.b2ContactEdge.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactEdge=b2ContactEdge;function b2ContactFactory(){b2ContactFactory.b2ContactFactory.apply(this,arguments);if(this.constructor===b2ContactFactory)this.b2ContactFactory.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactFactory=b2ContactFactory;function b2ContactRegister(){b2ContactRegister.b2ContactRegister.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactRegister=b2ContactRegister;function b2ContactResult(){b2ContactResult.b2ContactResult.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactResult=b2ContactResult;function b2ContactSolver(){b2ContactSolver.b2ContactSolver.apply(this,arguments);if(this.constructor===b2ContactSolver)this.b2ContactSolver.apply(this,arguments);};Box2D.Dynamics.Contacts.b2ContactSolver=b2ContactSolver;function b2EdgeAndCircleContact(){b2EdgeAndCircleContact.b2EdgeAndCircleContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2EdgeAndCircleContact=b2EdgeAndCircleContact;function b2NullContact(){b2NullContact.b2NullContact.apply(this,arguments);if(this.constructor===b2NullContact)this.b2NullContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2NullContact=b2NullContact;function b2PolyAndCircleContact(){b2PolyAndCircleContact.b2PolyAndCircleContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2PolyAndCircleContact=b2PolyAndCircleContact;function b2PolyAndEdgeContact(){b2PolyAndEdgeContact.b2PolyAndEdgeContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2PolyAndEdgeContact=b2PolyAndEdgeContact;function b2PolygonContact(){b2PolygonContact.b2PolygonContact.apply(this,arguments);};Box2D.Dynamics.Contacts.b2PolygonContact=b2PolygonContact;function b2PositionSolverManifold(){b2PositionSolverManifold.b2PositionSolverManifold.apply(this,arguments);if(this.constructor===b2PositionSolverManifold)this.b2PositionSolverManifold.apply(this,arguments);};Box2D.Dynamics.Contacts.b2PositionSolverManifold=b2PositionSolverManifold;function b2BuoyancyController(){b2BuoyancyController.b2BuoyancyController.apply(this,arguments);};Box2D.Dynamics.Controllers.b2BuoyancyController=b2BuoyancyController;function b2ConstantAccelController(){b2ConstantAccelController.b2ConstantAccelController.apply(this,arguments);};Box2D.Dynamics.Controllers.b2ConstantAccelController=b2ConstantAccelController;function b2ConstantForceController(){b2ConstantForceController.b2ConstantForceController.apply(this,arguments);};Box2D.Dynamics.Controllers.b2ConstantForceController=b2ConstantForceController;function b2Controller(){b2Controller.b2Controller.apply(this,arguments);};Box2D.Dynamics.Controllers.b2Controller=b2Controller;function b2ControllerEdge(){b2ControllerEdge.b2ControllerEdge.apply(this,arguments);};Box2D.Dynamics.Controllers.b2ControllerEdge=b2ControllerEdge;function b2GravityController(){b2GravityController.b2GravityController.apply(this,arguments);};Box2D.Dynamics.Controllers.b2GravityController=b2GravityController;function b2TensorDampingController(){b2TensorDampingController.b2TensorDampingController.apply(this,arguments);};Box2D.Dynamics.Controllers.b2TensorDampingController=b2TensorDampingController;function b2DistanceJoint(){b2DistanceJoint.b2DistanceJoint.apply(this,arguments);if(this.constructor===b2DistanceJoint)this.b2DistanceJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2DistanceJoint=b2DistanceJoint;function b2DistanceJointDef(){b2DistanceJointDef.b2DistanceJointDef.apply(this,arguments);if(this.constructor===b2DistanceJointDef)this.b2DistanceJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2DistanceJointDef=b2DistanceJointDef;function b2FrictionJoint(){b2FrictionJoint.b2FrictionJoint.apply(this,arguments);if(this.constructor===b2FrictionJoint)this.b2FrictionJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2FrictionJoint=b2FrictionJoint;function b2FrictionJointDef(){b2FrictionJointDef.b2FrictionJointDef.apply(this,arguments);if(this.constructor===b2FrictionJointDef)this.b2FrictionJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2FrictionJointDef=b2FrictionJointDef;function b2GearJoint(){b2GearJoint.b2GearJoint.apply(this,arguments);if(this.constructor===b2GearJoint)this.b2GearJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2GearJoint=b2GearJoint;function b2GearJointDef(){b2GearJointDef.b2GearJointDef.apply(this,arguments);if(this.constructor===b2GearJointDef)this.b2GearJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2GearJointDef=b2GearJointDef;function b2Jacobian(){b2Jacobian.b2Jacobian.apply(this,arguments);};Box2D.Dynamics.Joints.b2Jacobian=b2Jacobian;function b2Joint(){b2Joint.b2Joint.apply(this,arguments);if(this.constructor===b2Joint)this.b2Joint.apply(this,arguments);};Box2D.Dynamics.Joints.b2Joint=b2Joint;function b2JointDef(){b2JointDef.b2JointDef.apply(this,arguments);if(this.constructor===b2JointDef)this.b2JointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2JointDef=b2JointDef;function b2JointEdge(){b2JointEdge.b2JointEdge.apply(this,arguments);};Box2D.Dynamics.Joints.b2JointEdge=b2JointEdge;function b2LineJoint(){b2LineJoint.b2LineJoint.apply(this,arguments);if(this.constructor===b2LineJoint)this.b2LineJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2LineJoint=b2LineJoint;function b2LineJointDef(){b2LineJointDef.b2LineJointDef.apply(this,arguments);if(this.constructor===b2LineJointDef)this.b2LineJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2LineJointDef=b2LineJointDef;function b2MouseJoint(){b2MouseJoint.b2MouseJoint.apply(this,arguments);if(this.constructor===b2MouseJoint)this.b2MouseJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2MouseJoint=b2MouseJoint;function b2MouseJointDef(){b2MouseJointDef.b2MouseJointDef.apply(this,arguments);if(this.constructor===b2MouseJointDef)this.b2MouseJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2MouseJointDef=b2MouseJointDef;function b2PrismaticJoint(){b2PrismaticJoint.b2PrismaticJoint.apply(this,arguments);if(this.constructor===b2PrismaticJoint)this.b2PrismaticJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2PrismaticJoint=b2PrismaticJoint;function b2PrismaticJointDef(){b2PrismaticJointDef.b2PrismaticJointDef.apply(this,arguments);if(this.constructor===b2PrismaticJointDef)this.b2PrismaticJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2PrismaticJointDef=b2PrismaticJointDef;function b2PulleyJoint(){b2PulleyJoint.b2PulleyJoint.apply(this,arguments);if(this.constructor===b2PulleyJoint)this.b2PulleyJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2PulleyJoint=b2PulleyJoint;function b2PulleyJointDef(){b2PulleyJointDef.b2PulleyJointDef.apply(this,arguments);if(this.constructor===b2PulleyJointDef)this.b2PulleyJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2PulleyJointDef=b2PulleyJointDef;function b2RevoluteJoint(){b2RevoluteJoint.b2RevoluteJoint.apply(this,arguments);if(this.constructor===b2RevoluteJoint)this.b2RevoluteJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2RevoluteJoint=b2RevoluteJoint;function b2RevoluteJointDef(){b2RevoluteJointDef.b2RevoluteJointDef.apply(this,arguments);if(this.constructor===b2RevoluteJointDef)this.b2RevoluteJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2RevoluteJointDef=b2RevoluteJointDef;function b2WeldJoint(){b2WeldJoint.b2WeldJoint.apply(this,arguments);if(this.constructor===b2WeldJoint)this.b2WeldJoint.apply(this,arguments);};Box2D.Dynamics.Joints.b2WeldJoint=b2WeldJoint;function b2WeldJointDef(){b2WeldJointDef.b2WeldJointDef.apply(this,arguments);if(this.constructor===b2WeldJointDef)this.b2WeldJointDef.apply(this,arguments);};Box2D.Dynamics.Joints.b2WeldJointDef=b2WeldJointDef;})();//definitions
	Box2D.postDefs=[];(function(){var b2CircleShape=Box2D.Collision.Shapes.b2CircleShape,b2EdgeChainDef=Box2D.Collision.Shapes.b2EdgeChainDef,b2EdgeShape=Box2D.Collision.Shapes.b2EdgeShape,b2MassData=Box2D.Collision.Shapes.b2MassData,b2PolygonShape=Box2D.Collision.Shapes.b2PolygonShape,b2Shape=Box2D.Collision.Shapes.b2Shape,b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2AABB=Box2D.Collision.b2AABB,b2Bound=Box2D.Collision.b2Bound,b2BoundValues=Box2D.Collision.b2BoundValues,b2Collision=Box2D.Collision.b2Collision,b2ContactID=Box2D.Collision.b2ContactID,b2ContactPoint=Box2D.Collision.b2ContactPoint,b2Distance=Box2D.Collision.b2Distance,b2DistanceInput=Box2D.Collision.b2DistanceInput,b2DistanceOutput=Box2D.Collision.b2DistanceOutput,b2DistanceProxy=Box2D.Collision.b2DistanceProxy,b2DynamicTree=Box2D.Collision.b2DynamicTree,b2DynamicTreeBroadPhase=Box2D.Collision.b2DynamicTreeBroadPhase,b2DynamicTreeNode=Box2D.Collision.b2DynamicTreeNode,b2DynamicTreePair=Box2D.Collision.b2DynamicTreePair,b2Manifold=Box2D.Collision.b2Manifold,b2ManifoldPoint=Box2D.Collision.b2ManifoldPoint,b2Point=Box2D.Collision.b2Point,b2RayCastInput=Box2D.Collision.b2RayCastInput,b2RayCastOutput=Box2D.Collision.b2RayCastOutput,b2Segment=Box2D.Collision.b2Segment,b2SeparationFunction=Box2D.Collision.b2SeparationFunction,b2Simplex=Box2D.Collision.b2Simplex,b2SimplexCache=Box2D.Collision.b2SimplexCache,b2SimplexVertex=Box2D.Collision.b2SimplexVertex,b2TimeOfImpact=Box2D.Collision.b2TimeOfImpact,b2TOIInput=Box2D.Collision.b2TOIInput,b2WorldManifold=Box2D.Collision.b2WorldManifold,ClipVertex=Box2D.Collision.ClipVertex,Features=Box2D.Collision.Features,IBroadPhase=Box2D.Collision.IBroadPhase;b2AABB.b2AABB=function(){this.lowerBound=new b2Vec2();this.upperBound=new b2Vec2();};b2AABB.prototype.IsValid=function(){var dX=this.upperBound.x-this.lowerBound.x;var dY=this.upperBound.y-this.lowerBound.y;var valid=dX>=0.0&&dY>=0.0;valid=valid&&this.lowerBound.IsValid()&&this.upperBound.IsValid();return valid;};b2AABB.prototype.GetCenter=function(){return new b2Vec2((this.lowerBound.x+this.upperBound.x)/2,(this.lowerBound.y+this.upperBound.y)/2);};b2AABB.prototype.GetExtents=function(){return new b2Vec2((this.upperBound.x-this.lowerBound.x)/2,(this.upperBound.y-this.lowerBound.y)/2);};b2AABB.prototype.Contains=function(aabb){var result=true;result=result&&this.lowerBound.x<=aabb.lowerBound.x;result=result&&this.lowerBound.y<=aabb.lowerBound.y;result=result&&aabb.upperBound.x<=this.upperBound.x;result=result&&aabb.upperBound.y<=this.upperBound.y;return result;};b2AABB.prototype.RayCast=function(output,input){var tmin=-Number.MAX_VALUE;var tmax=Number.MAX_VALUE;var pX=input.p1.x;var pY=input.p1.y;var dX=input.p2.x-input.p1.x;var dY=input.p2.y-input.p1.y;var absDX=Math.abs(dX);var absDY=Math.abs(dY);var normal=output.normal;var inv_d=0;var t1=0;var t2=0;var t3=0;var s=0;{if(absDX<Number.MIN_VALUE){if(pX<this.lowerBound.x||this.upperBound.x<pX)return false;}else{inv_d=1.0/dX;t1=(this.lowerBound.x-pX)*inv_d;t2=(this.upperBound.x-pX)*inv_d;s=-1.0;if(t1>t2){t3=t1;t1=t2;t2=t3;s=1.0;}if(t1>tmin){normal.x=s;normal.y=0;tmin=t1;}tmax=Math.min(tmax,t2);if(tmin>tmax)return false;}}{if(absDY<Number.MIN_VALUE){if(pY<this.lowerBound.y||this.upperBound.y<pY)return false;}else{inv_d=1.0/dY;t1=(this.lowerBound.y-pY)*inv_d;t2=(this.upperBound.y-pY)*inv_d;s=-1.0;if(t1>t2){t3=t1;t1=t2;t2=t3;s=1.0;}if(t1>tmin){normal.y=s;normal.x=0;tmin=t1;}tmax=Math.min(tmax,t2);if(tmin>tmax)return false;}}output.fraction=tmin;return true;};b2AABB.prototype.TestOverlap=function(other){var d1X=other.lowerBound.x-this.upperBound.x;var d1Y=other.lowerBound.y-this.upperBound.y;var d2X=this.lowerBound.x-other.upperBound.x;var d2Y=this.lowerBound.y-other.upperBound.y;if(d1X>0.0||d1Y>0.0)return false;if(d2X>0.0||d2Y>0.0)return false;return true;};b2AABB.Combine=function(aabb1,aabb2){var aabb=new b2AABB();aabb.Combine(aabb1,aabb2);return aabb;};b2AABB.prototype.Combine=function(aabb1,aabb2){this.lowerBound.x=Math.min(aabb1.lowerBound.x,aabb2.lowerBound.x);this.lowerBound.y=Math.min(aabb1.lowerBound.y,aabb2.lowerBound.y);this.upperBound.x=Math.max(aabb1.upperBound.x,aabb2.upperBound.x);this.upperBound.y=Math.max(aabb1.upperBound.y,aabb2.upperBound.y);};b2Bound.b2Bound=function(){};b2Bound.prototype.IsLower=function(){return(this.value&1)==0;};b2Bound.prototype.IsUpper=function(){return(this.value&1)==1;};b2Bound.prototype.Swap=function(b){var tempValue=this.value;var tempProxy=this.proxy;var tempStabbingCount=this.stabbingCount;this.value=b.value;this.proxy=b.proxy;this.stabbingCount=b.stabbingCount;b.value=tempValue;b.proxy=tempProxy;b.stabbingCount=tempStabbingCount;};b2BoundValues.b2BoundValues=function(){};b2BoundValues.prototype.b2BoundValues=function(){this.lowerValues=new Vector_a2j_Number();this.lowerValues[0]=0.0;this.lowerValues[1]=0.0;this.upperValues=new Vector_a2j_Number();this.upperValues[0]=0.0;this.upperValues[1]=0.0;};b2Collision.b2Collision=function(){};b2Collision.ClipSegmentToLine=function(vOut,vIn,normal,offset){if(offset===undefined)offset=0;var cv;var numOut=0;cv=vIn[0];var vIn0=cv.v;cv=vIn[1];var vIn1=cv.v;var distance0=normal.x*vIn0.x+normal.y*vIn0.y-offset;var distance1=normal.x*vIn1.x+normal.y*vIn1.y-offset;if(distance0<=0.0)vOut[numOut++].Set(vIn[0]);if(distance1<=0.0)vOut[numOut++].Set(vIn[1]);if(distance0*distance1<0.0){var interp=distance0/(distance0-distance1);cv=vOut[numOut];var tVec=cv.v;tVec.x=vIn0.x+interp*(vIn1.x-vIn0.x);tVec.y=vIn0.y+interp*(vIn1.y-vIn0.y);cv=vOut[numOut];var cv2;if(distance0>0.0){cv2=vIn[0];cv.id=cv2.id;}else{cv2=vIn[1];cv.id=cv2.id;}++numOut;}return numOut;};b2Collision.EdgeSeparation=function(poly1,xf1,edge1,poly2,xf2){if(edge1===undefined)edge1=0;var count1=parseInt(poly1.m_vertexCount);var vertices1=poly1.m_vertices;var normals1=poly1.m_normals;var count2=parseInt(poly2.m_vertexCount);var vertices2=poly2.m_vertices;var tMat;var tVec;tMat=xf1.R;tVec=normals1[edge1];var normal1WorldX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;var normal1WorldY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=xf2.R;var normal1X=tMat.col1.x*normal1WorldX+tMat.col1.y*normal1WorldY;var normal1Y=tMat.col2.x*normal1WorldX+tMat.col2.y*normal1WorldY;var index=0;var minDot=Number.MAX_VALUE;for(var i=0;i<count2;++i){tVec=vertices2[i];var dot=tVec.x*normal1X+tVec.y*normal1Y;if(dot<minDot){minDot=dot;index=i;}}tVec=vertices1[edge1];tMat=xf1.R;var v1X=xf1.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var v1Y=xf1.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=vertices2[index];tMat=xf2.R;var v2X=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var v2Y=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);v2X-=v1X;v2Y-=v1Y;var separation=v2X*normal1WorldX+v2Y*normal1WorldY;return separation;};b2Collision.FindMaxSeparation=function(edgeIndex,poly1,xf1,poly2,xf2){var count1=parseInt(poly1.m_vertexCount);var normals1=poly1.m_normals;var tVec;var tMat;tMat=xf2.R;tVec=poly2.m_centroid;var dX=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var dY=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tMat=xf1.R;tVec=poly1.m_centroid;dX-=xf1.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);dY-=xf1.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);var dLocal1X=dX*xf1.R.col1.x+dY*xf1.R.col1.y;var dLocal1Y=dX*xf1.R.col2.x+dY*xf1.R.col2.y;var edge=0;var maxDot=-Number.MAX_VALUE;for(var i=0;i<count1;++i){tVec=normals1[i];var dot=tVec.x*dLocal1X+tVec.y*dLocal1Y;if(dot>maxDot){maxDot=dot;edge=i;}}var s=b2Collision.EdgeSeparation(poly1,xf1,edge,poly2,xf2);var prevEdge=parseInt(edge-1>=0?edge-1:count1-1);var sPrev=b2Collision.EdgeSeparation(poly1,xf1,prevEdge,poly2,xf2);var nextEdge=parseInt(edge+1<count1?edge+1:0);var sNext=b2Collision.EdgeSeparation(poly1,xf1,nextEdge,poly2,xf2);var bestEdge=0;var bestSeparation=0;var increment=0;if(sPrev>s&&sPrev>sNext){increment=-1;bestEdge=prevEdge;bestSeparation=sPrev;}else if(sNext>s){increment=1;bestEdge=nextEdge;bestSeparation=sNext;}else{edgeIndex[0]=edge;return s;}while(true){if(increment==-1)edge=bestEdge-1>=0?bestEdge-1:count1-1;else edge=bestEdge+1<count1?bestEdge+1:0;s=b2Collision.EdgeSeparation(poly1,xf1,edge,poly2,xf2);if(s>bestSeparation){bestEdge=edge;bestSeparation=s;}else{break;}}edgeIndex[0]=bestEdge;return bestSeparation;};b2Collision.FindIncidentEdge=function(c,poly1,xf1,edge1,poly2,xf2){if(edge1===undefined)edge1=0;var count1=parseInt(poly1.m_vertexCount);var normals1=poly1.m_normals;var count2=parseInt(poly2.m_vertexCount);var vertices2=poly2.m_vertices;var normals2=poly2.m_normals;var tMat;var tVec;tMat=xf1.R;tVec=normals1[edge1];var normal1X=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;var normal1Y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=xf2.R;var tX=tMat.col1.x*normal1X+tMat.col1.y*normal1Y;normal1Y=tMat.col2.x*normal1X+tMat.col2.y*normal1Y;normal1X=tX;var index=0;var minDot=Number.MAX_VALUE;for(var i=0;i<count2;++i){tVec=normals2[i];var dot=normal1X*tVec.x+normal1Y*tVec.y;if(dot<minDot){minDot=dot;index=i;}}var tClip;var i1=parseInt(index);var i2=parseInt(i1+1<count2?i1+1:0);tClip=c[0];tVec=vertices2[i1];tMat=xf2.R;tClip.v.x=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);tClip.v.y=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tClip.id.features.referenceEdge=edge1;tClip.id.features.incidentEdge=i1;tClip.id.features.incidentVertex=0;tClip=c[1];tVec=vertices2[i2];tMat=xf2.R;tClip.v.x=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);tClip.v.y=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tClip.id.features.referenceEdge=edge1;tClip.id.features.incidentEdge=i2;tClip.id.features.incidentVertex=1;};b2Collision.MakeClipPointVector=function(){var r=new Vector(2);r[0]=new ClipVertex();r[1]=new ClipVertex();return r;};b2Collision.CollidePolygons=function(manifold,polyA,xfA,polyB,xfB){var cv;manifold.m_pointCount=0;var totalRadius=polyA.m_radius+polyB.m_radius;var edgeA=0;b2Collision.s_edgeAO[0]=edgeA;var separationA=b2Collision.FindMaxSeparation(b2Collision.s_edgeAO,polyA,xfA,polyB,xfB);edgeA=b2Collision.s_edgeAO[0];if(separationA>totalRadius)return;var edgeB=0;b2Collision.s_edgeBO[0]=edgeB;var separationB=b2Collision.FindMaxSeparation(b2Collision.s_edgeBO,polyB,xfB,polyA,xfA);edgeB=b2Collision.s_edgeBO[0];if(separationB>totalRadius)return;var poly1;var poly2;var xf1;var xf2;var edge1=0;var flip=0;var k_relativeTol=0.98;var k_absoluteTol=0.001;var tMat;if(separationB>k_relativeTol*separationA+k_absoluteTol){poly1=polyB;poly2=polyA;xf1=xfB;xf2=xfA;edge1=edgeB;manifold.m_type=b2Manifold.e_faceB;flip=1;}else{poly1=polyA;poly2=polyB;xf1=xfA;xf2=xfB;edge1=edgeA;manifold.m_type=b2Manifold.e_faceA;flip=0;}var incidentEdge=b2Collision.s_incidentEdge;b2Collision.FindIncidentEdge(incidentEdge,poly1,xf1,edge1,poly2,xf2);var count1=parseInt(poly1.m_vertexCount);var vertices1=poly1.m_vertices;var local_v11=vertices1[edge1];var local_v12;if(edge1+1<count1){local_v12=vertices1[parseInt(edge1+1)];}else{local_v12=vertices1[0];}var localTangent=b2Collision.s_localTangent;localTangent.Set(local_v12.x-local_v11.x,local_v12.y-local_v11.y);localTangent.Normalize();var localNormal=b2Collision.s_localNormal;localNormal.x=localTangent.y;localNormal.y=-localTangent.x;var planePoint=b2Collision.s_planePoint;planePoint.Set(0.5*(local_v11.x+local_v12.x),0.5*(local_v11.y+local_v12.y));var tangent=b2Collision.s_tangent;tMat=xf1.R;tangent.x=tMat.col1.x*localTangent.x+tMat.col2.x*localTangent.y;tangent.y=tMat.col1.y*localTangent.x+tMat.col2.y*localTangent.y;var tangent2=b2Collision.s_tangent2;tangent2.x=-tangent.x;tangent2.y=-tangent.y;var normal=b2Collision.s_normal;normal.x=tangent.y;normal.y=-tangent.x;var v11=b2Collision.s_v11;var v12=b2Collision.s_v12;v11.x=xf1.position.x+(tMat.col1.x*local_v11.x+tMat.col2.x*local_v11.y);v11.y=xf1.position.y+(tMat.col1.y*local_v11.x+tMat.col2.y*local_v11.y);v12.x=xf1.position.x+(tMat.col1.x*local_v12.x+tMat.col2.x*local_v12.y);v12.y=xf1.position.y+(tMat.col1.y*local_v12.x+tMat.col2.y*local_v12.y);var frontOffset=normal.x*v11.x+normal.y*v11.y;var sideOffset1=-tangent.x*v11.x-tangent.y*v11.y+totalRadius;var sideOffset2=tangent.x*v12.x+tangent.y*v12.y+totalRadius;var clipPoints1=b2Collision.s_clipPoints1;var clipPoints2=b2Collision.s_clipPoints2;var np=0;np=b2Collision.ClipSegmentToLine(clipPoints1,incidentEdge,tangent2,sideOffset1);if(np<2)return;np=b2Collision.ClipSegmentToLine(clipPoints2,clipPoints1,tangent,sideOffset2);if(np<2)return;manifold.m_localPlaneNormal.SetV(localNormal);manifold.m_localPoint.SetV(planePoint);var pointCount=0;for(var i=0;i<b2Settings.b2_maxManifoldPoints;++i){cv=clipPoints2[i];var separation=normal.x*cv.v.x+normal.y*cv.v.y-frontOffset;if(separation<=totalRadius){var cp=manifold.m_points[pointCount];tMat=xf2.R;var tX=cv.v.x-xf2.position.x;var tY=cv.v.y-xf2.position.y;cp.m_localPoint.x=tX*tMat.col1.x+tY*tMat.col1.y;cp.m_localPoint.y=tX*tMat.col2.x+tY*tMat.col2.y;cp.m_id.Set(cv.id);cp.m_id.features.flip=flip;++pointCount;}}manifold.m_pointCount=pointCount;};b2Collision.CollideCircles=function(manifold,circle1,xf1,circle2,xf2){manifold.m_pointCount=0;var tMat;var tVec;tMat=xf1.R;tVec=circle1.m_p;var p1X=xf1.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var p1Y=xf1.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tMat=xf2.R;tVec=circle2.m_p;var p2X=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var p2Y=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);var dX=p2X-p1X;var dY=p2Y-p1Y;var distSqr=dX*dX+dY*dY;var radius=circle1.m_radius+circle2.m_radius;if(distSqr>radius*radius){return;}manifold.m_type=b2Manifold.e_circles;manifold.m_localPoint.SetV(circle1.m_p);manifold.m_localPlaneNormal.SetZero();manifold.m_pointCount=1;manifold.m_points[0].m_localPoint.SetV(circle2.m_p);manifold.m_points[0].m_id.key=0;};b2Collision.CollidePolygonAndCircle=function(manifold,polygon,xf1,circle,xf2){manifold.m_pointCount=0;var tPoint;var dX=0;var dY=0;var positionX=0;var positionY=0;var tVec;var tMat;tMat=xf2.R;tVec=circle.m_p;var cX=xf2.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var cY=xf2.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);dX=cX-xf1.position.x;dY=cY-xf1.position.y;tMat=xf1.R;var cLocalX=dX*tMat.col1.x+dY*tMat.col1.y;var cLocalY=dX*tMat.col2.x+dY*tMat.col2.y;var dist=0;var normalIndex=0;var separation=-Number.MAX_VALUE;var radius=polygon.m_radius+circle.m_radius;var vertexCount=parseInt(polygon.m_vertexCount);var vertices=polygon.m_vertices;var normals=polygon.m_normals;for(var i=0;i<vertexCount;++i){tVec=vertices[i];dX=cLocalX-tVec.x;dY=cLocalY-tVec.y;tVec=normals[i];var s=tVec.x*dX+tVec.y*dY;if(s>radius){return;}if(s>separation){separation=s;normalIndex=i;}}var vertIndex1=parseInt(normalIndex);var vertIndex2=parseInt(vertIndex1+1<vertexCount?vertIndex1+1:0);var v1=vertices[vertIndex1];var v2=vertices[vertIndex2];if(separation<Number.MIN_VALUE){manifold.m_pointCount=1;manifold.m_type=b2Manifold.e_faceA;manifold.m_localPlaneNormal.SetV(normals[normalIndex]);manifold.m_localPoint.x=0.5*(v1.x+v2.x);manifold.m_localPoint.y=0.5*(v1.y+v2.y);manifold.m_points[0].m_localPoint.SetV(circle.m_p);manifold.m_points[0].m_id.key=0;return;}var u1=(cLocalX-v1.x)*(v2.x-v1.x)+(cLocalY-v1.y)*(v2.y-v1.y);var u2=(cLocalX-v2.x)*(v1.x-v2.x)+(cLocalY-v2.y)*(v1.y-v2.y);if(u1<=0.0){if((cLocalX-v1.x)*(cLocalX-v1.x)+(cLocalY-v1.y)*(cLocalY-v1.y)>radius*radius)return;manifold.m_pointCount=1;manifold.m_type=b2Manifold.e_faceA;manifold.m_localPlaneNormal.x=cLocalX-v1.x;manifold.m_localPlaneNormal.y=cLocalY-v1.y;manifold.m_localPlaneNormal.Normalize();manifold.m_localPoint.SetV(v1);manifold.m_points[0].m_localPoint.SetV(circle.m_p);manifold.m_points[0].m_id.key=0;}else if(u2<=0){if((cLocalX-v2.x)*(cLocalX-v2.x)+(cLocalY-v2.y)*(cLocalY-v2.y)>radius*radius)return;manifold.m_pointCount=1;manifold.m_type=b2Manifold.e_faceA;manifold.m_localPlaneNormal.x=cLocalX-v2.x;manifold.m_localPlaneNormal.y=cLocalY-v2.y;manifold.m_localPlaneNormal.Normalize();manifold.m_localPoint.SetV(v2);manifold.m_points[0].m_localPoint.SetV(circle.m_p);manifold.m_points[0].m_id.key=0;}else{var faceCenterX=0.5*(v1.x+v2.x);var faceCenterY=0.5*(v1.y+v2.y);separation=(cLocalX-faceCenterX)*normals[vertIndex1].x+(cLocalY-faceCenterY)*normals[vertIndex1].y;if(separation>radius)return;manifold.m_pointCount=1;manifold.m_type=b2Manifold.e_faceA;manifold.m_localPlaneNormal.x=normals[vertIndex1].x;manifold.m_localPlaneNormal.y=normals[vertIndex1].y;manifold.m_localPlaneNormal.Normalize();manifold.m_localPoint.Set(faceCenterX,faceCenterY);manifold.m_points[0].m_localPoint.SetV(circle.m_p);manifold.m_points[0].m_id.key=0;}};b2Collision.TestOverlap=function(a,b){var t1=b.lowerBound;var t2=a.upperBound;var d1X=t1.x-t2.x;var d1Y=t1.y-t2.y;t1=a.lowerBound;t2=b.upperBound;var d2X=t1.x-t2.x;var d2Y=t1.y-t2.y;if(d1X>0.0||d1Y>0.0)return false;if(d2X>0.0||d2Y>0.0)return false;return true;};Box2D.postDefs.push(function(){Box2D.Collision.b2Collision.s_incidentEdge=b2Collision.MakeClipPointVector();Box2D.Collision.b2Collision.s_clipPoints1=b2Collision.MakeClipPointVector();Box2D.Collision.b2Collision.s_clipPoints2=b2Collision.MakeClipPointVector();Box2D.Collision.b2Collision.s_edgeAO=new Vector_a2j_Number(1);Box2D.Collision.b2Collision.s_edgeBO=new Vector_a2j_Number(1);Box2D.Collision.b2Collision.s_localTangent=new b2Vec2();Box2D.Collision.b2Collision.s_localNormal=new b2Vec2();Box2D.Collision.b2Collision.s_planePoint=new b2Vec2();Box2D.Collision.b2Collision.s_normal=new b2Vec2();Box2D.Collision.b2Collision.s_tangent=new b2Vec2();Box2D.Collision.b2Collision.s_tangent2=new b2Vec2();Box2D.Collision.b2Collision.s_v11=new b2Vec2();Box2D.Collision.b2Collision.s_v12=new b2Vec2();Box2D.Collision.b2Collision.b2CollidePolyTempVec=new b2Vec2();Box2D.Collision.b2Collision.b2_nullFeature=0x000000ff;});b2ContactID.b2ContactID=function(){this.features=new Features();};b2ContactID.prototype.b2ContactID=function(){this.features._m_id=this;};b2ContactID.prototype.Set=function(id){this.key=id._key;};b2ContactID.prototype.Copy=function(){var id=new b2ContactID();id.key=this.key;return id;};Object.defineProperty(b2ContactID.prototype,'key',{enumerable:false,configurable:true,get:function get(){return this._key;}});Object.defineProperty(b2ContactID.prototype,'key',{enumerable:false,configurable:true,set:function set(value){if(value===undefined)value=0;this._key=value;this.features._referenceEdge=this._key&0x000000ff;this.features._incidentEdge=(this._key&0x0000ff00)>>8&0x000000ff;this.features._incidentVertex=(this._key&0x00ff0000)>>16&0x000000ff;this.features._flip=(this._key&0xff000000)>>24&0x000000ff;}});b2ContactPoint.b2ContactPoint=function(){this.position=new b2Vec2();this.velocity=new b2Vec2();this.normal=new b2Vec2();this.id=new b2ContactID();};b2Distance.b2Distance=function(){};b2Distance.Distance=function(output,cache,input){++b2Distance.b2_gjkCalls;var proxyA=input.proxyA;var proxyB=input.proxyB;var transformA=input.transformA;var transformB=input.transformB;var simplex=b2Distance.s_simplex;simplex.ReadCache(cache,proxyA,transformA,proxyB,transformB);var vertices=simplex.m_vertices;var k_maxIters=20;var saveA=b2Distance.s_saveA;var saveB=b2Distance.s_saveB;var saveCount=0;var closestPoint=simplex.GetClosestPoint();var distanceSqr1=closestPoint.LengthSquared();var distanceSqr2=distanceSqr1;var i=0;var p;var iter=0;while(iter<k_maxIters){saveCount=simplex.m_count;for(i=0;i<saveCount;i++){saveA[i]=vertices[i].indexA;saveB[i]=vertices[i].indexB;}switch(simplex.m_count){case 1:break;case 2:simplex.Solve2();break;case 3:simplex.Solve3();break;default:b2Settings.b2Assert(false);}if(simplex.m_count==3){break;}p=simplex.GetClosestPoint();distanceSqr2=p.LengthSquared();if(distanceSqr2>distanceSqr1){}distanceSqr1=distanceSqr2;var d=simplex.GetSearchDirection();if(d.LengthSquared()<Number.MIN_VALUE*Number.MIN_VALUE){break;}var vertex=vertices[simplex.m_count];vertex.indexA=proxyA.GetSupport(b2Math.MulTMV(transformA.R,d.GetNegative()));vertex.wA=b2Math.MulX(transformA,proxyA.GetVertex(vertex.indexA));vertex.indexB=proxyB.GetSupport(b2Math.MulTMV(transformB.R,d));vertex.wB=b2Math.MulX(transformB,proxyB.GetVertex(vertex.indexB));vertex.w=b2Math.SubtractVV(vertex.wB,vertex.wA);++iter;++b2Distance.b2_gjkIters;var duplicate=false;for(i=0;i<saveCount;i++){if(vertex.indexA==saveA[i]&&vertex.indexB==saveB[i]){duplicate=true;break;}}if(duplicate){break;}++simplex.m_count;}b2Distance.b2_gjkMaxIters=b2Math.Max(b2Distance.b2_gjkMaxIters,iter);simplex.GetWitnessPoints(output.pointA,output.pointB);output.distance=b2Math.SubtractVV(output.pointA,output.pointB).Length();output.iterations=iter;simplex.WriteCache(cache);if(input.useRadii){var rA=proxyA.m_radius;var rB=proxyB.m_radius;if(output.distance>rA+rB&&output.distance>Number.MIN_VALUE){output.distance-=rA+rB;var normal=b2Math.SubtractVV(output.pointB,output.pointA);normal.Normalize();output.pointA.x+=rA*normal.x;output.pointA.y+=rA*normal.y;output.pointB.x-=rB*normal.x;output.pointB.y-=rB*normal.y;}else{p=new b2Vec2();p.x=.5*(output.pointA.x+output.pointB.x);p.y=.5*(output.pointA.y+output.pointB.y);output.pointA.x=output.pointB.x=p.x;output.pointA.y=output.pointB.y=p.y;output.distance=0.0;}}};Box2D.postDefs.push(function(){Box2D.Collision.b2Distance.s_simplex=new b2Simplex();Box2D.Collision.b2Distance.s_saveA=new Vector_a2j_Number(3);Box2D.Collision.b2Distance.s_saveB=new Vector_a2j_Number(3);});b2DistanceInput.b2DistanceInput=function(){};b2DistanceOutput.b2DistanceOutput=function(){this.pointA=new b2Vec2();this.pointB=new b2Vec2();};b2DistanceProxy.b2DistanceProxy=function(){};b2DistanceProxy.prototype.Set=function(shape){switch(shape.GetType()){case b2Shape.e_circleShape:{var circle=shape instanceof b2CircleShape?shape:null;this.m_vertices=new Vector(1,true);this.m_vertices[0]=circle.m_p;this.m_count=1;this.m_radius=circle.m_radius;}break;case b2Shape.e_polygonShape:{var polygon=shape instanceof b2PolygonShape?shape:null;this.m_vertices=polygon.m_vertices;this.m_count=polygon.m_vertexCount;this.m_radius=polygon.m_radius;}break;default:b2Settings.b2Assert(false);}};b2DistanceProxy.prototype.GetSupport=function(d){var bestIndex=0;var bestValue=this.m_vertices[0].x*d.x+this.m_vertices[0].y*d.y;for(var i=1;i<this.m_count;++i){var value=this.m_vertices[i].x*d.x+this.m_vertices[i].y*d.y;if(value>bestValue){bestIndex=i;bestValue=value;}}return bestIndex;};b2DistanceProxy.prototype.GetSupportVertex=function(d){var bestIndex=0;var bestValue=this.m_vertices[0].x*d.x+this.m_vertices[0].y*d.y;for(var i=1;i<this.m_count;++i){var value=this.m_vertices[i].x*d.x+this.m_vertices[i].y*d.y;if(value>bestValue){bestIndex=i;bestValue=value;}}return this.m_vertices[bestIndex];};b2DistanceProxy.prototype.GetVertexCount=function(){return this.m_count;};b2DistanceProxy.prototype.GetVertex=function(index){if(index===undefined)index=0;b2Settings.b2Assert(0<=index&&index<this.m_count);return this.m_vertices[index];};b2DynamicTree.b2DynamicTree=function(){};b2DynamicTree.prototype.b2DynamicTree=function(){this.m_root=null;this.m_freeList=null;this.m_path=0;this.m_insertionCount=0;};b2DynamicTree.prototype.CreateProxy=function(aabb,userData){var node=this.AllocateNode();var extendX=b2Settings.b2_aabbExtension;var extendY=b2Settings.b2_aabbExtension;node.aabb.lowerBound.x=aabb.lowerBound.x-extendX;node.aabb.lowerBound.y=aabb.lowerBound.y-extendY;node.aabb.upperBound.x=aabb.upperBound.x+extendX;node.aabb.upperBound.y=aabb.upperBound.y+extendY;node.userData=userData;this.InsertLeaf(node);return node;};b2DynamicTree.prototype.DestroyProxy=function(proxy){this.RemoveLeaf(proxy);this.FreeNode(proxy);};b2DynamicTree.prototype.MoveProxy=function(proxy,aabb,displacement){b2Settings.b2Assert(proxy.IsLeaf());if(proxy.aabb.Contains(aabb)){return false;}this.RemoveLeaf(proxy);var extendX=b2Settings.b2_aabbExtension+b2Settings.b2_aabbMultiplier*(displacement.x>0?displacement.x:-displacement.x);var extendY=b2Settings.b2_aabbExtension+b2Settings.b2_aabbMultiplier*(displacement.y>0?displacement.y:-displacement.y);proxy.aabb.lowerBound.x=aabb.lowerBound.x-extendX;proxy.aabb.lowerBound.y=aabb.lowerBound.y-extendY;proxy.aabb.upperBound.x=aabb.upperBound.x+extendX;proxy.aabb.upperBound.y=aabb.upperBound.y+extendY;this.InsertLeaf(proxy);return true;};b2DynamicTree.prototype.Rebalance=function(iterations){if(iterations===undefined)iterations=0;if(this.m_root==null)return;for(var i=0;i<iterations;i++){var node=this.m_root;var bit=0;while(node.IsLeaf()==false){node=this.m_path>>bit&1?node.child2:node.child1;bit=bit+1&31;}++this.m_path;this.RemoveLeaf(node);this.InsertLeaf(node);}};b2DynamicTree.prototype.GetFatAABB=function(proxy){return proxy.aabb;};b2DynamicTree.prototype.GetUserData=function(proxy){return proxy.userData;};b2DynamicTree.prototype.Query=function(callback,aabb){if(this.m_root==null)return;var stack=new Vector();var count=0;stack[count++]=this.m_root;while(count>0){var node=stack[--count];if(node.aabb.TestOverlap(aabb)){if(node.IsLeaf()){var proceed=callback(node);if(!proceed)return;}else{stack[count++]=node.child1;stack[count++]=node.child2;}}}};b2DynamicTree.prototype.RayCast=function(callback,input){if(this.m_root==null)return;var p1=input.p1;var p2=input.p2;var r=b2Math.SubtractVV(p1,p2);r.Normalize();var v=b2Math.CrossFV(1.0,r);var abs_v=b2Math.AbsV(v);var maxFraction=input.maxFraction;var segmentAABB=new b2AABB();var tX=0;var tY=0;{tX=p1.x+maxFraction*(p2.x-p1.x);tY=p1.y+maxFraction*(p2.y-p1.y);segmentAABB.lowerBound.x=Math.min(p1.x,tX);segmentAABB.lowerBound.y=Math.min(p1.y,tY);segmentAABB.upperBound.x=Math.max(p1.x,tX);segmentAABB.upperBound.y=Math.max(p1.y,tY);}var stack=new Vector();var count=0;stack[count++]=this.m_root;while(count>0){var node=stack[--count];if(node.aabb.TestOverlap(segmentAABB)==false){continue;}var c=node.aabb.GetCenter();var h=node.aabb.GetExtents();var separation=Math.abs(v.x*(p1.x-c.x)+v.y*(p1.y-c.y))-abs_v.x*h.x-abs_v.y*h.y;if(separation>0.0)continue;if(node.IsLeaf()){var subInput=new b2RayCastInput();subInput.p1=input.p1;subInput.p2=input.p2;subInput.maxFraction=input.maxFraction;maxFraction=callback(subInput,node);if(maxFraction==0.0)return;if(maxFraction>0.0){tX=p1.x+maxFraction*(p2.x-p1.x);tY=p1.y+maxFraction*(p2.y-p1.y);segmentAABB.lowerBound.x=Math.min(p1.x,tX);segmentAABB.lowerBound.y=Math.min(p1.y,tY);segmentAABB.upperBound.x=Math.max(p1.x,tX);segmentAABB.upperBound.y=Math.max(p1.y,tY);}}else{stack[count++]=node.child1;stack[count++]=node.child2;}}};b2DynamicTree.prototype.AllocateNode=function(){if(this.m_freeList){var node=this.m_freeList;this.m_freeList=node.parent;node.parent=null;node.child1=null;node.child2=null;return node;}return new b2DynamicTreeNode();};b2DynamicTree.prototype.FreeNode=function(node){node.parent=this.m_freeList;this.m_freeList=node;};b2DynamicTree.prototype.InsertLeaf=function(leaf){++this.m_insertionCount;if(this.m_root==null){this.m_root=leaf;this.m_root.parent=null;return;}var center=leaf.aabb.GetCenter();var sibling=this.m_root;if(sibling.IsLeaf()==false){do{var child1=sibling.child1;var child2=sibling.child2;var norm1=Math.abs((child1.aabb.lowerBound.x+child1.aabb.upperBound.x)/2-center.x)+Math.abs((child1.aabb.lowerBound.y+child1.aabb.upperBound.y)/2-center.y);var norm2=Math.abs((child2.aabb.lowerBound.x+child2.aabb.upperBound.x)/2-center.x)+Math.abs((child2.aabb.lowerBound.y+child2.aabb.upperBound.y)/2-center.y);if(norm1<norm2){sibling=child1;}else{sibling=child2;}}while(sibling.IsLeaf()==false);}var node1=sibling.parent;var node2=this.AllocateNode();node2.parent=node1;node2.userData=null;node2.aabb.Combine(leaf.aabb,sibling.aabb);if(node1){if(sibling.parent.child1==sibling){node1.child1=node2;}else{node1.child2=node2;}node2.child1=sibling;node2.child2=leaf;sibling.parent=node2;leaf.parent=node2;do{if(node1.aabb.Contains(node2.aabb))break;node1.aabb.Combine(node1.child1.aabb,node1.child2.aabb);node2=node1;node1=node1.parent;}while(node1);}else{node2.child1=sibling;node2.child2=leaf;sibling.parent=node2;leaf.parent=node2;this.m_root=node2;}};b2DynamicTree.prototype.RemoveLeaf=function(leaf){if(leaf==this.m_root){this.m_root=null;return;}var node2=leaf.parent;var node1=node2.parent;var sibling;if(node2.child1==leaf){sibling=node2.child2;}else{sibling=node2.child1;}if(node1){if(node1.child1==node2){node1.child1=sibling;}else{node1.child2=sibling;}sibling.parent=node1;this.FreeNode(node2);while(node1){var oldAABB=node1.aabb;node1.aabb=b2AABB.Combine(node1.child1.aabb,node1.child2.aabb);if(oldAABB.Contains(node1.aabb))break;node1=node1.parent;}}else{this.m_root=sibling;sibling.parent=null;this.FreeNode(node2);}};b2DynamicTreeBroadPhase.b2DynamicTreeBroadPhase=function(){this.m_tree=new b2DynamicTree();this.m_moveBuffer=new Vector();this.m_pairBuffer=new Vector();this.m_pairCount=0;};b2DynamicTreeBroadPhase.prototype.CreateProxy=function(aabb,userData){var proxy=this.m_tree.CreateProxy(aabb,userData);++this.m_proxyCount;this.BufferMove(proxy);return proxy;};b2DynamicTreeBroadPhase.prototype.DestroyProxy=function(proxy){this.UnBufferMove(proxy);--this.m_proxyCount;this.m_tree.DestroyProxy(proxy);};b2DynamicTreeBroadPhase.prototype.MoveProxy=function(proxy,aabb,displacement){var buffer=this.m_tree.MoveProxy(proxy,aabb,displacement);if(buffer){this.BufferMove(proxy);}};b2DynamicTreeBroadPhase.prototype.TestOverlap=function(proxyA,proxyB){var aabbA=this.m_tree.GetFatAABB(proxyA);var aabbB=this.m_tree.GetFatAABB(proxyB);return aabbA.TestOverlap(aabbB);};b2DynamicTreeBroadPhase.prototype.GetUserData=function(proxy){return this.m_tree.GetUserData(proxy);};b2DynamicTreeBroadPhase.prototype.GetFatAABB=function(proxy){return this.m_tree.GetFatAABB(proxy);};b2DynamicTreeBroadPhase.prototype.GetProxyCount=function(){return this.m_proxyCount;};b2DynamicTreeBroadPhase.prototype.UpdatePairs=function(callback){var __this=this;__this.m_pairCount=0;var i=0,queryProxy;var _loop=function _loop(){queryProxy=__this.m_moveBuffer[i];function QueryCallback(proxy){if(proxy==queryProxy)return true;if(__this.m_pairCount==__this.m_pairBuffer.length){__this.m_pairBuffer[__this.m_pairCount]=new b2DynamicTreePair();}var pair=__this.m_pairBuffer[__this.m_pairCount];pair.proxyA=proxy<queryProxy?proxy:queryProxy;pair.proxyB=proxy>=queryProxy?proxy:queryProxy;++__this.m_pairCount;return true;};fatAABB=__this.m_tree.GetFatAABB(queryProxy);__this.m_tree.Query(QueryCallback,fatAABB);};for(i=0;i<__this.m_moveBuffer.length;++i){var fatAABB;_loop();}__this.m_moveBuffer.length=0;for(var i=0;i<__this.m_pairCount;){var primaryPair=__this.m_pairBuffer[i];var userDataA=__this.m_tree.GetUserData(primaryPair.proxyA);var userDataB=__this.m_tree.GetUserData(primaryPair.proxyB);callback(userDataA,userDataB);++i;while(i<__this.m_pairCount){var pair=__this.m_pairBuffer[i];if(pair.proxyA!=primaryPair.proxyA||pair.proxyB!=primaryPair.proxyB){break;}++i;}}};b2DynamicTreeBroadPhase.prototype.Query=function(callback,aabb){this.m_tree.Query(callback,aabb);};b2DynamicTreeBroadPhase.prototype.RayCast=function(callback,input){this.m_tree.RayCast(callback,input);};b2DynamicTreeBroadPhase.prototype.Validate=function(){};b2DynamicTreeBroadPhase.prototype.Rebalance=function(iterations){if(iterations===undefined)iterations=0;this.m_tree.Rebalance(iterations);};b2DynamicTreeBroadPhase.prototype.BufferMove=function(proxy){this.m_moveBuffer[this.m_moveBuffer.length]=proxy;};b2DynamicTreeBroadPhase.prototype.UnBufferMove=function(proxy){var i=parseInt(this.m_moveBuffer.indexOf(proxy));this.m_moveBuffer.splice(i,1);};b2DynamicTreeBroadPhase.prototype.ComparePairs=function(pair1,pair2){return 0;};b2DynamicTreeBroadPhase.__implements={};b2DynamicTreeBroadPhase.__implements[IBroadPhase]=true;b2DynamicTreeNode.b2DynamicTreeNode=function(){this.aabb=new b2AABB();};b2DynamicTreeNode.prototype.IsLeaf=function(){return this.child1==null;};b2DynamicTreePair.b2DynamicTreePair=function(){};b2Manifold.b2Manifold=function(){this.m_pointCount=0;};b2Manifold.prototype.b2Manifold=function(){this.m_points=new Vector(b2Settings.b2_maxManifoldPoints);for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){this.m_points[i]=new b2ManifoldPoint();}this.m_localPlaneNormal=new b2Vec2();this.m_localPoint=new b2Vec2();};b2Manifold.prototype.Reset=function(){for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){(this.m_points[i]instanceof b2ManifoldPoint?this.m_points[i]:null).Reset();}this.m_localPlaneNormal.SetZero();this.m_localPoint.SetZero();this.m_type=0;this.m_pointCount=0;};b2Manifold.prototype.Set=function(m){this.m_pointCount=m.m_pointCount;for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){(this.m_points[i]instanceof b2ManifoldPoint?this.m_points[i]:null).Set(m.m_points[i]);}this.m_localPlaneNormal.SetV(m.m_localPlaneNormal);this.m_localPoint.SetV(m.m_localPoint);this.m_type=m.m_type;};b2Manifold.prototype.Copy=function(){var copy=new b2Manifold();copy.Set(this);return copy;};Box2D.postDefs.push(function(){Box2D.Collision.b2Manifold.e_circles=0x0001;Box2D.Collision.b2Manifold.e_faceA=0x0002;Box2D.Collision.b2Manifold.e_faceB=0x0004;});b2ManifoldPoint.b2ManifoldPoint=function(){this.m_localPoint=new b2Vec2();this.m_id=new b2ContactID();};b2ManifoldPoint.prototype.b2ManifoldPoint=function(){this.Reset();};b2ManifoldPoint.prototype.Reset=function(){this.m_localPoint.SetZero();this.m_normalImpulse=0.0;this.m_tangentImpulse=0.0;this.m_id.key=0;};b2ManifoldPoint.prototype.Set=function(m){this.m_localPoint.SetV(m.m_localPoint);this.m_normalImpulse=m.m_normalImpulse;this.m_tangentImpulse=m.m_tangentImpulse;this.m_id.Set(m.m_id);};b2Point.b2Point=function(){this.p=new b2Vec2();};b2Point.prototype.Support=function(xf,vX,vY){if(vX===undefined)vX=0;if(vY===undefined)vY=0;return this.p;};b2Point.prototype.GetFirstVertex=function(xf){return this.p;};b2RayCastInput.b2RayCastInput=function(){this.p1=new b2Vec2();this.p2=new b2Vec2();};b2RayCastInput.prototype.b2RayCastInput=function(p1,p2,maxFraction){if(p1===undefined)p1=null;if(p2===undefined)p2=null;if(maxFraction===undefined)maxFraction=1;if(p1)this.p1.SetV(p1);if(p2)this.p2.SetV(p2);this.maxFraction=maxFraction;};b2RayCastOutput.b2RayCastOutput=function(){this.normal=new b2Vec2();};b2Segment.b2Segment=function(){this.p1=new b2Vec2();this.p2=new b2Vec2();};b2Segment.prototype.TestSegment=function(lambda,normal,segment,maxLambda){if(maxLambda===undefined)maxLambda=0;var s=segment.p1;var rX=segment.p2.x-s.x;var rY=segment.p2.y-s.y;var dX=this.p2.x-this.p1.x;var dY=this.p2.y-this.p1.y;var nX=dY;var nY=-dX;var k_slop=100.0*Number.MIN_VALUE;var denom=-(rX*nX+rY*nY);if(denom>k_slop){var bX=s.x-this.p1.x;var bY=s.y-this.p1.y;var a=bX*nX+bY*nY;if(0.0<=a&&a<=maxLambda*denom){var mu2=-rX*bY+rY*bX;if(-k_slop*denom<=mu2&&mu2<=denom*(1.0+k_slop)){a/=denom;var nLen=Math.sqrt(nX*nX+nY*nY);nX/=nLen;nY/=nLen;lambda[0]=a;normal.Set(nX,nY);return true;}}}return false;};b2Segment.prototype.Extend=function(aabb){this.ExtendForward(aabb);this.ExtendBackward(aabb);};b2Segment.prototype.ExtendForward=function(aabb){var dX=this.p2.x-this.p1.x;var dY=this.p2.y-this.p1.y;var lambda=Math.min(dX>0?(aabb.upperBound.x-this.p1.x)/dX:dX<0?(aabb.lowerBound.x-this.p1.x)/dX:Number.POSITIVE_INFINITY,dY>0?(aabb.upperBound.y-this.p1.y)/dY:dY<0?(aabb.lowerBound.y-this.p1.y)/dY:Number.POSITIVE_INFINITY);this.p2.x=this.p1.x+dX*lambda;this.p2.y=this.p1.y+dY*lambda;};b2Segment.prototype.ExtendBackward=function(aabb){var dX=-this.p2.x+this.p1.x;var dY=-this.p2.y+this.p1.y;var lambda=Math.min(dX>0?(aabb.upperBound.x-this.p2.x)/dX:dX<0?(aabb.lowerBound.x-this.p2.x)/dX:Number.POSITIVE_INFINITY,dY>0?(aabb.upperBound.y-this.p2.y)/dY:dY<0?(aabb.lowerBound.y-this.p2.y)/dY:Number.POSITIVE_INFINITY);this.p1.x=this.p2.x+dX*lambda;this.p1.y=this.p2.y+dY*lambda;};b2SeparationFunction.b2SeparationFunction=function(){this.m_localPoint=new b2Vec2();this.m_axis=new b2Vec2();};b2SeparationFunction.prototype.Initialize=function(cache,proxyA,transformA,proxyB,transformB){this.m_proxyA=proxyA;this.m_proxyB=proxyB;var count=parseInt(cache.count);b2Settings.b2Assert(0<count&&count<3);var localPointA;var localPointA1;var localPointA2;var localPointB;var localPointB1;var localPointB2;var pointAX=0;var pointAY=0;var pointBX=0;var pointBY=0;var normalX=0;var normalY=0;var tMat;var tVec;var s=0;var sgn=0;if(count==1){this.m_type=b2SeparationFunction.e_points;localPointA=this.m_proxyA.GetVertex(cache.indexA[0]);localPointB=this.m_proxyB.GetVertex(cache.indexB[0]);tVec=localPointA;tMat=transformA.R;pointAX=transformA.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointAY=transformA.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=localPointB;tMat=transformB.R;pointBX=transformB.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointBY=transformB.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);this.m_axis.x=pointBX-pointAX;this.m_axis.y=pointBY-pointAY;this.m_axis.Normalize();}else if(cache.indexB[0]==cache.indexB[1]){this.m_type=b2SeparationFunction.e_faceA;localPointA1=this.m_proxyA.GetVertex(cache.indexA[0]);localPointA2=this.m_proxyA.GetVertex(cache.indexA[1]);localPointB=this.m_proxyB.GetVertex(cache.indexB[0]);this.m_localPoint.x=0.5*(localPointA1.x+localPointA2.x);this.m_localPoint.y=0.5*(localPointA1.y+localPointA2.y);this.m_axis=b2Math.CrossVF(b2Math.SubtractVV(localPointA2,localPointA1),1.0);this.m_axis.Normalize();tVec=this.m_axis;tMat=transformA.R;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tVec=this.m_localPoint;tMat=transformA.R;pointAX=transformA.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointAY=transformA.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=localPointB;tMat=transformB.R;pointBX=transformB.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointBY=transformB.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);s=(pointBX-pointAX)*normalX+(pointBY-pointAY)*normalY;if(s<0.0){this.m_axis.NegativeSelf();}}else if(cache.indexA[0]==cache.indexA[0]){this.m_type=b2SeparationFunction.e_faceB;localPointB1=this.m_proxyB.GetVertex(cache.indexB[0]);localPointB2=this.m_proxyB.GetVertex(cache.indexB[1]);localPointA=this.m_proxyA.GetVertex(cache.indexA[0]);this.m_localPoint.x=0.5*(localPointB1.x+localPointB2.x);this.m_localPoint.y=0.5*(localPointB1.y+localPointB2.y);this.m_axis=b2Math.CrossVF(b2Math.SubtractVV(localPointB2,localPointB1),1.0);this.m_axis.Normalize();tVec=this.m_axis;tMat=transformB.R;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tVec=this.m_localPoint;tMat=transformB.R;pointBX=transformB.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointBY=transformB.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=localPointA;tMat=transformA.R;pointAX=transformA.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointAY=transformA.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);s=(pointAX-pointBX)*normalX+(pointAY-pointBY)*normalY;if(s<0.0){this.m_axis.NegativeSelf();}}else{localPointA1=this.m_proxyA.GetVertex(cache.indexA[0]);localPointA2=this.m_proxyA.GetVertex(cache.indexA[1]);localPointB1=this.m_proxyB.GetVertex(cache.indexB[0]);localPointB2=this.m_proxyB.GetVertex(cache.indexB[1]);var pA=b2Math.MulX(transformA,localPointA);var dA=b2Math.MulMV(transformA.R,b2Math.SubtractVV(localPointA2,localPointA1));var pB=b2Math.MulX(transformB,localPointB);var dB=b2Math.MulMV(transformB.R,b2Math.SubtractVV(localPointB2,localPointB1));var a=dA.x*dA.x+dA.y*dA.y;var e=dB.x*dB.x+dB.y*dB.y;var r=b2Math.SubtractVV(dB,dA);var c=dA.x*r.x+dA.y*r.y;var f=dB.x*r.x+dB.y*r.y;var b=dA.x*dB.x+dA.y*dB.y;var denom=a*e-b*b;s=0.0;if(denom!=0.0){s=b2Math.Clamp((b*f-c*e)/denom,0.0,1.0);}var t=(b*s+f)/e;if(t<0.0){t=0.0;s=b2Math.Clamp((b-c)/a,0.0,1.0);}localPointA=new b2Vec2();localPointA.x=localPointA1.x+s*(localPointA2.x-localPointA1.x);localPointA.y=localPointA1.y+s*(localPointA2.y-localPointA1.y);localPointB=new b2Vec2();localPointB.x=localPointB1.x+s*(localPointB2.x-localPointB1.x);localPointB.y=localPointB1.y+s*(localPointB2.y-localPointB1.y);if(s==0.0||s==1.0){this.m_type=b2SeparationFunction.e_faceB;this.m_axis=b2Math.CrossVF(b2Math.SubtractVV(localPointB2,localPointB1),1.0);this.m_axis.Normalize();this.m_localPoint=localPointB;tVec=this.m_axis;tMat=transformB.R;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tVec=this.m_localPoint;tMat=transformB.R;pointBX=transformB.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointBY=transformB.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=localPointA;tMat=transformA.R;pointAX=transformA.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointAY=transformA.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);sgn=(pointAX-pointBX)*normalX+(pointAY-pointBY)*normalY;if(s<0.0){this.m_axis.NegativeSelf();}}else{this.m_type=b2SeparationFunction.e_faceA;this.m_axis=b2Math.CrossVF(b2Math.SubtractVV(localPointA2,localPointA1),1.0);this.m_localPoint=localPointA;tVec=this.m_axis;tMat=transformA.R;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tVec=this.m_localPoint;tMat=transformA.R;pointAX=transformA.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointAY=transformA.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tVec=localPointB;tMat=transformB.R;pointBX=transformB.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);pointBY=transformB.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);sgn=(pointBX-pointAX)*normalX+(pointBY-pointAY)*normalY;if(s<0.0){this.m_axis.NegativeSelf();}}}};b2SeparationFunction.prototype.Evaluate=function(transformA,transformB){var axisA;var axisB;var localPointA;var localPointB;var pointA;var pointB;var seperation=0;var normal;switch(this.m_type){case b2SeparationFunction.e_points:{axisA=b2Math.MulTMV(transformA.R,this.m_axis);axisB=b2Math.MulTMV(transformB.R,this.m_axis.GetNegative());localPointA=this.m_proxyA.GetSupportVertex(axisA);localPointB=this.m_proxyB.GetSupportVertex(axisB);pointA=b2Math.MulX(transformA,localPointA);pointB=b2Math.MulX(transformB,localPointB);seperation=(pointB.x-pointA.x)*this.m_axis.x+(pointB.y-pointA.y)*this.m_axis.y;return seperation;}case b2SeparationFunction.e_faceA:{normal=b2Math.MulMV(transformA.R,this.m_axis);pointA=b2Math.MulX(transformA,this.m_localPoint);axisB=b2Math.MulTMV(transformB.R,normal.GetNegative());localPointB=this.m_proxyB.GetSupportVertex(axisB);pointB=b2Math.MulX(transformB,localPointB);seperation=(pointB.x-pointA.x)*normal.x+(pointB.y-pointA.y)*normal.y;return seperation;}case b2SeparationFunction.e_faceB:{normal=b2Math.MulMV(transformB.R,this.m_axis);pointB=b2Math.MulX(transformB,this.m_localPoint);axisA=b2Math.MulTMV(transformA.R,normal.GetNegative());localPointA=this.m_proxyA.GetSupportVertex(axisA);pointA=b2Math.MulX(transformA,localPointA);seperation=(pointA.x-pointB.x)*normal.x+(pointA.y-pointB.y)*normal.y;return seperation;}default:b2Settings.b2Assert(false);return 0.0;}};Box2D.postDefs.push(function(){Box2D.Collision.b2SeparationFunction.e_points=0x01;Box2D.Collision.b2SeparationFunction.e_faceA=0x02;Box2D.Collision.b2SeparationFunction.e_faceB=0x04;});b2Simplex.b2Simplex=function(){this.m_v1=new b2SimplexVertex();this.m_v2=new b2SimplexVertex();this.m_v3=new b2SimplexVertex();this.m_vertices=new Vector(3);};b2Simplex.prototype.b2Simplex=function(){this.m_vertices[0]=this.m_v1;this.m_vertices[1]=this.m_v2;this.m_vertices[2]=this.m_v3;};b2Simplex.prototype.ReadCache=function(cache,proxyA,transformA,proxyB,transformB){b2Settings.b2Assert(0<=cache.count&&cache.count<=3);var wALocal;var wBLocal;this.m_count=cache.count;var vertices=this.m_vertices;for(var i=0;i<this.m_count;i++){var v=vertices[i];v.indexA=cache.indexA[i];v.indexB=cache.indexB[i];wALocal=proxyA.GetVertex(v.indexA);wBLocal=proxyB.GetVertex(v.indexB);v.wA=b2Math.MulX(transformA,wALocal);v.wB=b2Math.MulX(transformB,wBLocal);v.w=b2Math.SubtractVV(v.wB,v.wA);v.a=0;}if(this.m_count>1){var metric1=cache.metric;var metric2=this.GetMetric();if(metric2<.5*metric1||2.0*metric1<metric2||metric2<Number.MIN_VALUE){this.m_count=0;}}if(this.m_count==0){v=vertices[0];v.indexA=0;v.indexB=0;wALocal=proxyA.GetVertex(0);wBLocal=proxyB.GetVertex(0);v.wA=b2Math.MulX(transformA,wALocal);v.wB=b2Math.MulX(transformB,wBLocal);v.w=b2Math.SubtractVV(v.wB,v.wA);this.m_count=1;}};b2Simplex.prototype.WriteCache=function(cache){cache.metric=this.GetMetric();cache.count=Box2D.parseUInt(this.m_count);var vertices=this.m_vertices;for(var i=0;i<this.m_count;i++){cache.indexA[i]=Box2D.parseUInt(vertices[i].indexA);cache.indexB[i]=Box2D.parseUInt(vertices[i].indexB);}};b2Simplex.prototype.GetSearchDirection=function(){switch(this.m_count){case 1:return this.m_v1.w.GetNegative();case 2:{var e12=b2Math.SubtractVV(this.m_v2.w,this.m_v1.w);var sgn=b2Math.CrossVV(e12,this.m_v1.w.GetNegative());if(sgn>0.0){return b2Math.CrossFV(1.0,e12);}else{return b2Math.CrossVF(e12,1.0);}}default:b2Settings.b2Assert(false);return new b2Vec2();}};b2Simplex.prototype.GetClosestPoint=function(){switch(this.m_count){case 0:b2Settings.b2Assert(false);return new b2Vec2();case 1:return this.m_v1.w;case 2:return new b2Vec2(this.m_v1.a*this.m_v1.w.x+this.m_v2.a*this.m_v2.w.x,this.m_v1.a*this.m_v1.w.y+this.m_v2.a*this.m_v2.w.y);default:b2Settings.b2Assert(false);return new b2Vec2();}};b2Simplex.prototype.GetWitnessPoints=function(pA,pB){switch(this.m_count){case 0:b2Settings.b2Assert(false);break;case 1:pA.SetV(this.m_v1.wA);pB.SetV(this.m_v1.wB);break;case 2:pA.x=this.m_v1.a*this.m_v1.wA.x+this.m_v2.a*this.m_v2.wA.x;pA.y=this.m_v1.a*this.m_v1.wA.y+this.m_v2.a*this.m_v2.wA.y;pB.x=this.m_v1.a*this.m_v1.wB.x+this.m_v2.a*this.m_v2.wB.x;pB.y=this.m_v1.a*this.m_v1.wB.y+this.m_v2.a*this.m_v2.wB.y;break;case 3:pB.x=pA.x=this.m_v1.a*this.m_v1.wA.x+this.m_v2.a*this.m_v2.wA.x+this.m_v3.a*this.m_v3.wA.x;pB.y=pA.y=this.m_v1.a*this.m_v1.wA.y+this.m_v2.a*this.m_v2.wA.y+this.m_v3.a*this.m_v3.wA.y;break;default:b2Settings.b2Assert(false);break;}};b2Simplex.prototype.GetMetric=function(){switch(this.m_count){case 0:b2Settings.b2Assert(false);return 0.0;case 1:return 0.0;case 2:return b2Math.SubtractVV(this.m_v1.w,this.m_v2.w).Length();case 3:return b2Math.CrossVV(b2Math.SubtractVV(this.m_v2.w,this.m_v1.w),b2Math.SubtractVV(this.m_v3.w,this.m_v1.w));default:b2Settings.b2Assert(false);return 0.0;}};b2Simplex.prototype.Solve2=function(){var w1=this.m_v1.w;var w2=this.m_v2.w;var e12=b2Math.SubtractVV(w2,w1);var d12_2=-(w1.x*e12.x+w1.y*e12.y);if(d12_2<=0.0){this.m_v1.a=1.0;this.m_count=1;return;}var d12_1=w2.x*e12.x+w2.y*e12.y;if(d12_1<=0.0){this.m_v2.a=1.0;this.m_count=1;this.m_v1.Set(this.m_v2);return;}var inv_d12=1.0/(d12_1+d12_2);this.m_v1.a=d12_1*inv_d12;this.m_v2.a=d12_2*inv_d12;this.m_count=2;};b2Simplex.prototype.Solve3=function(){var w1=this.m_v1.w;var w2=this.m_v2.w;var w3=this.m_v3.w;var e12=b2Math.SubtractVV(w2,w1);var w1e12=b2Math.Dot(w1,e12);var w2e12=b2Math.Dot(w2,e12);var d12_1=w2e12;var d12_2=-w1e12;var e13=b2Math.SubtractVV(w3,w1);var w1e13=b2Math.Dot(w1,e13);var w3e13=b2Math.Dot(w3,e13);var d13_1=w3e13;var d13_2=-w1e13;var e23=b2Math.SubtractVV(w3,w2);var w2e23=b2Math.Dot(w2,e23);var w3e23=b2Math.Dot(w3,e23);var d23_1=w3e23;var d23_2=-w2e23;var n123=b2Math.CrossVV(e12,e13);var d123_1=n123*b2Math.CrossVV(w2,w3);var d123_2=n123*b2Math.CrossVV(w3,w1);var d123_3=n123*b2Math.CrossVV(w1,w2);if(d12_2<=0.0&&d13_2<=0.0){this.m_v1.a=1.0;this.m_count=1;return;}if(d12_1>0.0&&d12_2>0.0&&d123_3<=0.0){var inv_d12=1.0/(d12_1+d12_2);this.m_v1.a=d12_1*inv_d12;this.m_v2.a=d12_2*inv_d12;this.m_count=2;return;}if(d13_1>0.0&&d13_2>0.0&&d123_2<=0.0){var inv_d13=1.0/(d13_1+d13_2);this.m_v1.a=d13_1*inv_d13;this.m_v3.a=d13_2*inv_d13;this.m_count=2;this.m_v2.Set(this.m_v3);return;}if(d12_1<=0.0&&d23_2<=0.0){this.m_v2.a=1.0;this.m_count=1;this.m_v1.Set(this.m_v2);return;}if(d13_1<=0.0&&d23_1<=0.0){this.m_v3.a=1.0;this.m_count=1;this.m_v1.Set(this.m_v3);return;}if(d23_1>0.0&&d23_2>0.0&&d123_1<=0.0){var inv_d23=1.0/(d23_1+d23_2);this.m_v2.a=d23_1*inv_d23;this.m_v3.a=d23_2*inv_d23;this.m_count=2;this.m_v1.Set(this.m_v3);return;}var inv_d123=1.0/(d123_1+d123_2+d123_3);this.m_v1.a=d123_1*inv_d123;this.m_v2.a=d123_2*inv_d123;this.m_v3.a=d123_3*inv_d123;this.m_count=3;};b2SimplexCache.b2SimplexCache=function(){this.indexA=new Vector_a2j_Number(3);this.indexB=new Vector_a2j_Number(3);};b2SimplexVertex.b2SimplexVertex=function(){};b2SimplexVertex.prototype.Set=function(other){this.wA.SetV(other.wA);this.wB.SetV(other.wB);this.w.SetV(other.w);this.a=other.a;this.indexA=other.indexA;this.indexB=other.indexB;};b2TimeOfImpact.b2TimeOfImpact=function(){};b2TimeOfImpact.TimeOfImpact=function(input){++b2TimeOfImpact.b2_toiCalls;var proxyA=input.proxyA;var proxyB=input.proxyB;var sweepA=input.sweepA;var sweepB=input.sweepB;b2Settings.b2Assert(sweepA.t0==sweepB.t0);b2Settings.b2Assert(1.0-sweepA.t0>Number.MIN_VALUE);var radius=proxyA.m_radius+proxyB.m_radius;var tolerance=input.tolerance;var alpha=0.0;var k_maxIterations=1000;var iter=0;var target=0.0;b2TimeOfImpact.s_cache.count=0;b2TimeOfImpact.s_distanceInput.useRadii=false;for(;;){sweepA.GetTransform(b2TimeOfImpact.s_xfA,alpha);sweepB.GetTransform(b2TimeOfImpact.s_xfB,alpha);b2TimeOfImpact.s_distanceInput.proxyA=proxyA;b2TimeOfImpact.s_distanceInput.proxyB=proxyB;b2TimeOfImpact.s_distanceInput.transformA=b2TimeOfImpact.s_xfA;b2TimeOfImpact.s_distanceInput.transformB=b2TimeOfImpact.s_xfB;b2Distance.Distance(b2TimeOfImpact.s_distanceOutput,b2TimeOfImpact.s_cache,b2TimeOfImpact.s_distanceInput);if(b2TimeOfImpact.s_distanceOutput.distance<=0.0){alpha=1.0;break;}b2TimeOfImpact.s_fcn.Initialize(b2TimeOfImpact.s_cache,proxyA,b2TimeOfImpact.s_xfA,proxyB,b2TimeOfImpact.s_xfB);var separation=b2TimeOfImpact.s_fcn.Evaluate(b2TimeOfImpact.s_xfA,b2TimeOfImpact.s_xfB);if(separation<=0.0){alpha=1.0;break;}if(iter==0){if(separation>radius){target=b2Math.Max(radius-tolerance,0.75*radius);}else{target=b2Math.Max(separation-tolerance,0.02*radius);}}if(separation-target<0.5*tolerance){if(iter==0){alpha=1.0;break;}break;}var newAlpha=alpha;{var x1=alpha;var x2=1.0;var f1=separation;sweepA.GetTransform(b2TimeOfImpact.s_xfA,x2);sweepB.GetTransform(b2TimeOfImpact.s_xfB,x2);var f2=b2TimeOfImpact.s_fcn.Evaluate(b2TimeOfImpact.s_xfA,b2TimeOfImpact.s_xfB);if(f2>=target){alpha=1.0;break;}var rootIterCount=0;for(;;){var x=0;if(rootIterCount&1){x=x1+(target-f1)*(x2-x1)/(f2-f1);}else{x=0.5*(x1+x2);}sweepA.GetTransform(b2TimeOfImpact.s_xfA,x);sweepB.GetTransform(b2TimeOfImpact.s_xfB,x);var f=b2TimeOfImpact.s_fcn.Evaluate(b2TimeOfImpact.s_xfA,b2TimeOfImpact.s_xfB);if(b2Math.Abs(f-target)<0.025*tolerance){newAlpha=x;break;}if(f>target){x1=x;f1=f;}else{x2=x;f2=f;}++rootIterCount;++b2TimeOfImpact.b2_toiRootIters;if(rootIterCount==50){break;}}b2TimeOfImpact.b2_toiMaxRootIters=b2Math.Max(b2TimeOfImpact.b2_toiMaxRootIters,rootIterCount);}if(newAlpha<(1.0+100.0*Number.MIN_VALUE)*alpha){break;}alpha=newAlpha;iter++;++b2TimeOfImpact.b2_toiIters;if(iter==k_maxIterations){break;}}b2TimeOfImpact.b2_toiMaxIters=b2Math.Max(b2TimeOfImpact.b2_toiMaxIters,iter);return alpha;};Box2D.postDefs.push(function(){Box2D.Collision.b2TimeOfImpact.b2_toiCalls=0;Box2D.Collision.b2TimeOfImpact.b2_toiIters=0;Box2D.Collision.b2TimeOfImpact.b2_toiMaxIters=0;Box2D.Collision.b2TimeOfImpact.b2_toiRootIters=0;Box2D.Collision.b2TimeOfImpact.b2_toiMaxRootIters=0;Box2D.Collision.b2TimeOfImpact.s_cache=new b2SimplexCache();Box2D.Collision.b2TimeOfImpact.s_distanceInput=new b2DistanceInput();Box2D.Collision.b2TimeOfImpact.s_xfA=new b2Transform();Box2D.Collision.b2TimeOfImpact.s_xfB=new b2Transform();Box2D.Collision.b2TimeOfImpact.s_fcn=new b2SeparationFunction();Box2D.Collision.b2TimeOfImpact.s_distanceOutput=new b2DistanceOutput();});b2TOIInput.b2TOIInput=function(){this.proxyA=new b2DistanceProxy();this.proxyB=new b2DistanceProxy();this.sweepA=new b2Sweep();this.sweepB=new b2Sweep();};b2WorldManifold.b2WorldManifold=function(){this.m_normal=new b2Vec2();};b2WorldManifold.prototype.b2WorldManifold=function(){this.m_points=new Vector(b2Settings.b2_maxManifoldPoints);for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){this.m_points[i]=new b2Vec2();}};b2WorldManifold.prototype.Initialize=function(manifold,xfA,radiusA,xfB,radiusB){if(radiusA===undefined)radiusA=0;if(radiusB===undefined)radiusB=0;if(manifold.m_pointCount==0){return;}var i=0;var tVec;var tMat;var normalX=0;var normalY=0;var planePointX=0;var planePointY=0;var clipPointX=0;var clipPointY=0;switch(manifold.m_type){case b2Manifold.e_circles:{tMat=xfA.R;tVec=manifold.m_localPoint;var pointAX=xfA.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;var pointAY=xfA.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=xfB.R;tVec=manifold.m_points[0].m_localPoint;var pointBX=xfB.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;var pointBY=xfB.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;var dX=pointBX-pointAX;var dY=pointBY-pointAY;var d2=dX*dX+dY*dY;if(d2>Number.MIN_VALUE*Number.MIN_VALUE){var d=Math.sqrt(d2);this.m_normal.x=dX/d;this.m_normal.y=dY/d;}else{this.m_normal.x=1;this.m_normal.y=0;}var cAX=pointAX+radiusA*this.m_normal.x;var cAY=pointAY+radiusA*this.m_normal.y;var cBX=pointBX-radiusB*this.m_normal.x;var cBY=pointBY-radiusB*this.m_normal.y;this.m_points[0].x=0.5*(cAX+cBX);this.m_points[0].y=0.5*(cAY+cBY);}break;case b2Manifold.e_faceA:{tMat=xfA.R;tVec=manifold.m_localPlaneNormal;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=xfA.R;tVec=manifold.m_localPoint;planePointX=xfA.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;planePointY=xfA.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_normal.x=normalX;this.m_normal.y=normalY;for(i=0;i<manifold.m_pointCount;i++){tMat=xfB.R;tVec=manifold.m_points[i].m_localPoint;clipPointX=xfB.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;clipPointY=xfB.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_points[i].x=clipPointX+0.5*(radiusA-(clipPointX-planePointX)*normalX-(clipPointY-planePointY)*normalY-radiusB)*normalX;this.m_points[i].y=clipPointY+0.5*(radiusA-(clipPointX-planePointX)*normalX-(clipPointY-planePointY)*normalY-radiusB)*normalY;}}break;case b2Manifold.e_faceB:{tMat=xfB.R;tVec=manifold.m_localPlaneNormal;normalX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;normalY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=xfB.R;tVec=manifold.m_localPoint;planePointX=xfB.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;planePointY=xfB.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_normal.x=-normalX;this.m_normal.y=-normalY;for(i=0;i<manifold.m_pointCount;i++){tMat=xfA.R;tVec=manifold.m_points[i].m_localPoint;clipPointX=xfA.position.x+tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;clipPointY=xfA.position.y+tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_points[i].x=clipPointX+0.5*(radiusB-(clipPointX-planePointX)*normalX-(clipPointY-planePointY)*normalY-radiusA)*normalX;this.m_points[i].y=clipPointY+0.5*(radiusB-(clipPointX-planePointX)*normalX-(clipPointY-planePointY)*normalY-radiusA)*normalY;}}break;}};ClipVertex.ClipVertex=function(){this.v=new b2Vec2();this.id=new b2ContactID();};ClipVertex.prototype.Set=function(other){this.v.SetV(other.v);this.id.Set(other.id);};Features.Features=function(){};Object.defineProperty(Features.prototype,'referenceEdge',{enumerable:false,configurable:true,get:function get(){return this._referenceEdge;}});Object.defineProperty(Features.prototype,'referenceEdge',{enumerable:false,configurable:true,set:function set(value){if(value===undefined)value=0;this._referenceEdge=value;this._m_id._key=this._m_id._key&0xffffff00|this._referenceEdge&0x000000ff;}});Object.defineProperty(Features.prototype,'incidentEdge',{enumerable:false,configurable:true,get:function get(){return this._incidentEdge;}});Object.defineProperty(Features.prototype,'incidentEdge',{enumerable:false,configurable:true,set:function set(value){if(value===undefined)value=0;this._incidentEdge=value;this._m_id._key=this._m_id._key&0xffff00ff|this._incidentEdge<<8&0x0000ff00;}});Object.defineProperty(Features.prototype,'incidentVertex',{enumerable:false,configurable:true,get:function get(){return this._incidentVertex;}});Object.defineProperty(Features.prototype,'incidentVertex',{enumerable:false,configurable:true,set:function set(value){if(value===undefined)value=0;this._incidentVertex=value;this._m_id._key=this._m_id._key&0xff00ffff|this._incidentVertex<<16&0x00ff0000;}});Object.defineProperty(Features.prototype,'flip',{enumerable:false,configurable:true,get:function get(){return this._flip;}});Object.defineProperty(Features.prototype,'flip',{enumerable:false,configurable:true,set:function set(value){if(value===undefined)value=0;this._flip=value;this._m_id._key=this._m_id._key&0x00ffffff|this._flip<<24&0xff000000;}});})();(function(){var b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2CircleShape=Box2D.Collision.Shapes.b2CircleShape,b2EdgeChainDef=Box2D.Collision.Shapes.b2EdgeChainDef,b2EdgeShape=Box2D.Collision.Shapes.b2EdgeShape,b2MassData=Box2D.Collision.Shapes.b2MassData,b2PolygonShape=Box2D.Collision.Shapes.b2PolygonShape,b2Shape=Box2D.Collision.Shapes.b2Shape,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2Body=Box2D.Dynamics.b2Body,b2BodyDef=Box2D.Dynamics.b2BodyDef,b2ContactFilter=Box2D.Dynamics.b2ContactFilter,b2ContactImpulse=Box2D.Dynamics.b2ContactImpulse,b2ContactListener=Box2D.Dynamics.b2ContactListener,b2ContactManager=Box2D.Dynamics.b2ContactManager,b2DebugDraw=Box2D.Dynamics.b2DebugDraw,b2DestructionListener=Box2D.Dynamics.b2DestructionListener,b2FilterData=Box2D.Dynamics.b2FilterData,b2Fixture=Box2D.Dynamics.b2Fixture,b2FixtureDef=Box2D.Dynamics.b2FixtureDef,b2Island=Box2D.Dynamics.b2Island,b2TimeStep=Box2D.Dynamics.b2TimeStep,b2World=Box2D.Dynamics.b2World,b2AABB=Box2D.Collision.b2AABB,b2Bound=Box2D.Collision.b2Bound,b2BoundValues=Box2D.Collision.b2BoundValues,b2Collision=Box2D.Collision.b2Collision,b2ContactID=Box2D.Collision.b2ContactID,b2ContactPoint=Box2D.Collision.b2ContactPoint,b2Distance=Box2D.Collision.b2Distance,b2DistanceInput=Box2D.Collision.b2DistanceInput,b2DistanceOutput=Box2D.Collision.b2DistanceOutput,b2DistanceProxy=Box2D.Collision.b2DistanceProxy,b2DynamicTree=Box2D.Collision.b2DynamicTree,b2DynamicTreeBroadPhase=Box2D.Collision.b2DynamicTreeBroadPhase,b2DynamicTreeNode=Box2D.Collision.b2DynamicTreeNode,b2DynamicTreePair=Box2D.Collision.b2DynamicTreePair,b2Manifold=Box2D.Collision.b2Manifold,b2ManifoldPoint=Box2D.Collision.b2ManifoldPoint,b2Point=Box2D.Collision.b2Point,b2RayCastInput=Box2D.Collision.b2RayCastInput,b2RayCastOutput=Box2D.Collision.b2RayCastOutput,b2Segment=Box2D.Collision.b2Segment,b2SeparationFunction=Box2D.Collision.b2SeparationFunction,b2Simplex=Box2D.Collision.b2Simplex,b2SimplexCache=Box2D.Collision.b2SimplexCache,b2SimplexVertex=Box2D.Collision.b2SimplexVertex,b2TimeOfImpact=Box2D.Collision.b2TimeOfImpact,b2TOIInput=Box2D.Collision.b2TOIInput,b2WorldManifold=Box2D.Collision.b2WorldManifold,ClipVertex=Box2D.Collision.ClipVertex,Features=Box2D.Collision.Features,IBroadPhase=Box2D.Collision.IBroadPhase;Box2D.inherit(b2CircleShape,Box2D.Collision.Shapes.b2Shape);b2CircleShape.prototype.__super=Box2D.Collision.Shapes.b2Shape.prototype;b2CircleShape.b2CircleShape=function(){Box2D.Collision.Shapes.b2Shape.b2Shape.apply(this,arguments);this.m_p=new b2Vec2();};b2CircleShape.prototype.Copy=function(){var s=new b2CircleShape();s.Set(this);return s;};b2CircleShape.prototype.Set=function(other){this.__super.Set.call(this,other);if(Box2D.is(other,b2CircleShape)){var other2=other instanceof b2CircleShape?other:null;this.m_p.SetV(other2.m_p);}};b2CircleShape.prototype.TestPoint=function(transform,p){var tMat=transform.R;var dX=transform.position.x+(tMat.col1.x*this.m_p.x+tMat.col2.x*this.m_p.y);var dY=transform.position.y+(tMat.col1.y*this.m_p.x+tMat.col2.y*this.m_p.y);dX=p.x-dX;dY=p.y-dY;return dX*dX+dY*dY<=this.m_radius*this.m_radius;};b2CircleShape.prototype.RayCast=function(output,input,transform){var tMat=transform.R;var positionX=transform.position.x+(tMat.col1.x*this.m_p.x+tMat.col2.x*this.m_p.y);var positionY=transform.position.y+(tMat.col1.y*this.m_p.x+tMat.col2.y*this.m_p.y);var sX=input.p1.x-positionX;var sY=input.p1.y-positionY;var b=sX*sX+sY*sY-this.m_radius*this.m_radius;var rX=input.p2.x-input.p1.x;var rY=input.p2.y-input.p1.y;var c=sX*rX+sY*rY;var rr=rX*rX+rY*rY;var sigma=c*c-rr*b;if(sigma<0.0||rr<Number.MIN_VALUE){return false;}var a=-(c+Math.sqrt(sigma));if(0.0<=a&&a<=input.maxFraction*rr){a/=rr;output.fraction=a;output.normal.x=sX+a*rX;output.normal.y=sY+a*rY;output.normal.Normalize();return true;}return false;};b2CircleShape.prototype.ComputeAABB=function(aabb,transform){var tMat=transform.R;var pX=transform.position.x+(tMat.col1.x*this.m_p.x+tMat.col2.x*this.m_p.y);var pY=transform.position.y+(tMat.col1.y*this.m_p.x+tMat.col2.y*this.m_p.y);aabb.lowerBound.Set(pX-this.m_radius,pY-this.m_radius);aabb.upperBound.Set(pX+this.m_radius,pY+this.m_radius);};b2CircleShape.prototype.ComputeMass=function(massData,density){if(density===undefined)density=0;massData.mass=density*b2Settings.b2_pi*this.m_radius*this.m_radius;massData.center.SetV(this.m_p);massData.I=massData.mass*(0.5*this.m_radius*this.m_radius+(this.m_p.x*this.m_p.x+this.m_p.y*this.m_p.y));};b2CircleShape.prototype.ComputeSubmergedArea=function(normal,offset,xf,c){if(offset===undefined)offset=0;var p=b2Math.MulX(xf,this.m_p);var l=-(b2Math.Dot(normal,p)-offset);if(l<-this.m_radius+Number.MIN_VALUE){return 0;}if(l>this.m_radius){c.SetV(p);return Math.PI*this.m_radius*this.m_radius;}var r2=this.m_radius*this.m_radius;var l2=l*l;var area=r2*(Math.asin(l/this.m_radius)+Math.PI/2)+l*Math.sqrt(r2-l2);var com=-2/3*Math.pow(r2-l2,1.5)/area;c.x=p.x+normal.x*com;c.y=p.y+normal.y*com;return area;};b2CircleShape.prototype.GetLocalPosition=function(){return this.m_p;};b2CircleShape.prototype.SetLocalPosition=function(position){this.m_p.SetV(position);};b2CircleShape.prototype.GetRadius=function(){return this.m_radius;};b2CircleShape.prototype.SetRadius=function(radius){if(radius===undefined)radius=0;this.m_radius=radius;};b2CircleShape.prototype.b2CircleShape=function(radius){if(radius===undefined)radius=0;this.__super.b2Shape.call(this);this.m_type=b2Shape.e_circleShape;this.m_radius=radius;};b2EdgeChainDef.b2EdgeChainDef=function(){};b2EdgeChainDef.prototype.b2EdgeChainDef=function(){this.vertexCount=0;this.isALoop=true;this.vertices=[];};Box2D.inherit(b2EdgeShape,Box2D.Collision.Shapes.b2Shape);b2EdgeShape.prototype.__super=Box2D.Collision.Shapes.b2Shape.prototype;b2EdgeShape.b2EdgeShape=function(){Box2D.Collision.Shapes.b2Shape.b2Shape.apply(this,arguments);this.s_supportVec=new b2Vec2();this.m_v1=new b2Vec2();this.m_v2=new b2Vec2();this.m_coreV1=new b2Vec2();this.m_coreV2=new b2Vec2();this.m_normal=new b2Vec2();this.m_direction=new b2Vec2();this.m_cornerDir1=new b2Vec2();this.m_cornerDir2=new b2Vec2();};b2EdgeShape.prototype.TestPoint=function(transform,p){return false;};b2EdgeShape.prototype.RayCast=function(output,input,transform){var tMat;var rX=input.p2.x-input.p1.x;var rY=input.p2.y-input.p1.y;tMat=transform.R;var v1X=transform.position.x+(tMat.col1.x*this.m_v1.x+tMat.col2.x*this.m_v1.y);var v1Y=transform.position.y+(tMat.col1.y*this.m_v1.x+tMat.col2.y*this.m_v1.y);var nX=transform.position.y+(tMat.col1.y*this.m_v2.x+tMat.col2.y*this.m_v2.y)-v1Y;var nY=-(transform.position.x+(tMat.col1.x*this.m_v2.x+tMat.col2.x*this.m_v2.y)-v1X);var k_slop=100.0*Number.MIN_VALUE;var denom=-(rX*nX+rY*nY);if(denom>k_slop){var bX=input.p1.x-v1X;var bY=input.p1.y-v1Y;var a=bX*nX+bY*nY;if(0.0<=a&&a<=input.maxFraction*denom){var mu2=-rX*bY+rY*bX;if(-k_slop*denom<=mu2&&mu2<=denom*(1.0+k_slop)){a/=denom;output.fraction=a;var nLen=Math.sqrt(nX*nX+nY*nY);output.normal.x=nX/nLen;output.normal.y=nY/nLen;return true;}}}return false;};b2EdgeShape.prototype.ComputeAABB=function(aabb,transform){var tMat=transform.R;var v1X=transform.position.x+(tMat.col1.x*this.m_v1.x+tMat.col2.x*this.m_v1.y);var v1Y=transform.position.y+(tMat.col1.y*this.m_v1.x+tMat.col2.y*this.m_v1.y);var v2X=transform.position.x+(tMat.col1.x*this.m_v2.x+tMat.col2.x*this.m_v2.y);var v2Y=transform.position.y+(tMat.col1.y*this.m_v2.x+tMat.col2.y*this.m_v2.y);if(v1X<v2X){aabb.lowerBound.x=v1X;aabb.upperBound.x=v2X;}else{aabb.lowerBound.x=v2X;aabb.upperBound.x=v1X;}if(v1Y<v2Y){aabb.lowerBound.y=v1Y;aabb.upperBound.y=v2Y;}else{aabb.lowerBound.y=v2Y;aabb.upperBound.y=v1Y;}};b2EdgeShape.prototype.ComputeMass=function(massData,density){if(density===undefined)density=0;massData.mass=0;massData.center.SetV(this.m_v1);massData.I=0;};b2EdgeShape.prototype.ComputeSubmergedArea=function(normal,offset,xf,c){if(offset===undefined)offset=0;var v0=new b2Vec2(normal.x*offset,normal.y*offset);var v1=b2Math.MulX(xf,this.m_v1);var v2=b2Math.MulX(xf,this.m_v2);var d1=b2Math.Dot(normal,v1)-offset;var d2=b2Math.Dot(normal,v2)-offset;if(d1>0){if(d2>0){return 0;}else{v1.x=-d2/(d1-d2)*v1.x+d1/(d1-d2)*v2.x;v1.y=-d2/(d1-d2)*v1.y+d1/(d1-d2)*v2.y;}}else{if(d2>0){v2.x=-d2/(d1-d2)*v1.x+d1/(d1-d2)*v2.x;v2.y=-d2/(d1-d2)*v1.y+d1/(d1-d2)*v2.y;}else{}}c.x=(v0.x+v1.x+v2.x)/3;c.y=(v0.y+v1.y+v2.y)/3;return 0.5*((v1.x-v0.x)*(v2.y-v0.y)-(v1.y-v0.y)*(v2.x-v0.x));};b2EdgeShape.prototype.GetLength=function(){return this.m_length;};b2EdgeShape.prototype.GetVertex1=function(){return this.m_v1;};b2EdgeShape.prototype.GetVertex2=function(){return this.m_v2;};b2EdgeShape.prototype.GetCoreVertex1=function(){return this.m_coreV1;};b2EdgeShape.prototype.GetCoreVertex2=function(){return this.m_coreV2;};b2EdgeShape.prototype.GetNormalVector=function(){return this.m_normal;};b2EdgeShape.prototype.GetDirectionVector=function(){return this.m_direction;};b2EdgeShape.prototype.GetCorner1Vector=function(){return this.m_cornerDir1;};b2EdgeShape.prototype.GetCorner2Vector=function(){return this.m_cornerDir2;};b2EdgeShape.prototype.Corner1IsConvex=function(){return this.m_cornerConvex1;};b2EdgeShape.prototype.Corner2IsConvex=function(){return this.m_cornerConvex2;};b2EdgeShape.prototype.GetFirstVertex=function(xf){var tMat=xf.R;return new b2Vec2(xf.position.x+(tMat.col1.x*this.m_coreV1.x+tMat.col2.x*this.m_coreV1.y),xf.position.y+(tMat.col1.y*this.m_coreV1.x+tMat.col2.y*this.m_coreV1.y));};b2EdgeShape.prototype.GetNextEdge=function(){return this.m_nextEdge;};b2EdgeShape.prototype.GetPrevEdge=function(){return this.m_prevEdge;};b2EdgeShape.prototype.Support=function(xf,dX,dY){if(dX===undefined)dX=0;if(dY===undefined)dY=0;var tMat=xf.R;var v1X=xf.position.x+(tMat.col1.x*this.m_coreV1.x+tMat.col2.x*this.m_coreV1.y);var v1Y=xf.position.y+(tMat.col1.y*this.m_coreV1.x+tMat.col2.y*this.m_coreV1.y);var v2X=xf.position.x+(tMat.col1.x*this.m_coreV2.x+tMat.col2.x*this.m_coreV2.y);var v2Y=xf.position.y+(tMat.col1.y*this.m_coreV2.x+tMat.col2.y*this.m_coreV2.y);if(v1X*dX+v1Y*dY>v2X*dX+v2Y*dY){this.s_supportVec.x=v1X;this.s_supportVec.y=v1Y;}else{this.s_supportVec.x=v2X;this.s_supportVec.y=v2Y;}return this.s_supportVec;};b2EdgeShape.prototype.b2EdgeShape=function(v1,v2){this.__super.b2Shape.call(this);this.m_type=b2Shape.e_edgeShape;this.m_prevEdge=null;this.m_nextEdge=null;this.m_v1=v1;this.m_v2=v2;this.m_direction.Set(this.m_v2.x-this.m_v1.x,this.m_v2.y-this.m_v1.y);this.m_length=this.m_direction.Normalize();this.m_normal.Set(this.m_direction.y,-this.m_direction.x);this.m_coreV1.Set(-b2Settings.b2_toiSlop*(this.m_normal.x-this.m_direction.x)+this.m_v1.x,-b2Settings.b2_toiSlop*(this.m_normal.y-this.m_direction.y)+this.m_v1.y);this.m_coreV2.Set(-b2Settings.b2_toiSlop*(this.m_normal.x+this.m_direction.x)+this.m_v2.x,-b2Settings.b2_toiSlop*(this.m_normal.y+this.m_direction.y)+this.m_v2.y);this.m_cornerDir1=this.m_normal;this.m_cornerDir2.Set(-this.m_normal.x,-this.m_normal.y);};b2EdgeShape.prototype.SetPrevEdge=function(edge,core,cornerDir,convex){this.m_prevEdge=edge;this.m_coreV1=core;this.m_cornerDir1=cornerDir;this.m_cornerConvex1=convex;};b2EdgeShape.prototype.SetNextEdge=function(edge,core,cornerDir,convex){this.m_nextEdge=edge;this.m_coreV2=core;this.m_cornerDir2=cornerDir;this.m_cornerConvex2=convex;};b2MassData.b2MassData=function(){this.mass=0.0;this.center=new b2Vec2(0,0);this.I=0.0;};Box2D.inherit(b2PolygonShape,Box2D.Collision.Shapes.b2Shape);b2PolygonShape.prototype.__super=Box2D.Collision.Shapes.b2Shape.prototype;b2PolygonShape.b2PolygonShape=function(){Box2D.Collision.Shapes.b2Shape.b2Shape.apply(this,arguments);};b2PolygonShape.prototype.Copy=function(){var s=new b2PolygonShape();s.Set(this);return s;};b2PolygonShape.prototype.Set=function(other){this.__super.Set.call(this,other);if(Box2D.is(other,b2PolygonShape)){var other2=other instanceof b2PolygonShape?other:null;this.m_centroid.SetV(other2.m_centroid);this.m_vertexCount=other2.m_vertexCount;this.Reserve(this.m_vertexCount);for(var i=0;i<this.m_vertexCount;i++){this.m_vertices[i].SetV(other2.m_vertices[i]);this.m_normals[i].SetV(other2.m_normals[i]);}}};b2PolygonShape.prototype.SetAsArray=function(vertices,vertexCount){if(vertexCount===undefined)vertexCount=0;var v=new Vector();var i=0,tVec;for(i=0;i<vertices.length;++i){tVec=vertices[i];v.push(tVec);}this.SetAsVector(v,vertexCount);};b2PolygonShape.AsArray=function(vertices,vertexCount){if(vertexCount===undefined)vertexCount=0;var polygonShape=new b2PolygonShape();polygonShape.SetAsArray(vertices,vertexCount);return polygonShape;};b2PolygonShape.prototype.SetAsVector=function(vertices,vertexCount){if(vertexCount===undefined)vertexCount=0;if(vertexCount==0)vertexCount=vertices.length;b2Settings.b2Assert(2<=vertexCount);this.m_vertexCount=vertexCount;this.Reserve(vertexCount);var i=0;for(i=0;i<this.m_vertexCount;i++){this.m_vertices[i].SetV(vertices[i]);}for(i=0;i<this.m_vertexCount;++i){var i1=parseInt(i);var i2=parseInt(i+1<this.m_vertexCount?i+1:0);var edge=b2Math.SubtractVV(this.m_vertices[i2],this.m_vertices[i1]);b2Settings.b2Assert(edge.LengthSquared()>Number.MIN_VALUE);this.m_normals[i].SetV(b2Math.CrossVF(edge,1.0));this.m_normals[i].Normalize();}this.m_centroid=b2PolygonShape.ComputeCentroid(this.m_vertices,this.m_vertexCount);};b2PolygonShape.AsVector=function(vertices,vertexCount){if(vertexCount===undefined)vertexCount=0;var polygonShape=new b2PolygonShape();polygonShape.SetAsVector(vertices,vertexCount);return polygonShape;};b2PolygonShape.prototype.SetAsBox=function(hx,hy){if(hx===undefined)hx=0;if(hy===undefined)hy=0;this.m_vertexCount=4;this.Reserve(4);this.m_vertices[0].Set(-hx,-hy);this.m_vertices[1].Set(hx,-hy);this.m_vertices[2].Set(hx,hy);this.m_vertices[3].Set(-hx,hy);this.m_normals[0].Set(0.0,-1.0);this.m_normals[1].Set(1.0,0.0);this.m_normals[2].Set(0.0,1.0);this.m_normals[3].Set(-1.0,0.0);this.m_centroid.SetZero();};b2PolygonShape.AsBox=function(hx,hy){if(hx===undefined)hx=0;if(hy===undefined)hy=0;var polygonShape=new b2PolygonShape();polygonShape.SetAsBox(hx,hy);return polygonShape;};b2PolygonShape.prototype.SetAsOrientedBox=function(hx,hy,center,angle){if(hx===undefined)hx=0;if(hy===undefined)hy=0;if(center===undefined)center=null;if(angle===undefined)angle=0.0;this.m_vertexCount=4;this.Reserve(4);this.m_vertices[0].Set(-hx,-hy);this.m_vertices[1].Set(hx,-hy);this.m_vertices[2].Set(hx,hy);this.m_vertices[3].Set(-hx,hy);this.m_normals[0].Set(0.0,-1.0);this.m_normals[1].Set(1.0,0.0);this.m_normals[2].Set(0.0,1.0);this.m_normals[3].Set(-1.0,0.0);this.m_centroid=center;var xf=new b2Transform();xf.position=center;xf.R.Set(angle);for(var i=0;i<this.m_vertexCount;++i){this.m_vertices[i]=b2Math.MulX(xf,this.m_vertices[i]);this.m_normals[i]=b2Math.MulMV(xf.R,this.m_normals[i]);}};b2PolygonShape.AsOrientedBox=function(hx,hy,center,angle){if(hx===undefined)hx=0;if(hy===undefined)hy=0;if(center===undefined)center=null;if(angle===undefined)angle=0.0;var polygonShape=new b2PolygonShape();polygonShape.SetAsOrientedBox(hx,hy,center,angle);return polygonShape;};b2PolygonShape.prototype.SetAsEdge=function(v1,v2){this.m_vertexCount=2;this.Reserve(2);this.m_vertices[0].SetV(v1);this.m_vertices[1].SetV(v2);this.m_centroid.x=0.5*(v1.x+v2.x);this.m_centroid.y=0.5*(v1.y+v2.y);this.m_normals[0]=b2Math.CrossVF(b2Math.SubtractVV(v2,v1),1.0);this.m_normals[0].Normalize();this.m_normals[1].x=-this.m_normals[0].x;this.m_normals[1].y=-this.m_normals[0].y;};b2PolygonShape.AsEdge=function(v1,v2){var polygonShape=new b2PolygonShape();polygonShape.SetAsEdge(v1,v2);return polygonShape;};b2PolygonShape.prototype.TestPoint=function(xf,p){var tVec;var tMat=xf.R;var tX=p.x-xf.position.x;var tY=p.y-xf.position.y;var pLocalX=tX*tMat.col1.x+tY*tMat.col1.y;var pLocalY=tX*tMat.col2.x+tY*tMat.col2.y;for(var i=0;i<this.m_vertexCount;++i){tVec=this.m_vertices[i];tX=pLocalX-tVec.x;tY=pLocalY-tVec.y;tVec=this.m_normals[i];var dot=tVec.x*tX+tVec.y*tY;if(dot>0.0){return false;}}return true;};b2PolygonShape.prototype.RayCast=function(output,input,transform){var lower=0.0;var upper=input.maxFraction;var tX=0;var tY=0;var tMat;var tVec;tX=input.p1.x-transform.position.x;tY=input.p1.y-transform.position.y;tMat=transform.R;var p1X=tX*tMat.col1.x+tY*tMat.col1.y;var p1Y=tX*tMat.col2.x+tY*tMat.col2.y;tX=input.p2.x-transform.position.x;tY=input.p2.y-transform.position.y;tMat=transform.R;var p2X=tX*tMat.col1.x+tY*tMat.col1.y;var p2Y=tX*tMat.col2.x+tY*tMat.col2.y;var dX=p2X-p1X;var dY=p2Y-p1Y;var index=parseInt(-1);for(var i=0;i<this.m_vertexCount;++i){tVec=this.m_vertices[i];tX=tVec.x-p1X;tY=tVec.y-p1Y;tVec=this.m_normals[i];var numerator=tVec.x*tX+tVec.y*tY;var denominator=tVec.x*dX+tVec.y*dY;if(denominator==0.0){if(numerator<0.0){return false;}}else{if(denominator<0.0&&numerator<lower*denominator){lower=numerator/denominator;index=i;}else if(denominator>0.0&&numerator<upper*denominator){upper=numerator/denominator;}}if(upper<lower-Number.MIN_VALUE){return false;}}if(index>=0){output.fraction=lower;tMat=transform.R;tVec=this.m_normals[index];output.normal.x=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;output.normal.y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;return true;}return false;};b2PolygonShape.prototype.ComputeAABB=function(aabb,xf){var tMat=xf.R;var tVec=this.m_vertices[0];var lowerX=xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var lowerY=xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);var upperX=lowerX;var upperY=lowerY;for(var i=1;i<this.m_vertexCount;++i){tVec=this.m_vertices[i];var vX=xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var vY=xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);lowerX=lowerX<vX?lowerX:vX;lowerY=lowerY<vY?lowerY:vY;upperX=upperX>vX?upperX:vX;upperY=upperY>vY?upperY:vY;}aabb.lowerBound.x=lowerX-this.m_radius;aabb.lowerBound.y=lowerY-this.m_radius;aabb.upperBound.x=upperX+this.m_radius;aabb.upperBound.y=upperY+this.m_radius;};b2PolygonShape.prototype.ComputeMass=function(massData,density){if(density===undefined)density=0;if(this.m_vertexCount==2){massData.center.x=0.5*(this.m_vertices[0].x+this.m_vertices[1].x);massData.center.y=0.5*(this.m_vertices[0].y+this.m_vertices[1].y);massData.mass=0.0;massData.I=0.0;return;}var centerX=0.0;var centerY=0.0;var area=0.0;var I=0.0;var p1X=0.0;var p1Y=0.0;var k_inv3=1.0/3.0;for(var i=0;i<this.m_vertexCount;++i){var p2=this.m_vertices[i];var p3=i+1<this.m_vertexCount?this.m_vertices[parseInt(i+1)]:this.m_vertices[0];var e1X=p2.x-p1X;var e1Y=p2.y-p1Y;var e2X=p3.x-p1X;var e2Y=p3.y-p1Y;var D=e1X*e2Y-e1Y*e2X;var triangleArea=0.5*D;area+=triangleArea;centerX+=triangleArea*k_inv3*(p1X+p2.x+p3.x);centerY+=triangleArea*k_inv3*(p1Y+p2.y+p3.y);var px=p1X;var py=p1Y;var ex1=e1X;var ey1=e1Y;var ex2=e2X;var ey2=e2Y;var intx2=k_inv3*(0.25*(ex1*ex1+ex2*ex1+ex2*ex2)+(px*ex1+px*ex2))+0.5*px*px;var inty2=k_inv3*(0.25*(ey1*ey1+ey2*ey1+ey2*ey2)+(py*ey1+py*ey2))+0.5*py*py;I+=D*(intx2+inty2);}massData.mass=density*area;centerX*=1.0/area;centerY*=1.0/area;massData.center.Set(centerX,centerY);massData.I=density*I;};b2PolygonShape.prototype.ComputeSubmergedArea=function(normal,offset,xf,c){if(offset===undefined)offset=0;var normalL=b2Math.MulTMV(xf.R,normal);var offsetL=offset-b2Math.Dot(normal,xf.position);var depths=new Vector_a2j_Number();var diveCount=0;var intoIndex=parseInt(-1);var outoIndex=parseInt(-1);var lastSubmerged=false;var i=0;for(i=0;i<this.m_vertexCount;++i){depths[i]=b2Math.Dot(normalL,this.m_vertices[i])-offsetL;var isSubmerged=depths[i]<-Number.MIN_VALUE;if(i>0){if(isSubmerged){if(!lastSubmerged){intoIndex=i-1;diveCount++;}}else{if(lastSubmerged){outoIndex=i-1;diveCount++;}}}lastSubmerged=isSubmerged;}switch(diveCount){case 0:if(lastSubmerged){var md=new b2MassData();this.ComputeMass(md,1);c.SetV(b2Math.MulX(xf,md.center));return md.mass;}else{return 0;}break;case 1:if(intoIndex==-1){intoIndex=this.m_vertexCount-1;}else{outoIndex=this.m_vertexCount-1;}break;}var intoIndex2=parseInt((intoIndex+1)%this.m_vertexCount);var outoIndex2=parseInt((outoIndex+1)%this.m_vertexCount);var intoLamdda=(0-depths[intoIndex])/(depths[intoIndex2]-depths[intoIndex]);var outoLamdda=(0-depths[outoIndex])/(depths[outoIndex2]-depths[outoIndex]);var intoVec=new b2Vec2(this.m_vertices[intoIndex].x*(1-intoLamdda)+this.m_vertices[intoIndex2].x*intoLamdda,this.m_vertices[intoIndex].y*(1-intoLamdda)+this.m_vertices[intoIndex2].y*intoLamdda);var outoVec=new b2Vec2(this.m_vertices[outoIndex].x*(1-outoLamdda)+this.m_vertices[outoIndex2].x*outoLamdda,this.m_vertices[outoIndex].y*(1-outoLamdda)+this.m_vertices[outoIndex2].y*outoLamdda);var area=0;var center=new b2Vec2();var p2=this.m_vertices[intoIndex2];var p3;i=intoIndex2;while(i!=outoIndex2){i=(i+1)%this.m_vertexCount;if(i==outoIndex2)p3=outoVec;else p3=this.m_vertices[i];var triangleArea=0.5*((p2.x-intoVec.x)*(p3.y-intoVec.y)-(p2.y-intoVec.y)*(p3.x-intoVec.x));area+=triangleArea;center.x+=triangleArea*(intoVec.x+p2.x+p3.x)/3;center.y+=triangleArea*(intoVec.y+p2.y+p3.y)/3;p2=p3;}center.Multiply(1/area);c.SetV(b2Math.MulX(xf,center));return area;};b2PolygonShape.prototype.GetVertexCount=function(){return this.m_vertexCount;};b2PolygonShape.prototype.GetVertices=function(){return this.m_vertices;};b2PolygonShape.prototype.GetNormals=function(){return this.m_normals;};b2PolygonShape.prototype.GetSupport=function(d){var bestIndex=0;var bestValue=this.m_vertices[0].x*d.x+this.m_vertices[0].y*d.y;for(var i=1;i<this.m_vertexCount;++i){var value=this.m_vertices[i].x*d.x+this.m_vertices[i].y*d.y;if(value>bestValue){bestIndex=i;bestValue=value;}}return bestIndex;};b2PolygonShape.prototype.GetSupportVertex=function(d){var bestIndex=0;var bestValue=this.m_vertices[0].x*d.x+this.m_vertices[0].y*d.y;for(var i=1;i<this.m_vertexCount;++i){var value=this.m_vertices[i].x*d.x+this.m_vertices[i].y*d.y;if(value>bestValue){bestIndex=i;bestValue=value;}}return this.m_vertices[bestIndex];};b2PolygonShape.prototype.Validate=function(){return false;};b2PolygonShape.prototype.b2PolygonShape=function(){this.__super.b2Shape.call(this);this.m_type=b2Shape.e_polygonShape;this.m_centroid=new b2Vec2();this.m_vertices=new Vector();this.m_normals=new Vector();};b2PolygonShape.prototype.Reserve=function(count){if(count===undefined)count=0;for(var i=parseInt(this.m_vertices.length);i<count;i++){this.m_vertices[i]=new b2Vec2();this.m_normals[i]=new b2Vec2();}};b2PolygonShape.ComputeCentroid=function(vs,count){if(count===undefined)count=0;var c=new b2Vec2();var area=0.0;var p1X=0.0;var p1Y=0.0;var inv3=1.0/3.0;for(var i=0;i<count;++i){var p2=vs[i];var p3=i+1<count?vs[parseInt(i+1)]:vs[0];var e1X=p2.x-p1X;var e1Y=p2.y-p1Y;var e2X=p3.x-p1X;var e2Y=p3.y-p1Y;var D=e1X*e2Y-e1Y*e2X;var triangleArea=0.5*D;area+=triangleArea;c.x+=triangleArea*inv3*(p1X+p2.x+p3.x);c.y+=triangleArea*inv3*(p1Y+p2.y+p3.y);}c.x*=1.0/area;c.y*=1.0/area;return c;};b2PolygonShape.ComputeOBB=function(obb,vs,count){if(count===undefined)count=0;var i=0;var p=new Vector(count+1);for(i=0;i<count;++i){p[i]=vs[i];}p[count]=p[0];var minArea=Number.MAX_VALUE;for(i=1;i<=count;++i){var root=p[parseInt(i-1)];var uxX=p[i].x-root.x;var uxY=p[i].y-root.y;var length=Math.sqrt(uxX*uxX+uxY*uxY);uxX/=length;uxY/=length;var uyX=-uxY;var uyY=uxX;var lowerX=Number.MAX_VALUE;var lowerY=Number.MAX_VALUE;var upperX=-Number.MAX_VALUE;var upperY=-Number.MAX_VALUE;for(var j=0;j<count;++j){var dX=p[j].x-root.x;var dY=p[j].y-root.y;var rX=uxX*dX+uxY*dY;var rY=uyX*dX+uyY*dY;if(rX<lowerX)lowerX=rX;if(rY<lowerY)lowerY=rY;if(rX>upperX)upperX=rX;if(rY>upperY)upperY=rY;}var area=(upperX-lowerX)*(upperY-lowerY);if(area<0.95*minArea){minArea=area;obb.R.col1.x=uxX;obb.R.col1.y=uxY;obb.R.col2.x=uyX;obb.R.col2.y=uyY;var centerX=0.5*(lowerX+upperX);var centerY=0.5*(lowerY+upperY);var tMat=obb.R;obb.center.x=root.x+(tMat.col1.x*centerX+tMat.col2.x*centerY);obb.center.y=root.y+(tMat.col1.y*centerX+tMat.col2.y*centerY);obb.extents.x=0.5*(upperX-lowerX);obb.extents.y=0.5*(upperY-lowerY);}}};Box2D.postDefs.push(function(){Box2D.Collision.Shapes.b2PolygonShape.s_mat=new b2Mat22();});b2Shape.b2Shape=function(){};b2Shape.prototype.Copy=function(){return null;};b2Shape.prototype.Set=function(other){this.m_radius=other.m_radius;};b2Shape.prototype.GetType=function(){return this.m_type;};b2Shape.prototype.TestPoint=function(xf,p){return false;};b2Shape.prototype.RayCast=function(output,input,transform){return false;};b2Shape.prototype.ComputeAABB=function(aabb,xf){};b2Shape.prototype.ComputeMass=function(massData,density){if(density===undefined)density=0;};b2Shape.prototype.ComputeSubmergedArea=function(normal,offset,xf,c){if(offset===undefined)offset=0;return 0;};b2Shape.TestOverlap=function(shape1,transform1,shape2,transform2){var input=new b2DistanceInput();input.proxyA=new b2DistanceProxy();input.proxyA.Set(shape1);input.proxyB=new b2DistanceProxy();input.proxyB.Set(shape2);input.transformA=transform1;input.transformB=transform2;input.useRadii=true;var simplexCache=new b2SimplexCache();simplexCache.count=0;var output=new b2DistanceOutput();b2Distance.Distance(output,simplexCache,input);return output.distance<10.0*Number.MIN_VALUE;};b2Shape.prototype.b2Shape=function(){this.m_type=b2Shape.e_unknownShape;this.m_radius=b2Settings.b2_linearSlop;};Box2D.postDefs.push(function(){Box2D.Collision.Shapes.b2Shape.e_unknownShape=parseInt(-1);Box2D.Collision.Shapes.b2Shape.e_circleShape=0;Box2D.Collision.Shapes.b2Shape.e_polygonShape=1;Box2D.Collision.Shapes.b2Shape.e_edgeShape=2;Box2D.Collision.Shapes.b2Shape.e_shapeTypeCount=3;Box2D.Collision.Shapes.b2Shape.e_hitCollide=1;Box2D.Collision.Shapes.b2Shape.e_missCollide=0;Box2D.Collision.Shapes.b2Shape.e_startsInsideCollide=parseInt(-1);});})();(function(){var b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3;b2Color.b2Color=function(){this._r=0;this._g=0;this._b=0;};b2Color.prototype.b2Color=function(rr,gg,bb){if(rr===undefined)rr=0;if(gg===undefined)gg=0;if(bb===undefined)bb=0;this._r=Box2D.parseUInt(255*b2Math.Clamp(rr,0.0,1.0));this._g=Box2D.parseUInt(255*b2Math.Clamp(gg,0.0,1.0));this._b=Box2D.parseUInt(255*b2Math.Clamp(bb,0.0,1.0));};b2Color.prototype.Set=function(rr,gg,bb){if(rr===undefined)rr=0;if(gg===undefined)gg=0;if(bb===undefined)bb=0;this._r=Box2D.parseUInt(255*b2Math.Clamp(rr,0.0,1.0));this._g=Box2D.parseUInt(255*b2Math.Clamp(gg,0.0,1.0));this._b=Box2D.parseUInt(255*b2Math.Clamp(bb,0.0,1.0));};Object.defineProperty(b2Color.prototype,'r',{enumerable:false,configurable:true,set:function set(rr){if(rr===undefined)rr=0;this._r=Box2D.parseUInt(255*b2Math.Clamp(rr,0.0,1.0));}});Object.defineProperty(b2Color.prototype,'g',{enumerable:false,configurable:true,set:function set(gg){if(gg===undefined)gg=0;this._g=Box2D.parseUInt(255*b2Math.Clamp(gg,0.0,1.0));}});Object.defineProperty(b2Color.prototype,'b',{enumerable:false,configurable:true,set:function set(bb){if(bb===undefined)bb=0;this._b=Box2D.parseUInt(255*b2Math.Clamp(bb,0.0,1.0));}});Object.defineProperty(b2Color.prototype,'color',{enumerable:false,configurable:true,get:function get(){return this._r<<16|this._g<<8|this._b;}});b2Settings.b2Settings=function(){};b2Settings.b2MixFriction=function(friction1,friction2){if(friction1===undefined)friction1=0;if(friction2===undefined)friction2=0;return Math.sqrt(friction1*friction2);};b2Settings.b2MixRestitution=function(restitution1,restitution2){if(restitution1===undefined)restitution1=0;if(restitution2===undefined)restitution2=0;return restitution1>restitution2?restitution1:restitution2;};b2Settings.b2Assert=function(a){if(!a){throw"Assertion Failed";}};Box2D.postDefs.push(function(){Box2D.Common.b2Settings.VERSION="2.1alpha";Box2D.Common.b2Settings.USHRT_MAX=0x0000ffff;Box2D.Common.b2Settings.b2_pi=Math.PI;Box2D.Common.b2Settings.b2_maxManifoldPoints=2;Box2D.Common.b2Settings.b2_aabbExtension=0.1;Box2D.Common.b2Settings.b2_aabbMultiplier=2.0;Box2D.Common.b2Settings.b2_polygonRadius=2.0*b2Settings.b2_linearSlop;Box2D.Common.b2Settings.b2_linearSlop=0.005;Box2D.Common.b2Settings.b2_angularSlop=2.0/180.0*b2Settings.b2_pi;Box2D.Common.b2Settings.b2_toiSlop=8.0*b2Settings.b2_linearSlop;Box2D.Common.b2Settings.b2_maxTOIContactsPerIsland=32;Box2D.Common.b2Settings.b2_maxTOIJointsPerIsland=32;Box2D.Common.b2Settings.b2_velocityThreshold=1.0;Box2D.Common.b2Settings.b2_maxLinearCorrection=0.2;Box2D.Common.b2Settings.b2_maxAngularCorrection=8.0/180.0*b2Settings.b2_pi;Box2D.Common.b2Settings.b2_maxTranslation=2.0;Box2D.Common.b2Settings.b2_maxTranslationSquared=b2Settings.b2_maxTranslation*b2Settings.b2_maxTranslation;Box2D.Common.b2Settings.b2_maxRotation=0.5*b2Settings.b2_pi;Box2D.Common.b2Settings.b2_maxRotationSquared=b2Settings.b2_maxRotation*b2Settings.b2_maxRotation;Box2D.Common.b2Settings.b2_contactBaumgarte=0.2;Box2D.Common.b2Settings.b2_timeToSleep=0.5;Box2D.Common.b2Settings.b2_linearSleepTolerance=0.01;Box2D.Common.b2Settings.b2_angularSleepTolerance=2.0/180.0*b2Settings.b2_pi;});})();(function(){var b2AABB=Box2D.Collision.b2AABB,b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3;b2Mat22.b2Mat22=function(){this.col1=new b2Vec2();this.col2=new b2Vec2();};b2Mat22.prototype.b2Mat22=function(){this.SetIdentity();};b2Mat22.FromAngle=function(angle){if(angle===undefined)angle=0;var mat=new b2Mat22();mat.Set(angle);return mat;};b2Mat22.FromVV=function(c1,c2){var mat=new b2Mat22();mat.SetVV(c1,c2);return mat;};b2Mat22.prototype.Set=function(angle){if(angle===undefined)angle=0;var c=Math.cos(angle);var s=Math.sin(angle);this.col1.x=c;this.col2.x=-s;this.col1.y=s;this.col2.y=c;};b2Mat22.prototype.SetVV=function(c1,c2){this.col1.SetV(c1);this.col2.SetV(c2);};b2Mat22.prototype.Copy=function(){var mat=new b2Mat22();mat.SetM(this);return mat;};b2Mat22.prototype.SetM=function(m){this.col1.SetV(m.col1);this.col2.SetV(m.col2);};b2Mat22.prototype.AddM=function(m){this.col1.x+=m.col1.x;this.col1.y+=m.col1.y;this.col2.x+=m.col2.x;this.col2.y+=m.col2.y;};b2Mat22.prototype.SetIdentity=function(){this.col1.x=1.0;this.col2.x=0.0;this.col1.y=0.0;this.col2.y=1.0;};b2Mat22.prototype.SetZero=function(){this.col1.x=0.0;this.col2.x=0.0;this.col1.y=0.0;this.col2.y=0.0;};b2Mat22.prototype.GetAngle=function(){return Math.atan2(this.col1.y,this.col1.x);};b2Mat22.prototype.GetInverse=function(out){var a=this.col1.x;var b=this.col2.x;var c=this.col1.y;var d=this.col2.y;var det=a*d-b*c;if(det!=0.0){det=1.0/det;}out.col1.x=det*d;out.col2.x=-det*b;out.col1.y=-det*c;out.col2.y=det*a;return out;};b2Mat22.prototype.Solve=function(out,bX,bY){if(bX===undefined)bX=0;if(bY===undefined)bY=0;var a11=this.col1.x;var a12=this.col2.x;var a21=this.col1.y;var a22=this.col2.y;var det=a11*a22-a12*a21;if(det!=0.0){det=1.0/det;}out.x=det*(a22*bX-a12*bY);out.y=det*(a11*bY-a21*bX);return out;};b2Mat22.prototype.Abs=function(){this.col1.Abs();this.col2.Abs();};b2Mat33.b2Mat33=function(){this.col1=new b2Vec3();this.col2=new b2Vec3();this.col3=new b2Vec3();};b2Mat33.prototype.b2Mat33=function(c1,c2,c3){if(c1===undefined)c1=null;if(c2===undefined)c2=null;if(c3===undefined)c3=null;if(!c1&&!c2&&!c3){this.col1.SetZero();this.col2.SetZero();this.col3.SetZero();}else{this.col1.SetV(c1);this.col2.SetV(c2);this.col3.SetV(c3);}};b2Mat33.prototype.SetVVV=function(c1,c2,c3){this.col1.SetV(c1);this.col2.SetV(c2);this.col3.SetV(c3);};b2Mat33.prototype.Copy=function(){return new b2Mat33(this.col1,this.col2,this.col3);};b2Mat33.prototype.SetM=function(m){this.col1.SetV(m.col1);this.col2.SetV(m.col2);this.col3.SetV(m.col3);};b2Mat33.prototype.AddM=function(m){this.col1.x+=m.col1.x;this.col1.y+=m.col1.y;this.col1.z+=m.col1.z;this.col2.x+=m.col2.x;this.col2.y+=m.col2.y;this.col2.z+=m.col2.z;this.col3.x+=m.col3.x;this.col3.y+=m.col3.y;this.col3.z+=m.col3.z;};b2Mat33.prototype.SetIdentity=function(){this.col1.x=1.0;this.col2.x=0.0;this.col3.x=0.0;this.col1.y=0.0;this.col2.y=1.0;this.col3.y=0.0;this.col1.z=0.0;this.col2.z=0.0;this.col3.z=1.0;};b2Mat33.prototype.SetZero=function(){this.col1.x=0.0;this.col2.x=0.0;this.col3.x=0.0;this.col1.y=0.0;this.col2.y=0.0;this.col3.y=0.0;this.col1.z=0.0;this.col2.z=0.0;this.col3.z=0.0;};b2Mat33.prototype.Solve22=function(out,bX,bY){if(bX===undefined)bX=0;if(bY===undefined)bY=0;var a11=this.col1.x;var a12=this.col2.x;var a21=this.col1.y;var a22=this.col2.y;var det=a11*a22-a12*a21;if(det!=0.0){det=1.0/det;}out.x=det*(a22*bX-a12*bY);out.y=det*(a11*bY-a21*bX);return out;};b2Mat33.prototype.Solve33=function(out,bX,bY,bZ){if(bX===undefined)bX=0;if(bY===undefined)bY=0;if(bZ===undefined)bZ=0;var a11=this.col1.x;var a21=this.col1.y;var a31=this.col1.z;var a12=this.col2.x;var a22=this.col2.y;var a32=this.col2.z;var a13=this.col3.x;var a23=this.col3.y;var a33=this.col3.z;var det=a11*(a22*a33-a32*a23)+a21*(a32*a13-a12*a33)+a31*(a12*a23-a22*a13);if(det!=0.0){det=1.0/det;}out.x=det*(bX*(a22*a33-a32*a23)+bY*(a32*a13-a12*a33)+bZ*(a12*a23-a22*a13));out.y=det*(a11*(bY*a33-bZ*a23)+a21*(bZ*a13-bX*a33)+a31*(bX*a23-bY*a13));out.z=det*(a11*(a22*bZ-a32*bY)+a21*(a32*bX-a12*bZ)+a31*(a12*bY-a22*bX));return out;};b2Math.b2Math=function(){};b2Math.IsValid=function(x){if(x===undefined)x=0;return isFinite(x);};b2Math.Dot=function(a,b){return a.x*b.x+a.y*b.y;};b2Math.CrossVV=function(a,b){return a.x*b.y-a.y*b.x;};b2Math.CrossVF=function(a,s){if(s===undefined)s=0;var v=new b2Vec2(s*a.y,-s*a.x);return v;};b2Math.CrossFV=function(s,a){if(s===undefined)s=0;var v=new b2Vec2(-s*a.y,s*a.x);return v;};b2Math.MulMV=function(A,v){var u=new b2Vec2(A.col1.x*v.x+A.col2.x*v.y,A.col1.y*v.x+A.col2.y*v.y);return u;};b2Math.MulTMV=function(A,v){var u=new b2Vec2(b2Math.Dot(v,A.col1),b2Math.Dot(v,A.col2));return u;};b2Math.MulX=function(T,v){var a=b2Math.MulMV(T.R,v);a.x+=T.position.x;a.y+=T.position.y;return a;};b2Math.MulXT=function(T,v){var a=b2Math.SubtractVV(v,T.position);var tX=a.x*T.R.col1.x+a.y*T.R.col1.y;a.y=a.x*T.R.col2.x+a.y*T.R.col2.y;a.x=tX;return a;};b2Math.AddVV=function(a,b){var v=new b2Vec2(a.x+b.x,a.y+b.y);return v;};b2Math.SubtractVV=function(a,b){var v=new b2Vec2(a.x-b.x,a.y-b.y);return v;};b2Math.Distance=function(a,b){var cX=a.x-b.x;var cY=a.y-b.y;return Math.sqrt(cX*cX+cY*cY);};b2Math.DistanceSquared=function(a,b){var cX=a.x-b.x;var cY=a.y-b.y;return cX*cX+cY*cY;};b2Math.MulFV=function(s,a){if(s===undefined)s=0;var v=new b2Vec2(s*a.x,s*a.y);return v;};b2Math.AddMM=function(A,B){var C=b2Mat22.FromVV(b2Math.AddVV(A.col1,B.col1),b2Math.AddVV(A.col2,B.col2));return C;};b2Math.MulMM=function(A,B){var C=b2Mat22.FromVV(b2Math.MulMV(A,B.col1),b2Math.MulMV(A,B.col2));return C;};b2Math.MulTMM=function(A,B){var c1=new b2Vec2(b2Math.Dot(A.col1,B.col1),b2Math.Dot(A.col2,B.col1));var c2=new b2Vec2(b2Math.Dot(A.col1,B.col2),b2Math.Dot(A.col2,B.col2));var C=b2Mat22.FromVV(c1,c2);return C;};b2Math.Abs=function(a){if(a===undefined)a=0;return a>0.0?a:-a;};b2Math.AbsV=function(a){var b=new b2Vec2(b2Math.Abs(a.x),b2Math.Abs(a.y));return b;};b2Math.AbsM=function(A){var B=b2Mat22.FromVV(b2Math.AbsV(A.col1),b2Math.AbsV(A.col2));return B;};b2Math.Min=function(a,b){if(a===undefined)a=0;if(b===undefined)b=0;return a<b?a:b;};b2Math.MinV=function(a,b){var c=new b2Vec2(b2Math.Min(a.x,b.x),b2Math.Min(a.y,b.y));return c;};b2Math.Max=function(a,b){if(a===undefined)a=0;if(b===undefined)b=0;return a>b?a:b;};b2Math.MaxV=function(a,b){var c=new b2Vec2(b2Math.Max(a.x,b.x),b2Math.Max(a.y,b.y));return c;};b2Math.Clamp=function(a,low,high){if(a===undefined)a=0;if(low===undefined)low=0;if(high===undefined)high=0;return a<low?low:a>high?high:a;};b2Math.ClampV=function(a,low,high){return b2Math.MaxV(low,b2Math.MinV(a,high));};b2Math.Swap=function(a,b){var tmp=a[0];a[0]=b[0];b[0]=tmp;};b2Math.Random=function(){return Math.random()*2-1;};b2Math.RandomRange=function(lo,hi){if(lo===undefined)lo=0;if(hi===undefined)hi=0;var r=Math.random();r=(hi-lo)*r+lo;return r;};b2Math.NextPowerOfTwo=function(x){if(x===undefined)x=0;x|=x>>1&0x7FFFFFFF;x|=x>>2&0x3FFFFFFF;x|=x>>4&0x0FFFFFFF;x|=x>>8&0x00FFFFFF;x|=x>>16&0x0000FFFF;return x+1;};b2Math.IsPowerOfTwo=function(x){if(x===undefined)x=0;var result=x>0&&(x&x-1)==0;return result;};Box2D.postDefs.push(function(){Box2D.Common.Math.b2Math.b2Vec2_zero=new b2Vec2(0.0,0.0);Box2D.Common.Math.b2Math.b2Mat22_identity=b2Mat22.FromVV(new b2Vec2(1.0,0.0),new b2Vec2(0.0,1.0));Box2D.Common.Math.b2Math.b2Transform_identity=new b2Transform(b2Math.b2Vec2_zero,b2Math.b2Mat22_identity);});b2Sweep.b2Sweep=function(){this.localCenter=new b2Vec2();this.c0=new b2Vec2();this.c=new b2Vec2();};b2Sweep.prototype.Set=function(other){this.localCenter.SetV(other.localCenter);this.c0.SetV(other.c0);this.c.SetV(other.c);this.a0=other.a0;this.a=other.a;this.t0=other.t0;};b2Sweep.prototype.Copy=function(){var copy=new b2Sweep();copy.localCenter.SetV(this.localCenter);copy.c0.SetV(this.c0);copy.c.SetV(this.c);copy.a0=this.a0;copy.a=this.a;copy.t0=this.t0;return copy;};b2Sweep.prototype.GetTransform=function(xf,alpha){if(alpha===undefined)alpha=0;xf.position.x=(1.0-alpha)*this.c0.x+alpha*this.c.x;xf.position.y=(1.0-alpha)*this.c0.y+alpha*this.c.y;var angle=(1.0-alpha)*this.a0+alpha*this.a;xf.R.Set(angle);var tMat=xf.R;xf.position.x-=tMat.col1.x*this.localCenter.x+tMat.col2.x*this.localCenter.y;xf.position.y-=tMat.col1.y*this.localCenter.x+tMat.col2.y*this.localCenter.y;};b2Sweep.prototype.Advance=function(t){if(t===undefined)t=0;if(this.t0<t&&1.0-this.t0>Number.MIN_VALUE){var alpha=(t-this.t0)/(1.0-this.t0);this.c0.x=(1.0-alpha)*this.c0.x+alpha*this.c.x;this.c0.y=(1.0-alpha)*this.c0.y+alpha*this.c.y;this.a0=(1.0-alpha)*this.a0+alpha*this.a;this.t0=t;}};b2Transform.b2Transform=function(){this.position=new b2Vec2();this.R=new b2Mat22();};b2Transform.prototype.b2Transform=function(pos,r){if(pos===undefined)pos=null;if(r===undefined)r=null;if(pos){this.position.SetV(pos);this.R.SetM(r);}};b2Transform.prototype.Initialize=function(pos,r){this.position.SetV(pos);this.R.SetM(r);};b2Transform.prototype.SetIdentity=function(){this.position.SetZero();this.R.SetIdentity();};b2Transform.prototype.Set=function(x){this.position.SetV(x.position);this.R.SetM(x.R);};b2Transform.prototype.GetAngle=function(){return Math.atan2(this.R.col1.y,this.R.col1.x);};b2Vec2.b2Vec2=function(){};b2Vec2.prototype.b2Vec2=function(x_,y_){if(x_===undefined)x_=0;if(y_===undefined)y_=0;this.x=x_;this.y=y_;};b2Vec2.prototype.SetZero=function(){this.x=0.0;this.y=0.0;};b2Vec2.prototype.Set=function(x_,y_){if(x_===undefined)x_=0;if(y_===undefined)y_=0;this.x=x_;this.y=y_;};b2Vec2.prototype.SetV=function(v){this.x=v.x;this.y=v.y;};b2Vec2.prototype.GetNegative=function(){return new b2Vec2(-this.x,-this.y);};b2Vec2.prototype.NegativeSelf=function(){this.x=-this.x;this.y=-this.y;};b2Vec2.Make=function(x_,y_){if(x_===undefined)x_=0;if(y_===undefined)y_=0;return new b2Vec2(x_,y_);};b2Vec2.prototype.Copy=function(){return new b2Vec2(this.x,this.y);};b2Vec2.prototype.Add=function(v){this.x+=v.x;this.y+=v.y;};b2Vec2.prototype.Subtract=function(v){this.x-=v.x;this.y-=v.y;};b2Vec2.prototype.Multiply=function(a){if(a===undefined)a=0;this.x*=a;this.y*=a;};b2Vec2.prototype.MulM=function(A){var tX=this.x;this.x=A.col1.x*tX+A.col2.x*this.y;this.y=A.col1.y*tX+A.col2.y*this.y;};b2Vec2.prototype.MulTM=function(A){var tX=b2Math.Dot(this,A.col1);this.y=b2Math.Dot(this,A.col2);this.x=tX;};b2Vec2.prototype.CrossVF=function(s){if(s===undefined)s=0;var tX=this.x;this.x=s*this.y;this.y=-s*tX;};b2Vec2.prototype.CrossFV=function(s){if(s===undefined)s=0;var tX=this.x;this.x=-s*this.y;this.y=s*tX;};b2Vec2.prototype.MinV=function(b){this.x=this.x<b.x?this.x:b.x;this.y=this.y<b.y?this.y:b.y;};b2Vec2.prototype.MaxV=function(b){this.x=this.x>b.x?this.x:b.x;this.y=this.y>b.y?this.y:b.y;};b2Vec2.prototype.Abs=function(){if(this.x<0)this.x=-this.x;if(this.y<0)this.y=-this.y;};b2Vec2.prototype.Length=function(){return Math.sqrt(this.x*this.x+this.y*this.y);};b2Vec2.prototype.LengthSquared=function(){return this.x*this.x+this.y*this.y;};b2Vec2.prototype.Normalize=function(){var length=Math.sqrt(this.x*this.x+this.y*this.y);if(length<Number.MIN_VALUE){return 0.0;}var invLength=1.0/length;this.x*=invLength;this.y*=invLength;return length;};b2Vec2.prototype.IsValid=function(){return b2Math.IsValid(this.x)&&b2Math.IsValid(this.y);};b2Vec3.b2Vec3=function(){};b2Vec3.prototype.b2Vec3=function(x,y,z){if(x===undefined)x=0;if(y===undefined)y=0;if(z===undefined)z=0;this.x=x;this.y=y;this.z=z;};b2Vec3.prototype.SetZero=function(){this.x=this.y=this.z=0.0;};b2Vec3.prototype.Set=function(x,y,z){if(x===undefined)x=0;if(y===undefined)y=0;if(z===undefined)z=0;this.x=x;this.y=y;this.z=z;};b2Vec3.prototype.SetV=function(v){this.x=v.x;this.y=v.y;this.z=v.z;};b2Vec3.prototype.GetNegative=function(){return new b2Vec3(-this.x,-this.y,-this.z);};b2Vec3.prototype.NegativeSelf=function(){this.x=-this.x;this.y=-this.y;this.z=-this.z;};b2Vec3.prototype.Copy=function(){return new b2Vec3(this.x,this.y,this.z);};b2Vec3.prototype.Add=function(v){this.x+=v.x;this.y+=v.y;this.z+=v.z;};b2Vec3.prototype.Subtract=function(v){this.x-=v.x;this.y-=v.y;this.z-=v.z;};b2Vec3.prototype.Multiply=function(a){if(a===undefined)a=0;this.x*=a;this.y*=a;this.z*=a;};})();(function(){var b2ControllerEdge=Box2D.Dynamics.Controllers.b2ControllerEdge,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2AABB=Box2D.Collision.b2AABB,b2Bound=Box2D.Collision.b2Bound,b2BoundValues=Box2D.Collision.b2BoundValues,b2Collision=Box2D.Collision.b2Collision,b2ContactID=Box2D.Collision.b2ContactID,b2ContactPoint=Box2D.Collision.b2ContactPoint,b2Distance=Box2D.Collision.b2Distance,b2DistanceInput=Box2D.Collision.b2DistanceInput,b2DistanceOutput=Box2D.Collision.b2DistanceOutput,b2DistanceProxy=Box2D.Collision.b2DistanceProxy,b2DynamicTree=Box2D.Collision.b2DynamicTree,b2DynamicTreeBroadPhase=Box2D.Collision.b2DynamicTreeBroadPhase,b2DynamicTreeNode=Box2D.Collision.b2DynamicTreeNode,b2DynamicTreePair=Box2D.Collision.b2DynamicTreePair,b2Manifold=Box2D.Collision.b2Manifold,b2ManifoldPoint=Box2D.Collision.b2ManifoldPoint,b2Point=Box2D.Collision.b2Point,b2RayCastInput=Box2D.Collision.b2RayCastInput,b2RayCastOutput=Box2D.Collision.b2RayCastOutput,b2Segment=Box2D.Collision.b2Segment,b2SeparationFunction=Box2D.Collision.b2SeparationFunction,b2Simplex=Box2D.Collision.b2Simplex,b2SimplexCache=Box2D.Collision.b2SimplexCache,b2SimplexVertex=Box2D.Collision.b2SimplexVertex,b2TimeOfImpact=Box2D.Collision.b2TimeOfImpact,b2TOIInput=Box2D.Collision.b2TOIInput,b2WorldManifold=Box2D.Collision.b2WorldManifold,ClipVertex=Box2D.Collision.ClipVertex,Features=Box2D.Collision.Features,IBroadPhase=Box2D.Collision.IBroadPhase,b2CircleShape=Box2D.Collision.Shapes.b2CircleShape,b2EdgeChainDef=Box2D.Collision.Shapes.b2EdgeChainDef,b2EdgeShape=Box2D.Collision.Shapes.b2EdgeShape,b2MassData=Box2D.Collision.Shapes.b2MassData,b2PolygonShape=Box2D.Collision.Shapes.b2PolygonShape,b2Shape=Box2D.Collision.Shapes.b2Shape,b2Body=Box2D.Dynamics.b2Body,b2BodyDef=Box2D.Dynamics.b2BodyDef,b2ContactFilter=Box2D.Dynamics.b2ContactFilter,b2ContactImpulse=Box2D.Dynamics.b2ContactImpulse,b2ContactListener=Box2D.Dynamics.b2ContactListener,b2ContactManager=Box2D.Dynamics.b2ContactManager,b2DebugDraw=Box2D.Dynamics.b2DebugDraw,b2DestructionListener=Box2D.Dynamics.b2DestructionListener,b2FilterData=Box2D.Dynamics.b2FilterData,b2Fixture=Box2D.Dynamics.b2Fixture,b2FixtureDef=Box2D.Dynamics.b2FixtureDef,b2Island=Box2D.Dynamics.b2Island,b2TimeStep=Box2D.Dynamics.b2TimeStep,b2World=Box2D.Dynamics.b2World,b2CircleContact=Box2D.Dynamics.Contacts.b2CircleContact,b2Contact=Box2D.Dynamics.Contacts.b2Contact,b2ContactConstraint=Box2D.Dynamics.Contacts.b2ContactConstraint,b2ContactConstraintPoint=Box2D.Dynamics.Contacts.b2ContactConstraintPoint,b2ContactEdge=Box2D.Dynamics.Contacts.b2ContactEdge,b2ContactFactory=Box2D.Dynamics.Contacts.b2ContactFactory,b2ContactRegister=Box2D.Dynamics.Contacts.b2ContactRegister,b2ContactResult=Box2D.Dynamics.Contacts.b2ContactResult,b2ContactSolver=Box2D.Dynamics.Contacts.b2ContactSolver,b2EdgeAndCircleContact=Box2D.Dynamics.Contacts.b2EdgeAndCircleContact,b2NullContact=Box2D.Dynamics.Contacts.b2NullContact,b2PolyAndCircleContact=Box2D.Dynamics.Contacts.b2PolyAndCircleContact,b2PolyAndEdgeContact=Box2D.Dynamics.Contacts.b2PolyAndEdgeContact,b2PolygonContact=Box2D.Dynamics.Contacts.b2PolygonContact,b2PositionSolverManifold=Box2D.Dynamics.Contacts.b2PositionSolverManifold,b2Controller=Box2D.Dynamics.Controllers.b2Controller,b2DistanceJoint=Box2D.Dynamics.Joints.b2DistanceJoint,b2DistanceJointDef=Box2D.Dynamics.Joints.b2DistanceJointDef,b2FrictionJoint=Box2D.Dynamics.Joints.b2FrictionJoint,b2FrictionJointDef=Box2D.Dynamics.Joints.b2FrictionJointDef,b2GearJoint=Box2D.Dynamics.Joints.b2GearJoint,b2GearJointDef=Box2D.Dynamics.Joints.b2GearJointDef,b2Jacobian=Box2D.Dynamics.Joints.b2Jacobian,b2Joint=Box2D.Dynamics.Joints.b2Joint,b2JointDef=Box2D.Dynamics.Joints.b2JointDef,b2JointEdge=Box2D.Dynamics.Joints.b2JointEdge,b2LineJoint=Box2D.Dynamics.Joints.b2LineJoint,b2LineJointDef=Box2D.Dynamics.Joints.b2LineJointDef,b2MouseJoint=Box2D.Dynamics.Joints.b2MouseJoint,b2MouseJointDef=Box2D.Dynamics.Joints.b2MouseJointDef,b2PrismaticJoint=Box2D.Dynamics.Joints.b2PrismaticJoint,b2PrismaticJointDef=Box2D.Dynamics.Joints.b2PrismaticJointDef,b2PulleyJoint=Box2D.Dynamics.Joints.b2PulleyJoint,b2PulleyJointDef=Box2D.Dynamics.Joints.b2PulleyJointDef,b2RevoluteJoint=Box2D.Dynamics.Joints.b2RevoluteJoint,b2RevoluteJointDef=Box2D.Dynamics.Joints.b2RevoluteJointDef,b2WeldJoint=Box2D.Dynamics.Joints.b2WeldJoint,b2WeldJointDef=Box2D.Dynamics.Joints.b2WeldJointDef;b2Body.b2Body=function(){this.m_xf=new b2Transform();this.m_sweep=new b2Sweep();this.m_linearVelocity=new b2Vec2();this.m_force=new b2Vec2();};b2Body.prototype.connectEdges=function(s1,s2,angle1){if(angle1===undefined)angle1=0;var angle2=Math.atan2(s2.GetDirectionVector().y,s2.GetDirectionVector().x);var coreOffset=Math.tan((angle2-angle1)*0.5);var core=b2Math.MulFV(coreOffset,s2.GetDirectionVector());core=b2Math.SubtractVV(core,s2.GetNormalVector());core=b2Math.MulFV(b2Settings.b2_toiSlop,core);core=b2Math.AddVV(core,s2.GetVertex1());var cornerDir=b2Math.AddVV(s1.GetDirectionVector(),s2.GetDirectionVector());cornerDir.Normalize();var convex=b2Math.Dot(s1.GetDirectionVector(),s2.GetNormalVector())>0.0;s1.SetNextEdge(s2,core,cornerDir,convex);s2.SetPrevEdge(s1,core,cornerDir,convex);return angle2;};b2Body.prototype.CreateFixture=function(def){if(this.m_world.IsLocked()==true){return null;}var fixture=new b2Fixture();fixture.Create(this,this.m_xf,def);if(this.m_flags&b2Body.e_activeFlag){var broadPhase=this.m_world.m_contactManager.m_broadPhase;fixture.CreateProxy(broadPhase,this.m_xf);}fixture.m_next=this.m_fixtureList;this.m_fixtureList=fixture;++this.m_fixtureCount;fixture.m_body=this;if(fixture.m_density>0.0){this.ResetMassData();}this.m_world.m_flags|=b2World.e_newFixture;return fixture;};b2Body.prototype.CreateFixture2=function(shape,density){if(density===undefined)density=0.0;var def=new b2FixtureDef();def.shape=shape;def.density=density;return this.CreateFixture(def);};b2Body.prototype.DestroyFixture=function(fixture){if(this.m_world.IsLocked()==true){return;}var node=this.m_fixtureList;var ppF=null;var found=false;while(node!=null){if(node==fixture){if(ppF)ppF.m_next=fixture.m_next;else this.m_fixtureList=fixture.m_next;found=true;break;}ppF=node;node=node.m_next;}var edge=this.m_contactList;while(edge){var c=edge.contact;edge=edge.next;var fixtureA=c.GetFixtureA();var fixtureB=c.GetFixtureB();if(fixture==fixtureA||fixture==fixtureB){this.m_world.m_contactManager.Destroy(c);}}if(this.m_flags&b2Body.e_activeFlag){var broadPhase=this.m_world.m_contactManager.m_broadPhase;fixture.DestroyProxy(broadPhase);}else{}fixture.Destroy();fixture.m_body=null;fixture.m_next=null;--this.m_fixtureCount;this.ResetMassData();};b2Body.prototype.SetPositionAndAngle=function(position,angle){if(angle===undefined)angle=0;var f;if(this.m_world.IsLocked()==true){return;}this.m_xf.R.Set(angle);this.m_xf.position.SetV(position);var tMat=this.m_xf.R;var tVec=this.m_sweep.localCenter;this.m_sweep.c.x=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;this.m_sweep.c.y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_sweep.c.x+=this.m_xf.position.x;this.m_sweep.c.y+=this.m_xf.position.y;this.m_sweep.c0.SetV(this.m_sweep.c);this.m_sweep.a0=this.m_sweep.a=angle;var broadPhase=this.m_world.m_contactManager.m_broadPhase;for(f=this.m_fixtureList;f;f=f.m_next){f.Synchronize(broadPhase,this.m_xf,this.m_xf);}this.m_world.m_contactManager.FindNewContacts();};b2Body.prototype.SetTransform=function(xf){this.SetPositionAndAngle(xf.position,xf.GetAngle());};b2Body.prototype.GetTransform=function(){return this.m_xf;};b2Body.prototype.GetPosition=function(){return this.m_xf.position;};b2Body.prototype.SetPosition=function(position){this.SetPositionAndAngle(position,this.GetAngle());};b2Body.prototype.GetAngle=function(){return this.m_sweep.a;};b2Body.prototype.SetAngle=function(angle){if(angle===undefined)angle=0;this.SetPositionAndAngle(this.GetPosition(),angle);};b2Body.prototype.GetWorldCenter=function(){return this.m_sweep.c;};b2Body.prototype.GetLocalCenter=function(){return this.m_sweep.localCenter;};b2Body.prototype.SetLinearVelocity=function(v){if(this.m_type==b2Body.b2_staticBody){return;}this.m_linearVelocity.SetV(v);};b2Body.prototype.GetLinearVelocity=function(){return this.m_linearVelocity;};b2Body.prototype.SetAngularVelocity=function(omega){if(omega===undefined)omega=0;if(this.m_type==b2Body.b2_staticBody){return;}this.m_angularVelocity=omega;};b2Body.prototype.GetAngularVelocity=function(){return this.m_angularVelocity;};b2Body.prototype.GetDefinition=function(){var bd=new b2BodyDef();bd.type=this.GetType();bd.allowSleep=(this.m_flags&b2Body.e_allowSleepFlag)==b2Body.e_allowSleepFlag;bd.angle=this.GetAngle();bd.angularDamping=this.m_angularDamping;bd.angularVelocity=this.m_angularVelocity;bd.fixedRotation=(this.m_flags&b2Body.e_fixedRotationFlag)==b2Body.e_fixedRotationFlag;bd.bullet=(this.m_flags&b2Body.e_bulletFlag)==b2Body.e_bulletFlag;bd.awake=(this.m_flags&b2Body.e_awakeFlag)==b2Body.e_awakeFlag;bd.linearDamping=this.m_linearDamping;bd.linearVelocity.SetV(this.GetLinearVelocity());bd.position=this.GetPosition();bd.userData=this.GetUserData();return bd;};b2Body.prototype.ApplyForce=function(force,point){if(this.m_type!=b2Body.b2_dynamicBody){return;}if(this.IsAwake()==false){this.SetAwake(true);}this.m_force.x+=force.x;this.m_force.y+=force.y;this.m_torque+=(point.x-this.m_sweep.c.x)*force.y-(point.y-this.m_sweep.c.y)*force.x;};b2Body.prototype.ApplyTorque=function(torque){if(torque===undefined)torque=0;if(this.m_type!=b2Body.b2_dynamicBody){return;}if(this.IsAwake()==false){this.SetAwake(true);}this.m_torque+=torque;};b2Body.prototype.ApplyImpulse=function(impulse,point){if(this.m_type!=b2Body.b2_dynamicBody){return;}if(this.IsAwake()==false){this.SetAwake(true);}this.m_linearVelocity.x+=this.m_invMass*impulse.x;this.m_linearVelocity.y+=this.m_invMass*impulse.y;this.m_angularVelocity+=this.m_invI*((point.x-this.m_sweep.c.x)*impulse.y-(point.y-this.m_sweep.c.y)*impulse.x);};b2Body.prototype.Split=function(callback){var linearVelocity=this.GetLinearVelocity().Copy();var angularVelocity=this.GetAngularVelocity();var center=this.GetWorldCenter();var body1=this;var body2=this.m_world.CreateBody(this.GetDefinition());var prev;for(var f=body1.m_fixtureList;f;){if(callback(f)){var next=f.m_next;if(prev){prev.m_next=next;}else{body1.m_fixtureList=next;}body1.m_fixtureCount--;f.m_next=body2.m_fixtureList;body2.m_fixtureList=f;body2.m_fixtureCount++;f.m_body=body2;f=next;}else{prev=f;f=f.m_next;}}body1.ResetMassData();body2.ResetMassData();var center1=body1.GetWorldCenter();var center2=body2.GetWorldCenter();var velocity1=b2Math.AddVV(linearVelocity,b2Math.CrossFV(angularVelocity,b2Math.SubtractVV(center1,center)));var velocity2=b2Math.AddVV(linearVelocity,b2Math.CrossFV(angularVelocity,b2Math.SubtractVV(center2,center)));body1.SetLinearVelocity(velocity1);body2.SetLinearVelocity(velocity2);body1.SetAngularVelocity(angularVelocity);body2.SetAngularVelocity(angularVelocity);body1.SynchronizeFixtures();body2.SynchronizeFixtures();return body2;};b2Body.prototype.Merge=function(other){var f;for(f=other.m_fixtureList;f;){var next=f.m_next;other.m_fixtureCount--;f.m_next=this.m_fixtureList;this.m_fixtureList=f;this.m_fixtureCount++;f.m_body=body2;f=next;}body1.m_fixtureCount=0;var body1=this;var body2=other;var center1=body1.GetWorldCenter();var center2=body2.GetWorldCenter();var velocity1=body1.GetLinearVelocity().Copy();var velocity2=body2.GetLinearVelocity().Copy();var angular1=body1.GetAngularVelocity();var angular=body2.GetAngularVelocity();body1.ResetMassData();this.SynchronizeFixtures();};b2Body.prototype.GetMass=function(){return this.m_mass;};b2Body.prototype.GetInertia=function(){return this.m_I;};b2Body.prototype.GetMassData=function(data){data.mass=this.m_mass;data.I=this.m_I;data.center.SetV(this.m_sweep.localCenter);};b2Body.prototype.SetMassData=function(massData){b2Settings.b2Assert(this.m_world.IsLocked()==false);if(this.m_world.IsLocked()==true){return;}if(this.m_type!=b2Body.b2_dynamicBody){return;}this.m_invMass=0.0;this.m_I=0.0;this.m_invI=0.0;this.m_mass=massData.mass;if(this.m_mass<=0.0){this.m_mass=1.0;}this.m_invMass=1.0/this.m_mass;if(massData.I>0.0&&(this.m_flags&b2Body.e_fixedRotationFlag)==0){this.m_I=massData.I-this.m_mass*(massData.center.x*massData.center.x+massData.center.y*massData.center.y);this.m_invI=1.0/this.m_I;}var oldCenter=this.m_sweep.c.Copy();this.m_sweep.localCenter.SetV(massData.center);this.m_sweep.c0.SetV(b2Math.MulX(this.m_xf,this.m_sweep.localCenter));this.m_sweep.c.SetV(this.m_sweep.c0);this.m_linearVelocity.x+=this.m_angularVelocity*-(this.m_sweep.c.y-oldCenter.y);this.m_linearVelocity.y+=this.m_angularVelocity*+(this.m_sweep.c.x-oldCenter.x);};b2Body.prototype.ResetMassData=function(){this.m_mass=0.0;this.m_invMass=0.0;this.m_I=0.0;this.m_invI=0.0;this.m_sweep.localCenter.SetZero();if(this.m_type==b2Body.b2_staticBody||this.m_type==b2Body.b2_kinematicBody){return;}var center=b2Vec2.Make(0,0);for(var f=this.m_fixtureList;f;f=f.m_next){if(f.m_density==0.0){continue;}var massData=f.GetMassData();this.m_mass+=massData.mass;center.x+=massData.center.x*massData.mass;center.y+=massData.center.y*massData.mass;this.m_I+=massData.I;}if(this.m_mass>0.0){this.m_invMass=1.0/this.m_mass;center.x*=this.m_invMass;center.y*=this.m_invMass;}else{this.m_mass=1.0;this.m_invMass=1.0;}if(this.m_I>0.0&&(this.m_flags&b2Body.e_fixedRotationFlag)==0){this.m_I-=this.m_mass*(center.x*center.x+center.y*center.y);this.m_I*=this.m_inertiaScale;b2Settings.b2Assert(this.m_I>0);this.m_invI=1.0/this.m_I;}else{this.m_I=0.0;this.m_invI=0.0;}var oldCenter=this.m_sweep.c.Copy();this.m_sweep.localCenter.SetV(center);this.m_sweep.c0.SetV(b2Math.MulX(this.m_xf,this.m_sweep.localCenter));this.m_sweep.c.SetV(this.m_sweep.c0);this.m_linearVelocity.x+=this.m_angularVelocity*-(this.m_sweep.c.y-oldCenter.y);this.m_linearVelocity.y+=this.m_angularVelocity*+(this.m_sweep.c.x-oldCenter.x);};b2Body.prototype.GetWorldPoint=function(localPoint){var A=this.m_xf.R;var u=new b2Vec2(A.col1.x*localPoint.x+A.col2.x*localPoint.y,A.col1.y*localPoint.x+A.col2.y*localPoint.y);u.x+=this.m_xf.position.x;u.y+=this.m_xf.position.y;return u;};b2Body.prototype.GetWorldVector=function(localVector){return b2Math.MulMV(this.m_xf.R,localVector);};b2Body.prototype.GetLocalPoint=function(worldPoint){return b2Math.MulXT(this.m_xf,worldPoint);};b2Body.prototype.GetLocalVector=function(worldVector){return b2Math.MulTMV(this.m_xf.R,worldVector);};b2Body.prototype.GetLinearVelocityFromWorldPoint=function(worldPoint){return new b2Vec2(this.m_linearVelocity.x-this.m_angularVelocity*(worldPoint.y-this.m_sweep.c.y),this.m_linearVelocity.y+this.m_angularVelocity*(worldPoint.x-this.m_sweep.c.x));};b2Body.prototype.GetLinearVelocityFromLocalPoint=function(localPoint){var A=this.m_xf.R;var worldPoint=new b2Vec2(A.col1.x*localPoint.x+A.col2.x*localPoint.y,A.col1.y*localPoint.x+A.col2.y*localPoint.y);worldPoint.x+=this.m_xf.position.x;worldPoint.y+=this.m_xf.position.y;return new b2Vec2(this.m_linearVelocity.x-this.m_angularVelocity*(worldPoint.y-this.m_sweep.c.y),this.m_linearVelocity.y+this.m_angularVelocity*(worldPoint.x-this.m_sweep.c.x));};b2Body.prototype.GetLinearDamping=function(){return this.m_linearDamping;};b2Body.prototype.SetLinearDamping=function(linearDamping){if(linearDamping===undefined)linearDamping=0;this.m_linearDamping=linearDamping;};b2Body.prototype.GetAngularDamping=function(){return this.m_angularDamping;};b2Body.prototype.SetAngularDamping=function(angularDamping){if(angularDamping===undefined)angularDamping=0;this.m_angularDamping=angularDamping;};b2Body.prototype.SetType=function(type){if(type===undefined)type=0;if(this.m_type==type){return;}this.m_type=type;this.ResetMassData();if(this.m_type==b2Body.b2_staticBody){this.m_linearVelocity.SetZero();this.m_angularVelocity=0.0;}this.SetAwake(true);this.m_force.SetZero();this.m_torque=0.0;for(var ce=this.m_contactList;ce;ce=ce.next){ce.contact.FlagForFiltering();}};b2Body.prototype.GetType=function(){return this.m_type;};b2Body.prototype.SetBullet=function(flag){if(flag){this.m_flags|=b2Body.e_bulletFlag;}else{this.m_flags&=~b2Body.e_bulletFlag;}};b2Body.prototype.IsBullet=function(){return(this.m_flags&b2Body.e_bulletFlag)==b2Body.e_bulletFlag;};b2Body.prototype.SetSleepingAllowed=function(flag){if(flag){this.m_flags|=b2Body.e_allowSleepFlag;}else{this.m_flags&=~b2Body.e_allowSleepFlag;this.SetAwake(true);}};b2Body.prototype.SetAwake=function(flag){if(flag){this.m_flags|=b2Body.e_awakeFlag;this.m_sleepTime=0.0;}else{this.m_flags&=~b2Body.e_awakeFlag;this.m_sleepTime=0.0;this.m_linearVelocity.SetZero();this.m_angularVelocity=0.0;this.m_force.SetZero();this.m_torque=0.0;}};b2Body.prototype.IsAwake=function(){return(this.m_flags&b2Body.e_awakeFlag)==b2Body.e_awakeFlag;};b2Body.prototype.SetFixedRotation=function(fixed){if(fixed){this.m_flags|=b2Body.e_fixedRotationFlag;}else{this.m_flags&=~b2Body.e_fixedRotationFlag;}this.ResetMassData();};b2Body.prototype.IsFixedRotation=function(){return(this.m_flags&b2Body.e_fixedRotationFlag)==b2Body.e_fixedRotationFlag;};b2Body.prototype.SetActive=function(flag){if(flag==this.IsActive()){return;}var broadPhase;var f;if(flag){this.m_flags|=b2Body.e_activeFlag;broadPhase=this.m_world.m_contactManager.m_broadPhase;for(f=this.m_fixtureList;f;f=f.m_next){f.CreateProxy(broadPhase,this.m_xf);}}else{this.m_flags&=~b2Body.e_activeFlag;broadPhase=this.m_world.m_contactManager.m_broadPhase;for(f=this.m_fixtureList;f;f=f.m_next){f.DestroyProxy(broadPhase);}var ce=this.m_contactList;while(ce){var ce0=ce;ce=ce.next;this.m_world.m_contactManager.Destroy(ce0.contact);}this.m_contactList=null;}};b2Body.prototype.IsActive=function(){return(this.m_flags&b2Body.e_activeFlag)==b2Body.e_activeFlag;};b2Body.prototype.IsSleepingAllowed=function(){return(this.m_flags&b2Body.e_allowSleepFlag)==b2Body.e_allowSleepFlag;};b2Body.prototype.GetFixtureList=function(){return this.m_fixtureList;};b2Body.prototype.GetJointList=function(){return this.m_jointList;};b2Body.prototype.GetControllerList=function(){return this.m_controllerList;};b2Body.prototype.GetContactList=function(){return this.m_contactList;};b2Body.prototype.GetNext=function(){return this.m_next;};b2Body.prototype.GetUserData=function(){return this.m_userData;};b2Body.prototype.SetUserData=function(data){this.m_userData=data;};b2Body.prototype.GetWorld=function(){return this.m_world;};b2Body.prototype.b2Body=function(bd,world){this.m_flags=0;if(bd.bullet){this.m_flags|=b2Body.e_bulletFlag;}if(bd.fixedRotation){this.m_flags|=b2Body.e_fixedRotationFlag;}if(bd.allowSleep){this.m_flags|=b2Body.e_allowSleepFlag;}if(bd.awake){this.m_flags|=b2Body.e_awakeFlag;}if(bd.active){this.m_flags|=b2Body.e_activeFlag;}this.m_world=world;this.m_xf.position.SetV(bd.position);this.m_xf.R.Set(bd.angle);this.m_sweep.localCenter.SetZero();this.m_sweep.t0=1.0;this.m_sweep.a0=this.m_sweep.a=bd.angle;var tMat=this.m_xf.R;var tVec=this.m_sweep.localCenter;this.m_sweep.c.x=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;this.m_sweep.c.y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;this.m_sweep.c.x+=this.m_xf.position.x;this.m_sweep.c.y+=this.m_xf.position.y;this.m_sweep.c0.SetV(this.m_sweep.c);this.m_jointList=null;this.m_controllerList=null;this.m_contactList=null;this.m_controllerCount=0;this.m_prev=null;this.m_next=null;this.m_linearVelocity.SetV(bd.linearVelocity);this.m_angularVelocity=bd.angularVelocity;this.m_linearDamping=bd.linearDamping;this.m_angularDamping=bd.angularDamping;this.m_force.Set(0.0,0.0);this.m_torque=0.0;this.m_sleepTime=0.0;this.m_type=bd.type;if(this.m_type==b2Body.b2_dynamicBody){this.m_mass=1.0;this.m_invMass=1.0;}else{this.m_mass=0.0;this.m_invMass=0.0;}this.m_I=0.0;this.m_invI=0.0;this.m_inertiaScale=bd.inertiaScale;this.m_userData=bd.userData;this.m_fixtureList=null;this.m_fixtureCount=0;};b2Body.prototype.SynchronizeFixtures=function(){var xf1=b2Body.s_xf1;xf1.R.Set(this.m_sweep.a0);var tMat=xf1.R;var tVec=this.m_sweep.localCenter;xf1.position.x=this.m_sweep.c0.x-(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);xf1.position.y=this.m_sweep.c0.y-(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);var f;var broadPhase=this.m_world.m_contactManager.m_broadPhase;for(f=this.m_fixtureList;f;f=f.m_next){f.Synchronize(broadPhase,xf1,this.m_xf);}};b2Body.prototype.SynchronizeTransform=function(){this.m_xf.R.Set(this.m_sweep.a);var tMat=this.m_xf.R;var tVec=this.m_sweep.localCenter;this.m_xf.position.x=this.m_sweep.c.x-(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);this.m_xf.position.y=this.m_sweep.c.y-(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);};b2Body.prototype.ShouldCollide=function(other){if(this.m_type!=b2Body.b2_dynamicBody&&other.m_type!=b2Body.b2_dynamicBody){return false;}for(var jn=this.m_jointList;jn;jn=jn.next){if(jn.other==other)if(jn.joint.m_collideConnected==false){return false;}}return true;};b2Body.prototype.Advance=function(t){if(t===undefined)t=0;this.m_sweep.Advance(t);this.m_sweep.c.SetV(this.m_sweep.c0);this.m_sweep.a=this.m_sweep.a0;this.SynchronizeTransform();};Box2D.postDefs.push(function(){Box2D.Dynamics.b2Body.s_xf1=new b2Transform();Box2D.Dynamics.b2Body.e_islandFlag=0x0001;Box2D.Dynamics.b2Body.e_awakeFlag=0x0002;Box2D.Dynamics.b2Body.e_allowSleepFlag=0x0004;Box2D.Dynamics.b2Body.e_bulletFlag=0x0008;Box2D.Dynamics.b2Body.e_fixedRotationFlag=0x0010;Box2D.Dynamics.b2Body.e_activeFlag=0x0020;Box2D.Dynamics.b2Body.b2_staticBody=0;Box2D.Dynamics.b2Body.b2_kinematicBody=1;Box2D.Dynamics.b2Body.b2_dynamicBody=2;});b2BodyDef.b2BodyDef=function(){this.position=new b2Vec2();this.linearVelocity=new b2Vec2();};b2BodyDef.prototype.b2BodyDef=function(){this.userData=null;this.position.Set(0.0,0.0);this.angle=0.0;this.linearVelocity.Set(0,0);this.angularVelocity=0.0;this.linearDamping=0.0;this.angularDamping=0.0;this.allowSleep=true;this.awake=true;this.fixedRotation=false;this.bullet=false;this.type=b2Body.b2_staticBody;this.active=true;this.inertiaScale=1.0;};b2ContactFilter.b2ContactFilter=function(){};b2ContactFilter.prototype.ShouldCollide=function(fixtureA,fixtureB){var filter1=fixtureA.GetFilterData();var filter2=fixtureB.GetFilterData();if(filter1.groupIndex==filter2.groupIndex&&filter1.groupIndex!=0){return filter1.groupIndex>0;}var collide=(filter1.maskBits&filter2.categoryBits)!=0&&(filter1.categoryBits&filter2.maskBits)!=0;return collide;};b2ContactFilter.prototype.RayCollide=function(userData,fixture){if(!userData)return true;return this.ShouldCollide(userData instanceof b2Fixture?userData:null,fixture);};Box2D.postDefs.push(function(){Box2D.Dynamics.b2ContactFilter.b2_defaultFilter=new b2ContactFilter();});b2ContactImpulse.b2ContactImpulse=function(){this.normalImpulses=new Vector_a2j_Number(b2Settings.b2_maxManifoldPoints);this.tangentImpulses=new Vector_a2j_Number(b2Settings.b2_maxManifoldPoints);};b2ContactListener.b2ContactListener=function(){};b2ContactListener.prototype.BeginContact=function(contact){};b2ContactListener.prototype.EndContact=function(contact){};b2ContactListener.prototype.PreSolve=function(contact,oldManifold){};b2ContactListener.prototype.PostSolve=function(contact,impulse){};Box2D.postDefs.push(function(){Box2D.Dynamics.b2ContactListener.b2_defaultListener=new b2ContactListener();});b2ContactManager.b2ContactManager=function(){};b2ContactManager.prototype.b2ContactManager=function(){this.m_world=null;this.m_contactCount=0;this.m_contactFilter=b2ContactFilter.b2_defaultFilter;this.m_contactListener=b2ContactListener.b2_defaultListener;this.m_contactFactory=new b2ContactFactory(this.m_allocator);this.m_broadPhase=new b2DynamicTreeBroadPhase();};b2ContactManager.prototype.AddPair=function(proxyUserDataA,proxyUserDataB){var fixtureA=proxyUserDataA instanceof b2Fixture?proxyUserDataA:null;var fixtureB=proxyUserDataB instanceof b2Fixture?proxyUserDataB:null;var bodyA=fixtureA.GetBody();var bodyB=fixtureB.GetBody();if(bodyA==bodyB)return;var edge=bodyB.GetContactList();while(edge){if(edge.other==bodyA){var fA=edge.contact.GetFixtureA();var fB=edge.contact.GetFixtureB();if(fA==fixtureA&&fB==fixtureB)return;if(fA==fixtureB&&fB==fixtureA)return;}edge=edge.next;}if(bodyB.ShouldCollide(bodyA)==false){return;}if(this.m_contactFilter.ShouldCollide(fixtureA,fixtureB)==false){return;}var c=this.m_contactFactory.Create(fixtureA,fixtureB);fixtureA=c.GetFixtureA();fixtureB=c.GetFixtureB();bodyA=fixtureA.m_body;bodyB=fixtureB.m_body;c.m_prev=null;c.m_next=this.m_world.m_contactList;if(this.m_world.m_contactList!=null){this.m_world.m_contactList.m_prev=c;}this.m_world.m_contactList=c;c.m_nodeA.contact=c;c.m_nodeA.other=bodyB;c.m_nodeA.prev=null;c.m_nodeA.next=bodyA.m_contactList;if(bodyA.m_contactList!=null){bodyA.m_contactList.prev=c.m_nodeA;}bodyA.m_contactList=c.m_nodeA;c.m_nodeB.contact=c;c.m_nodeB.other=bodyA;c.m_nodeB.prev=null;c.m_nodeB.next=bodyB.m_contactList;if(bodyB.m_contactList!=null){bodyB.m_contactList.prev=c.m_nodeB;}bodyB.m_contactList=c.m_nodeB;++this.m_world.m_contactCount;return;};b2ContactManager.prototype.FindNewContacts=function(){this.m_broadPhase.UpdatePairs(Box2D.generateCallback(this,this.AddPair));};b2ContactManager.prototype.Destroy=function(c){var fixtureA=c.GetFixtureA();var fixtureB=c.GetFixtureB();var bodyA=fixtureA.GetBody();var bodyB=fixtureB.GetBody();if(c.IsTouching()){this.m_contactListener.EndContact(c);}if(c.m_prev){c.m_prev.m_next=c.m_next;}if(c.m_next){c.m_next.m_prev=c.m_prev;}if(c==this.m_world.m_contactList){this.m_world.m_contactList=c.m_next;}if(c.m_nodeA.prev){c.m_nodeA.prev.next=c.m_nodeA.next;}if(c.m_nodeA.next){c.m_nodeA.next.prev=c.m_nodeA.prev;}if(c.m_nodeA==bodyA.m_contactList){bodyA.m_contactList=c.m_nodeA.next;}if(c.m_nodeB.prev){c.m_nodeB.prev.next=c.m_nodeB.next;}if(c.m_nodeB.next){c.m_nodeB.next.prev=c.m_nodeB.prev;}if(c.m_nodeB==bodyB.m_contactList){bodyB.m_contactList=c.m_nodeB.next;}this.m_contactFactory.Destroy(c);--this.m_contactCount;};b2ContactManager.prototype.Collide=function(){var c=this.m_world.m_contactList;while(c){var fixtureA=c.GetFixtureA();var fixtureB=c.GetFixtureB();var bodyA=fixtureA.GetBody();var bodyB=fixtureB.GetBody();if(bodyA.IsAwake()==false&&bodyB.IsAwake()==false){c=c.GetNext();continue;}if(c.m_flags&b2Contact.e_filterFlag){if(bodyB.ShouldCollide(bodyA)==false){var cNuke=c;c=cNuke.GetNext();this.Destroy(cNuke);continue;}if(this.m_contactFilter.ShouldCollide(fixtureA,fixtureB)==false){cNuke=c;c=cNuke.GetNext();this.Destroy(cNuke);continue;}c.m_flags&=~b2Contact.e_filterFlag;}var proxyA=fixtureA.m_proxy;var proxyB=fixtureB.m_proxy;var overlap=this.m_broadPhase.TestOverlap(proxyA,proxyB);if(overlap==false){cNuke=c;c=cNuke.GetNext();this.Destroy(cNuke);continue;}c.Update(this.m_contactListener);c=c.GetNext();}};Box2D.postDefs.push(function(){Box2D.Dynamics.b2ContactManager.s_evalCP=new b2ContactPoint();});b2DebugDraw.b2DebugDraw=function(){};b2DebugDraw.prototype.b2DebugDraw=function(){};b2DebugDraw.prototype.SetFlags=function(flags){if(flags===undefined)flags=0;};b2DebugDraw.prototype.GetFlags=function(){};b2DebugDraw.prototype.AppendFlags=function(flags){if(flags===undefined)flags=0;};b2DebugDraw.prototype.ClearFlags=function(flags){if(flags===undefined)flags=0;};b2DebugDraw.prototype.SetSprite=function(sprite){};b2DebugDraw.prototype.GetSprite=function(){};b2DebugDraw.prototype.SetDrawScale=function(drawScale){if(drawScale===undefined)drawScale=0;};b2DebugDraw.prototype.GetDrawScale=function(){};b2DebugDraw.prototype.SetLineThickness=function(lineThickness){if(lineThickness===undefined)lineThickness=0;};b2DebugDraw.prototype.GetLineThickness=function(){};b2DebugDraw.prototype.SetAlpha=function(alpha){if(alpha===undefined)alpha=0;};b2DebugDraw.prototype.GetAlpha=function(){};b2DebugDraw.prototype.SetFillAlpha=function(alpha){if(alpha===undefined)alpha=0;};b2DebugDraw.prototype.GetFillAlpha=function(){};b2DebugDraw.prototype.SetXFormScale=function(xformScale){if(xformScale===undefined)xformScale=0;};b2DebugDraw.prototype.GetXFormScale=function(){};b2DebugDraw.prototype.DrawPolygon=function(vertices,vertexCount,color){if(vertexCount===undefined)vertexCount=0;};b2DebugDraw.prototype.DrawSolidPolygon=function(vertices,vertexCount,color){if(vertexCount===undefined)vertexCount=0;};b2DebugDraw.prototype.DrawCircle=function(center,radius,color){if(radius===undefined)radius=0;};b2DebugDraw.prototype.DrawSolidCircle=function(center,radius,axis,color){if(radius===undefined)radius=0;};b2DebugDraw.prototype.DrawSegment=function(p1,p2,color){};b2DebugDraw.prototype.DrawTransform=function(xf){};Box2D.postDefs.push(function(){Box2D.Dynamics.b2DebugDraw.e_shapeBit=0x0001;Box2D.Dynamics.b2DebugDraw.e_jointBit=0x0002;Box2D.Dynamics.b2DebugDraw.e_aabbBit=0x0004;Box2D.Dynamics.b2DebugDraw.e_pairBit=0x0008;Box2D.Dynamics.b2DebugDraw.e_centerOfMassBit=0x0010;Box2D.Dynamics.b2DebugDraw.e_controllerBit=0x0020;});b2DestructionListener.b2DestructionListener=function(){};b2DestructionListener.prototype.SayGoodbyeJoint=function(joint){};b2DestructionListener.prototype.SayGoodbyeFixture=function(fixture){};b2FilterData.b2FilterData=function(){this.categoryBits=0x0001;this.maskBits=0xFFFF;this.groupIndex=0;};b2FilterData.prototype.Copy=function(){var copy=new b2FilterData();copy.categoryBits=this.categoryBits;copy.maskBits=this.maskBits;copy.groupIndex=this.groupIndex;return copy;};b2Fixture.b2Fixture=function(){this.m_filter=new b2FilterData();};b2Fixture.prototype.GetType=function(){return this.m_shape.GetType();};b2Fixture.prototype.GetShape=function(){return this.m_shape;};b2Fixture.prototype.SetSensor=function(sensor){if(this.m_isSensor==sensor)return;this.m_isSensor=sensor;if(this.m_body==null)return;var edge=this.m_body.GetContactList();while(edge){var contact=edge.contact;var fixtureA=contact.GetFixtureA();var fixtureB=contact.GetFixtureB();if(fixtureA==this||fixtureB==this)contact.SetSensor(fixtureA.IsSensor()||fixtureB.IsSensor());edge=edge.next;}};b2Fixture.prototype.IsSensor=function(){return this.m_isSensor;};b2Fixture.prototype.SetFilterData=function(filter){this.m_filter=filter.Copy();if(this.m_body)return;var edge=this.m_body.GetContactList();while(edge){var contact=edge.contact;var fixtureA=contact.GetFixtureA();var fixtureB=contact.GetFixtureB();if(fixtureA==this||fixtureB==this)contact.FlagForFiltering();edge=edge.next;}};b2Fixture.prototype.GetFilterData=function(){return this.m_filter.Copy();};b2Fixture.prototype.GetBody=function(){return this.m_body;};b2Fixture.prototype.GetNext=function(){return this.m_next;};b2Fixture.prototype.GetUserData=function(){return this.m_userData;};b2Fixture.prototype.SetUserData=function(data){this.m_userData=data;};b2Fixture.prototype.TestPoint=function(p){return this.m_shape.TestPoint(this.m_body.GetTransform(),p);};b2Fixture.prototype.RayCast=function(output,input){return this.m_shape.RayCast(output,input,this.m_body.GetTransform());};b2Fixture.prototype.GetMassData=function(massData){if(massData===undefined)massData=null;if(massData==null){massData=new b2MassData();}this.m_shape.ComputeMass(massData,this.m_density);return massData;};b2Fixture.prototype.SetDensity=function(density){if(density===undefined)density=0;this.m_density=density;};b2Fixture.prototype.GetDensity=function(){return this.m_density;};b2Fixture.prototype.GetFriction=function(){return this.m_friction;};b2Fixture.prototype.SetFriction=function(friction){if(friction===undefined)friction=0;this.m_friction=friction;};b2Fixture.prototype.GetRestitution=function(){return this.m_restitution;};b2Fixture.prototype.SetRestitution=function(restitution){if(restitution===undefined)restitution=0;this.m_restitution=restitution;};b2Fixture.prototype.GetAABB=function(){return this.m_aabb;};b2Fixture.prototype.b2Fixture=function(){this.m_aabb=new b2AABB();this.m_userData=null;this.m_body=null;this.m_next=null;this.m_shape=null;this.m_density=0.0;this.m_friction=0.0;this.m_restitution=0.0;};b2Fixture.prototype.Create=function(body,xf,def){this.m_userData=def.userData;this.m_friction=def.friction;this.m_restitution=def.restitution;this.m_body=body;this.m_next=null;this.m_filter=def.filter.Copy();this.m_isSensor=def.isSensor;this.m_shape=def.shape.Copy();this.m_density=def.density;};b2Fixture.prototype.Destroy=function(){this.m_shape=null;};b2Fixture.prototype.CreateProxy=function(broadPhase,xf){this.m_shape.ComputeAABB(this.m_aabb,xf);this.m_proxy=broadPhase.CreateProxy(this.m_aabb,this);};b2Fixture.prototype.DestroyProxy=function(broadPhase){if(this.m_proxy==null){return;}broadPhase.DestroyProxy(this.m_proxy);this.m_proxy=null;};b2Fixture.prototype.Synchronize=function(broadPhase,transform1,transform2){if(!this.m_proxy)return;var aabb1=new b2AABB();var aabb2=new b2AABB();this.m_shape.ComputeAABB(aabb1,transform1);this.m_shape.ComputeAABB(aabb2,transform2);this.m_aabb.Combine(aabb1,aabb2);var displacement=b2Math.SubtractVV(transform2.position,transform1.position);broadPhase.MoveProxy(this.m_proxy,this.m_aabb,displacement);};b2FixtureDef.b2FixtureDef=function(){this.filter=new b2FilterData();};b2FixtureDef.prototype.b2FixtureDef=function(){this.shape=null;this.userData=null;this.friction=0.2;this.restitution=0.0;this.density=0.0;this.filter.categoryBits=0x0001;this.filter.maskBits=0xFFFF;this.filter.groupIndex=0;this.isSensor=false;};b2Island.b2Island=function(){};b2Island.prototype.b2Island=function(){this.m_bodies=new Vector();this.m_contacts=new Vector();this.m_joints=new Vector();};b2Island.prototype.Initialize=function(bodyCapacity,contactCapacity,jointCapacity,allocator,listener,contactSolver){if(bodyCapacity===undefined)bodyCapacity=0;if(contactCapacity===undefined)contactCapacity=0;if(jointCapacity===undefined)jointCapacity=0;var i=0;this.m_bodyCapacity=bodyCapacity;this.m_contactCapacity=contactCapacity;this.m_jointCapacity=jointCapacity;this.m_bodyCount=0;this.m_contactCount=0;this.m_jointCount=0;this.m_allocator=allocator;this.m_listener=listener;this.m_contactSolver=contactSolver;for(i=this.m_bodies.length;i<bodyCapacity;i++){this.m_bodies[i]=null;}for(i=this.m_contacts.length;i<contactCapacity;i++){this.m_contacts[i]=null;}for(i=this.m_joints.length;i<jointCapacity;i++){this.m_joints[i]=null;}};b2Island.prototype.Clear=function(){this.m_bodyCount=0;this.m_contactCount=0;this.m_jointCount=0;};b2Island.prototype.Solve=function(step,gravity,allowSleep){var i=0;var j=0;var b;var joint;for(i=0;i<this.m_bodyCount;++i){b=this.m_bodies[i];if(b.GetType()!=b2Body.b2_dynamicBody)continue;b.m_linearVelocity.x+=step.dt*(gravity.x+b.m_invMass*b.m_force.x);b.m_linearVelocity.y+=step.dt*(gravity.y+b.m_invMass*b.m_force.y);b.m_angularVelocity+=step.dt*b.m_invI*b.m_torque;b.m_linearVelocity.Multiply(b2Math.Clamp(1.0-step.dt*b.m_linearDamping,0.0,1.0));b.m_angularVelocity*=b2Math.Clamp(1.0-step.dt*b.m_angularDamping,0.0,1.0);}this.m_contactSolver.Initialize(step,this.m_contacts,this.m_contactCount,this.m_allocator);var contactSolver=this.m_contactSolver;contactSolver.InitVelocityConstraints(step);for(i=0;i<this.m_jointCount;++i){joint=this.m_joints[i];joint.InitVelocityConstraints(step);}for(i=0;i<step.velocityIterations;++i){for(j=0;j<this.m_jointCount;++j){joint=this.m_joints[j];joint.SolveVelocityConstraints(step);}contactSolver.SolveVelocityConstraints();}for(i=0;i<this.m_jointCount;++i){joint=this.m_joints[i];joint.FinalizeVelocityConstraints();}contactSolver.FinalizeVelocityConstraints();for(i=0;i<this.m_bodyCount;++i){b=this.m_bodies[i];if(b.GetType()==b2Body.b2_staticBody)continue;var translationX=step.dt*b.m_linearVelocity.x;var translationY=step.dt*b.m_linearVelocity.y;if(translationX*translationX+translationY*translationY>b2Settings.b2_maxTranslationSquared){b.m_linearVelocity.Normalize();b.m_linearVelocity.x*=b2Settings.b2_maxTranslation*step.inv_dt;b.m_linearVelocity.y*=b2Settings.b2_maxTranslation*step.inv_dt;}var rotation=step.dt*b.m_angularVelocity;if(rotation*rotation>b2Settings.b2_maxRotationSquared){if(b.m_angularVelocity<0.0){b.m_angularVelocity=-b2Settings.b2_maxRotation*step.inv_dt;}else{b.m_angularVelocity=b2Settings.b2_maxRotation*step.inv_dt;}}b.m_sweep.c0.SetV(b.m_sweep.c);b.m_sweep.a0=b.m_sweep.a;b.m_sweep.c.x+=step.dt*b.m_linearVelocity.x;b.m_sweep.c.y+=step.dt*b.m_linearVelocity.y;b.m_sweep.a+=step.dt*b.m_angularVelocity;b.SynchronizeTransform();}for(i=0;i<step.positionIterations;++i){var contactsOkay=contactSolver.SolvePositionConstraints(b2Settings.b2_contactBaumgarte);var jointsOkay=true;for(j=0;j<this.m_jointCount;++j){joint=this.m_joints[j];var jointOkay=joint.SolvePositionConstraints(b2Settings.b2_contactBaumgarte);jointsOkay=jointsOkay&&jointOkay;}if(contactsOkay&&jointsOkay){break;}}this.Report(contactSolver.m_constraints);if(allowSleep){var minSleepTime=Number.MAX_VALUE;var linTolSqr=b2Settings.b2_linearSleepTolerance*b2Settings.b2_linearSleepTolerance;var angTolSqr=b2Settings.b2_angularSleepTolerance*b2Settings.b2_angularSleepTolerance;for(i=0;i<this.m_bodyCount;++i){b=this.m_bodies[i];if(b.GetType()==b2Body.b2_staticBody){continue;}if((b.m_flags&b2Body.e_allowSleepFlag)==0){b.m_sleepTime=0.0;minSleepTime=0.0;}if((b.m_flags&b2Body.e_allowSleepFlag)==0||b.m_angularVelocity*b.m_angularVelocity>angTolSqr||b2Math.Dot(b.m_linearVelocity,b.m_linearVelocity)>linTolSqr){b.m_sleepTime=0.0;minSleepTime=0.0;}else{b.m_sleepTime+=step.dt;minSleepTime=b2Math.Min(minSleepTime,b.m_sleepTime);}}if(minSleepTime>=b2Settings.b2_timeToSleep){for(i=0;i<this.m_bodyCount;++i){b=this.m_bodies[i];b.SetAwake(false);}}}};b2Island.prototype.SolveTOI=function(subStep){var i=0;var j=0;this.m_contactSolver.Initialize(subStep,this.m_contacts,this.m_contactCount,this.m_allocator);var contactSolver=this.m_contactSolver;for(i=0;i<this.m_jointCount;++i){this.m_joints[i].InitVelocityConstraints(subStep);}for(i=0;i<subStep.velocityIterations;++i){contactSolver.SolveVelocityConstraints();for(j=0;j<this.m_jointCount;++j){this.m_joints[j].SolveVelocityConstraints(subStep);}}for(i=0;i<this.m_bodyCount;++i){var b=this.m_bodies[i];if(b.GetType()==b2Body.b2_staticBody)continue;var translationX=subStep.dt*b.m_linearVelocity.x;var translationY=subStep.dt*b.m_linearVelocity.y;if(translationX*translationX+translationY*translationY>b2Settings.b2_maxTranslationSquared){b.m_linearVelocity.Normalize();b.m_linearVelocity.x*=b2Settings.b2_maxTranslation*subStep.inv_dt;b.m_linearVelocity.y*=b2Settings.b2_maxTranslation*subStep.inv_dt;}var rotation=subStep.dt*b.m_angularVelocity;if(rotation*rotation>b2Settings.b2_maxRotationSquared){if(b.m_angularVelocity<0.0){b.m_angularVelocity=-b2Settings.b2_maxRotation*subStep.inv_dt;}else{b.m_angularVelocity=b2Settings.b2_maxRotation*subStep.inv_dt;}}b.m_sweep.c0.SetV(b.m_sweep.c);b.m_sweep.a0=b.m_sweep.a;b.m_sweep.c.x+=subStep.dt*b.m_linearVelocity.x;b.m_sweep.c.y+=subStep.dt*b.m_linearVelocity.y;b.m_sweep.a+=subStep.dt*b.m_angularVelocity;b.SynchronizeTransform();}var k_toiBaumgarte=0.75;for(i=0;i<subStep.positionIterations;++i){var contactsOkay=contactSolver.SolvePositionConstraints(k_toiBaumgarte);var jointsOkay=true;for(j=0;j<this.m_jointCount;++j){var jointOkay=this.m_joints[j].SolvePositionConstraints(b2Settings.b2_contactBaumgarte);jointsOkay=jointsOkay&&jointOkay;}if(contactsOkay&&jointsOkay){break;}}this.Report(contactSolver.m_constraints);};b2Island.prototype.Report=function(constraints){if(this.m_listener==null){return;}for(var i=0;i<this.m_contactCount;++i){var c=this.m_contacts[i];var cc=constraints[i];for(var j=0;j<cc.pointCount;++j){b2Island.s_impulse.normalImpulses[j]=cc.points[j].normalImpulse;b2Island.s_impulse.tangentImpulses[j]=cc.points[j].tangentImpulse;}this.m_listener.PostSolve(c,b2Island.s_impulse);}};b2Island.prototype.AddBody=function(body){body.m_islandIndex=this.m_bodyCount;this.m_bodies[this.m_bodyCount++]=body;};b2Island.prototype.AddContact=function(contact){this.m_contacts[this.m_contactCount++]=contact;};b2Island.prototype.AddJoint=function(joint){this.m_joints[this.m_jointCount++]=joint;};Box2D.postDefs.push(function(){Box2D.Dynamics.b2Island.s_impulse=new b2ContactImpulse();});b2TimeStep.b2TimeStep=function(){};b2TimeStep.prototype.Set=function(step){this.dt=step.dt;this.inv_dt=step.inv_dt;this.positionIterations=step.positionIterations;this.velocityIterations=step.velocityIterations;this.warmStarting=step.warmStarting;};b2World.b2World=function(){this.s_stack=new Vector();this.m_contactManager=new b2ContactManager();this.m_contactSolver=new b2ContactSolver();this.m_island=new b2Island();};b2World.prototype.b2World=function(gravity,doSleep){this.m_destructionListener=null;this.m_debugDraw=null;this.m_bodyList=null;this.m_contactList=null;this.m_jointList=null;this.m_controllerList=null;this.m_bodyCount=0;this.m_contactCount=0;this.m_jointCount=0;this.m_controllerCount=0;b2World.m_warmStarting=true;b2World.m_continuousPhysics=true;this.m_allowSleep=doSleep;this.m_gravity=gravity;this.m_inv_dt0=0.0;this.m_contactManager.m_world=this;var bd=new b2BodyDef();this.m_groundBody=this.CreateBody(bd);};b2World.prototype.SetDestructionListener=function(listener){this.m_destructionListener=listener;};b2World.prototype.SetContactFilter=function(filter){this.m_contactManager.m_contactFilter=filter;};b2World.prototype.SetContactListener=function(listener){this.m_contactManager.m_contactListener=listener;};b2World.prototype.SetDebugDraw=function(debugDraw){this.m_debugDraw=debugDraw;};b2World.prototype.SetBroadPhase=function(broadPhase){var oldBroadPhase=this.m_contactManager.m_broadPhase;this.m_contactManager.m_broadPhase=broadPhase;for(var b=this.m_bodyList;b;b=b.m_next){for(var f=b.m_fixtureList;f;f=f.m_next){f.m_proxy=broadPhase.CreateProxy(oldBroadPhase.GetFatAABB(f.m_proxy),f);}}};b2World.prototype.Validate=function(){this.m_contactManager.m_broadPhase.Validate();};b2World.prototype.GetProxyCount=function(){return this.m_contactManager.m_broadPhase.GetProxyCount();};b2World.prototype.CreateBody=function(def){if(this.IsLocked()==true){return null;}var b=new b2Body(def,this);b.m_prev=null;b.m_next=this.m_bodyList;if(this.m_bodyList){this.m_bodyList.m_prev=b;}this.m_bodyList=b;++this.m_bodyCount;return b;};b2World.prototype.DestroyBody=function(b){if(this.IsLocked()==true){return;}var jn=b.m_jointList;while(jn){var jn0=jn;jn=jn.next;if(this.m_destructionListener){this.m_destructionListener.SayGoodbyeJoint(jn0.joint);}this.DestroyJoint(jn0.joint);}var coe=b.m_controllerList;while(coe){var coe0=coe;coe=coe.nextController;coe0.controller.RemoveBody(b);}var ce=b.m_contactList;while(ce){var ce0=ce;ce=ce.next;this.m_contactManager.Destroy(ce0.contact);}b.m_contactList=null;var f=b.m_fixtureList;while(f){var f0=f;f=f.m_next;if(this.m_destructionListener){this.m_destructionListener.SayGoodbyeFixture(f0);}f0.DestroyProxy(this.m_contactManager.m_broadPhase);f0.Destroy();}b.m_fixtureList=null;b.m_fixtureCount=0;if(b.m_prev){b.m_prev.m_next=b.m_next;}if(b.m_next){b.m_next.m_prev=b.m_prev;}if(b==this.m_bodyList){this.m_bodyList=b.m_next;}--this.m_bodyCount;};b2World.prototype.CreateJoint=function(def){var j=b2Joint.Create(def,null);j.m_prev=null;j.m_next=this.m_jointList;if(this.m_jointList){this.m_jointList.m_prev=j;}this.m_jointList=j;++this.m_jointCount;j.m_edgeA.joint=j;j.m_edgeA.other=j.m_bodyB;j.m_edgeA.prev=null;j.m_edgeA.next=j.m_bodyA.m_jointList;if(j.m_bodyA.m_jointList)j.m_bodyA.m_jointList.prev=j.m_edgeA;j.m_bodyA.m_jointList=j.m_edgeA;j.m_edgeB.joint=j;j.m_edgeB.other=j.m_bodyA;j.m_edgeB.prev=null;j.m_edgeB.next=j.m_bodyB.m_jointList;if(j.m_bodyB.m_jointList)j.m_bodyB.m_jointList.prev=j.m_edgeB;j.m_bodyB.m_jointList=j.m_edgeB;var bodyA=def.bodyA;var bodyB=def.bodyB;if(def.collideConnected==false){var edge=bodyB.GetContactList();while(edge){if(edge.other==bodyA){edge.contact.FlagForFiltering();}edge=edge.next;}}return j;};b2World.prototype.DestroyJoint=function(j){var collideConnected=j.m_collideConnected;if(j.m_prev){j.m_prev.m_next=j.m_next;}if(j.m_next){j.m_next.m_prev=j.m_prev;}if(j==this.m_jointList){this.m_jointList=j.m_next;}var bodyA=j.m_bodyA;var bodyB=j.m_bodyB;bodyA.SetAwake(true);bodyB.SetAwake(true);if(j.m_edgeA.prev){j.m_edgeA.prev.next=j.m_edgeA.next;}if(j.m_edgeA.next){j.m_edgeA.next.prev=j.m_edgeA.prev;}if(j.m_edgeA==bodyA.m_jointList){bodyA.m_jointList=j.m_edgeA.next;}j.m_edgeA.prev=null;j.m_edgeA.next=null;if(j.m_edgeB.prev){j.m_edgeB.prev.next=j.m_edgeB.next;}if(j.m_edgeB.next){j.m_edgeB.next.prev=j.m_edgeB.prev;}if(j.m_edgeB==bodyB.m_jointList){bodyB.m_jointList=j.m_edgeB.next;}j.m_edgeB.prev=null;j.m_edgeB.next=null;b2Joint.Destroy(j,null);--this.m_jointCount;if(collideConnected==false){var edge=bodyB.GetContactList();while(edge){if(edge.other==bodyA){edge.contact.FlagForFiltering();}edge=edge.next;}}};b2World.prototype.AddController=function(c){c.m_next=this.m_controllerList;c.m_prev=null;this.m_controllerList=c;c.m_world=this;this.m_controllerCount++;return c;};b2World.prototype.RemoveController=function(c){if(c.m_prev)c.m_prev.m_next=c.m_next;if(c.m_next)c.m_next.m_prev=c.m_prev;if(this.m_controllerList==c)this.m_controllerList=c.m_next;this.m_controllerCount--;};b2World.prototype.CreateController=function(controller){if(controller.m_world!=this)throw new Error("Controller can only be a member of one world");controller.m_next=this.m_controllerList;controller.m_prev=null;if(this.m_controllerList)this.m_controllerList.m_prev=controller;this.m_controllerList=controller;++this.m_controllerCount;controller.m_world=this;return controller;};b2World.prototype.DestroyController=function(controller){controller.Clear();if(controller.m_next)controller.m_next.m_prev=controller.m_prev;if(controller.m_prev)controller.m_prev.m_next=controller.m_next;if(controller==this.m_controllerList)this.m_controllerList=controller.m_next;--this.m_controllerCount;};b2World.prototype.SetWarmStarting=function(flag){b2World.m_warmStarting=flag;};b2World.prototype.SetContinuousPhysics=function(flag){b2World.m_continuousPhysics=flag;};b2World.prototype.GetBodyCount=function(){return this.m_bodyCount;};b2World.prototype.GetJointCount=function(){return this.m_jointCount;};b2World.prototype.GetContactCount=function(){return this.m_contactCount;};b2World.prototype.SetGravity=function(gravity){this.m_gravity=gravity;};b2World.prototype.GetGravity=function(){return this.m_gravity;};b2World.prototype.GetGroundBody=function(){return this.m_groundBody;};b2World.prototype.Step=function(dt,velocityIterations,positionIterations){if(dt===undefined)dt=0;if(velocityIterations===undefined)velocityIterations=0;if(positionIterations===undefined)positionIterations=0;if(this.m_flags&b2World.e_newFixture){this.m_contactManager.FindNewContacts();this.m_flags&=~b2World.e_newFixture;}this.m_flags|=b2World.e_locked;var step=b2World.s_timestep2;step.dt=dt;step.velocityIterations=velocityIterations;step.positionIterations=positionIterations;if(dt>0.0){step.inv_dt=1.0/dt;}else{step.inv_dt=0.0;}step.dtRatio=this.m_inv_dt0*dt;step.warmStarting=b2World.m_warmStarting;this.m_contactManager.Collide();if(step.dt>0.0){this.Solve(step);}if(b2World.m_continuousPhysics&&step.dt>0.0){this.SolveTOI(step);}if(step.dt>0.0){this.m_inv_dt0=step.inv_dt;}this.m_flags&=~b2World.e_locked;};b2World.prototype.ClearForces=function(){for(var body=this.m_bodyList;body;body=body.m_next){body.m_force.SetZero();body.m_torque=0.0;}};b2World.prototype.DrawDebugData=function(){if(this.m_debugDraw==null){return;}this.m_debugDraw.m_sprite.graphics.clear();var flags=this.m_debugDraw.GetFlags();var i=0;var b;var f;var s;var j;var bp;var invQ=new b2Vec2();var x1=new b2Vec2();var x2=new b2Vec2();var xf;var b1=new b2AABB();var b2=new b2AABB();var vs=[new b2Vec2(),new b2Vec2(),new b2Vec2(),new b2Vec2()];var color=new b2Color(0,0,0);if(flags&b2DebugDraw.e_shapeBit){for(b=this.m_bodyList;b;b=b.m_next){xf=b.m_xf;for(f=b.GetFixtureList();f;f=f.m_next){s=f.GetShape();if(b.IsActive()==false){color.Set(0.5,0.5,0.3);this.DrawShape(s,xf,color);}else if(b.GetType()==b2Body.b2_staticBody){color.Set(0.5,0.9,0.5);this.DrawShape(s,xf,color);}else if(b.GetType()==b2Body.b2_kinematicBody){color.Set(0.5,0.5,0.9);this.DrawShape(s,xf,color);}else if(b.IsAwake()==false){color.Set(0.6,0.6,0.6);this.DrawShape(s,xf,color);}else{color.Set(0.9,0.7,0.7);this.DrawShape(s,xf,color);}}}}if(flags&b2DebugDraw.e_jointBit){for(j=this.m_jointList;j;j=j.m_next){this.DrawJoint(j);}}if(flags&b2DebugDraw.e_controllerBit){for(var c=this.m_controllerList;c;c=c.m_next){c.Draw(this.m_debugDraw);}}if(flags&b2DebugDraw.e_pairBit){color.Set(0.3,0.9,0.9);for(var contact=this.m_contactManager.m_contactList;contact;contact=contact.GetNext()){var fixtureA=contact.GetFixtureA();var fixtureB=contact.GetFixtureB();var cA=fixtureA.GetAABB().GetCenter();var cB=fixtureB.GetAABB().GetCenter();this.m_debugDraw.DrawSegment(cA,cB,color);}}if(flags&b2DebugDraw.e_aabbBit){bp=this.m_contactManager.m_broadPhase;vs=[new b2Vec2(),new b2Vec2(),new b2Vec2(),new b2Vec2()];for(b=this.m_bodyList;b;b=b.GetNext()){if(b.IsActive()==false){continue;}for(f=b.GetFixtureList();f;f=f.GetNext()){var aabb=bp.GetFatAABB(f.m_proxy);vs[0].Set(aabb.lowerBound.x,aabb.lowerBound.y);vs[1].Set(aabb.upperBound.x,aabb.lowerBound.y);vs[2].Set(aabb.upperBound.x,aabb.upperBound.y);vs[3].Set(aabb.lowerBound.x,aabb.upperBound.y);this.m_debugDraw.DrawPolygon(vs,4,color);}}}if(flags&b2DebugDraw.e_centerOfMassBit){for(b=this.m_bodyList;b;b=b.m_next){xf=b2World.s_xf;xf.R=b.m_xf.R;xf.position=b.GetWorldCenter();this.m_debugDraw.DrawTransform(xf);}}};b2World.prototype.QueryAABB=function(callback,aabb){var __this=this;var broadPhase=__this.m_contactManager.m_broadPhase;function WorldQueryWrapper(proxy){return callback(broadPhase.GetUserData(proxy));};broadPhase.Query(WorldQueryWrapper,aabb);};b2World.prototype.QueryShape=function(callback,shape,transform){var __this=this;if(transform===undefined)transform=null;if(transform==null){transform=new b2Transform();transform.SetIdentity();}var broadPhase=__this.m_contactManager.m_broadPhase;function WorldQueryWrapper(proxy){var fixture=broadPhase.GetUserData(proxy)instanceof b2Fixture?broadPhase.GetUserData(proxy):null;if(b2Shape.TestOverlap(shape,transform,fixture.GetShape(),fixture.GetBody().GetTransform()))return callback(fixture);return true;};var aabb=new b2AABB();shape.ComputeAABB(aabb,transform);broadPhase.Query(WorldQueryWrapper,aabb);};b2World.prototype.QueryPoint=function(callback,p){var __this=this;var broadPhase=__this.m_contactManager.m_broadPhase;function WorldQueryWrapper(proxy){var fixture=broadPhase.GetUserData(proxy)instanceof b2Fixture?broadPhase.GetUserData(proxy):null;if(fixture.TestPoint(p))return callback(fixture);return true;};var aabb=new b2AABB();aabb.lowerBound.Set(p.x-b2Settings.b2_linearSlop,p.y-b2Settings.b2_linearSlop);aabb.upperBound.Set(p.x+b2Settings.b2_linearSlop,p.y+b2Settings.b2_linearSlop);broadPhase.Query(WorldQueryWrapper,aabb);};b2World.prototype.RayCast=function(callback,point1,point2){var __this=this;var broadPhase=__this.m_contactManager.m_broadPhase;var output=new b2RayCastOutput();function RayCastWrapper(input,proxy){var userData=broadPhase.GetUserData(proxy);var fixture=userData instanceof b2Fixture?userData:null;var hit=fixture.RayCast(output,input);if(hit){var fraction=output.fraction;var point=new b2Vec2((1.0-fraction)*point1.x+fraction*point2.x,(1.0-fraction)*point1.y+fraction*point2.y);return callback(fixture,point,output.normal,fraction);}return input.maxFraction;};var input=new b2RayCastInput(point1,point2);broadPhase.RayCast(RayCastWrapper,input);};b2World.prototype.RayCastOne=function(point1,point2){var __this=this;var result;function RayCastOneWrapper(fixture,point,normal,fraction){if(fraction===undefined)fraction=0;result=fixture;return fraction;};__this.RayCast(RayCastOneWrapper,point1,point2);return result;};b2World.prototype.RayCastAll=function(point1,point2){var __this=this;var result=new Vector();function RayCastAllWrapper(fixture,point,normal,fraction){if(fraction===undefined)fraction=0;result[result.length]=fixture;return 1;};__this.RayCast(RayCastAllWrapper,point1,point2);return result;};b2World.prototype.GetBodyList=function(){return this.m_bodyList;};b2World.prototype.GetJointList=function(){return this.m_jointList;};b2World.prototype.GetContactList=function(){return this.m_contactList;};b2World.prototype.IsLocked=function(){return(this.m_flags&b2World.e_locked)>0;};b2World.prototype.Solve=function(step){var b;for(var controller=this.m_controllerList;controller;controller=controller.m_next){controller.Step(step);}var island=this.m_island;island.Initialize(this.m_bodyCount,this.m_contactCount,this.m_jointCount,null,this.m_contactManager.m_contactListener,this.m_contactSolver);for(b=this.m_bodyList;b;b=b.m_next){b.m_flags&=~b2Body.e_islandFlag;}for(var c=this.m_contactList;c;c=c.m_next){c.m_flags&=~b2Contact.e_islandFlag;}for(var j=this.m_jointList;j;j=j.m_next){j.m_islandFlag=false;}var stackSize=parseInt(this.m_bodyCount);var stack=this.s_stack;for(var seed=this.m_bodyList;seed;seed=seed.m_next){if(seed.m_flags&b2Body.e_islandFlag){continue;}if(seed.IsAwake()==false||seed.IsActive()==false){continue;}if(seed.GetType()==b2Body.b2_staticBody){continue;}island.Clear();var stackCount=0;stack[stackCount++]=seed;seed.m_flags|=b2Body.e_islandFlag;while(stackCount>0){b=stack[--stackCount];island.AddBody(b);if(b.IsAwake()==false){b.SetAwake(true);}if(b.GetType()==b2Body.b2_staticBody){continue;}var other;for(var ce=b.m_contactList;ce;ce=ce.next){if(ce.contact.m_flags&b2Contact.e_islandFlag){continue;}if(ce.contact.IsSensor()==true||ce.contact.IsEnabled()==false||ce.contact.IsTouching()==false){continue;}island.AddContact(ce.contact);ce.contact.m_flags|=b2Contact.e_islandFlag;other=ce.other;if(other.m_flags&b2Body.e_islandFlag){continue;}stack[stackCount++]=other;other.m_flags|=b2Body.e_islandFlag;}for(var jn=b.m_jointList;jn;jn=jn.next){if(jn.joint.m_islandFlag==true){continue;}other=jn.other;if(other.IsActive()==false){continue;}island.AddJoint(jn.joint);jn.joint.m_islandFlag=true;if(other.m_flags&b2Body.e_islandFlag){continue;}stack[stackCount++]=other;other.m_flags|=b2Body.e_islandFlag;}}island.Solve(step,this.m_gravity,this.m_allowSleep);for(var i=0;i<island.m_bodyCount;++i){b=island.m_bodies[i];if(b.GetType()==b2Body.b2_staticBody){b.m_flags&=~b2Body.e_islandFlag;}}}for(i=0;i<stack.length;++i){if(!stack[i])break;stack[i]=null;}for(b=this.m_bodyList;b;b=b.m_next){if(b.IsAwake()==false||b.IsActive()==false){continue;}if(b.GetType()==b2Body.b2_staticBody){continue;}b.SynchronizeFixtures();}this.m_contactManager.FindNewContacts();};b2World.prototype.SolveTOI=function(step){var b;var fA;var fB;var bA;var bB;var cEdge;var j;var island=this.m_island;island.Initialize(this.m_bodyCount,b2Settings.b2_maxTOIContactsPerIsland,b2Settings.b2_maxTOIJointsPerIsland,null,this.m_contactManager.m_contactListener,this.m_contactSolver);var queue=b2World.s_queue;for(b=this.m_bodyList;b;b=b.m_next){b.m_flags&=~b2Body.e_islandFlag;b.m_sweep.t0=0.0;}var c;for(c=this.m_contactList;c;c=c.m_next){c.m_flags&=~(b2Contact.e_toiFlag|b2Contact.e_islandFlag);}for(j=this.m_jointList;j;j=j.m_next){j.m_islandFlag=false;}for(;;){var minContact=null;var minTOI=1.0;for(c=this.m_contactList;c;c=c.m_next){if(c.IsSensor()==true||c.IsEnabled()==false||c.IsContinuous()==false){continue;}var toi=1.0;if(c.m_flags&b2Contact.e_toiFlag){toi=c.m_toi;}else{fA=c.m_fixtureA;fB=c.m_fixtureB;bA=fA.m_body;bB=fB.m_body;if((bA.GetType()!=b2Body.b2_dynamicBody||bA.IsAwake()==false)&&(bB.GetType()!=b2Body.b2_dynamicBody||bB.IsAwake()==false)){continue;}var t0=bA.m_sweep.t0;if(bA.m_sweep.t0<bB.m_sweep.t0){t0=bB.m_sweep.t0;bA.m_sweep.Advance(t0);}else if(bB.m_sweep.t0<bA.m_sweep.t0){t0=bA.m_sweep.t0;bB.m_sweep.Advance(t0);}toi=c.ComputeTOI(bA.m_sweep,bB.m_sweep);b2Settings.b2Assert(0.0<=toi&&toi<=1.0);if(toi>0.0&&toi<1.0){toi=(1.0-toi)*t0+toi;if(toi>1)toi=1;}c.m_toi=toi;c.m_flags|=b2Contact.e_toiFlag;}if(Number.MIN_VALUE<toi&&toi<minTOI){minContact=c;minTOI=toi;}}if(minContact==null||1.0-100.0*Number.MIN_VALUE<minTOI){break;}fA=minContact.m_fixtureA;fB=minContact.m_fixtureB;bA=fA.m_body;bB=fB.m_body;b2World.s_backupA.Set(bA.m_sweep);b2World.s_backupB.Set(bB.m_sweep);bA.Advance(minTOI);bB.Advance(minTOI);minContact.Update(this.m_contactManager.m_contactListener);minContact.m_flags&=~b2Contact.e_toiFlag;if(minContact.IsSensor()==true||minContact.IsEnabled()==false){bA.m_sweep.Set(b2World.s_backupA);bB.m_sweep.Set(b2World.s_backupB);bA.SynchronizeTransform();bB.SynchronizeTransform();continue;}if(minContact.IsTouching()==false){continue;}var seed=bA;if(seed.GetType()!=b2Body.b2_dynamicBody){seed=bB;}island.Clear();var queueStart=0;var queueSize=0;queue[queueStart+queueSize++]=seed;seed.m_flags|=b2Body.e_islandFlag;while(queueSize>0){b=queue[queueStart++];--queueSize;island.AddBody(b);if(b.IsAwake()==false){b.SetAwake(true);}if(b.GetType()!=b2Body.b2_dynamicBody){continue;}for(cEdge=b.m_contactList;cEdge;cEdge=cEdge.next){if(island.m_contactCount==island.m_contactCapacity){break;}if(cEdge.contact.m_flags&b2Contact.e_islandFlag){continue;}if(cEdge.contact.IsSensor()==true||cEdge.contact.IsEnabled()==false||cEdge.contact.IsTouching()==false){continue;}island.AddContact(cEdge.contact);cEdge.contact.m_flags|=b2Contact.e_islandFlag;var other=cEdge.other;if(other.m_flags&b2Body.e_islandFlag){continue;}if(other.GetType()!=b2Body.b2_staticBody){other.Advance(minTOI);other.SetAwake(true);}queue[queueStart+queueSize]=other;++queueSize;other.m_flags|=b2Body.e_islandFlag;}for(var jEdge=b.m_jointList;jEdge;jEdge=jEdge.next){if(island.m_jointCount==island.m_jointCapacity)continue;if(jEdge.joint.m_islandFlag==true)continue;other=jEdge.other;if(other.IsActive()==false){continue;}island.AddJoint(jEdge.joint);jEdge.joint.m_islandFlag=true;if(other.m_flags&b2Body.e_islandFlag)continue;if(other.GetType()!=b2Body.b2_staticBody){other.Advance(minTOI);other.SetAwake(true);}queue[queueStart+queueSize]=other;++queueSize;other.m_flags|=b2Body.e_islandFlag;}}var subStep=b2World.s_timestep;subStep.warmStarting=false;subStep.dt=(1.0-minTOI)*step.dt;subStep.inv_dt=1.0/subStep.dt;subStep.dtRatio=0.0;subStep.velocityIterations=step.velocityIterations;subStep.positionIterations=step.positionIterations;island.SolveTOI(subStep);var i=0;for(i=0;i<island.m_bodyCount;++i){b=island.m_bodies[i];b.m_flags&=~b2Body.e_islandFlag;if(b.IsAwake()==false){continue;}if(b.GetType()!=b2Body.b2_dynamicBody){continue;}b.SynchronizeFixtures();for(cEdge=b.m_contactList;cEdge;cEdge=cEdge.next){cEdge.contact.m_flags&=~b2Contact.e_toiFlag;}}for(i=0;i<island.m_contactCount;++i){c=island.m_contacts[i];c.m_flags&=~(b2Contact.e_toiFlag|b2Contact.e_islandFlag);}for(i=0;i<island.m_jointCount;++i){j=island.m_joints[i];j.m_islandFlag=false;}this.m_contactManager.FindNewContacts();}};b2World.prototype.DrawJoint=function(joint){var b1=joint.GetBodyA();var b2=joint.GetBodyB();var xf1=b1.m_xf;var xf2=b2.m_xf;var x1=xf1.position;var x2=xf2.position;var p1=joint.GetAnchorA();var p2=joint.GetAnchorB();var color=b2World.s_jointColor;switch(joint.m_type){case b2Joint.e_distanceJoint:this.m_debugDraw.DrawSegment(p1,p2,color);break;case b2Joint.e_pulleyJoint:{var pulley=joint instanceof b2PulleyJoint?joint:null;var s1=pulley.GetGroundAnchorA();var s2=pulley.GetGroundAnchorB();this.m_debugDraw.DrawSegment(s1,p1,color);this.m_debugDraw.DrawSegment(s2,p2,color);this.m_debugDraw.DrawSegment(s1,s2,color);}break;case b2Joint.e_mouseJoint:this.m_debugDraw.DrawSegment(p1,p2,color);break;default:if(b1!=this.m_groundBody)this.m_debugDraw.DrawSegment(x1,p1,color);this.m_debugDraw.DrawSegment(p1,p2,color);if(b2!=this.m_groundBody)this.m_debugDraw.DrawSegment(x2,p2,color);}};b2World.prototype.DrawShape=function(shape,xf,color){switch(shape.m_type){case b2Shape.e_circleShape:{var circle=shape instanceof b2CircleShape?shape:null;var center=b2Math.MulX(xf,circle.m_p);var radius=circle.m_radius;var axis=xf.R.col1;this.m_debugDraw.DrawSolidCircle(center,radius,axis,color);}break;case b2Shape.e_polygonShape:{var i=0;var poly=shape instanceof b2PolygonShape?shape:null;var vertexCount=parseInt(poly.GetVertexCount());var localVertices=poly.GetVertices();var vertices=new Vector(vertexCount);for(i=0;i<vertexCount;++i){vertices[i]=b2Math.MulX(xf,localVertices[i]);}this.m_debugDraw.DrawSolidPolygon(vertices,vertexCount,color);}break;case b2Shape.e_edgeShape:{var edge=shape instanceof b2EdgeShape?shape:null;this.m_debugDraw.DrawSegment(b2Math.MulX(xf,edge.GetVertex1()),b2Math.MulX(xf,edge.GetVertex2()),color);}break;}};Box2D.postDefs.push(function(){Box2D.Dynamics.b2World.s_timestep2=new b2TimeStep();Box2D.Dynamics.b2World.s_xf=new b2Transform();Box2D.Dynamics.b2World.s_backupA=new b2Sweep();Box2D.Dynamics.b2World.s_backupB=new b2Sweep();Box2D.Dynamics.b2World.s_timestep=new b2TimeStep();Box2D.Dynamics.b2World.s_queue=new Vector();Box2D.Dynamics.b2World.s_jointColor=new b2Color(0.5,0.8,0.8);Box2D.Dynamics.b2World.e_newFixture=0x0001;Box2D.Dynamics.b2World.e_locked=0x0002;});})();(function(){var b2CircleShape=Box2D.Collision.Shapes.b2CircleShape,b2EdgeChainDef=Box2D.Collision.Shapes.b2EdgeChainDef,b2EdgeShape=Box2D.Collision.Shapes.b2EdgeShape,b2MassData=Box2D.Collision.Shapes.b2MassData,b2PolygonShape=Box2D.Collision.Shapes.b2PolygonShape,b2Shape=Box2D.Collision.Shapes.b2Shape,b2CircleContact=Box2D.Dynamics.Contacts.b2CircleContact,b2Contact=Box2D.Dynamics.Contacts.b2Contact,b2ContactConstraint=Box2D.Dynamics.Contacts.b2ContactConstraint,b2ContactConstraintPoint=Box2D.Dynamics.Contacts.b2ContactConstraintPoint,b2ContactEdge=Box2D.Dynamics.Contacts.b2ContactEdge,b2ContactFactory=Box2D.Dynamics.Contacts.b2ContactFactory,b2ContactRegister=Box2D.Dynamics.Contacts.b2ContactRegister,b2ContactResult=Box2D.Dynamics.Contacts.b2ContactResult,b2ContactSolver=Box2D.Dynamics.Contacts.b2ContactSolver,b2EdgeAndCircleContact=Box2D.Dynamics.Contacts.b2EdgeAndCircleContact,b2NullContact=Box2D.Dynamics.Contacts.b2NullContact,b2PolyAndCircleContact=Box2D.Dynamics.Contacts.b2PolyAndCircleContact,b2PolyAndEdgeContact=Box2D.Dynamics.Contacts.b2PolyAndEdgeContact,b2PolygonContact=Box2D.Dynamics.Contacts.b2PolygonContact,b2PositionSolverManifold=Box2D.Dynamics.Contacts.b2PositionSolverManifold,b2Body=Box2D.Dynamics.b2Body,b2BodyDef=Box2D.Dynamics.b2BodyDef,b2ContactFilter=Box2D.Dynamics.b2ContactFilter,b2ContactImpulse=Box2D.Dynamics.b2ContactImpulse,b2ContactListener=Box2D.Dynamics.b2ContactListener,b2ContactManager=Box2D.Dynamics.b2ContactManager,b2DebugDraw=Box2D.Dynamics.b2DebugDraw,b2DestructionListener=Box2D.Dynamics.b2DestructionListener,b2FilterData=Box2D.Dynamics.b2FilterData,b2Fixture=Box2D.Dynamics.b2Fixture,b2FixtureDef=Box2D.Dynamics.b2FixtureDef,b2Island=Box2D.Dynamics.b2Island,b2TimeStep=Box2D.Dynamics.b2TimeStep,b2World=Box2D.Dynamics.b2World,b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2AABB=Box2D.Collision.b2AABB,b2Bound=Box2D.Collision.b2Bound,b2BoundValues=Box2D.Collision.b2BoundValues,b2Collision=Box2D.Collision.b2Collision,b2ContactID=Box2D.Collision.b2ContactID,b2ContactPoint=Box2D.Collision.b2ContactPoint,b2Distance=Box2D.Collision.b2Distance,b2DistanceInput=Box2D.Collision.b2DistanceInput,b2DistanceOutput=Box2D.Collision.b2DistanceOutput,b2DistanceProxy=Box2D.Collision.b2DistanceProxy,b2DynamicTree=Box2D.Collision.b2DynamicTree,b2DynamicTreeBroadPhase=Box2D.Collision.b2DynamicTreeBroadPhase,b2DynamicTreeNode=Box2D.Collision.b2DynamicTreeNode,b2DynamicTreePair=Box2D.Collision.b2DynamicTreePair,b2Manifold=Box2D.Collision.b2Manifold,b2ManifoldPoint=Box2D.Collision.b2ManifoldPoint,b2Point=Box2D.Collision.b2Point,b2RayCastInput=Box2D.Collision.b2RayCastInput,b2RayCastOutput=Box2D.Collision.b2RayCastOutput,b2Segment=Box2D.Collision.b2Segment,b2SeparationFunction=Box2D.Collision.b2SeparationFunction,b2Simplex=Box2D.Collision.b2Simplex,b2SimplexCache=Box2D.Collision.b2SimplexCache,b2SimplexVertex=Box2D.Collision.b2SimplexVertex,b2TimeOfImpact=Box2D.Collision.b2TimeOfImpact,b2TOIInput=Box2D.Collision.b2TOIInput,b2WorldManifold=Box2D.Collision.b2WorldManifold,ClipVertex=Box2D.Collision.ClipVertex,Features=Box2D.Collision.Features,IBroadPhase=Box2D.Collision.IBroadPhase;Box2D.inherit(b2CircleContact,Box2D.Dynamics.Contacts.b2Contact);b2CircleContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2CircleContact.b2CircleContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2CircleContact.Create=function(allocator){return new b2CircleContact();};b2CircleContact.Destroy=function(contact,allocator){};b2CircleContact.prototype.Reset=function(fixtureA,fixtureB){this.__super.Reset.call(this,fixtureA,fixtureB);};b2CircleContact.prototype.Evaluate=function(){var bA=this.m_fixtureA.GetBody();var bB=this.m_fixtureB.GetBody();b2Collision.CollideCircles(this.m_manifold,this.m_fixtureA.GetShape()instanceof b2CircleShape?this.m_fixtureA.GetShape():null,bA.m_xf,this.m_fixtureB.GetShape()instanceof b2CircleShape?this.m_fixtureB.GetShape():null,bB.m_xf);};b2Contact.b2Contact=function(){this.m_nodeA=new b2ContactEdge();this.m_nodeB=new b2ContactEdge();this.m_manifold=new b2Manifold();this.m_oldManifold=new b2Manifold();};b2Contact.prototype.GetManifold=function(){return this.m_manifold;};b2Contact.prototype.GetWorldManifold=function(worldManifold){var bodyA=this.m_fixtureA.GetBody();var bodyB=this.m_fixtureB.GetBody();var shapeA=this.m_fixtureA.GetShape();var shapeB=this.m_fixtureB.GetShape();worldManifold.Initialize(this.m_manifold,bodyA.GetTransform(),shapeA.m_radius,bodyB.GetTransform(),shapeB.m_radius);};b2Contact.prototype.IsTouching=function(){return(this.m_flags&b2Contact.e_touchingFlag)==b2Contact.e_touchingFlag;};b2Contact.prototype.IsContinuous=function(){return(this.m_flags&b2Contact.e_continuousFlag)==b2Contact.e_continuousFlag;};b2Contact.prototype.SetSensor=function(sensor){if(sensor){this.m_flags|=b2Contact.e_sensorFlag;}else{this.m_flags&=~b2Contact.e_sensorFlag;}};b2Contact.prototype.IsSensor=function(){return(this.m_flags&b2Contact.e_sensorFlag)==b2Contact.e_sensorFlag;};b2Contact.prototype.SetEnabled=function(flag){if(flag){this.m_flags|=b2Contact.e_enabledFlag;}else{this.m_flags&=~b2Contact.e_enabledFlag;}};b2Contact.prototype.IsEnabled=function(){return(this.m_flags&b2Contact.e_enabledFlag)==b2Contact.e_enabledFlag;};b2Contact.prototype.GetNext=function(){return this.m_next;};b2Contact.prototype.GetFixtureA=function(){return this.m_fixtureA;};b2Contact.prototype.GetFixtureB=function(){return this.m_fixtureB;};b2Contact.prototype.FlagForFiltering=function(){this.m_flags|=b2Contact.e_filterFlag;};b2Contact.prototype.b2Contact=function(){};b2Contact.prototype.Reset=function(fixtureA,fixtureB){if(fixtureA===undefined)fixtureA=null;if(fixtureB===undefined)fixtureB=null;this.m_flags=b2Contact.e_enabledFlag;if(!fixtureA||!fixtureB){this.m_fixtureA=null;this.m_fixtureB=null;return;}if(fixtureA.IsSensor()||fixtureB.IsSensor()){this.m_flags|=b2Contact.e_sensorFlag;}var bodyA=fixtureA.GetBody();var bodyB=fixtureB.GetBody();if(bodyA.GetType()!=b2Body.b2_dynamicBody||bodyA.IsBullet()||bodyB.GetType()!=b2Body.b2_dynamicBody||bodyB.IsBullet()){this.m_flags|=b2Contact.e_continuousFlag;}this.m_fixtureA=fixtureA;this.m_fixtureB=fixtureB;this.m_manifold.m_pointCount=0;this.m_prev=null;this.m_next=null;this.m_nodeA.contact=null;this.m_nodeA.prev=null;this.m_nodeA.next=null;this.m_nodeA.other=null;this.m_nodeB.contact=null;this.m_nodeB.prev=null;this.m_nodeB.next=null;this.m_nodeB.other=null;};b2Contact.prototype.Update=function(listener){var tManifold=this.m_oldManifold;this.m_oldManifold=this.m_manifold;this.m_manifold=tManifold;this.m_flags|=b2Contact.e_enabledFlag;var touching=false;var wasTouching=(this.m_flags&b2Contact.e_touchingFlag)==b2Contact.e_touchingFlag;var bodyA=this.m_fixtureA.m_body;var bodyB=this.m_fixtureB.m_body;var aabbOverlap=this.m_fixtureA.m_aabb.TestOverlap(this.m_fixtureB.m_aabb);if(this.m_flags&b2Contact.e_sensorFlag){if(aabbOverlap){var shapeA=this.m_fixtureA.GetShape();var shapeB=this.m_fixtureB.GetShape();var xfA=bodyA.GetTransform();var xfB=bodyB.GetTransform();touching=b2Shape.TestOverlap(shapeA,xfA,shapeB,xfB);}this.m_manifold.m_pointCount=0;}else{if(bodyA.GetType()!=b2Body.b2_dynamicBody||bodyA.IsBullet()||bodyB.GetType()!=b2Body.b2_dynamicBody||bodyB.IsBullet()){this.m_flags|=b2Contact.e_continuousFlag;}else{this.m_flags&=~b2Contact.e_continuousFlag;}if(aabbOverlap){this.Evaluate();touching=this.m_manifold.m_pointCount>0;for(var i=0;i<this.m_manifold.m_pointCount;++i){var mp2=this.m_manifold.m_points[i];mp2.m_normalImpulse=0.0;mp2.m_tangentImpulse=0.0;var id2=mp2.m_id;for(var j=0;j<this.m_oldManifold.m_pointCount;++j){var mp1=this.m_oldManifold.m_points[j];if(mp1.m_id.key==id2.key){mp2.m_normalImpulse=mp1.m_normalImpulse;mp2.m_tangentImpulse=mp1.m_tangentImpulse;break;}}}}else{this.m_manifold.m_pointCount=0;}if(touching!=wasTouching){bodyA.SetAwake(true);bodyB.SetAwake(true);}}if(touching){this.m_flags|=b2Contact.e_touchingFlag;}else{this.m_flags&=~b2Contact.e_touchingFlag;}if(wasTouching==false&&touching==true){listener.BeginContact(this);}if(wasTouching==true&&touching==false){listener.EndContact(this);}if((this.m_flags&b2Contact.e_sensorFlag)==0){listener.PreSolve(this,this.m_oldManifold);}};b2Contact.prototype.Evaluate=function(){};b2Contact.prototype.ComputeTOI=function(sweepA,sweepB){b2Contact.s_input.proxyA.Set(this.m_fixtureA.GetShape());b2Contact.s_input.proxyB.Set(this.m_fixtureB.GetShape());b2Contact.s_input.sweepA=sweepA;b2Contact.s_input.sweepB=sweepB;b2Contact.s_input.tolerance=b2Settings.b2_linearSlop;return b2TimeOfImpact.TimeOfImpact(b2Contact.s_input);};Box2D.postDefs.push(function(){Box2D.Dynamics.Contacts.b2Contact.e_sensorFlag=0x0001;Box2D.Dynamics.Contacts.b2Contact.e_continuousFlag=0x0002;Box2D.Dynamics.Contacts.b2Contact.e_islandFlag=0x0004;Box2D.Dynamics.Contacts.b2Contact.e_toiFlag=0x0008;Box2D.Dynamics.Contacts.b2Contact.e_touchingFlag=0x0010;Box2D.Dynamics.Contacts.b2Contact.e_enabledFlag=0x0020;Box2D.Dynamics.Contacts.b2Contact.e_filterFlag=0x0040;Box2D.Dynamics.Contacts.b2Contact.s_input=new b2TOIInput();});b2ContactConstraint.b2ContactConstraint=function(){this.localPlaneNormal=new b2Vec2();this.localPoint=new b2Vec2();this.normal=new b2Vec2();this.normalMass=new b2Mat22();this.K=new b2Mat22();};b2ContactConstraint.prototype.b2ContactConstraint=function(){this.points=new Vector(b2Settings.b2_maxManifoldPoints);for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){this.points[i]=new b2ContactConstraintPoint();}};b2ContactConstraintPoint.b2ContactConstraintPoint=function(){this.localPoint=new b2Vec2();this.rA=new b2Vec2();this.rB=new b2Vec2();};b2ContactEdge.b2ContactEdge=function(){};b2ContactFactory.b2ContactFactory=function(){};b2ContactFactory.prototype.b2ContactFactory=function(allocator){this.m_allocator=allocator;this.InitializeRegisters();};b2ContactFactory.prototype.AddType=function(createFcn,destroyFcn,type1,type2){if(type1===undefined)type1=0;if(type2===undefined)type2=0;this.m_registers[type1][type2].createFcn=createFcn;this.m_registers[type1][type2].destroyFcn=destroyFcn;this.m_registers[type1][type2].primary=true;if(type1!=type2){this.m_registers[type2][type1].createFcn=createFcn;this.m_registers[type2][type1].destroyFcn=destroyFcn;this.m_registers[type2][type1].primary=false;}};b2ContactFactory.prototype.InitializeRegisters=function(){this.m_registers=new Vector(b2Shape.e_shapeTypeCount);for(var i=0;i<b2Shape.e_shapeTypeCount;i++){this.m_registers[i]=new Vector(b2Shape.e_shapeTypeCount);for(var j=0;j<b2Shape.e_shapeTypeCount;j++){this.m_registers[i][j]=new b2ContactRegister();}}this.AddType(b2CircleContact.Create,b2CircleContact.Destroy,b2Shape.e_circleShape,b2Shape.e_circleShape);this.AddType(b2PolyAndCircleContact.Create,b2PolyAndCircleContact.Destroy,b2Shape.e_polygonShape,b2Shape.e_circleShape);this.AddType(b2PolygonContact.Create,b2PolygonContact.Destroy,b2Shape.e_polygonShape,b2Shape.e_polygonShape);this.AddType(b2EdgeAndCircleContact.Create,b2EdgeAndCircleContact.Destroy,b2Shape.e_edgeShape,b2Shape.e_circleShape);this.AddType(b2PolyAndEdgeContact.Create,b2PolyAndEdgeContact.Destroy,b2Shape.e_polygonShape,b2Shape.e_edgeShape);};b2ContactFactory.prototype.Create=function(fixtureA,fixtureB){var type1=parseInt(fixtureA.GetType());var type2=parseInt(fixtureB.GetType());var reg=this.m_registers[type1][type2];var c;if(reg.pool){c=reg.pool;reg.pool=c.m_next;reg.poolCount--;c.Reset(fixtureA,fixtureB);return c;}var createFcn=reg.createFcn;if(createFcn!=null){if(reg.primary){c=createFcn(this.m_allocator);c.Reset(fixtureA,fixtureB);return c;}else{c=createFcn(this.m_allocator);c.Reset(fixtureB,fixtureA);return c;}}else{return null;}};b2ContactFactory.prototype.Destroy=function(contact){if(contact.m_manifold.m_pointCount>0){contact.m_fixtureA.m_body.SetAwake(true);contact.m_fixtureB.m_body.SetAwake(true);}var type1=parseInt(contact.m_fixtureA.GetType());var type2=parseInt(contact.m_fixtureB.GetType());var reg=this.m_registers[type1][type2];if(true){reg.poolCount++;contact.m_next=reg.pool;reg.pool=contact;}var destroyFcn=reg.destroyFcn;destroyFcn(contact,this.m_allocator);};b2ContactRegister.b2ContactRegister=function(){};b2ContactResult.b2ContactResult=function(){this.position=new b2Vec2();this.normal=new b2Vec2();this.id=new b2ContactID();};b2ContactSolver.b2ContactSolver=function(){this.m_step=new b2TimeStep();this.m_constraints=new Vector();};b2ContactSolver.prototype.b2ContactSolver=function(){};b2ContactSolver.prototype.Initialize=function(step,contacts,contactCount,allocator){if(contactCount===undefined)contactCount=0;var contact;this.m_step.Set(step);this.m_allocator=allocator;var i=0;var tVec;var tMat;this.m_constraintCount=contactCount;while(this.m_constraints.length<this.m_constraintCount){this.m_constraints[this.m_constraints.length]=new b2ContactConstraint();}for(i=0;i<contactCount;++i){contact=contacts[i];var fixtureA=contact.m_fixtureA;var fixtureB=contact.m_fixtureB;var shapeA=fixtureA.m_shape;var shapeB=fixtureB.m_shape;var radiusA=shapeA.m_radius;var radiusB=shapeB.m_radius;var bodyA=fixtureA.m_body;var bodyB=fixtureB.m_body;var manifold=contact.GetManifold();var friction=b2Settings.b2MixFriction(fixtureA.GetFriction(),fixtureB.GetFriction());var restitution=b2Settings.b2MixRestitution(fixtureA.GetRestitution(),fixtureB.GetRestitution());var vAX=bodyA.m_linearVelocity.x;var vAY=bodyA.m_linearVelocity.y;var vBX=bodyB.m_linearVelocity.x;var vBY=bodyB.m_linearVelocity.y;var wA=bodyA.m_angularVelocity;var wB=bodyB.m_angularVelocity;b2Settings.b2Assert(manifold.m_pointCount>0);b2ContactSolver.s_worldManifold.Initialize(manifold,bodyA.m_xf,radiusA,bodyB.m_xf,radiusB);var normalX=b2ContactSolver.s_worldManifold.m_normal.x;var normalY=b2ContactSolver.s_worldManifold.m_normal.y;var cc=this.m_constraints[i];cc.bodyA=bodyA;cc.bodyB=bodyB;cc.manifold=manifold;cc.normal.x=normalX;cc.normal.y=normalY;cc.pointCount=manifold.m_pointCount;cc.friction=friction;cc.restitution=restitution;cc.localPlaneNormal.x=manifold.m_localPlaneNormal.x;cc.localPlaneNormal.y=manifold.m_localPlaneNormal.y;cc.localPoint.x=manifold.m_localPoint.x;cc.localPoint.y=manifold.m_localPoint.y;cc.radius=radiusA+radiusB;cc.type=manifold.m_type;for(var k=0;k<cc.pointCount;++k){var cp=manifold.m_points[k];var ccp=cc.points[k];ccp.normalImpulse=cp.m_normalImpulse;ccp.tangentImpulse=cp.m_tangentImpulse;ccp.localPoint.SetV(cp.m_localPoint);var rAX=ccp.rA.x=b2ContactSolver.s_worldManifold.m_points[k].x-bodyA.m_sweep.c.x;var rAY=ccp.rA.y=b2ContactSolver.s_worldManifold.m_points[k].y-bodyA.m_sweep.c.y;var rBX=ccp.rB.x=b2ContactSolver.s_worldManifold.m_points[k].x-bodyB.m_sweep.c.x;var rBY=ccp.rB.y=b2ContactSolver.s_worldManifold.m_points[k].y-bodyB.m_sweep.c.y;var rnA=rAX*normalY-rAY*normalX;var rnB=rBX*normalY-rBY*normalX;rnA*=rnA;rnB*=rnB;var kNormal=bodyA.m_invMass+bodyB.m_invMass+bodyA.m_invI*rnA+bodyB.m_invI*rnB;ccp.normalMass=1.0/kNormal;var kEqualized=bodyA.m_mass*bodyA.m_invMass+bodyB.m_mass*bodyB.m_invMass;kEqualized+=bodyA.m_mass*bodyA.m_invI*rnA+bodyB.m_mass*bodyB.m_invI*rnB;ccp.equalizedMass=1.0/kEqualized;var tangentX=normalY;var tangentY=-normalX;var rtA=rAX*tangentY-rAY*tangentX;var rtB=rBX*tangentY-rBY*tangentX;rtA*=rtA;rtB*=rtB;var kTangent=bodyA.m_invMass+bodyB.m_invMass+bodyA.m_invI*rtA+bodyB.m_invI*rtB;ccp.tangentMass=1.0/kTangent;ccp.velocityBias=0.0;var tX=vBX+-wB*rBY-vAX- -wA*rAY;var tY=vBY+wB*rBX-vAY-wA*rAX;var vRel=cc.normal.x*tX+cc.normal.y*tY;if(vRel<-b2Settings.b2_velocityThreshold){ccp.velocityBias+=-cc.restitution*vRel;}}if(cc.pointCount==2){var ccp1=cc.points[0];var ccp2=cc.points[1];var invMassA=bodyA.m_invMass;var invIA=bodyA.m_invI;var invMassB=bodyB.m_invMass;var invIB=bodyB.m_invI;var rn1A=ccp1.rA.x*normalY-ccp1.rA.y*normalX;var rn1B=ccp1.rB.x*normalY-ccp1.rB.y*normalX;var rn2A=ccp2.rA.x*normalY-ccp2.rA.y*normalX;var rn2B=ccp2.rB.x*normalY-ccp2.rB.y*normalX;var k11=invMassA+invMassB+invIA*rn1A*rn1A+invIB*rn1B*rn1B;var k22=invMassA+invMassB+invIA*rn2A*rn2A+invIB*rn2B*rn2B;var k12=invMassA+invMassB+invIA*rn1A*rn2A+invIB*rn1B*rn2B;var k_maxConditionNumber=100.0;if(k11*k11<k_maxConditionNumber*(k11*k22-k12*k12)){cc.K.col1.Set(k11,k12);cc.K.col2.Set(k12,k22);cc.K.GetInverse(cc.normalMass);}else{cc.pointCount=1;}}}};b2ContactSolver.prototype.InitVelocityConstraints=function(step){var tVec;var tVec2;var tMat;for(var i=0;i<this.m_constraintCount;++i){var c=this.m_constraints[i];var bodyA=c.bodyA;var bodyB=c.bodyB;var invMassA=bodyA.m_invMass;var invIA=bodyA.m_invI;var invMassB=bodyB.m_invMass;var invIB=bodyB.m_invI;var normalX=c.normal.x;var normalY=c.normal.y;var tangentX=normalY;var tangentY=-normalX;var tX=0;var j=0;var tCount=0;if(step.warmStarting){tCount=c.pointCount;for(j=0;j<tCount;++j){var ccp=c.points[j];ccp.normalImpulse*=step.dtRatio;ccp.tangentImpulse*=step.dtRatio;var PX=ccp.normalImpulse*normalX+ccp.tangentImpulse*tangentX;var PY=ccp.normalImpulse*normalY+ccp.tangentImpulse*tangentY;bodyA.m_angularVelocity-=invIA*(ccp.rA.x*PY-ccp.rA.y*PX);bodyA.m_linearVelocity.x-=invMassA*PX;bodyA.m_linearVelocity.y-=invMassA*PY;bodyB.m_angularVelocity+=invIB*(ccp.rB.x*PY-ccp.rB.y*PX);bodyB.m_linearVelocity.x+=invMassB*PX;bodyB.m_linearVelocity.y+=invMassB*PY;}}else{tCount=c.pointCount;for(j=0;j<tCount;++j){var ccp2=c.points[j];ccp2.normalImpulse=0.0;ccp2.tangentImpulse=0.0;}}}};b2ContactSolver.prototype.SolveVelocityConstraints=function(){var j=0;var ccp;var rAX=0;var rAY=0;var rBX=0;var rBY=0;var dvX=0;var dvY=0;var vn=0;var vt=0;var lambda=0;var maxFriction=0;var newImpulse=0;var PX=0;var PY=0;var dX=0;var dY=0;var P1X=0;var P1Y=0;var P2X=0;var P2Y=0;var tMat;var tVec;for(var i=0;i<this.m_constraintCount;++i){var c=this.m_constraints[i];var bodyA=c.bodyA;var bodyB=c.bodyB;var wA=bodyA.m_angularVelocity;var wB=bodyB.m_angularVelocity;var vA=bodyA.m_linearVelocity;var vB=bodyB.m_linearVelocity;var invMassA=bodyA.m_invMass;var invIA=bodyA.m_invI;var invMassB=bodyB.m_invMass;var invIB=bodyB.m_invI;var normalX=c.normal.x;var normalY=c.normal.y;var tangentX=normalY;var tangentY=-normalX;var friction=c.friction;var tX=0;for(j=0;j<c.pointCount;j++){ccp=c.points[j];dvX=vB.x-wB*ccp.rB.y-vA.x+wA*ccp.rA.y;dvY=vB.y+wB*ccp.rB.x-vA.y-wA*ccp.rA.x;vt=dvX*tangentX+dvY*tangentY;lambda=ccp.tangentMass*-vt;maxFriction=friction*ccp.normalImpulse;newImpulse=b2Math.Clamp(ccp.tangentImpulse+lambda,-maxFriction,maxFriction);lambda=newImpulse-ccp.tangentImpulse;PX=lambda*tangentX;PY=lambda*tangentY;vA.x-=invMassA*PX;vA.y-=invMassA*PY;wA-=invIA*(ccp.rA.x*PY-ccp.rA.y*PX);vB.x+=invMassB*PX;vB.y+=invMassB*PY;wB+=invIB*(ccp.rB.x*PY-ccp.rB.y*PX);ccp.tangentImpulse=newImpulse;}var tCount=parseInt(c.pointCount);if(c.pointCount==1){ccp=c.points[0];dvX=vB.x+-wB*ccp.rB.y-vA.x- -wA*ccp.rA.y;dvY=vB.y+wB*ccp.rB.x-vA.y-wA*ccp.rA.x;vn=dvX*normalX+dvY*normalY;lambda=-ccp.normalMass*(vn-ccp.velocityBias);newImpulse=ccp.normalImpulse+lambda;newImpulse=newImpulse>0?newImpulse:0.0;lambda=newImpulse-ccp.normalImpulse;PX=lambda*normalX;PY=lambda*normalY;vA.x-=invMassA*PX;vA.y-=invMassA*PY;wA-=invIA*(ccp.rA.x*PY-ccp.rA.y*PX);vB.x+=invMassB*PX;vB.y+=invMassB*PY;wB+=invIB*(ccp.rB.x*PY-ccp.rB.y*PX);ccp.normalImpulse=newImpulse;}else{var cp1=c.points[0];var cp2=c.points[1];var aX=cp1.normalImpulse;var aY=cp2.normalImpulse;var dv1X=vB.x-wB*cp1.rB.y-vA.x+wA*cp1.rA.y;var dv1Y=vB.y+wB*cp1.rB.x-vA.y-wA*cp1.rA.x;var dv2X=vB.x-wB*cp2.rB.y-vA.x+wA*cp2.rA.y;var dv2Y=vB.y+wB*cp2.rB.x-vA.y-wA*cp2.rA.x;var vn1=dv1X*normalX+dv1Y*normalY;var vn2=dv2X*normalX+dv2Y*normalY;var bX=vn1-cp1.velocityBias;var bY=vn2-cp2.velocityBias;tMat=c.K;bX-=tMat.col1.x*aX+tMat.col2.x*aY;bY-=tMat.col1.y*aX+tMat.col2.y*aY;var k_errorTol=0.001;for(;;){tMat=c.normalMass;var xX=-(tMat.col1.x*bX+tMat.col2.x*bY);var xY=-(tMat.col1.y*bX+tMat.col2.y*bY);if(xX>=0.0&&xY>=0.0){dX=xX-aX;dY=xY-aY;P1X=dX*normalX;P1Y=dX*normalY;P2X=dY*normalX;P2Y=dY*normalY;vA.x-=invMassA*(P1X+P2X);vA.y-=invMassA*(P1Y+P2Y);wA-=invIA*(cp1.rA.x*P1Y-cp1.rA.y*P1X+cp2.rA.x*P2Y-cp2.rA.y*P2X);vB.x+=invMassB*(P1X+P2X);vB.y+=invMassB*(P1Y+P2Y);wB+=invIB*(cp1.rB.x*P1Y-cp1.rB.y*P1X+cp2.rB.x*P2Y-cp2.rB.y*P2X);cp1.normalImpulse=xX;cp2.normalImpulse=xY;break;}xX=-cp1.normalMass*bX;xY=0.0;vn1=0.0;vn2=c.K.col1.y*xX+bY;if(xX>=0.0&&vn2>=0.0){dX=xX-aX;dY=xY-aY;P1X=dX*normalX;P1Y=dX*normalY;P2X=dY*normalX;P2Y=dY*normalY;vA.x-=invMassA*(P1X+P2X);vA.y-=invMassA*(P1Y+P2Y);wA-=invIA*(cp1.rA.x*P1Y-cp1.rA.y*P1X+cp2.rA.x*P2Y-cp2.rA.y*P2X);vB.x+=invMassB*(P1X+P2X);vB.y+=invMassB*(P1Y+P2Y);wB+=invIB*(cp1.rB.x*P1Y-cp1.rB.y*P1X+cp2.rB.x*P2Y-cp2.rB.y*P2X);cp1.normalImpulse=xX;cp2.normalImpulse=xY;break;}xX=0.0;xY=-cp2.normalMass*bY;vn1=c.K.col2.x*xY+bX;vn2=0.0;if(xY>=0.0&&vn1>=0.0){dX=xX-aX;dY=xY-aY;P1X=dX*normalX;P1Y=dX*normalY;P2X=dY*normalX;P2Y=dY*normalY;vA.x-=invMassA*(P1X+P2X);vA.y-=invMassA*(P1Y+P2Y);wA-=invIA*(cp1.rA.x*P1Y-cp1.rA.y*P1X+cp2.rA.x*P2Y-cp2.rA.y*P2X);vB.x+=invMassB*(P1X+P2X);vB.y+=invMassB*(P1Y+P2Y);wB+=invIB*(cp1.rB.x*P1Y-cp1.rB.y*P1X+cp2.rB.x*P2Y-cp2.rB.y*P2X);cp1.normalImpulse=xX;cp2.normalImpulse=xY;break;}xX=0.0;xY=0.0;vn1=bX;vn2=bY;if(vn1>=0.0&&vn2>=0.0){dX=xX-aX;dY=xY-aY;P1X=dX*normalX;P1Y=dX*normalY;P2X=dY*normalX;P2Y=dY*normalY;vA.x-=invMassA*(P1X+P2X);vA.y-=invMassA*(P1Y+P2Y);wA-=invIA*(cp1.rA.x*P1Y-cp1.rA.y*P1X+cp2.rA.x*P2Y-cp2.rA.y*P2X);vB.x+=invMassB*(P1X+P2X);vB.y+=invMassB*(P1Y+P2Y);wB+=invIB*(cp1.rB.x*P1Y-cp1.rB.y*P1X+cp2.rB.x*P2Y-cp2.rB.y*P2X);cp1.normalImpulse=xX;cp2.normalImpulse=xY;break;}break;}}bodyA.m_angularVelocity=wA;bodyB.m_angularVelocity=wB;}};b2ContactSolver.prototype.FinalizeVelocityConstraints=function(){for(var i=0;i<this.m_constraintCount;++i){var c=this.m_constraints[i];var m=c.manifold;for(var j=0;j<c.pointCount;++j){var point1=m.m_points[j];var point2=c.points[j];point1.m_normalImpulse=point2.normalImpulse;point1.m_tangentImpulse=point2.tangentImpulse;}}};b2ContactSolver.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var minSeparation=0.0;for(var i=0;i<this.m_constraintCount;i++){var c=this.m_constraints[i];var bodyA=c.bodyA;var bodyB=c.bodyB;var invMassA=bodyA.m_mass*bodyA.m_invMass;var invIA=bodyA.m_mass*bodyA.m_invI;var invMassB=bodyB.m_mass*bodyB.m_invMass;var invIB=bodyB.m_mass*bodyB.m_invI;b2ContactSolver.s_psm.Initialize(c);var normal=b2ContactSolver.s_psm.m_normal;for(var j=0;j<c.pointCount;j++){var ccp=c.points[j];var point=b2ContactSolver.s_psm.m_points[j];var separation=b2ContactSolver.s_psm.m_separations[j];var rAX=point.x-bodyA.m_sweep.c.x;var rAY=point.y-bodyA.m_sweep.c.y;var rBX=point.x-bodyB.m_sweep.c.x;var rBY=point.y-bodyB.m_sweep.c.y;minSeparation=minSeparation<separation?minSeparation:separation;var C=b2Math.Clamp(baumgarte*(separation+b2Settings.b2_linearSlop),-b2Settings.b2_maxLinearCorrection,0.0);var impulse=-ccp.equalizedMass*C;var PX=impulse*normal.x;var PY=impulse*normal.y;bodyA.m_sweep.c.x-=invMassA*PX;bodyA.m_sweep.c.y-=invMassA*PY;bodyA.m_sweep.a-=invIA*(rAX*PY-rAY*PX);bodyA.SynchronizeTransform();bodyB.m_sweep.c.x+=invMassB*PX;bodyB.m_sweep.c.y+=invMassB*PY;bodyB.m_sweep.a+=invIB*(rBX*PY-rBY*PX);bodyB.SynchronizeTransform();}}return minSeparation>-1.5*b2Settings.b2_linearSlop;};Box2D.postDefs.push(function(){Box2D.Dynamics.Contacts.b2ContactSolver.s_worldManifold=new b2WorldManifold();Box2D.Dynamics.Contacts.b2ContactSolver.s_psm=new b2PositionSolverManifold();});Box2D.inherit(b2EdgeAndCircleContact,Box2D.Dynamics.Contacts.b2Contact);b2EdgeAndCircleContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2EdgeAndCircleContact.b2EdgeAndCircleContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2EdgeAndCircleContact.Create=function(allocator){return new b2EdgeAndCircleContact();};b2EdgeAndCircleContact.Destroy=function(contact,allocator){};b2EdgeAndCircleContact.prototype.Reset=function(fixtureA,fixtureB){this.__super.Reset.call(this,fixtureA,fixtureB);};b2EdgeAndCircleContact.prototype.Evaluate=function(){var bA=this.m_fixtureA.GetBody();var bB=this.m_fixtureB.GetBody();this.b2CollideEdgeAndCircle(this.m_manifold,this.m_fixtureA.GetShape()instanceof b2EdgeShape?this.m_fixtureA.GetShape():null,bA.m_xf,this.m_fixtureB.GetShape()instanceof b2CircleShape?this.m_fixtureB.GetShape():null,bB.m_xf);};b2EdgeAndCircleContact.prototype.b2CollideEdgeAndCircle=function(manifold,edge,xf1,circle,xf2){};Box2D.inherit(b2NullContact,Box2D.Dynamics.Contacts.b2Contact);b2NullContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2NullContact.b2NullContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2NullContact.prototype.b2NullContact=function(){this.__super.b2Contact.call(this);};b2NullContact.prototype.Evaluate=function(){};Box2D.inherit(b2PolyAndCircleContact,Box2D.Dynamics.Contacts.b2Contact);b2PolyAndCircleContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2PolyAndCircleContact.b2PolyAndCircleContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2PolyAndCircleContact.Create=function(allocator){return new b2PolyAndCircleContact();};b2PolyAndCircleContact.Destroy=function(contact,allocator){};b2PolyAndCircleContact.prototype.Reset=function(fixtureA,fixtureB){this.__super.Reset.call(this,fixtureA,fixtureB);b2Settings.b2Assert(fixtureA.GetType()==b2Shape.e_polygonShape);b2Settings.b2Assert(fixtureB.GetType()==b2Shape.e_circleShape);};b2PolyAndCircleContact.prototype.Evaluate=function(){var bA=this.m_fixtureA.m_body;var bB=this.m_fixtureB.m_body;b2Collision.CollidePolygonAndCircle(this.m_manifold,this.m_fixtureA.GetShape()instanceof b2PolygonShape?this.m_fixtureA.GetShape():null,bA.m_xf,this.m_fixtureB.GetShape()instanceof b2CircleShape?this.m_fixtureB.GetShape():null,bB.m_xf);};Box2D.inherit(b2PolyAndEdgeContact,Box2D.Dynamics.Contacts.b2Contact);b2PolyAndEdgeContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2PolyAndEdgeContact.b2PolyAndEdgeContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2PolyAndEdgeContact.Create=function(allocator){return new b2PolyAndEdgeContact();};b2PolyAndEdgeContact.Destroy=function(contact,allocator){};b2PolyAndEdgeContact.prototype.Reset=function(fixtureA,fixtureB){this.__super.Reset.call(this,fixtureA,fixtureB);b2Settings.b2Assert(fixtureA.GetType()==b2Shape.e_polygonShape);b2Settings.b2Assert(fixtureB.GetType()==b2Shape.e_edgeShape);};b2PolyAndEdgeContact.prototype.Evaluate=function(){var bA=this.m_fixtureA.GetBody();var bB=this.m_fixtureB.GetBody();this.b2CollidePolyAndEdge(this.m_manifold,this.m_fixtureA.GetShape()instanceof b2PolygonShape?this.m_fixtureA.GetShape():null,bA.m_xf,this.m_fixtureB.GetShape()instanceof b2EdgeShape?this.m_fixtureB.GetShape():null,bB.m_xf);};b2PolyAndEdgeContact.prototype.b2CollidePolyAndEdge=function(manifold,polygon,xf1,edge,xf2){};Box2D.inherit(b2PolygonContact,Box2D.Dynamics.Contacts.b2Contact);b2PolygonContact.prototype.__super=Box2D.Dynamics.Contacts.b2Contact.prototype;b2PolygonContact.b2PolygonContact=function(){Box2D.Dynamics.Contacts.b2Contact.b2Contact.apply(this,arguments);};b2PolygonContact.Create=function(allocator){return new b2PolygonContact();};b2PolygonContact.Destroy=function(contact,allocator){};b2PolygonContact.prototype.Reset=function(fixtureA,fixtureB){this.__super.Reset.call(this,fixtureA,fixtureB);};b2PolygonContact.prototype.Evaluate=function(){var bA=this.m_fixtureA.GetBody();var bB=this.m_fixtureB.GetBody();b2Collision.CollidePolygons(this.m_manifold,this.m_fixtureA.GetShape()instanceof b2PolygonShape?this.m_fixtureA.GetShape():null,bA.m_xf,this.m_fixtureB.GetShape()instanceof b2PolygonShape?this.m_fixtureB.GetShape():null,bB.m_xf);};b2PositionSolverManifold.b2PositionSolverManifold=function(){};b2PositionSolverManifold.prototype.b2PositionSolverManifold=function(){this.m_normal=new b2Vec2();this.m_separations=new Vector_a2j_Number(b2Settings.b2_maxManifoldPoints);this.m_points=new Vector(b2Settings.b2_maxManifoldPoints);for(var i=0;i<b2Settings.b2_maxManifoldPoints;i++){this.m_points[i]=new b2Vec2();}};b2PositionSolverManifold.prototype.Initialize=function(cc){b2Settings.b2Assert(cc.pointCount>0);var i=0;var clipPointX=0;var clipPointY=0;var tMat;var tVec;var planePointX=0;var planePointY=0;switch(cc.type){case b2Manifold.e_circles:{tMat=cc.bodyA.m_xf.R;tVec=cc.localPoint;var pointAX=cc.bodyA.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var pointAY=cc.bodyA.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tMat=cc.bodyB.m_xf.R;tVec=cc.points[0].localPoint;var pointBX=cc.bodyB.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);var pointBY=cc.bodyB.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);var dX=pointBX-pointAX;var dY=pointBY-pointAY;var d2=dX*dX+dY*dY;if(d2>Number.MIN_VALUE*Number.MIN_VALUE){var d=Math.sqrt(d2);this.m_normal.x=dX/d;this.m_normal.y=dY/d;}else{this.m_normal.x=1.0;this.m_normal.y=0.0;}this.m_points[0].x=0.5*(pointAX+pointBX);this.m_points[0].y=0.5*(pointAY+pointBY);this.m_separations[0]=dX*this.m_normal.x+dY*this.m_normal.y-cc.radius;}break;case b2Manifold.e_faceA:{tMat=cc.bodyA.m_xf.R;tVec=cc.localPlaneNormal;this.m_normal.x=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;this.m_normal.y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=cc.bodyA.m_xf.R;tVec=cc.localPoint;planePointX=cc.bodyA.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);planePointY=cc.bodyA.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tMat=cc.bodyB.m_xf.R;for(i=0;i<cc.pointCount;++i){tVec=cc.points[i].localPoint;clipPointX=cc.bodyB.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);clipPointY=cc.bodyB.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);this.m_separations[i]=(clipPointX-planePointX)*this.m_normal.x+(clipPointY-planePointY)*this.m_normal.y-cc.radius;this.m_points[i].x=clipPointX;this.m_points[i].y=clipPointY;}}break;case b2Manifold.e_faceB:{tMat=cc.bodyB.m_xf.R;tVec=cc.localPlaneNormal;this.m_normal.x=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;this.m_normal.y=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=cc.bodyB.m_xf.R;tVec=cc.localPoint;planePointX=cc.bodyB.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);planePointY=cc.bodyB.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);tMat=cc.bodyA.m_xf.R;for(i=0;i<cc.pointCount;++i){tVec=cc.points[i].localPoint;clipPointX=cc.bodyA.m_xf.position.x+(tMat.col1.x*tVec.x+tMat.col2.x*tVec.y);clipPointY=cc.bodyA.m_xf.position.y+(tMat.col1.y*tVec.x+tMat.col2.y*tVec.y);this.m_separations[i]=(clipPointX-planePointX)*this.m_normal.x+(clipPointY-planePointY)*this.m_normal.y-cc.radius;this.m_points[i].Set(clipPointX,clipPointY);}this.m_normal.x*=-1;this.m_normal.y*=-1;}break;}};Box2D.postDefs.push(function(){Box2D.Dynamics.Contacts.b2PositionSolverManifold.circlePointA=new b2Vec2();Box2D.Dynamics.Contacts.b2PositionSolverManifold.circlePointB=new b2Vec2();});})();(function(){var b2Body=Box2D.Dynamics.b2Body,b2BodyDef=Box2D.Dynamics.b2BodyDef,b2ContactFilter=Box2D.Dynamics.b2ContactFilter,b2ContactImpulse=Box2D.Dynamics.b2ContactImpulse,b2ContactListener=Box2D.Dynamics.b2ContactListener,b2ContactManager=Box2D.Dynamics.b2ContactManager,b2DebugDraw=Box2D.Dynamics.b2DebugDraw,b2DestructionListener=Box2D.Dynamics.b2DestructionListener,b2FilterData=Box2D.Dynamics.b2FilterData,b2Fixture=Box2D.Dynamics.b2Fixture,b2FixtureDef=Box2D.Dynamics.b2FixtureDef,b2Island=Box2D.Dynamics.b2Island,b2TimeStep=Box2D.Dynamics.b2TimeStep,b2World=Box2D.Dynamics.b2World,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2CircleShape=Box2D.Collision.Shapes.b2CircleShape,b2EdgeChainDef=Box2D.Collision.Shapes.b2EdgeChainDef,b2EdgeShape=Box2D.Collision.Shapes.b2EdgeShape,b2MassData=Box2D.Collision.Shapes.b2MassData,b2PolygonShape=Box2D.Collision.Shapes.b2PolygonShape,b2Shape=Box2D.Collision.Shapes.b2Shape,b2BuoyancyController=Box2D.Dynamics.Controllers.b2BuoyancyController,b2ConstantAccelController=Box2D.Dynamics.Controllers.b2ConstantAccelController,b2ConstantForceController=Box2D.Dynamics.Controllers.b2ConstantForceController,b2Controller=Box2D.Dynamics.Controllers.b2Controller,b2ControllerEdge=Box2D.Dynamics.Controllers.b2ControllerEdge,b2GravityController=Box2D.Dynamics.Controllers.b2GravityController,b2TensorDampingController=Box2D.Dynamics.Controllers.b2TensorDampingController;Box2D.inherit(b2BuoyancyController,Box2D.Dynamics.Controllers.b2Controller);b2BuoyancyController.prototype.__super=Box2D.Dynamics.Controllers.b2Controller.prototype;b2BuoyancyController.b2BuoyancyController=function(){Box2D.Dynamics.Controllers.b2Controller.b2Controller.apply(this,arguments);this.normal=new b2Vec2(0,-1);this.offset=0;this.density=0;this.velocity=new b2Vec2(0,0);this.linearDrag=2;this.angularDrag=1;this.useDensity=false;this.useWorldGravity=true;this.gravity=null;};b2BuoyancyController.prototype.Step=function(step){if(!this.m_bodyList)return;if(this.useWorldGravity){this.gravity=this.GetWorld().GetGravity().Copy();}for(var i=this.m_bodyList;i;i=i.nextBody){var body=i.body;if(body.IsAwake()==false){continue;}var areac=new b2Vec2();var massc=new b2Vec2();var area=0.0;var mass=0.0;for(var fixture=body.GetFixtureList();fixture;fixture=fixture.GetNext()){var sc=new b2Vec2();var sarea=fixture.GetShape().ComputeSubmergedArea(this.normal,this.offset,body.GetTransform(),sc);area+=sarea;areac.x+=sarea*sc.x;areac.y+=sarea*sc.y;var shapeDensity=0;if(this.useDensity){shapeDensity=1;}else{shapeDensity=1;}mass+=sarea*shapeDensity;massc.x+=sarea*sc.x*shapeDensity;massc.y+=sarea*sc.y*shapeDensity;}areac.x/=area;areac.y/=area;massc.x/=mass;massc.y/=mass;if(area<Number.MIN_VALUE)continue;var buoyancyForce=this.gravity.GetNegative();buoyancyForce.Multiply(this.density*area);body.ApplyForce(buoyancyForce,massc);var dragForce=body.GetLinearVelocityFromWorldPoint(areac);dragForce.Subtract(this.velocity);dragForce.Multiply(-this.linearDrag*area);body.ApplyForce(dragForce,areac);body.ApplyTorque(-body.GetInertia()/body.GetMass()*area*body.GetAngularVelocity()*this.angularDrag);}};b2BuoyancyController.prototype.Draw=function(debugDraw){var r=1000;var p1=new b2Vec2();var p2=new b2Vec2();p1.x=this.normal.x*this.offset+this.normal.y*r;p1.y=this.normal.y*this.offset-this.normal.x*r;p2.x=this.normal.x*this.offset-this.normal.y*r;p2.y=this.normal.y*this.offset+this.normal.x*r;var color=new b2Color(0,0,1);debugDraw.DrawSegment(p1,p2,color);};Box2D.inherit(b2ConstantAccelController,Box2D.Dynamics.Controllers.b2Controller);b2ConstantAccelController.prototype.__super=Box2D.Dynamics.Controllers.b2Controller.prototype;b2ConstantAccelController.b2ConstantAccelController=function(){Box2D.Dynamics.Controllers.b2Controller.b2Controller.apply(this,arguments);this.A=new b2Vec2(0,0);};b2ConstantAccelController.prototype.Step=function(step){var smallA=new b2Vec2(this.A.x*step.dt,this.A.y*step.dt);for(var i=this.m_bodyList;i;i=i.nextBody){var body=i.body;if(!body.IsAwake())continue;body.SetLinearVelocity(new b2Vec2(body.GetLinearVelocity().x+smallA.x,body.GetLinearVelocity().y+smallA.y));}};Box2D.inherit(b2ConstantForceController,Box2D.Dynamics.Controllers.b2Controller);b2ConstantForceController.prototype.__super=Box2D.Dynamics.Controllers.b2Controller.prototype;b2ConstantForceController.b2ConstantForceController=function(){Box2D.Dynamics.Controllers.b2Controller.b2Controller.apply(this,arguments);this.F=new b2Vec2(0,0);};b2ConstantForceController.prototype.Step=function(step){for(var i=this.m_bodyList;i;i=i.nextBody){var body=i.body;if(!body.IsAwake())continue;body.ApplyForce(this.F,body.GetWorldCenter());}};b2Controller.b2Controller=function(){};b2Controller.prototype.Step=function(step){};b2Controller.prototype.Draw=function(debugDraw){};b2Controller.prototype.AddBody=function(body){var edge=new b2ControllerEdge();edge.controller=this;edge.body=body;edge.nextBody=this.m_bodyList;edge.prevBody=null;this.m_bodyList=edge;if(edge.nextBody)edge.nextBody.prevBody=edge;this.m_bodyCount++;edge.nextController=body.m_controllerList;edge.prevController=null;body.m_controllerList=edge;if(edge.nextController)edge.nextController.prevController=edge;body.m_controllerCount++;};b2Controller.prototype.RemoveBody=function(body){var edge=body.m_controllerList;while(edge&&edge.controller!=this){edge=edge.nextController;}if(edge.prevBody)edge.prevBody.nextBody=edge.nextBody;if(edge.nextBody)edge.nextBody.prevBody=edge.prevBody;if(edge.nextController)edge.nextController.prevController=edge.prevController;if(edge.prevController)edge.prevController.nextController=edge.nextController;if(this.m_bodyList==edge)this.m_bodyList=edge.nextBody;if(body.m_controllerList==edge)body.m_controllerList=edge.nextController;body.m_controllerCount--;this.m_bodyCount--;};b2Controller.prototype.Clear=function(){while(this.m_bodyList){this.RemoveBody(this.m_bodyList.body);}};b2Controller.prototype.GetNext=function(){return this.m_next;};b2Controller.prototype.GetWorld=function(){return this.m_world;};b2Controller.prototype.GetBodyList=function(){return this.m_bodyList;};b2ControllerEdge.b2ControllerEdge=function(){};Box2D.inherit(b2GravityController,Box2D.Dynamics.Controllers.b2Controller);b2GravityController.prototype.__super=Box2D.Dynamics.Controllers.b2Controller.prototype;b2GravityController.b2GravityController=function(){Box2D.Dynamics.Controllers.b2Controller.b2Controller.apply(this,arguments);this.G=1;this.invSqr=true;};b2GravityController.prototype.Step=function(step){var i=null;var body1=null;var p1=null;var mass1=0;var j=null;var body2=null;var p2=null;var dx=0;var dy=0;var r2=0;var f=null;if(this.invSqr){for(i=this.m_bodyList;i;i=i.nextBody){body1=i.body;p1=body1.GetWorldCenter();mass1=body1.GetMass();for(j=this.m_bodyList;j!=i;j=j.nextBody){body2=j.body;p2=body2.GetWorldCenter();dx=p2.x-p1.x;dy=p2.y-p1.y;r2=dx*dx+dy*dy;if(r2<Number.MIN_VALUE)continue;f=new b2Vec2(dx,dy);f.Multiply(this.G/r2/Math.sqrt(r2)*mass1*body2.GetMass());if(body1.IsAwake())body1.ApplyForce(f,p1);f.Multiply(-1);if(body2.IsAwake())body2.ApplyForce(f,p2);}}}else{for(i=this.m_bodyList;i;i=i.nextBody){body1=i.body;p1=body1.GetWorldCenter();mass1=body1.GetMass();for(j=this.m_bodyList;j!=i;j=j.nextBody){body2=j.body;p2=body2.GetWorldCenter();dx=p2.x-p1.x;dy=p2.y-p1.y;r2=dx*dx+dy*dy;if(r2<Number.MIN_VALUE)continue;f=new b2Vec2(dx,dy);f.Multiply(this.G/r2*mass1*body2.GetMass());if(body1.IsAwake())body1.ApplyForce(f,p1);f.Multiply(-1);if(body2.IsAwake())body2.ApplyForce(f,p2);}}}};Box2D.inherit(b2TensorDampingController,Box2D.Dynamics.Controllers.b2Controller);b2TensorDampingController.prototype.__super=Box2D.Dynamics.Controllers.b2Controller.prototype;b2TensorDampingController.b2TensorDampingController=function(){Box2D.Dynamics.Controllers.b2Controller.b2Controller.apply(this,arguments);this.T=new b2Mat22();this.maxTimestep=0;};b2TensorDampingController.prototype.SetAxisAligned=function(xDamping,yDamping){if(xDamping===undefined)xDamping=0;if(yDamping===undefined)yDamping=0;this.T.col1.x=-xDamping;this.T.col1.y=0;this.T.col2.x=0;this.T.col2.y=-yDamping;if(xDamping>0||yDamping>0){this.maxTimestep=1/Math.max(xDamping,yDamping);}else{this.maxTimestep=0;}};b2TensorDampingController.prototype.Step=function(step){var timestep=step.dt;if(timestep<=Number.MIN_VALUE)return;if(timestep>this.maxTimestep&&this.maxTimestep>0)timestep=this.maxTimestep;for(var i=this.m_bodyList;i;i=i.nextBody){var body=i.body;if(!body.IsAwake()){continue;}var damping=body.GetWorldVector(b2Math.MulMV(this.T,body.GetLocalVector(body.GetLinearVelocity())));body.SetLinearVelocity(new b2Vec2(body.GetLinearVelocity().x+damping.x*timestep,body.GetLinearVelocity().y+damping.y*timestep));}};})();(function(){var b2Color=Box2D.Common.b2Color,b2internal=Box2D.Common.b2internal,b2Settings=Box2D.Common.b2Settings,b2Mat22=Box2D.Common.Math.b2Mat22,b2Mat33=Box2D.Common.Math.b2Mat33,b2Math=Box2D.Common.Math.b2Math,b2Sweep=Box2D.Common.Math.b2Sweep,b2Transform=Box2D.Common.Math.b2Transform,b2Vec2=Box2D.Common.Math.b2Vec2,b2Vec3=Box2D.Common.Math.b2Vec3,b2DistanceJoint=Box2D.Dynamics.Joints.b2DistanceJoint,b2DistanceJointDef=Box2D.Dynamics.Joints.b2DistanceJointDef,b2FrictionJoint=Box2D.Dynamics.Joints.b2FrictionJoint,b2FrictionJointDef=Box2D.Dynamics.Joints.b2FrictionJointDef,b2GearJoint=Box2D.Dynamics.Joints.b2GearJoint,b2GearJointDef=Box2D.Dynamics.Joints.b2GearJointDef,b2Jacobian=Box2D.Dynamics.Joints.b2Jacobian,b2Joint=Box2D.Dynamics.Joints.b2Joint,b2JointDef=Box2D.Dynamics.Joints.b2JointDef,b2JointEdge=Box2D.Dynamics.Joints.b2JointEdge,b2LineJoint=Box2D.Dynamics.Joints.b2LineJoint,b2LineJointDef=Box2D.Dynamics.Joints.b2LineJointDef,b2MouseJoint=Box2D.Dynamics.Joints.b2MouseJoint,b2MouseJointDef=Box2D.Dynamics.Joints.b2MouseJointDef,b2PrismaticJoint=Box2D.Dynamics.Joints.b2PrismaticJoint,b2PrismaticJointDef=Box2D.Dynamics.Joints.b2PrismaticJointDef,b2PulleyJoint=Box2D.Dynamics.Joints.b2PulleyJoint,b2PulleyJointDef=Box2D.Dynamics.Joints.b2PulleyJointDef,b2RevoluteJoint=Box2D.Dynamics.Joints.b2RevoluteJoint,b2RevoluteJointDef=Box2D.Dynamics.Joints.b2RevoluteJointDef,b2WeldJoint=Box2D.Dynamics.Joints.b2WeldJoint,b2WeldJointDef=Box2D.Dynamics.Joints.b2WeldJointDef,b2Body=Box2D.Dynamics.b2Body,b2BodyDef=Box2D.Dynamics.b2BodyDef,b2ContactFilter=Box2D.Dynamics.b2ContactFilter,b2ContactImpulse=Box2D.Dynamics.b2ContactImpulse,b2ContactListener=Box2D.Dynamics.b2ContactListener,b2ContactManager=Box2D.Dynamics.b2ContactManager,b2DebugDraw=Box2D.Dynamics.b2DebugDraw,b2DestructionListener=Box2D.Dynamics.b2DestructionListener,b2FilterData=Box2D.Dynamics.b2FilterData,b2Fixture=Box2D.Dynamics.b2Fixture,b2FixtureDef=Box2D.Dynamics.b2FixtureDef,b2Island=Box2D.Dynamics.b2Island,b2TimeStep=Box2D.Dynamics.b2TimeStep,b2World=Box2D.Dynamics.b2World;Box2D.inherit(b2DistanceJoint,Box2D.Dynamics.Joints.b2Joint);b2DistanceJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2DistanceJoint.b2DistanceJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_u=new b2Vec2();};b2DistanceJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2DistanceJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2DistanceJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse*this.m_u.x,inv_dt*this.m_impulse*this.m_u.y);};b2DistanceJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return 0.0;};b2DistanceJoint.prototype.GetLength=function(){return this.m_length;};b2DistanceJoint.prototype.SetLength=function(length){if(length===undefined)length=0;this.m_length=length;};b2DistanceJoint.prototype.GetFrequency=function(){return this.m_frequencyHz;};b2DistanceJoint.prototype.SetFrequency=function(hz){if(hz===undefined)hz=0;this.m_frequencyHz=hz;};b2DistanceJoint.prototype.GetDampingRatio=function(){return this.m_dampingRatio;};b2DistanceJoint.prototype.SetDampingRatio=function(ratio){if(ratio===undefined)ratio=0;this.m_dampingRatio=ratio;};b2DistanceJoint.prototype.b2DistanceJoint=function(def){this.__super.b2Joint.call(this,def);var tMat;var tX=0;var tY=0;this.m_localAnchor1.SetV(def.localAnchorA);this.m_localAnchor2.SetV(def.localAnchorB);this.m_length=def.length;this.m_frequencyHz=def.frequencyHz;this.m_dampingRatio=def.dampingRatio;this.m_impulse=0.0;this.m_gamma=0.0;this.m_bias=0.0;};b2DistanceJoint.prototype.InitVelocityConstraints=function(step){var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;this.m_u.x=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;this.m_u.y=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;var length=Math.sqrt(this.m_u.x*this.m_u.x+this.m_u.y*this.m_u.y);if(length>b2Settings.b2_linearSlop){this.m_u.Multiply(1.0/length);}else{this.m_u.SetZero();}var cr1u=r1X*this.m_u.y-r1Y*this.m_u.x;var cr2u=r2X*this.m_u.y-r2Y*this.m_u.x;var invMass=bA.m_invMass+bA.m_invI*cr1u*cr1u+bB.m_invMass+bB.m_invI*cr2u*cr2u;this.m_mass=invMass!=0.0?1.0/invMass:0.0;if(this.m_frequencyHz>0.0){var C=length-this.m_length;var omega=2.0*Math.PI*this.m_frequencyHz;var d=2.0*this.m_mass*this.m_dampingRatio*omega;var k=this.m_mass*omega*omega;this.m_gamma=step.dt*(d+step.dt*k);this.m_gamma=this.m_gamma!=0.0?1/this.m_gamma:0.0;this.m_bias=C*step.dt*k*this.m_gamma;this.m_mass=invMass+this.m_gamma;this.m_mass=this.m_mass!=0.0?1.0/this.m_mass:0.0;}if(step.warmStarting){this.m_impulse*=step.dtRatio;var PX=this.m_impulse*this.m_u.x;var PY=this.m_impulse*this.m_u.y;bA.m_linearVelocity.x-=bA.m_invMass*PX;bA.m_linearVelocity.y-=bA.m_invMass*PY;bA.m_angularVelocity-=bA.m_invI*(r1X*PY-r1Y*PX);bB.m_linearVelocity.x+=bB.m_invMass*PX;bB.m_linearVelocity.y+=bB.m_invMass*PY;bB.m_angularVelocity+=bB.m_invI*(r2X*PY-r2Y*PX);}else{this.m_impulse=0.0;}};b2DistanceJoint.prototype.SolveVelocityConstraints=function(step){var tMat;var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var v1X=bA.m_linearVelocity.x+-bA.m_angularVelocity*r1Y;var v1Y=bA.m_linearVelocity.y+bA.m_angularVelocity*r1X;var v2X=bB.m_linearVelocity.x+-bB.m_angularVelocity*r2Y;var v2Y=bB.m_linearVelocity.y+bB.m_angularVelocity*r2X;var Cdot=this.m_u.x*(v2X-v1X)+this.m_u.y*(v2Y-v1Y);var impulse=-this.m_mass*(Cdot+this.m_bias+this.m_gamma*this.m_impulse);this.m_impulse+=impulse;var PX=impulse*this.m_u.x;var PY=impulse*this.m_u.y;bA.m_linearVelocity.x-=bA.m_invMass*PX;bA.m_linearVelocity.y-=bA.m_invMass*PY;bA.m_angularVelocity-=bA.m_invI*(r1X*PY-r1Y*PX);bB.m_linearVelocity.x+=bB.m_invMass*PX;bB.m_linearVelocity.y+=bB.m_invMass*PY;bB.m_angularVelocity+=bB.m_invI*(r2X*PY-r2Y*PX);};b2DistanceJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var tMat;if(this.m_frequencyHz>0.0){return true;}var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var dX=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;var dY=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;var length=Math.sqrt(dX*dX+dY*dY);dX/=length;dY/=length;var C=length-this.m_length;C=b2Math.Clamp(C,-b2Settings.b2_maxLinearCorrection,b2Settings.b2_maxLinearCorrection);var impulse=-this.m_mass*C;this.m_u.Set(dX,dY);var PX=impulse*this.m_u.x;var PY=impulse*this.m_u.y;bA.m_sweep.c.x-=bA.m_invMass*PX;bA.m_sweep.c.y-=bA.m_invMass*PY;bA.m_sweep.a-=bA.m_invI*(r1X*PY-r1Y*PX);bB.m_sweep.c.x+=bB.m_invMass*PX;bB.m_sweep.c.y+=bB.m_invMass*PY;bB.m_sweep.a+=bB.m_invI*(r2X*PY-r2Y*PX);bA.SynchronizeTransform();bB.SynchronizeTransform();return b2Math.Abs(C)<b2Settings.b2_linearSlop;};Box2D.inherit(b2DistanceJointDef,Box2D.Dynamics.Joints.b2JointDef);b2DistanceJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2DistanceJointDef.b2DistanceJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();};b2DistanceJointDef.prototype.b2DistanceJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_distanceJoint;this.length=1.0;this.frequencyHz=0.0;this.dampingRatio=0.0;};b2DistanceJointDef.prototype.Initialize=function(bA,bB,anchorA,anchorB){this.bodyA=bA;this.bodyB=bB;this.localAnchorA.SetV(this.bodyA.GetLocalPoint(anchorA));this.localAnchorB.SetV(this.bodyB.GetLocalPoint(anchorB));var dX=anchorB.x-anchorA.x;var dY=anchorB.y-anchorA.y;this.length=Math.sqrt(dX*dX+dY*dY);this.frequencyHz=0.0;this.dampingRatio=0.0;};Box2D.inherit(b2FrictionJoint,Box2D.Dynamics.Joints.b2Joint);b2FrictionJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2FrictionJoint.b2FrictionJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_localAnchorA=new b2Vec2();this.m_localAnchorB=new b2Vec2();this.m_linearMass=new b2Mat22();this.m_linearImpulse=new b2Vec2();};b2FrictionJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchorA);};b2FrictionJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchorB);};b2FrictionJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_linearImpulse.x,inv_dt*this.m_linearImpulse.y);};b2FrictionJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return inv_dt*this.m_angularImpulse;};b2FrictionJoint.prototype.SetMaxForce=function(force){if(force===undefined)force=0;this.m_maxForce=force;};b2FrictionJoint.prototype.GetMaxForce=function(){return this.m_maxForce;};b2FrictionJoint.prototype.SetMaxTorque=function(torque){if(torque===undefined)torque=0;this.m_maxTorque=torque;};b2FrictionJoint.prototype.GetMaxTorque=function(){return this.m_maxTorque;};b2FrictionJoint.prototype.b2FrictionJoint=function(def){this.__super.b2Joint.call(this,def);this.m_localAnchorA.SetV(def.localAnchorA);this.m_localAnchorB.SetV(def.localAnchorB);this.m_linearMass.SetZero();this.m_angularMass=0.0;this.m_linearImpulse.SetZero();this.m_angularImpulse=0.0;this.m_maxForce=def.maxForce;this.m_maxTorque=def.maxTorque;};b2FrictionJoint.prototype.InitVelocityConstraints=function(step){var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var rAX=this.m_localAnchorA.x-bA.m_sweep.localCenter.x;var rAY=this.m_localAnchorA.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rAX+tMat.col2.x*rAY;rAY=tMat.col1.y*rAX+tMat.col2.y*rAY;rAX=tX;tMat=bB.m_xf.R;var rBX=this.m_localAnchorB.x-bB.m_sweep.localCenter.x;var rBY=this.m_localAnchorB.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rBX+tMat.col2.x*rBY;rBY=tMat.col1.y*rBX+tMat.col2.y*rBY;rBX=tX;var mA=bA.m_invMass;var mB=bB.m_invMass;var iA=bA.m_invI;var iB=bB.m_invI;var K=new b2Mat22();K.col1.x=mA+mB;K.col2.x=0.0;K.col1.y=0.0;K.col2.y=mA+mB;K.col1.x+=iA*rAY*rAY;K.col2.x+=-iA*rAX*rAY;K.col1.y+=-iA*rAX*rAY;K.col2.y+=iA*rAX*rAX;K.col1.x+=iB*rBY*rBY;K.col2.x+=-iB*rBX*rBY;K.col1.y+=-iB*rBX*rBY;K.col2.y+=iB*rBX*rBX;K.GetInverse(this.m_linearMass);this.m_angularMass=iA+iB;if(this.m_angularMass>0.0){this.m_angularMass=1.0/this.m_angularMass;}if(step.warmStarting){this.m_linearImpulse.x*=step.dtRatio;this.m_linearImpulse.y*=step.dtRatio;this.m_angularImpulse*=step.dtRatio;var P=this.m_linearImpulse;bA.m_linearVelocity.x-=mA*P.x;bA.m_linearVelocity.y-=mA*P.y;bA.m_angularVelocity-=iA*(rAX*P.y-rAY*P.x+this.m_angularImpulse);bB.m_linearVelocity.x+=mB*P.x;bB.m_linearVelocity.y+=mB*P.y;bB.m_angularVelocity+=iB*(rBX*P.y-rBY*P.x+this.m_angularImpulse);}else{this.m_linearImpulse.SetZero();this.m_angularImpulse=0.0;}};b2FrictionJoint.prototype.SolveVelocityConstraints=function(step){var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;var vA=bA.m_linearVelocity;var wA=bA.m_angularVelocity;var vB=bB.m_linearVelocity;var wB=bB.m_angularVelocity;var mA=bA.m_invMass;var mB=bB.m_invMass;var iA=bA.m_invI;var iB=bB.m_invI;tMat=bA.m_xf.R;var rAX=this.m_localAnchorA.x-bA.m_sweep.localCenter.x;var rAY=this.m_localAnchorA.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rAX+tMat.col2.x*rAY;rAY=tMat.col1.y*rAX+tMat.col2.y*rAY;rAX=tX;tMat=bB.m_xf.R;var rBX=this.m_localAnchorB.x-bB.m_sweep.localCenter.x;var rBY=this.m_localAnchorB.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rBX+tMat.col2.x*rBY;rBY=tMat.col1.y*rBX+tMat.col2.y*rBY;rBX=tX;var maxImpulse=0;{var Cdot=wB-wA;var impulse=-this.m_angularMass*Cdot;var oldImpulse=this.m_angularImpulse;maxImpulse=step.dt*this.m_maxTorque;this.m_angularImpulse=b2Math.Clamp(this.m_angularImpulse+impulse,-maxImpulse,maxImpulse);impulse=this.m_angularImpulse-oldImpulse;wA-=iA*impulse;wB+=iB*impulse;}{var CdotX=vB.x-wB*rBY-vA.x+wA*rAY;var CdotY=vB.y+wB*rBX-vA.y-wA*rAX;var impulseV=b2Math.MulMV(this.m_linearMass,new b2Vec2(-CdotX,-CdotY));var oldImpulseV=this.m_linearImpulse.Copy();this.m_linearImpulse.Add(impulseV);maxImpulse=step.dt*this.m_maxForce;if(this.m_linearImpulse.LengthSquared()>maxImpulse*maxImpulse){this.m_linearImpulse.Normalize();this.m_linearImpulse.Multiply(maxImpulse);}impulseV=b2Math.SubtractVV(this.m_linearImpulse,oldImpulseV);vA.x-=mA*impulseV.x;vA.y-=mA*impulseV.y;wA-=iA*(rAX*impulseV.y-rAY*impulseV.x);vB.x+=mB*impulseV.x;vB.y+=mB*impulseV.y;wB+=iB*(rBX*impulseV.y-rBY*impulseV.x);}bA.m_angularVelocity=wA;bB.m_angularVelocity=wB;};b2FrictionJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;return true;};Box2D.inherit(b2FrictionJointDef,Box2D.Dynamics.Joints.b2JointDef);b2FrictionJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2FrictionJointDef.b2FrictionJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();};b2FrictionJointDef.prototype.b2FrictionJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_frictionJoint;this.maxForce=0.0;this.maxTorque=0.0;};b2FrictionJointDef.prototype.Initialize=function(bA,bB,anchor){this.bodyA=bA;this.bodyB=bB;this.localAnchorA.SetV(this.bodyA.GetLocalPoint(anchor));this.localAnchorB.SetV(this.bodyB.GetLocalPoint(anchor));};Box2D.inherit(b2GearJoint,Box2D.Dynamics.Joints.b2Joint);b2GearJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2GearJoint.b2GearJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_groundAnchor1=new b2Vec2();this.m_groundAnchor2=new b2Vec2();this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_J=new b2Jacobian();};b2GearJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2GearJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2GearJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse*this.m_J.linearB.x,inv_dt*this.m_impulse*this.m_J.linearB.y);};b2GearJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;var tMat=this.m_bodyB.m_xf.R;var rX=this.m_localAnchor1.x-this.m_bodyB.m_sweep.localCenter.x;var rY=this.m_localAnchor1.y-this.m_bodyB.m_sweep.localCenter.y;var tX=tMat.col1.x*rX+tMat.col2.x*rY;rY=tMat.col1.y*rX+tMat.col2.y*rY;rX=tX;var PX=this.m_impulse*this.m_J.linearB.x;var PY=this.m_impulse*this.m_J.linearB.y;return inv_dt*(this.m_impulse*this.m_J.angularB-rX*PY+rY*PX);};b2GearJoint.prototype.GetRatio=function(){return this.m_ratio;};b2GearJoint.prototype.SetRatio=function(ratio){if(ratio===undefined)ratio=0;this.m_ratio=ratio;};b2GearJoint.prototype.b2GearJoint=function(def){this.__super.b2Joint.call(this,def);var type1=parseInt(def.joint1.m_type);var type2=parseInt(def.joint2.m_type);this.m_revolute1=null;this.m_prismatic1=null;this.m_revolute2=null;this.m_prismatic2=null;var coordinate1=0;var coordinate2=0;this.m_ground1=def.joint1.GetBodyA();this.m_bodyA=def.joint1.GetBodyB();if(type1==b2Joint.e_revoluteJoint){this.m_revolute1=def.joint1 instanceof b2RevoluteJoint?def.joint1:null;this.m_groundAnchor1.SetV(this.m_revolute1.m_localAnchor1);this.m_localAnchor1.SetV(this.m_revolute1.m_localAnchor2);coordinate1=this.m_revolute1.GetJointAngle();}else{this.m_prismatic1=def.joint1 instanceof b2PrismaticJoint?def.joint1:null;this.m_groundAnchor1.SetV(this.m_prismatic1.m_localAnchor1);this.m_localAnchor1.SetV(this.m_prismatic1.m_localAnchor2);coordinate1=this.m_prismatic1.GetJointTranslation();}this.m_ground2=def.joint2.GetBodyA();this.m_bodyB=def.joint2.GetBodyB();if(type2==b2Joint.e_revoluteJoint){this.m_revolute2=def.joint2 instanceof b2RevoluteJoint?def.joint2:null;this.m_groundAnchor2.SetV(this.m_revolute2.m_localAnchor1);this.m_localAnchor2.SetV(this.m_revolute2.m_localAnchor2);coordinate2=this.m_revolute2.GetJointAngle();}else{this.m_prismatic2=def.joint2 instanceof b2PrismaticJoint?def.joint2:null;this.m_groundAnchor2.SetV(this.m_prismatic2.m_localAnchor1);this.m_localAnchor2.SetV(this.m_prismatic2.m_localAnchor2);coordinate2=this.m_prismatic2.GetJointTranslation();}this.m_ratio=def.ratio;this.m_constant=coordinate1+this.m_ratio*coordinate2;this.m_impulse=0.0;};b2GearJoint.prototype.InitVelocityConstraints=function(step){var g1=this.m_ground1;var g2=this.m_ground2;var bA=this.m_bodyA;var bB=this.m_bodyB;var ugX=0;var ugY=0;var rX=0;var rY=0;var tMat;var tVec;var crug=0;var tX=0;var K=0.0;this.m_J.SetZero();if(this.m_revolute1){this.m_J.angularA=-1.0;K+=bA.m_invI;}else{tMat=g1.m_xf.R;tVec=this.m_prismatic1.m_localXAxis1;ugX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;ugY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=bA.m_xf.R;rX=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;rY=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rX+tMat.col2.x*rY;rY=tMat.col1.y*rX+tMat.col2.y*rY;rX=tX;crug=rX*ugY-rY*ugX;this.m_J.linearA.Set(-ugX,-ugY);this.m_J.angularA=-crug;K+=bA.m_invMass+bA.m_invI*crug*crug;}if(this.m_revolute2){this.m_J.angularB=-this.m_ratio;K+=this.m_ratio*this.m_ratio*bB.m_invI;}else{tMat=g2.m_xf.R;tVec=this.m_prismatic2.m_localXAxis1;ugX=tMat.col1.x*tVec.x+tMat.col2.x*tVec.y;ugY=tMat.col1.y*tVec.x+tMat.col2.y*tVec.y;tMat=bB.m_xf.R;rX=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;rY=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rX+tMat.col2.x*rY;rY=tMat.col1.y*rX+tMat.col2.y*rY;rX=tX;crug=rX*ugY-rY*ugX;this.m_J.linearB.Set(-this.m_ratio*ugX,-this.m_ratio*ugY);this.m_J.angularB=-this.m_ratio*crug;K+=this.m_ratio*this.m_ratio*(bB.m_invMass+bB.m_invI*crug*crug);}this.m_mass=K>0.0?1.0/K:0.0;if(step.warmStarting){bA.m_linearVelocity.x+=bA.m_invMass*this.m_impulse*this.m_J.linearA.x;bA.m_linearVelocity.y+=bA.m_invMass*this.m_impulse*this.m_J.linearA.y;bA.m_angularVelocity+=bA.m_invI*this.m_impulse*this.m_J.angularA;bB.m_linearVelocity.x+=bB.m_invMass*this.m_impulse*this.m_J.linearB.x;bB.m_linearVelocity.y+=bB.m_invMass*this.m_impulse*this.m_J.linearB.y;bB.m_angularVelocity+=bB.m_invI*this.m_impulse*this.m_J.angularB;}else{this.m_impulse=0.0;}};b2GearJoint.prototype.SolveVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var Cdot=this.m_J.Compute(bA.m_linearVelocity,bA.m_angularVelocity,bB.m_linearVelocity,bB.m_angularVelocity);var impulse=-this.m_mass*Cdot;this.m_impulse+=impulse;bA.m_linearVelocity.x+=bA.m_invMass*impulse*this.m_J.linearA.x;bA.m_linearVelocity.y+=bA.m_invMass*impulse*this.m_J.linearA.y;bA.m_angularVelocity+=bA.m_invI*impulse*this.m_J.angularA;bB.m_linearVelocity.x+=bB.m_invMass*impulse*this.m_J.linearB.x;bB.m_linearVelocity.y+=bB.m_invMass*impulse*this.m_J.linearB.y;bB.m_angularVelocity+=bB.m_invI*impulse*this.m_J.angularB;};b2GearJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var linearError=0.0;var bA=this.m_bodyA;var bB=this.m_bodyB;var coordinate1=0;var coordinate2=0;if(this.m_revolute1){coordinate1=this.m_revolute1.GetJointAngle();}else{coordinate1=this.m_prismatic1.GetJointTranslation();}if(this.m_revolute2){coordinate2=this.m_revolute2.GetJointAngle();}else{coordinate2=this.m_prismatic2.GetJointTranslation();}var C=this.m_constant-(coordinate1+this.m_ratio*coordinate2);var impulse=-this.m_mass*C;bA.m_sweep.c.x+=bA.m_invMass*impulse*this.m_J.linearA.x;bA.m_sweep.c.y+=bA.m_invMass*impulse*this.m_J.linearA.y;bA.m_sweep.a+=bA.m_invI*impulse*this.m_J.angularA;bB.m_sweep.c.x+=bB.m_invMass*impulse*this.m_J.linearB.x;bB.m_sweep.c.y+=bB.m_invMass*impulse*this.m_J.linearB.y;bB.m_sweep.a+=bB.m_invI*impulse*this.m_J.angularB;bA.SynchronizeTransform();bB.SynchronizeTransform();return linearError<b2Settings.b2_linearSlop;};Box2D.inherit(b2GearJointDef,Box2D.Dynamics.Joints.b2JointDef);b2GearJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2GearJointDef.b2GearJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);};b2GearJointDef.prototype.b2GearJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_gearJoint;this.joint1=null;this.joint2=null;this.ratio=1.0;};b2Jacobian.b2Jacobian=function(){this.linearA=new b2Vec2();this.linearB=new b2Vec2();};b2Jacobian.prototype.SetZero=function(){this.linearA.SetZero();this.angularA=0.0;this.linearB.SetZero();this.angularB=0.0;};b2Jacobian.prototype.Set=function(x1,a1,x2,a2){if(a1===undefined)a1=0;if(a2===undefined)a2=0;this.linearA.SetV(x1);this.angularA=a1;this.linearB.SetV(x2);this.angularB=a2;};b2Jacobian.prototype.Compute=function(x1,a1,x2,a2){if(a1===undefined)a1=0;if(a2===undefined)a2=0;return this.linearA.x*x1.x+this.linearA.y*x1.y+this.angularA*a1+(this.linearB.x*x2.x+this.linearB.y*x2.y)+this.angularB*a2;};b2Joint.b2Joint=function(){this.m_edgeA=new b2JointEdge();this.m_edgeB=new b2JointEdge();this.m_localCenterA=new b2Vec2();this.m_localCenterB=new b2Vec2();};b2Joint.prototype.GetType=function(){return this.m_type;};b2Joint.prototype.GetAnchorA=function(){return null;};b2Joint.prototype.GetAnchorB=function(){return null;};b2Joint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return null;};b2Joint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return 0.0;};b2Joint.prototype.GetBodyA=function(){return this.m_bodyA;};b2Joint.prototype.GetBodyB=function(){return this.m_bodyB;};b2Joint.prototype.GetNext=function(){return this.m_next;};b2Joint.prototype.GetUserData=function(){return this.m_userData;};b2Joint.prototype.SetUserData=function(data){this.m_userData=data;};b2Joint.prototype.IsActive=function(){return this.m_bodyA.IsActive()&&this.m_bodyB.IsActive();};b2Joint.Create=function(def,allocator){var joint=null;switch(def.type){case b2Joint.e_distanceJoint:{joint=new b2DistanceJoint(def instanceof b2DistanceJointDef?def:null);}break;case b2Joint.e_mouseJoint:{joint=new b2MouseJoint(def instanceof b2MouseJointDef?def:null);}break;case b2Joint.e_prismaticJoint:{joint=new b2PrismaticJoint(def instanceof b2PrismaticJointDef?def:null);}break;case b2Joint.e_revoluteJoint:{joint=new b2RevoluteJoint(def instanceof b2RevoluteJointDef?def:null);}break;case b2Joint.e_pulleyJoint:{joint=new b2PulleyJoint(def instanceof b2PulleyJointDef?def:null);}break;case b2Joint.e_gearJoint:{joint=new b2GearJoint(def instanceof b2GearJointDef?def:null);}break;case b2Joint.e_lineJoint:{joint=new b2LineJoint(def instanceof b2LineJointDef?def:null);}break;case b2Joint.e_weldJoint:{joint=new b2WeldJoint(def instanceof b2WeldJointDef?def:null);}break;case b2Joint.e_frictionJoint:{joint=new b2FrictionJoint(def instanceof b2FrictionJointDef?def:null);}break;default:break;}return joint;};b2Joint.Destroy=function(joint,allocator){};b2Joint.prototype.b2Joint=function(def){b2Settings.b2Assert(def.bodyA!=def.bodyB);this.m_type=def.type;this.m_prev=null;this.m_next=null;this.m_bodyA=def.bodyA;this.m_bodyB=def.bodyB;this.m_collideConnected=def.collideConnected;this.m_islandFlag=false;this.m_userData=def.userData;};b2Joint.prototype.InitVelocityConstraints=function(step){};b2Joint.prototype.SolveVelocityConstraints=function(step){};b2Joint.prototype.FinalizeVelocityConstraints=function(){};b2Joint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;return false;};Box2D.postDefs.push(function(){Box2D.Dynamics.Joints.b2Joint.e_unknownJoint=0;Box2D.Dynamics.Joints.b2Joint.e_revoluteJoint=1;Box2D.Dynamics.Joints.b2Joint.e_prismaticJoint=2;Box2D.Dynamics.Joints.b2Joint.e_distanceJoint=3;Box2D.Dynamics.Joints.b2Joint.e_pulleyJoint=4;Box2D.Dynamics.Joints.b2Joint.e_mouseJoint=5;Box2D.Dynamics.Joints.b2Joint.e_gearJoint=6;Box2D.Dynamics.Joints.b2Joint.e_lineJoint=7;Box2D.Dynamics.Joints.b2Joint.e_weldJoint=8;Box2D.Dynamics.Joints.b2Joint.e_frictionJoint=9;Box2D.Dynamics.Joints.b2Joint.e_inactiveLimit=0;Box2D.Dynamics.Joints.b2Joint.e_atLowerLimit=1;Box2D.Dynamics.Joints.b2Joint.e_atUpperLimit=2;Box2D.Dynamics.Joints.b2Joint.e_equalLimits=3;});b2JointDef.b2JointDef=function(){};b2JointDef.prototype.b2JointDef=function(){this.type=b2Joint.e_unknownJoint;this.userData=null;this.bodyA=null;this.bodyB=null;this.collideConnected=false;};b2JointEdge.b2JointEdge=function(){};Box2D.inherit(b2LineJoint,Box2D.Dynamics.Joints.b2Joint);b2LineJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2LineJoint.b2LineJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_localXAxis1=new b2Vec2();this.m_localYAxis1=new b2Vec2();this.m_axis=new b2Vec2();this.m_perp=new b2Vec2();this.m_K=new b2Mat22();this.m_impulse=new b2Vec2();};b2LineJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2LineJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2LineJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*(this.m_impulse.x*this.m_perp.x+(this.m_motorImpulse+this.m_impulse.y)*this.m_axis.x),inv_dt*(this.m_impulse.x*this.m_perp.y+(this.m_motorImpulse+this.m_impulse.y)*this.m_axis.y));};b2LineJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return inv_dt*this.m_impulse.y;};b2LineJoint.prototype.GetJointTranslation=function(){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var p1=bA.GetWorldPoint(this.m_localAnchor1);var p2=bB.GetWorldPoint(this.m_localAnchor2);var dX=p2.x-p1.x;var dY=p2.y-p1.y;var axis=bA.GetWorldVector(this.m_localXAxis1);var translation=axis.x*dX+axis.y*dY;return translation;};b2LineJoint.prototype.GetJointSpeed=function(){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var p1X=bA.m_sweep.c.x+r1X;var p1Y=bA.m_sweep.c.y+r1Y;var p2X=bB.m_sweep.c.x+r2X;var p2Y=bB.m_sweep.c.y+r2Y;var dX=p2X-p1X;var dY=p2Y-p1Y;var axis=bA.GetWorldVector(this.m_localXAxis1);var v1=bA.m_linearVelocity;var v2=bB.m_linearVelocity;var w1=bA.m_angularVelocity;var w2=bB.m_angularVelocity;var speed=dX*(-w1*axis.y)+dY*(w1*axis.x)+(axis.x*(v2.x+-w2*r2Y-v1.x- -w1*r1Y)+axis.y*(v2.y+w2*r2X-v1.y-w1*r1X));return speed;};b2LineJoint.prototype.IsLimitEnabled=function(){return this.m_enableLimit;};b2LineJoint.prototype.EnableLimit=function(flag){this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_enableLimit=flag;};b2LineJoint.prototype.GetLowerLimit=function(){return this.m_lowerTranslation;};b2LineJoint.prototype.GetUpperLimit=function(){return this.m_upperTranslation;};b2LineJoint.prototype.SetLimits=function(lower,upper){if(lower===undefined)lower=0;if(upper===undefined)upper=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_lowerTranslation=lower;this.m_upperTranslation=upper;};b2LineJoint.prototype.IsMotorEnabled=function(){return this.m_enableMotor;};b2LineJoint.prototype.EnableMotor=function(flag){this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_enableMotor=flag;};b2LineJoint.prototype.SetMotorSpeed=function(speed){if(speed===undefined)speed=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_motorSpeed=speed;};b2LineJoint.prototype.GetMotorSpeed=function(){return this.m_motorSpeed;};b2LineJoint.prototype.SetMaxMotorForce=function(force){if(force===undefined)force=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_maxMotorForce=force;};b2LineJoint.prototype.GetMaxMotorForce=function(){return this.m_maxMotorForce;};b2LineJoint.prototype.GetMotorForce=function(){return this.m_motorImpulse;};b2LineJoint.prototype.b2LineJoint=function(def){this.__super.b2Joint.call(this,def);var tMat;var tX=0;var tY=0;this.m_localAnchor1.SetV(def.localAnchorA);this.m_localAnchor2.SetV(def.localAnchorB);this.m_localXAxis1.SetV(def.localAxisA);this.m_localYAxis1.x=-this.m_localXAxis1.y;this.m_localYAxis1.y=this.m_localXAxis1.x;this.m_impulse.SetZero();this.m_motorMass=0.0;this.m_motorImpulse=0.0;this.m_lowerTranslation=def.lowerTranslation;this.m_upperTranslation=def.upperTranslation;this.m_maxMotorForce=def.maxMotorForce;this.m_motorSpeed=def.motorSpeed;this.m_enableLimit=def.enableLimit;this.m_enableMotor=def.enableMotor;this.m_limitState=b2Joint.e_inactiveLimit;this.m_axis.SetZero();this.m_perp.SetZero();};b2LineJoint.prototype.InitVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var tX=0;this.m_localCenterA.SetV(bA.GetLocalCenter());this.m_localCenterB.SetV(bB.GetLocalCenter());var xf1=bA.GetTransform();var xf2=bB.GetTransform();tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-this.m_localCenterA.x;var r1Y=this.m_localAnchor1.y-this.m_localCenterA.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-this.m_localCenterB.x;var r2Y=this.m_localAnchor2.y-this.m_localCenterB.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var dX=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;var dY=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;this.m_invMassA=bA.m_invMass;this.m_invMassB=bB.m_invMass;this.m_invIA=bA.m_invI;this.m_invIB=bB.m_invI;{this.m_axis.SetV(b2Math.MulMV(xf1.R,this.m_localXAxis1));this.m_a1=(dX+r1X)*this.m_axis.y-(dY+r1Y)*this.m_axis.x;this.m_a2=r2X*this.m_axis.y-r2Y*this.m_axis.x;this.m_motorMass=this.m_invMassA+this.m_invMassB+this.m_invIA*this.m_a1*this.m_a1+this.m_invIB*this.m_a2*this.m_a2;this.m_motorMass=this.m_motorMass>Number.MIN_VALUE?1.0/this.m_motorMass:0.0;}{this.m_perp.SetV(b2Math.MulMV(xf1.R,this.m_localYAxis1));this.m_s1=(dX+r1X)*this.m_perp.y-(dY+r1Y)*this.m_perp.x;this.m_s2=r2X*this.m_perp.y-r2Y*this.m_perp.x;var m1=this.m_invMassA;var m2=this.m_invMassB;var i1=this.m_invIA;var i2=this.m_invIB;this.m_K.col1.x=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;this.m_K.col1.y=i1*this.m_s1*this.m_a1+i2*this.m_s2*this.m_a2;this.m_K.col2.x=this.m_K.col1.y;this.m_K.col2.y=m1+m2+i1*this.m_a1*this.m_a1+i2*this.m_a2*this.m_a2;}if(this.m_enableLimit){var jointTransition=this.m_axis.x*dX+this.m_axis.y*dY;if(b2Math.Abs(this.m_upperTranslation-this.m_lowerTranslation)<2.0*b2Settings.b2_linearSlop){this.m_limitState=b2Joint.e_equalLimits;}else if(jointTransition<=this.m_lowerTranslation){if(this.m_limitState!=b2Joint.e_atLowerLimit){this.m_limitState=b2Joint.e_atLowerLimit;this.m_impulse.y=0.0;}}else if(jointTransition>=this.m_upperTranslation){if(this.m_limitState!=b2Joint.e_atUpperLimit){this.m_limitState=b2Joint.e_atUpperLimit;this.m_impulse.y=0.0;}}else{this.m_limitState=b2Joint.e_inactiveLimit;this.m_impulse.y=0.0;}}else{this.m_limitState=b2Joint.e_inactiveLimit;}if(this.m_enableMotor==false){this.m_motorImpulse=0.0;}if(step.warmStarting){this.m_impulse.x*=step.dtRatio;this.m_impulse.y*=step.dtRatio;this.m_motorImpulse*=step.dtRatio;var PX=this.m_impulse.x*this.m_perp.x+(this.m_motorImpulse+this.m_impulse.y)*this.m_axis.x;var PY=this.m_impulse.x*this.m_perp.y+(this.m_motorImpulse+this.m_impulse.y)*this.m_axis.y;var L1=this.m_impulse.x*this.m_s1+(this.m_motorImpulse+this.m_impulse.y)*this.m_a1;var L2=this.m_impulse.x*this.m_s2+(this.m_motorImpulse+this.m_impulse.y)*this.m_a2;bA.m_linearVelocity.x-=this.m_invMassA*PX;bA.m_linearVelocity.y-=this.m_invMassA*PY;bA.m_angularVelocity-=this.m_invIA*L1;bB.m_linearVelocity.x+=this.m_invMassB*PX;bB.m_linearVelocity.y+=this.m_invMassB*PY;bB.m_angularVelocity+=this.m_invIB*L2;}else{this.m_impulse.SetZero();this.m_motorImpulse=0.0;}};b2LineJoint.prototype.SolveVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var v1=bA.m_linearVelocity;var w1=bA.m_angularVelocity;var v2=bB.m_linearVelocity;var w2=bB.m_angularVelocity;var PX=0;var PY=0;var L1=0;var L2=0;if(this.m_enableMotor&&this.m_limitState!=b2Joint.e_equalLimits){var Cdot=this.m_axis.x*(v2.x-v1.x)+this.m_axis.y*(v2.y-v1.y)+this.m_a2*w2-this.m_a1*w1;var impulse=this.m_motorMass*(this.m_motorSpeed-Cdot);var oldImpulse=this.m_motorImpulse;var maxImpulse=step.dt*this.m_maxMotorForce;this.m_motorImpulse=b2Math.Clamp(this.m_motorImpulse+impulse,-maxImpulse,maxImpulse);impulse=this.m_motorImpulse-oldImpulse;PX=impulse*this.m_axis.x;PY=impulse*this.m_axis.y;L1=impulse*this.m_a1;L2=impulse*this.m_a2;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}var Cdot1=this.m_perp.x*(v2.x-v1.x)+this.m_perp.y*(v2.y-v1.y)+this.m_s2*w2-this.m_s1*w1;if(this.m_enableLimit&&this.m_limitState!=b2Joint.e_inactiveLimit){var Cdot2=this.m_axis.x*(v2.x-v1.x)+this.m_axis.y*(v2.y-v1.y)+this.m_a2*w2-this.m_a1*w1;var f1=this.m_impulse.Copy();var df=this.m_K.Solve(new b2Vec2(),-Cdot1,-Cdot2);this.m_impulse.Add(df);if(this.m_limitState==b2Joint.e_atLowerLimit){this.m_impulse.y=b2Math.Max(this.m_impulse.y,0.0);}else if(this.m_limitState==b2Joint.e_atUpperLimit){this.m_impulse.y=b2Math.Min(this.m_impulse.y,0.0);}var b=-Cdot1-(this.m_impulse.y-f1.y)*this.m_K.col2.x;var f2r=0;if(this.m_K.col1.x!=0.0){f2r=b/this.m_K.col1.x+f1.x;}else{f2r=f1.x;}this.m_impulse.x=f2r;df.x=this.m_impulse.x-f1.x;df.y=this.m_impulse.y-f1.y;PX=df.x*this.m_perp.x+df.y*this.m_axis.x;PY=df.x*this.m_perp.y+df.y*this.m_axis.y;L1=df.x*this.m_s1+df.y*this.m_a1;L2=df.x*this.m_s2+df.y*this.m_a2;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}else{var df2=0;if(this.m_K.col1.x!=0.0){df2=-Cdot1/this.m_K.col1.x;}else{df2=0.0;}this.m_impulse.x+=df2;PX=df2*this.m_perp.x;PY=df2*this.m_perp.y;L1=df2*this.m_s1;L2=df2*this.m_s2;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}bA.m_linearVelocity.SetV(v1);bA.m_angularVelocity=w1;bB.m_linearVelocity.SetV(v2);bB.m_angularVelocity=w2;};b2LineJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var limitC=0;var oldLimitImpulse=0;var bA=this.m_bodyA;var bB=this.m_bodyB;var c1=bA.m_sweep.c;var a1=bA.m_sweep.a;var c2=bB.m_sweep.c;var a2=bB.m_sweep.a;var tMat;var tX=0;var m1=0;var m2=0;var i1=0;var i2=0;var linearError=0.0;var angularError=0.0;var active=false;var C2=0.0;var R1=b2Mat22.FromAngle(a1);var R2=b2Mat22.FromAngle(a2);tMat=R1;var r1X=this.m_localAnchor1.x-this.m_localCenterA.x;var r1Y=this.m_localAnchor1.y-this.m_localCenterA.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=R2;var r2X=this.m_localAnchor2.x-this.m_localCenterB.x;var r2Y=this.m_localAnchor2.y-this.m_localCenterB.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var dX=c2.x+r2X-c1.x-r1X;var dY=c2.y+r2Y-c1.y-r1Y;if(this.m_enableLimit){this.m_axis=b2Math.MulMV(R1,this.m_localXAxis1);this.m_a1=(dX+r1X)*this.m_axis.y-(dY+r1Y)*this.m_axis.x;this.m_a2=r2X*this.m_axis.y-r2Y*this.m_axis.x;var translation=this.m_axis.x*dX+this.m_axis.y*dY;if(b2Math.Abs(this.m_upperTranslation-this.m_lowerTranslation)<2.0*b2Settings.b2_linearSlop){C2=b2Math.Clamp(translation,-b2Settings.b2_maxLinearCorrection,b2Settings.b2_maxLinearCorrection);linearError=b2Math.Abs(translation);active=true;}else if(translation<=this.m_lowerTranslation){C2=b2Math.Clamp(translation-this.m_lowerTranslation+b2Settings.b2_linearSlop,-b2Settings.b2_maxLinearCorrection,0.0);linearError=this.m_lowerTranslation-translation;active=true;}else if(translation>=this.m_upperTranslation){C2=b2Math.Clamp(translation-this.m_upperTranslation+b2Settings.b2_linearSlop,0.0,b2Settings.b2_maxLinearCorrection);linearError=translation-this.m_upperTranslation;active=true;}}this.m_perp=b2Math.MulMV(R1,this.m_localYAxis1);this.m_s1=(dX+r1X)*this.m_perp.y-(dY+r1Y)*this.m_perp.x;this.m_s2=r2X*this.m_perp.y-r2Y*this.m_perp.x;var impulse=new b2Vec2();var C1=this.m_perp.x*dX+this.m_perp.y*dY;linearError=b2Math.Max(linearError,b2Math.Abs(C1));angularError=0.0;if(active){m1=this.m_invMassA;m2=this.m_invMassB;i1=this.m_invIA;i2=this.m_invIB;this.m_K.col1.x=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;this.m_K.col1.y=i1*this.m_s1*this.m_a1+i2*this.m_s2*this.m_a2;this.m_K.col2.x=this.m_K.col1.y;this.m_K.col2.y=m1+m2+i1*this.m_a1*this.m_a1+i2*this.m_a2*this.m_a2;this.m_K.Solve(impulse,-C1,-C2);}else{m1=this.m_invMassA;m2=this.m_invMassB;i1=this.m_invIA;i2=this.m_invIB;var k11=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;var impulse1=0;if(k11!=0.0){impulse1=-C1/k11;}else{impulse1=0.0;}impulse.x=impulse1;impulse.y=0.0;}var PX=impulse.x*this.m_perp.x+impulse.y*this.m_axis.x;var PY=impulse.x*this.m_perp.y+impulse.y*this.m_axis.y;var L1=impulse.x*this.m_s1+impulse.y*this.m_a1;var L2=impulse.x*this.m_s2+impulse.y*this.m_a2;c1.x-=this.m_invMassA*PX;c1.y-=this.m_invMassA*PY;a1-=this.m_invIA*L1;c2.x+=this.m_invMassB*PX;c2.y+=this.m_invMassB*PY;a2+=this.m_invIB*L2;bA.m_sweep.a=a1;bB.m_sweep.a=a2;bA.SynchronizeTransform();bB.SynchronizeTransform();return linearError<=b2Settings.b2_linearSlop&&angularError<=b2Settings.b2_angularSlop;};Box2D.inherit(b2LineJointDef,Box2D.Dynamics.Joints.b2JointDef);b2LineJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2LineJointDef.b2LineJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();this.localAxisA=new b2Vec2();};b2LineJointDef.prototype.b2LineJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_lineJoint;this.localAxisA.Set(1.0,0.0);this.enableLimit=false;this.lowerTranslation=0.0;this.upperTranslation=0.0;this.enableMotor=false;this.maxMotorForce=0.0;this.motorSpeed=0.0;};b2LineJointDef.prototype.Initialize=function(bA,bB,anchor,axis){this.bodyA=bA;this.bodyB=bB;this.localAnchorA=this.bodyA.GetLocalPoint(anchor);this.localAnchorB=this.bodyB.GetLocalPoint(anchor);this.localAxisA=this.bodyA.GetLocalVector(axis);};Box2D.inherit(b2MouseJoint,Box2D.Dynamics.Joints.b2Joint);b2MouseJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2MouseJoint.b2MouseJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.K=new b2Mat22();this.K1=new b2Mat22();this.K2=new b2Mat22();this.m_localAnchor=new b2Vec2();this.m_target=new b2Vec2();this.m_impulse=new b2Vec2();this.m_mass=new b2Mat22();this.m_C=new b2Vec2();};b2MouseJoint.prototype.GetAnchorA=function(){return this.m_target;};b2MouseJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor);};b2MouseJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse.x,inv_dt*this.m_impulse.y);};b2MouseJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return 0.0;};b2MouseJoint.prototype.GetTarget=function(){return this.m_target;};b2MouseJoint.prototype.SetTarget=function(target){if(this.m_bodyB.IsAwake()==false){this.m_bodyB.SetAwake(true);}this.m_target=target;};b2MouseJoint.prototype.GetMaxForce=function(){return this.m_maxForce;};b2MouseJoint.prototype.SetMaxForce=function(maxForce){if(maxForce===undefined)maxForce=0;this.m_maxForce=maxForce;};b2MouseJoint.prototype.GetFrequency=function(){return this.m_frequencyHz;};b2MouseJoint.prototype.SetFrequency=function(hz){if(hz===undefined)hz=0;this.m_frequencyHz=hz;};b2MouseJoint.prototype.GetDampingRatio=function(){return this.m_dampingRatio;};b2MouseJoint.prototype.SetDampingRatio=function(ratio){if(ratio===undefined)ratio=0;this.m_dampingRatio=ratio;};b2MouseJoint.prototype.b2MouseJoint=function(def){this.__super.b2Joint.call(this,def);this.m_target.SetV(def.target);var tX=this.m_target.x-this.m_bodyB.m_xf.position.x;var tY=this.m_target.y-this.m_bodyB.m_xf.position.y;var tMat=this.m_bodyB.m_xf.R;this.m_localAnchor.x=tX*tMat.col1.x+tY*tMat.col1.y;this.m_localAnchor.y=tX*tMat.col2.x+tY*tMat.col2.y;this.m_maxForce=def.maxForce;this.m_impulse.SetZero();this.m_frequencyHz=def.frequencyHz;this.m_dampingRatio=def.dampingRatio;this.m_beta=0.0;this.m_gamma=0.0;};b2MouseJoint.prototype.InitVelocityConstraints=function(step){var b=this.m_bodyB;var mass=b.GetMass();var omega=2.0*Math.PI*this.m_frequencyHz;var d=2.0*mass*this.m_dampingRatio*omega;var k=mass*omega*omega;this.m_gamma=step.dt*(d+step.dt*k);this.m_gamma=this.m_gamma!=0?1/this.m_gamma:0.0;this.m_beta=step.dt*k*this.m_gamma;var tMat;tMat=b.m_xf.R;var rX=this.m_localAnchor.x-b.m_sweep.localCenter.x;var rY=this.m_localAnchor.y-b.m_sweep.localCenter.y;var tX=tMat.col1.x*rX+tMat.col2.x*rY;rY=tMat.col1.y*rX+tMat.col2.y*rY;rX=tX;var invMass=b.m_invMass;var invI=b.m_invI;this.K1.col1.x=invMass;this.K1.col2.x=0.0;this.K1.col1.y=0.0;this.K1.col2.y=invMass;this.K2.col1.x=invI*rY*rY;this.K2.col2.x=-invI*rX*rY;this.K2.col1.y=-invI*rX*rY;this.K2.col2.y=invI*rX*rX;this.K.SetM(this.K1);this.K.AddM(this.K2);this.K.col1.x+=this.m_gamma;this.K.col2.y+=this.m_gamma;this.K.GetInverse(this.m_mass);this.m_C.x=b.m_sweep.c.x+rX-this.m_target.x;this.m_C.y=b.m_sweep.c.y+rY-this.m_target.y;b.m_angularVelocity*=0.98;this.m_impulse.x*=step.dtRatio;this.m_impulse.y*=step.dtRatio;b.m_linearVelocity.x+=invMass*this.m_impulse.x;b.m_linearVelocity.y+=invMass*this.m_impulse.y;b.m_angularVelocity+=invI*(rX*this.m_impulse.y-rY*this.m_impulse.x);};b2MouseJoint.prototype.SolveVelocityConstraints=function(step){var b=this.m_bodyB;var tMat;var tX=0;var tY=0;tMat=b.m_xf.R;var rX=this.m_localAnchor.x-b.m_sweep.localCenter.x;var rY=this.m_localAnchor.y-b.m_sweep.localCenter.y;tX=tMat.col1.x*rX+tMat.col2.x*rY;rY=tMat.col1.y*rX+tMat.col2.y*rY;rX=tX;var CdotX=b.m_linearVelocity.x+-b.m_angularVelocity*rY;var CdotY=b.m_linearVelocity.y+b.m_angularVelocity*rX;tMat=this.m_mass;tX=CdotX+this.m_beta*this.m_C.x+this.m_gamma*this.m_impulse.x;tY=CdotY+this.m_beta*this.m_C.y+this.m_gamma*this.m_impulse.y;var impulseX=-(tMat.col1.x*tX+tMat.col2.x*tY);var impulseY=-(tMat.col1.y*tX+tMat.col2.y*tY);var oldImpulseX=this.m_impulse.x;var oldImpulseY=this.m_impulse.y;this.m_impulse.x+=impulseX;this.m_impulse.y+=impulseY;var maxImpulse=step.dt*this.m_maxForce;if(this.m_impulse.LengthSquared()>maxImpulse*maxImpulse){this.m_impulse.Multiply(maxImpulse/this.m_impulse.Length());}impulseX=this.m_impulse.x-oldImpulseX;impulseY=this.m_impulse.y-oldImpulseY;b.m_linearVelocity.x+=b.m_invMass*impulseX;b.m_linearVelocity.y+=b.m_invMass*impulseY;b.m_angularVelocity+=b.m_invI*(rX*impulseY-rY*impulseX);};b2MouseJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;return true;};Box2D.inherit(b2MouseJointDef,Box2D.Dynamics.Joints.b2JointDef);b2MouseJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2MouseJointDef.b2MouseJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.target=new b2Vec2();};b2MouseJointDef.prototype.b2MouseJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_mouseJoint;this.maxForce=0.0;this.frequencyHz=5.0;this.dampingRatio=0.7;};Box2D.inherit(b2PrismaticJoint,Box2D.Dynamics.Joints.b2Joint);b2PrismaticJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2PrismaticJoint.b2PrismaticJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_localXAxis1=new b2Vec2();this.m_localYAxis1=new b2Vec2();this.m_axis=new b2Vec2();this.m_perp=new b2Vec2();this.m_K=new b2Mat33();this.m_impulse=new b2Vec3();};b2PrismaticJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2PrismaticJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2PrismaticJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*(this.m_impulse.x*this.m_perp.x+(this.m_motorImpulse+this.m_impulse.z)*this.m_axis.x),inv_dt*(this.m_impulse.x*this.m_perp.y+(this.m_motorImpulse+this.m_impulse.z)*this.m_axis.y));};b2PrismaticJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return inv_dt*this.m_impulse.y;};b2PrismaticJoint.prototype.GetJointTranslation=function(){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var p1=bA.GetWorldPoint(this.m_localAnchor1);var p2=bB.GetWorldPoint(this.m_localAnchor2);var dX=p2.x-p1.x;var dY=p2.y-p1.y;var axis=bA.GetWorldVector(this.m_localXAxis1);var translation=axis.x*dX+axis.y*dY;return translation;};b2PrismaticJoint.prototype.GetJointSpeed=function(){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var p1X=bA.m_sweep.c.x+r1X;var p1Y=bA.m_sweep.c.y+r1Y;var p2X=bB.m_sweep.c.x+r2X;var p2Y=bB.m_sweep.c.y+r2Y;var dX=p2X-p1X;var dY=p2Y-p1Y;var axis=bA.GetWorldVector(this.m_localXAxis1);var v1=bA.m_linearVelocity;var v2=bB.m_linearVelocity;var w1=bA.m_angularVelocity;var w2=bB.m_angularVelocity;var speed=dX*(-w1*axis.y)+dY*(w1*axis.x)+(axis.x*(v2.x+-w2*r2Y-v1.x- -w1*r1Y)+axis.y*(v2.y+w2*r2X-v1.y-w1*r1X));return speed;};b2PrismaticJoint.prototype.IsLimitEnabled=function(){return this.m_enableLimit;};b2PrismaticJoint.prototype.EnableLimit=function(flag){this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_enableLimit=flag;};b2PrismaticJoint.prototype.GetLowerLimit=function(){return this.m_lowerTranslation;};b2PrismaticJoint.prototype.GetUpperLimit=function(){return this.m_upperTranslation;};b2PrismaticJoint.prototype.SetLimits=function(lower,upper){if(lower===undefined)lower=0;if(upper===undefined)upper=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_lowerTranslation=lower;this.m_upperTranslation=upper;};b2PrismaticJoint.prototype.IsMotorEnabled=function(){return this.m_enableMotor;};b2PrismaticJoint.prototype.EnableMotor=function(flag){this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_enableMotor=flag;};b2PrismaticJoint.prototype.SetMotorSpeed=function(speed){if(speed===undefined)speed=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_motorSpeed=speed;};b2PrismaticJoint.prototype.GetMotorSpeed=function(){return this.m_motorSpeed;};b2PrismaticJoint.prototype.SetMaxMotorForce=function(force){if(force===undefined)force=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_maxMotorForce=force;};b2PrismaticJoint.prototype.GetMotorForce=function(){return this.m_motorImpulse;};b2PrismaticJoint.prototype.b2PrismaticJoint=function(def){this.__super.b2Joint.call(this,def);var tMat;var tX=0;var tY=0;this.m_localAnchor1.SetV(def.localAnchorA);this.m_localAnchor2.SetV(def.localAnchorB);this.m_localXAxis1.SetV(def.localAxisA);this.m_localYAxis1.x=-this.m_localXAxis1.y;this.m_localYAxis1.y=this.m_localXAxis1.x;this.m_refAngle=def.referenceAngle;this.m_impulse.SetZero();this.m_motorMass=0.0;this.m_motorImpulse=0.0;this.m_lowerTranslation=def.lowerTranslation;this.m_upperTranslation=def.upperTranslation;this.m_maxMotorForce=def.maxMotorForce;this.m_motorSpeed=def.motorSpeed;this.m_enableLimit=def.enableLimit;this.m_enableMotor=def.enableMotor;this.m_limitState=b2Joint.e_inactiveLimit;this.m_axis.SetZero();this.m_perp.SetZero();};b2PrismaticJoint.prototype.InitVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var tX=0;this.m_localCenterA.SetV(bA.GetLocalCenter());this.m_localCenterB.SetV(bB.GetLocalCenter());var xf1=bA.GetTransform();var xf2=bB.GetTransform();tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-this.m_localCenterA.x;var r1Y=this.m_localAnchor1.y-this.m_localCenterA.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-this.m_localCenterB.x;var r2Y=this.m_localAnchor2.y-this.m_localCenterB.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var dX=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;var dY=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;this.m_invMassA=bA.m_invMass;this.m_invMassB=bB.m_invMass;this.m_invIA=bA.m_invI;this.m_invIB=bB.m_invI;{this.m_axis.SetV(b2Math.MulMV(xf1.R,this.m_localXAxis1));this.m_a1=(dX+r1X)*this.m_axis.y-(dY+r1Y)*this.m_axis.x;this.m_a2=r2X*this.m_axis.y-r2Y*this.m_axis.x;this.m_motorMass=this.m_invMassA+this.m_invMassB+this.m_invIA*this.m_a1*this.m_a1+this.m_invIB*this.m_a2*this.m_a2;if(this.m_motorMass>Number.MIN_VALUE)this.m_motorMass=1.0/this.m_motorMass;}{this.m_perp.SetV(b2Math.MulMV(xf1.R,this.m_localYAxis1));this.m_s1=(dX+r1X)*this.m_perp.y-(dY+r1Y)*this.m_perp.x;this.m_s2=r2X*this.m_perp.y-r2Y*this.m_perp.x;var m1=this.m_invMassA;var m2=this.m_invMassB;var i1=this.m_invIA;var i2=this.m_invIB;this.m_K.col1.x=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;this.m_K.col1.y=i1*this.m_s1+i2*this.m_s2;this.m_K.col1.z=i1*this.m_s1*this.m_a1+i2*this.m_s2*this.m_a2;this.m_K.col2.x=this.m_K.col1.y;this.m_K.col2.y=i1+i2;this.m_K.col2.z=i1*this.m_a1+i2*this.m_a2;this.m_K.col3.x=this.m_K.col1.z;this.m_K.col3.y=this.m_K.col2.z;this.m_K.col3.z=m1+m2+i1*this.m_a1*this.m_a1+i2*this.m_a2*this.m_a2;}if(this.m_enableLimit){var jointTransition=this.m_axis.x*dX+this.m_axis.y*dY;if(b2Math.Abs(this.m_upperTranslation-this.m_lowerTranslation)<2.0*b2Settings.b2_linearSlop){this.m_limitState=b2Joint.e_equalLimits;}else if(jointTransition<=this.m_lowerTranslation){if(this.m_limitState!=b2Joint.e_atLowerLimit){this.m_limitState=b2Joint.e_atLowerLimit;this.m_impulse.z=0.0;}}else if(jointTransition>=this.m_upperTranslation){if(this.m_limitState!=b2Joint.e_atUpperLimit){this.m_limitState=b2Joint.e_atUpperLimit;this.m_impulse.z=0.0;}}else{this.m_limitState=b2Joint.e_inactiveLimit;this.m_impulse.z=0.0;}}else{this.m_limitState=b2Joint.e_inactiveLimit;}if(this.m_enableMotor==false){this.m_motorImpulse=0.0;}if(step.warmStarting){this.m_impulse.x*=step.dtRatio;this.m_impulse.y*=step.dtRatio;this.m_motorImpulse*=step.dtRatio;var PX=this.m_impulse.x*this.m_perp.x+(this.m_motorImpulse+this.m_impulse.z)*this.m_axis.x;var PY=this.m_impulse.x*this.m_perp.y+(this.m_motorImpulse+this.m_impulse.z)*this.m_axis.y;var L1=this.m_impulse.x*this.m_s1+this.m_impulse.y+(this.m_motorImpulse+this.m_impulse.z)*this.m_a1;var L2=this.m_impulse.x*this.m_s2+this.m_impulse.y+(this.m_motorImpulse+this.m_impulse.z)*this.m_a2;bA.m_linearVelocity.x-=this.m_invMassA*PX;bA.m_linearVelocity.y-=this.m_invMassA*PY;bA.m_angularVelocity-=this.m_invIA*L1;bB.m_linearVelocity.x+=this.m_invMassB*PX;bB.m_linearVelocity.y+=this.m_invMassB*PY;bB.m_angularVelocity+=this.m_invIB*L2;}else{this.m_impulse.SetZero();this.m_motorImpulse=0.0;}};b2PrismaticJoint.prototype.SolveVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var v1=bA.m_linearVelocity;var w1=bA.m_angularVelocity;var v2=bB.m_linearVelocity;var w2=bB.m_angularVelocity;var PX=0;var PY=0;var L1=0;var L2=0;if(this.m_enableMotor&&this.m_limitState!=b2Joint.e_equalLimits){var Cdot=this.m_axis.x*(v2.x-v1.x)+this.m_axis.y*(v2.y-v1.y)+this.m_a2*w2-this.m_a1*w1;var impulse=this.m_motorMass*(this.m_motorSpeed-Cdot);var oldImpulse=this.m_motorImpulse;var maxImpulse=step.dt*this.m_maxMotorForce;this.m_motorImpulse=b2Math.Clamp(this.m_motorImpulse+impulse,-maxImpulse,maxImpulse);impulse=this.m_motorImpulse-oldImpulse;PX=impulse*this.m_axis.x;PY=impulse*this.m_axis.y;L1=impulse*this.m_a1;L2=impulse*this.m_a2;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}var Cdot1X=this.m_perp.x*(v2.x-v1.x)+this.m_perp.y*(v2.y-v1.y)+this.m_s2*w2-this.m_s1*w1;var Cdot1Y=w2-w1;if(this.m_enableLimit&&this.m_limitState!=b2Joint.e_inactiveLimit){var Cdot2=this.m_axis.x*(v2.x-v1.x)+this.m_axis.y*(v2.y-v1.y)+this.m_a2*w2-this.m_a1*w1;var f1=this.m_impulse.Copy();var df=this.m_K.Solve33(new b2Vec3(),-Cdot1X,-Cdot1Y,-Cdot2);this.m_impulse.Add(df);if(this.m_limitState==b2Joint.e_atLowerLimit){this.m_impulse.z=b2Math.Max(this.m_impulse.z,0.0);}else if(this.m_limitState==b2Joint.e_atUpperLimit){this.m_impulse.z=b2Math.Min(this.m_impulse.z,0.0);}var bX=-Cdot1X-(this.m_impulse.z-f1.z)*this.m_K.col3.x;var bY=-Cdot1Y-(this.m_impulse.z-f1.z)*this.m_K.col3.y;var f2r=this.m_K.Solve22(new b2Vec2(),bX,bY);f2r.x+=f1.x;f2r.y+=f1.y;this.m_impulse.x=f2r.x;this.m_impulse.y=f2r.y;df.x=this.m_impulse.x-f1.x;df.y=this.m_impulse.y-f1.y;df.z=this.m_impulse.z-f1.z;PX=df.x*this.m_perp.x+df.z*this.m_axis.x;PY=df.x*this.m_perp.y+df.z*this.m_axis.y;L1=df.x*this.m_s1+df.y+df.z*this.m_a1;L2=df.x*this.m_s2+df.y+df.z*this.m_a2;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}else{var df2=this.m_K.Solve22(new b2Vec2(),-Cdot1X,-Cdot1Y);this.m_impulse.x+=df2.x;this.m_impulse.y+=df2.y;PX=df2.x*this.m_perp.x;PY=df2.x*this.m_perp.y;L1=df2.x*this.m_s1+df2.y;L2=df2.x*this.m_s2+df2.y;v1.x-=this.m_invMassA*PX;v1.y-=this.m_invMassA*PY;w1-=this.m_invIA*L1;v2.x+=this.m_invMassB*PX;v2.y+=this.m_invMassB*PY;w2+=this.m_invIB*L2;}bA.m_linearVelocity.SetV(v1);bA.m_angularVelocity=w1;bB.m_linearVelocity.SetV(v2);bB.m_angularVelocity=w2;};b2PrismaticJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var limitC=0;var oldLimitImpulse=0;var bA=this.m_bodyA;var bB=this.m_bodyB;var c1=bA.m_sweep.c;var a1=bA.m_sweep.a;var c2=bB.m_sweep.c;var a2=bB.m_sweep.a;var tMat;var tX=0;var m1=0;var m2=0;var i1=0;var i2=0;var linearError=0.0;var angularError=0.0;var active=false;var C2=0.0;var R1=b2Mat22.FromAngle(a1);var R2=b2Mat22.FromAngle(a2);tMat=R1;var r1X=this.m_localAnchor1.x-this.m_localCenterA.x;var r1Y=this.m_localAnchor1.y-this.m_localCenterA.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=R2;var r2X=this.m_localAnchor2.x-this.m_localCenterB.x;var r2Y=this.m_localAnchor2.y-this.m_localCenterB.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var dX=c2.x+r2X-c1.x-r1X;var dY=c2.y+r2Y-c1.y-r1Y;if(this.m_enableLimit){this.m_axis=b2Math.MulMV(R1,this.m_localXAxis1);this.m_a1=(dX+r1X)*this.m_axis.y-(dY+r1Y)*this.m_axis.x;this.m_a2=r2X*this.m_axis.y-r2Y*this.m_axis.x;var translation=this.m_axis.x*dX+this.m_axis.y*dY;if(b2Math.Abs(this.m_upperTranslation-this.m_lowerTranslation)<2.0*b2Settings.b2_linearSlop){C2=b2Math.Clamp(translation,-b2Settings.b2_maxLinearCorrection,b2Settings.b2_maxLinearCorrection);linearError=b2Math.Abs(translation);active=true;}else if(translation<=this.m_lowerTranslation){C2=b2Math.Clamp(translation-this.m_lowerTranslation+b2Settings.b2_linearSlop,-b2Settings.b2_maxLinearCorrection,0.0);linearError=this.m_lowerTranslation-translation;active=true;}else if(translation>=this.m_upperTranslation){C2=b2Math.Clamp(translation-this.m_upperTranslation+b2Settings.b2_linearSlop,0.0,b2Settings.b2_maxLinearCorrection);linearError=translation-this.m_upperTranslation;active=true;}}this.m_perp=b2Math.MulMV(R1,this.m_localYAxis1);this.m_s1=(dX+r1X)*this.m_perp.y-(dY+r1Y)*this.m_perp.x;this.m_s2=r2X*this.m_perp.y-r2Y*this.m_perp.x;var impulse=new b2Vec3();var C1X=this.m_perp.x*dX+this.m_perp.y*dY;var C1Y=a2-a1-this.m_refAngle;linearError=b2Math.Max(linearError,b2Math.Abs(C1X));angularError=b2Math.Abs(C1Y);if(active){m1=this.m_invMassA;m2=this.m_invMassB;i1=this.m_invIA;i2=this.m_invIB;this.m_K.col1.x=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;this.m_K.col1.y=i1*this.m_s1+i2*this.m_s2;this.m_K.col1.z=i1*this.m_s1*this.m_a1+i2*this.m_s2*this.m_a2;this.m_K.col2.x=this.m_K.col1.y;this.m_K.col2.y=i1+i2;this.m_K.col2.z=i1*this.m_a1+i2*this.m_a2;this.m_K.col3.x=this.m_K.col1.z;this.m_K.col3.y=this.m_K.col2.z;this.m_K.col3.z=m1+m2+i1*this.m_a1*this.m_a1+i2*this.m_a2*this.m_a2;this.m_K.Solve33(impulse,-C1X,-C1Y,-C2);}else{m1=this.m_invMassA;m2=this.m_invMassB;i1=this.m_invIA;i2=this.m_invIB;var k11=m1+m2+i1*this.m_s1*this.m_s1+i2*this.m_s2*this.m_s2;var k12=i1*this.m_s1+i2*this.m_s2;var k22=i1+i2;this.m_K.col1.Set(k11,k12,0.0);this.m_K.col2.Set(k12,k22,0.0);var impulse1=this.m_K.Solve22(new b2Vec2(),-C1X,-C1Y);impulse.x=impulse1.x;impulse.y=impulse1.y;impulse.z=0.0;}var PX=impulse.x*this.m_perp.x+impulse.z*this.m_axis.x;var PY=impulse.x*this.m_perp.y+impulse.z*this.m_axis.y;var L1=impulse.x*this.m_s1+impulse.y+impulse.z*this.m_a1;var L2=impulse.x*this.m_s2+impulse.y+impulse.z*this.m_a2;c1.x-=this.m_invMassA*PX;c1.y-=this.m_invMassA*PY;a1-=this.m_invIA*L1;c2.x+=this.m_invMassB*PX;c2.y+=this.m_invMassB*PY;a2+=this.m_invIB*L2;bA.m_sweep.a=a1;bB.m_sweep.a=a2;bA.SynchronizeTransform();bB.SynchronizeTransform();return linearError<=b2Settings.b2_linearSlop&&angularError<=b2Settings.b2_angularSlop;};Box2D.inherit(b2PrismaticJointDef,Box2D.Dynamics.Joints.b2JointDef);b2PrismaticJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2PrismaticJointDef.b2PrismaticJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();this.localAxisA=new b2Vec2();};b2PrismaticJointDef.prototype.b2PrismaticJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_prismaticJoint;this.localAxisA.Set(1.0,0.0);this.referenceAngle=0.0;this.enableLimit=false;this.lowerTranslation=0.0;this.upperTranslation=0.0;this.enableMotor=false;this.maxMotorForce=0.0;this.motorSpeed=0.0;};b2PrismaticJointDef.prototype.Initialize=function(bA,bB,anchor,axis){this.bodyA=bA;this.bodyB=bB;this.localAnchorA=this.bodyA.GetLocalPoint(anchor);this.localAnchorB=this.bodyB.GetLocalPoint(anchor);this.localAxisA=this.bodyA.GetLocalVector(axis);this.referenceAngle=this.bodyB.GetAngle()-this.bodyA.GetAngle();};Box2D.inherit(b2PulleyJoint,Box2D.Dynamics.Joints.b2Joint);b2PulleyJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2PulleyJoint.b2PulleyJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_groundAnchor1=new b2Vec2();this.m_groundAnchor2=new b2Vec2();this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_u1=new b2Vec2();this.m_u2=new b2Vec2();};b2PulleyJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2PulleyJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2PulleyJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse*this.m_u2.x,inv_dt*this.m_impulse*this.m_u2.y);};b2PulleyJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return 0.0;};b2PulleyJoint.prototype.GetGroundAnchorA=function(){var a=this.m_ground.m_xf.position.Copy();a.Add(this.m_groundAnchor1);return a;};b2PulleyJoint.prototype.GetGroundAnchorB=function(){var a=this.m_ground.m_xf.position.Copy();a.Add(this.m_groundAnchor2);return a;};b2PulleyJoint.prototype.GetLength1=function(){var p=this.m_bodyA.GetWorldPoint(this.m_localAnchor1);var sX=this.m_ground.m_xf.position.x+this.m_groundAnchor1.x;var sY=this.m_ground.m_xf.position.y+this.m_groundAnchor1.y;var dX=p.x-sX;var dY=p.y-sY;return Math.sqrt(dX*dX+dY*dY);};b2PulleyJoint.prototype.GetLength2=function(){var p=this.m_bodyB.GetWorldPoint(this.m_localAnchor2);var sX=this.m_ground.m_xf.position.x+this.m_groundAnchor2.x;var sY=this.m_ground.m_xf.position.y+this.m_groundAnchor2.y;var dX=p.x-sX;var dY=p.y-sY;return Math.sqrt(dX*dX+dY*dY);};b2PulleyJoint.prototype.GetRatio=function(){return this.m_ratio;};b2PulleyJoint.prototype.b2PulleyJoint=function(def){this.__super.b2Joint.call(this,def);var tMat;var tX=0;var tY=0;this.m_ground=this.m_bodyA.m_world.m_groundBody;this.m_groundAnchor1.x=def.groundAnchorA.x-this.m_ground.m_xf.position.x;this.m_groundAnchor1.y=def.groundAnchorA.y-this.m_ground.m_xf.position.y;this.m_groundAnchor2.x=def.groundAnchorB.x-this.m_ground.m_xf.position.x;this.m_groundAnchor2.y=def.groundAnchorB.y-this.m_ground.m_xf.position.y;this.m_localAnchor1.SetV(def.localAnchorA);this.m_localAnchor2.SetV(def.localAnchorB);this.m_ratio=def.ratio;this.m_constant=def.lengthA+this.m_ratio*def.lengthB;this.m_maxLength1=b2Math.Min(def.maxLengthA,this.m_constant-this.m_ratio*b2PulleyJoint.b2_minPulleyLength);this.m_maxLength2=b2Math.Min(def.maxLengthB,(this.m_constant-b2PulleyJoint.b2_minPulleyLength)/this.m_ratio);this.m_impulse=0.0;this.m_limitImpulse1=0.0;this.m_limitImpulse2=0.0;};b2PulleyJoint.prototype.InitVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var p1X=bA.m_sweep.c.x+r1X;var p1Y=bA.m_sweep.c.y+r1Y;var p2X=bB.m_sweep.c.x+r2X;var p2Y=bB.m_sweep.c.y+r2Y;var s1X=this.m_ground.m_xf.position.x+this.m_groundAnchor1.x;var s1Y=this.m_ground.m_xf.position.y+this.m_groundAnchor1.y;var s2X=this.m_ground.m_xf.position.x+this.m_groundAnchor2.x;var s2Y=this.m_ground.m_xf.position.y+this.m_groundAnchor2.y;this.m_u1.Set(p1X-s1X,p1Y-s1Y);this.m_u2.Set(p2X-s2X,p2Y-s2Y);var length1=this.m_u1.Length();var length2=this.m_u2.Length();if(length1>b2Settings.b2_linearSlop){this.m_u1.Multiply(1.0/length1);}else{this.m_u1.SetZero();}if(length2>b2Settings.b2_linearSlop){this.m_u2.Multiply(1.0/length2);}else{this.m_u2.SetZero();}var C=this.m_constant-length1-this.m_ratio*length2;if(C>0.0){this.m_state=b2Joint.e_inactiveLimit;this.m_impulse=0.0;}else{this.m_state=b2Joint.e_atUpperLimit;}if(length1<this.m_maxLength1){this.m_limitState1=b2Joint.e_inactiveLimit;this.m_limitImpulse1=0.0;}else{this.m_limitState1=b2Joint.e_atUpperLimit;}if(length2<this.m_maxLength2){this.m_limitState2=b2Joint.e_inactiveLimit;this.m_limitImpulse2=0.0;}else{this.m_limitState2=b2Joint.e_atUpperLimit;}var cr1u1=r1X*this.m_u1.y-r1Y*this.m_u1.x;var cr2u2=r2X*this.m_u2.y-r2Y*this.m_u2.x;this.m_limitMass1=bA.m_invMass+bA.m_invI*cr1u1*cr1u1;this.m_limitMass2=bB.m_invMass+bB.m_invI*cr2u2*cr2u2;this.m_pulleyMass=this.m_limitMass1+this.m_ratio*this.m_ratio*this.m_limitMass2;this.m_limitMass1=1.0/this.m_limitMass1;this.m_limitMass2=1.0/this.m_limitMass2;this.m_pulleyMass=1.0/this.m_pulleyMass;if(step.warmStarting){this.m_impulse*=step.dtRatio;this.m_limitImpulse1*=step.dtRatio;this.m_limitImpulse2*=step.dtRatio;var P1X=(-this.m_impulse-this.m_limitImpulse1)*this.m_u1.x;var P1Y=(-this.m_impulse-this.m_limitImpulse1)*this.m_u1.y;var P2X=(-this.m_ratio*this.m_impulse-this.m_limitImpulse2)*this.m_u2.x;var P2Y=(-this.m_ratio*this.m_impulse-this.m_limitImpulse2)*this.m_u2.y;bA.m_linearVelocity.x+=bA.m_invMass*P1X;bA.m_linearVelocity.y+=bA.m_invMass*P1Y;bA.m_angularVelocity+=bA.m_invI*(r1X*P1Y-r1Y*P1X);bB.m_linearVelocity.x+=bB.m_invMass*P2X;bB.m_linearVelocity.y+=bB.m_invMass*P2Y;bB.m_angularVelocity+=bB.m_invI*(r2X*P2Y-r2Y*P2X);}else{this.m_impulse=0.0;this.m_limitImpulse1=0.0;this.m_limitImpulse2=0.0;}};b2PulleyJoint.prototype.SolveVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;var tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var v1X=0;var v1Y=0;var v2X=0;var v2Y=0;var P1X=0;var P1Y=0;var P2X=0;var P2Y=0;var Cdot=0;var impulse=0;var oldImpulse=0;if(this.m_state==b2Joint.e_atUpperLimit){v1X=bA.m_linearVelocity.x+-bA.m_angularVelocity*r1Y;v1Y=bA.m_linearVelocity.y+bA.m_angularVelocity*r1X;v2X=bB.m_linearVelocity.x+-bB.m_angularVelocity*r2Y;v2Y=bB.m_linearVelocity.y+bB.m_angularVelocity*r2X;Cdot=-(this.m_u1.x*v1X+this.m_u1.y*v1Y)-this.m_ratio*(this.m_u2.x*v2X+this.m_u2.y*v2Y);impulse=this.m_pulleyMass*-Cdot;oldImpulse=this.m_impulse;this.m_impulse=b2Math.Max(0.0,this.m_impulse+impulse);impulse=this.m_impulse-oldImpulse;P1X=-impulse*this.m_u1.x;P1Y=-impulse*this.m_u1.y;P2X=-this.m_ratio*impulse*this.m_u2.x;P2Y=-this.m_ratio*impulse*this.m_u2.y;bA.m_linearVelocity.x+=bA.m_invMass*P1X;bA.m_linearVelocity.y+=bA.m_invMass*P1Y;bA.m_angularVelocity+=bA.m_invI*(r1X*P1Y-r1Y*P1X);bB.m_linearVelocity.x+=bB.m_invMass*P2X;bB.m_linearVelocity.y+=bB.m_invMass*P2Y;bB.m_angularVelocity+=bB.m_invI*(r2X*P2Y-r2Y*P2X);}if(this.m_limitState1==b2Joint.e_atUpperLimit){v1X=bA.m_linearVelocity.x+-bA.m_angularVelocity*r1Y;v1Y=bA.m_linearVelocity.y+bA.m_angularVelocity*r1X;Cdot=-(this.m_u1.x*v1X+this.m_u1.y*v1Y);impulse=-this.m_limitMass1*Cdot;oldImpulse=this.m_limitImpulse1;this.m_limitImpulse1=b2Math.Max(0.0,this.m_limitImpulse1+impulse);impulse=this.m_limitImpulse1-oldImpulse;P1X=-impulse*this.m_u1.x;P1Y=-impulse*this.m_u1.y;bA.m_linearVelocity.x+=bA.m_invMass*P1X;bA.m_linearVelocity.y+=bA.m_invMass*P1Y;bA.m_angularVelocity+=bA.m_invI*(r1X*P1Y-r1Y*P1X);}if(this.m_limitState2==b2Joint.e_atUpperLimit){v2X=bB.m_linearVelocity.x+-bB.m_angularVelocity*r2Y;v2Y=bB.m_linearVelocity.y+bB.m_angularVelocity*r2X;Cdot=-(this.m_u2.x*v2X+this.m_u2.y*v2Y);impulse=-this.m_limitMass2*Cdot;oldImpulse=this.m_limitImpulse2;this.m_limitImpulse2=b2Math.Max(0.0,this.m_limitImpulse2+impulse);impulse=this.m_limitImpulse2-oldImpulse;P2X=-impulse*this.m_u2.x;P2Y=-impulse*this.m_u2.y;bB.m_linearVelocity.x+=bB.m_invMass*P2X;bB.m_linearVelocity.y+=bB.m_invMass*P2Y;bB.m_angularVelocity+=bB.m_invI*(r2X*P2Y-r2Y*P2X);}};b2PulleyJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var s1X=this.m_ground.m_xf.position.x+this.m_groundAnchor1.x;var s1Y=this.m_ground.m_xf.position.y+this.m_groundAnchor1.y;var s2X=this.m_ground.m_xf.position.x+this.m_groundAnchor2.x;var s2Y=this.m_ground.m_xf.position.y+this.m_groundAnchor2.y;var r1X=0;var r1Y=0;var r2X=0;var r2Y=0;var p1X=0;var p1Y=0;var p2X=0;var p2Y=0;var length1=0;var length2=0;var C=0;var impulse=0;var oldImpulse=0;var oldLimitPositionImpulse=0;var tX=0;var linearError=0.0;if(this.m_state==b2Joint.e_atUpperLimit){tMat=bA.m_xf.R;r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;p1X=bA.m_sweep.c.x+r1X;p1Y=bA.m_sweep.c.y+r1Y;p2X=bB.m_sweep.c.x+r2X;p2Y=bB.m_sweep.c.y+r2Y;this.m_u1.Set(p1X-s1X,p1Y-s1Y);this.m_u2.Set(p2X-s2X,p2Y-s2Y);length1=this.m_u1.Length();length2=this.m_u2.Length();if(length1>b2Settings.b2_linearSlop){this.m_u1.Multiply(1.0/length1);}else{this.m_u1.SetZero();}if(length2>b2Settings.b2_linearSlop){this.m_u2.Multiply(1.0/length2);}else{this.m_u2.SetZero();}C=this.m_constant-length1-this.m_ratio*length2;linearError=b2Math.Max(linearError,-C);C=b2Math.Clamp(C+b2Settings.b2_linearSlop,-b2Settings.b2_maxLinearCorrection,0.0);impulse=-this.m_pulleyMass*C;p1X=-impulse*this.m_u1.x;p1Y=-impulse*this.m_u1.y;p2X=-this.m_ratio*impulse*this.m_u2.x;p2Y=-this.m_ratio*impulse*this.m_u2.y;bA.m_sweep.c.x+=bA.m_invMass*p1X;bA.m_sweep.c.y+=bA.m_invMass*p1Y;bA.m_sweep.a+=bA.m_invI*(r1X*p1Y-r1Y*p1X);bB.m_sweep.c.x+=bB.m_invMass*p2X;bB.m_sweep.c.y+=bB.m_invMass*p2Y;bB.m_sweep.a+=bB.m_invI*(r2X*p2Y-r2Y*p2X);bA.SynchronizeTransform();bB.SynchronizeTransform();}if(this.m_limitState1==b2Joint.e_atUpperLimit){tMat=bA.m_xf.R;r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;p1X=bA.m_sweep.c.x+r1X;p1Y=bA.m_sweep.c.y+r1Y;this.m_u1.Set(p1X-s1X,p1Y-s1Y);length1=this.m_u1.Length();if(length1>b2Settings.b2_linearSlop){this.m_u1.x*=1.0/length1;this.m_u1.y*=1.0/length1;}else{this.m_u1.SetZero();}C=this.m_maxLength1-length1;linearError=b2Math.Max(linearError,-C);C=b2Math.Clamp(C+b2Settings.b2_linearSlop,-b2Settings.b2_maxLinearCorrection,0.0);impulse=-this.m_limitMass1*C;p1X=-impulse*this.m_u1.x;p1Y=-impulse*this.m_u1.y;bA.m_sweep.c.x+=bA.m_invMass*p1X;bA.m_sweep.c.y+=bA.m_invMass*p1Y;bA.m_sweep.a+=bA.m_invI*(r1X*p1Y-r1Y*p1X);bA.SynchronizeTransform();}if(this.m_limitState2==b2Joint.e_atUpperLimit){tMat=bB.m_xf.R;r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;p2X=bB.m_sweep.c.x+r2X;p2Y=bB.m_sweep.c.y+r2Y;this.m_u2.Set(p2X-s2X,p2Y-s2Y);length2=this.m_u2.Length();if(length2>b2Settings.b2_linearSlop){this.m_u2.x*=1.0/length2;this.m_u2.y*=1.0/length2;}else{this.m_u2.SetZero();}C=this.m_maxLength2-length2;linearError=b2Math.Max(linearError,-C);C=b2Math.Clamp(C+b2Settings.b2_linearSlop,-b2Settings.b2_maxLinearCorrection,0.0);impulse=-this.m_limitMass2*C;p2X=-impulse*this.m_u2.x;p2Y=-impulse*this.m_u2.y;bB.m_sweep.c.x+=bB.m_invMass*p2X;bB.m_sweep.c.y+=bB.m_invMass*p2Y;bB.m_sweep.a+=bB.m_invI*(r2X*p2Y-r2Y*p2X);bB.SynchronizeTransform();}return linearError<b2Settings.b2_linearSlop;};Box2D.postDefs.push(function(){Box2D.Dynamics.Joints.b2PulleyJoint.b2_minPulleyLength=2.0;});Box2D.inherit(b2PulleyJointDef,Box2D.Dynamics.Joints.b2JointDef);b2PulleyJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2PulleyJointDef.b2PulleyJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.groundAnchorA=new b2Vec2();this.groundAnchorB=new b2Vec2();this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();};b2PulleyJointDef.prototype.b2PulleyJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_pulleyJoint;this.groundAnchorA.Set(-1.0,1.0);this.groundAnchorB.Set(1.0,1.0);this.localAnchorA.Set(-1.0,0.0);this.localAnchorB.Set(1.0,0.0);this.lengthA=0.0;this.maxLengthA=0.0;this.lengthB=0.0;this.maxLengthB=0.0;this.ratio=1.0;this.collideConnected=true;};b2PulleyJointDef.prototype.Initialize=function(bA,bB,gaA,gaB,anchorA,anchorB,r){if(r===undefined)r=0;this.bodyA=bA;this.bodyB=bB;this.groundAnchorA.SetV(gaA);this.groundAnchorB.SetV(gaB);this.localAnchorA=this.bodyA.GetLocalPoint(anchorA);this.localAnchorB=this.bodyB.GetLocalPoint(anchorB);var d1X=anchorA.x-gaA.x;var d1Y=anchorA.y-gaA.y;this.lengthA=Math.sqrt(d1X*d1X+d1Y*d1Y);var d2X=anchorB.x-gaB.x;var d2Y=anchorB.y-gaB.y;this.lengthB=Math.sqrt(d2X*d2X+d2Y*d2Y);this.ratio=r;var C=this.lengthA+this.ratio*this.lengthB;this.maxLengthA=C-this.ratio*b2PulleyJoint.b2_minPulleyLength;this.maxLengthB=(C-b2PulleyJoint.b2_minPulleyLength)/this.ratio;};Box2D.inherit(b2RevoluteJoint,Box2D.Dynamics.Joints.b2Joint);b2RevoluteJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2RevoluteJoint.b2RevoluteJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.K=new b2Mat22();this.K1=new b2Mat22();this.K2=new b2Mat22();this.K3=new b2Mat22();this.impulse3=new b2Vec3();this.impulse2=new b2Vec2();this.reduced=new b2Vec2();this.m_localAnchor1=new b2Vec2();this.m_localAnchor2=new b2Vec2();this.m_impulse=new b2Vec3();this.m_mass=new b2Mat33();};b2RevoluteJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchor1);};b2RevoluteJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchor2);};b2RevoluteJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse.x,inv_dt*this.m_impulse.y);};b2RevoluteJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return inv_dt*this.m_impulse.z;};b2RevoluteJoint.prototype.GetJointAngle=function(){return this.m_bodyB.m_sweep.a-this.m_bodyA.m_sweep.a-this.m_referenceAngle;};b2RevoluteJoint.prototype.GetJointSpeed=function(){return this.m_bodyB.m_angularVelocity-this.m_bodyA.m_angularVelocity;};b2RevoluteJoint.prototype.IsLimitEnabled=function(){return this.m_enableLimit;};b2RevoluteJoint.prototype.EnableLimit=function(flag){this.m_enableLimit=flag;};b2RevoluteJoint.prototype.GetLowerLimit=function(){return this.m_lowerAngle;};b2RevoluteJoint.prototype.GetUpperLimit=function(){return this.m_upperAngle;};b2RevoluteJoint.prototype.SetLimits=function(lower,upper){if(lower===undefined)lower=0;if(upper===undefined)upper=0;this.m_lowerAngle=lower;this.m_upperAngle=upper;};b2RevoluteJoint.prototype.IsMotorEnabled=function(){this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);return this.m_enableMotor;};b2RevoluteJoint.prototype.EnableMotor=function(flag){this.m_enableMotor=flag;};b2RevoluteJoint.prototype.SetMotorSpeed=function(speed){if(speed===undefined)speed=0;this.m_bodyA.SetAwake(true);this.m_bodyB.SetAwake(true);this.m_motorSpeed=speed;};b2RevoluteJoint.prototype.GetMotorSpeed=function(){return this.m_motorSpeed;};b2RevoluteJoint.prototype.SetMaxMotorTorque=function(torque){if(torque===undefined)torque=0;this.m_maxMotorTorque=torque;};b2RevoluteJoint.prototype.GetMotorTorque=function(){return this.m_maxMotorTorque;};b2RevoluteJoint.prototype.b2RevoluteJoint=function(def){this.__super.b2Joint.call(this,def);this.m_localAnchor1.SetV(def.localAnchorA);this.m_localAnchor2.SetV(def.localAnchorB);this.m_referenceAngle=def.referenceAngle;this.m_impulse.SetZero();this.m_motorImpulse=0.0;this.m_lowerAngle=def.lowerAngle;this.m_upperAngle=def.upperAngle;this.m_maxMotorTorque=def.maxMotorTorque;this.m_motorSpeed=def.motorSpeed;this.m_enableLimit=def.enableLimit;this.m_enableMotor=def.enableMotor;this.m_limitState=b2Joint.e_inactiveLimit;};b2RevoluteJoint.prototype.InitVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var tX=0;if(this.m_enableMotor||this.m_enableLimit){}tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var m1=bA.m_invMass;var m2=bB.m_invMass;var i1=bA.m_invI;var i2=bB.m_invI;this.m_mass.col1.x=m1+m2+r1Y*r1Y*i1+r2Y*r2Y*i2;this.m_mass.col2.x=-r1Y*r1X*i1-r2Y*r2X*i2;this.m_mass.col3.x=-r1Y*i1-r2Y*i2;this.m_mass.col1.y=this.m_mass.col2.x;this.m_mass.col2.y=m1+m2+r1X*r1X*i1+r2X*r2X*i2;this.m_mass.col3.y=r1X*i1+r2X*i2;this.m_mass.col1.z=this.m_mass.col3.x;this.m_mass.col2.z=this.m_mass.col3.y;this.m_mass.col3.z=i1+i2;this.m_motorMass=1.0/(i1+i2);if(this.m_enableMotor==false){this.m_motorImpulse=0.0;}if(this.m_enableLimit){var jointAngle=bB.m_sweep.a-bA.m_sweep.a-this.m_referenceAngle;if(b2Math.Abs(this.m_upperAngle-this.m_lowerAngle)<2.0*b2Settings.b2_angularSlop){this.m_limitState=b2Joint.e_equalLimits;}else if(jointAngle<=this.m_lowerAngle){if(this.m_limitState!=b2Joint.e_atLowerLimit){this.m_impulse.z=0.0;}this.m_limitState=b2Joint.e_atLowerLimit;}else if(jointAngle>=this.m_upperAngle){if(this.m_limitState!=b2Joint.e_atUpperLimit){this.m_impulse.z=0.0;}this.m_limitState=b2Joint.e_atUpperLimit;}else{this.m_limitState=b2Joint.e_inactiveLimit;this.m_impulse.z=0.0;}}else{this.m_limitState=b2Joint.e_inactiveLimit;}if(step.warmStarting){this.m_impulse.x*=step.dtRatio;this.m_impulse.y*=step.dtRatio;this.m_motorImpulse*=step.dtRatio;var PX=this.m_impulse.x;var PY=this.m_impulse.y;bA.m_linearVelocity.x-=m1*PX;bA.m_linearVelocity.y-=m1*PY;bA.m_angularVelocity-=i1*(r1X*PY-r1Y*PX+this.m_motorImpulse+this.m_impulse.z);bB.m_linearVelocity.x+=m2*PX;bB.m_linearVelocity.y+=m2*PY;bB.m_angularVelocity+=i2*(r2X*PY-r2Y*PX+this.m_motorImpulse+this.m_impulse.z);}else{this.m_impulse.SetZero();this.m_motorImpulse=0.0;}};b2RevoluteJoint.prototype.SolveVelocityConstraints=function(step){var bA=this.m_bodyA;var bB=this.m_bodyB;var tMat;var tX=0;var newImpulse=0;var r1X=0;var r1Y=0;var r2X=0;var r2Y=0;var v1=bA.m_linearVelocity;var w1=bA.m_angularVelocity;var v2=bB.m_linearVelocity;var w2=bB.m_angularVelocity;var m1=bA.m_invMass;var m2=bB.m_invMass;var i1=bA.m_invI;var i2=bB.m_invI;if(this.m_enableMotor&&this.m_limitState!=b2Joint.e_equalLimits){var Cdot=w2-w1-this.m_motorSpeed;var impulse=this.m_motorMass*-Cdot;var oldImpulse=this.m_motorImpulse;var maxImpulse=step.dt*this.m_maxMotorTorque;this.m_motorImpulse=b2Math.Clamp(this.m_motorImpulse+impulse,-maxImpulse,maxImpulse);impulse=this.m_motorImpulse-oldImpulse;w1-=i1*impulse;w2+=i2*impulse;}if(this.m_enableLimit&&this.m_limitState!=b2Joint.e_inactiveLimit){tMat=bA.m_xf.R;r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var Cdot1X=v2.x+-w2*r2Y-v1.x- -w1*r1Y;var Cdot1Y=v2.y+w2*r2X-v1.y-w1*r1X;var Cdot2=w2-w1;this.m_mass.Solve33(this.impulse3,-Cdot1X,-Cdot1Y,-Cdot2);if(this.m_limitState==b2Joint.e_equalLimits){this.m_impulse.Add(this.impulse3);}else if(this.m_limitState==b2Joint.e_atLowerLimit){newImpulse=this.m_impulse.z+this.impulse3.z;if(newImpulse<0.0){this.m_mass.Solve22(this.reduced,-Cdot1X,-Cdot1Y);this.impulse3.x=this.reduced.x;this.impulse3.y=this.reduced.y;this.impulse3.z=-this.m_impulse.z;this.m_impulse.x+=this.reduced.x;this.m_impulse.y+=this.reduced.y;this.m_impulse.z=0.0;}}else if(this.m_limitState==b2Joint.e_atUpperLimit){newImpulse=this.m_impulse.z+this.impulse3.z;if(newImpulse>0.0){this.m_mass.Solve22(this.reduced,-Cdot1X,-Cdot1Y);this.impulse3.x=this.reduced.x;this.impulse3.y=this.reduced.y;this.impulse3.z=-this.m_impulse.z;this.m_impulse.x+=this.reduced.x;this.m_impulse.y+=this.reduced.y;this.m_impulse.z=0.0;}}v1.x-=m1*this.impulse3.x;v1.y-=m1*this.impulse3.y;w1-=i1*(r1X*this.impulse3.y-r1Y*this.impulse3.x+this.impulse3.z);v2.x+=m2*this.impulse3.x;v2.y+=m2*this.impulse3.y;w2+=i2*(r2X*this.impulse3.y-r2Y*this.impulse3.x+this.impulse3.z);}else{tMat=bA.m_xf.R;r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var CdotX=v2.x+-w2*r2Y-v1.x- -w1*r1Y;var CdotY=v2.y+w2*r2X-v1.y-w1*r1X;this.m_mass.Solve22(this.impulse2,-CdotX,-CdotY);this.m_impulse.x+=this.impulse2.x;this.m_impulse.y+=this.impulse2.y;v1.x-=m1*this.impulse2.x;v1.y-=m1*this.impulse2.y;w1-=i1*(r1X*this.impulse2.y-r1Y*this.impulse2.x);v2.x+=m2*this.impulse2.x;v2.y+=m2*this.impulse2.y;w2+=i2*(r2X*this.impulse2.y-r2Y*this.impulse2.x);}bA.m_linearVelocity.SetV(v1);bA.m_angularVelocity=w1;bB.m_linearVelocity.SetV(v2);bB.m_angularVelocity=w2;};b2RevoluteJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var oldLimitImpulse=0;var C=0;var tMat;var bA=this.m_bodyA;var bB=this.m_bodyB;var angularError=0.0;var positionError=0.0;var tX=0;var impulseX=0;var impulseY=0;if(this.m_enableLimit&&this.m_limitState!=b2Joint.e_inactiveLimit){var angle=bB.m_sweep.a-bA.m_sweep.a-this.m_referenceAngle;var limitImpulse=0.0;if(this.m_limitState==b2Joint.e_equalLimits){C=b2Math.Clamp(angle-this.m_lowerAngle,-b2Settings.b2_maxAngularCorrection,b2Settings.b2_maxAngularCorrection);limitImpulse=-this.m_motorMass*C;angularError=b2Math.Abs(C);}else if(this.m_limitState==b2Joint.e_atLowerLimit){C=angle-this.m_lowerAngle;angularError=-C;C=b2Math.Clamp(C+b2Settings.b2_angularSlop,-b2Settings.b2_maxAngularCorrection,0.0);limitImpulse=-this.m_motorMass*C;}else if(this.m_limitState==b2Joint.e_atUpperLimit){C=angle-this.m_upperAngle;angularError=C;C=b2Math.Clamp(C-b2Settings.b2_angularSlop,0.0,b2Settings.b2_maxAngularCorrection);limitImpulse=-this.m_motorMass*C;}bA.m_sweep.a-=bA.m_invI*limitImpulse;bB.m_sweep.a+=bB.m_invI*limitImpulse;bA.SynchronizeTransform();bB.SynchronizeTransform();}{tMat=bA.m_xf.R;var r1X=this.m_localAnchor1.x-bA.m_sweep.localCenter.x;var r1Y=this.m_localAnchor1.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*r1X+tMat.col2.x*r1Y;r1Y=tMat.col1.y*r1X+tMat.col2.y*r1Y;r1X=tX;tMat=bB.m_xf.R;var r2X=this.m_localAnchor2.x-bB.m_sweep.localCenter.x;var r2Y=this.m_localAnchor2.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*r2X+tMat.col2.x*r2Y;r2Y=tMat.col1.y*r2X+tMat.col2.y*r2Y;r2X=tX;var CX=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;var CY=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;var CLengthSquared=CX*CX+CY*CY;var CLength=Math.sqrt(CLengthSquared);positionError=CLength;var invMass1=bA.m_invMass;var invMass2=bB.m_invMass;var invI1=bA.m_invI;var invI2=bB.m_invI;var k_allowedStretch=10.0*b2Settings.b2_linearSlop;if(CLengthSquared>k_allowedStretch*k_allowedStretch){var uX=CX/CLength;var uY=CY/CLength;var k=invMass1+invMass2;var m=1.0/k;impulseX=m*-CX;impulseY=m*-CY;var k_beta=0.5;bA.m_sweep.c.x-=k_beta*invMass1*impulseX;bA.m_sweep.c.y-=k_beta*invMass1*impulseY;bB.m_sweep.c.x+=k_beta*invMass2*impulseX;bB.m_sweep.c.y+=k_beta*invMass2*impulseY;CX=bB.m_sweep.c.x+r2X-bA.m_sweep.c.x-r1X;CY=bB.m_sweep.c.y+r2Y-bA.m_sweep.c.y-r1Y;}this.K1.col1.x=invMass1+invMass2;this.K1.col2.x=0.0;this.K1.col1.y=0.0;this.K1.col2.y=invMass1+invMass2;this.K2.col1.x=invI1*r1Y*r1Y;this.K2.col2.x=-invI1*r1X*r1Y;this.K2.col1.y=-invI1*r1X*r1Y;this.K2.col2.y=invI1*r1X*r1X;this.K3.col1.x=invI2*r2Y*r2Y;this.K3.col2.x=-invI2*r2X*r2Y;this.K3.col1.y=-invI2*r2X*r2Y;this.K3.col2.y=invI2*r2X*r2X;this.K.SetM(this.K1);this.K.AddM(this.K2);this.K.AddM(this.K3);this.K.Solve(b2RevoluteJoint.tImpulse,-CX,-CY);impulseX=b2RevoluteJoint.tImpulse.x;impulseY=b2RevoluteJoint.tImpulse.y;bA.m_sweep.c.x-=bA.m_invMass*impulseX;bA.m_sweep.c.y-=bA.m_invMass*impulseY;bA.m_sweep.a-=bA.m_invI*(r1X*impulseY-r1Y*impulseX);bB.m_sweep.c.x+=bB.m_invMass*impulseX;bB.m_sweep.c.y+=bB.m_invMass*impulseY;bB.m_sweep.a+=bB.m_invI*(r2X*impulseY-r2Y*impulseX);bA.SynchronizeTransform();bB.SynchronizeTransform();}return positionError<=b2Settings.b2_linearSlop&&angularError<=b2Settings.b2_angularSlop;};Box2D.postDefs.push(function(){Box2D.Dynamics.Joints.b2RevoluteJoint.tImpulse=new b2Vec2();});Box2D.inherit(b2RevoluteJointDef,Box2D.Dynamics.Joints.b2JointDef);b2RevoluteJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2RevoluteJointDef.b2RevoluteJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();};b2RevoluteJointDef.prototype.b2RevoluteJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_revoluteJoint;this.localAnchorA.Set(0.0,0.0);this.localAnchorB.Set(0.0,0.0);this.referenceAngle=0.0;this.lowerAngle=0.0;this.upperAngle=0.0;this.maxMotorTorque=0.0;this.motorSpeed=0.0;this.enableLimit=false;this.enableMotor=false;};b2RevoluteJointDef.prototype.Initialize=function(bA,bB,anchor){this.bodyA=bA;this.bodyB=bB;this.localAnchorA=this.bodyA.GetLocalPoint(anchor);this.localAnchorB=this.bodyB.GetLocalPoint(anchor);this.referenceAngle=this.bodyB.GetAngle()-this.bodyA.GetAngle();};Box2D.inherit(b2WeldJoint,Box2D.Dynamics.Joints.b2Joint);b2WeldJoint.prototype.__super=Box2D.Dynamics.Joints.b2Joint.prototype;b2WeldJoint.b2WeldJoint=function(){Box2D.Dynamics.Joints.b2Joint.b2Joint.apply(this,arguments);this.m_localAnchorA=new b2Vec2();this.m_localAnchorB=new b2Vec2();this.m_impulse=new b2Vec3();this.m_mass=new b2Mat33();};b2WeldJoint.prototype.GetAnchorA=function(){return this.m_bodyA.GetWorldPoint(this.m_localAnchorA);};b2WeldJoint.prototype.GetAnchorB=function(){return this.m_bodyB.GetWorldPoint(this.m_localAnchorB);};b2WeldJoint.prototype.GetReactionForce=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return new b2Vec2(inv_dt*this.m_impulse.x,inv_dt*this.m_impulse.y);};b2WeldJoint.prototype.GetReactionTorque=function(inv_dt){if(inv_dt===undefined)inv_dt=0;return inv_dt*this.m_impulse.z;};b2WeldJoint.prototype.b2WeldJoint=function(def){this.__super.b2Joint.call(this,def);this.m_localAnchorA.SetV(def.localAnchorA);this.m_localAnchorB.SetV(def.localAnchorB);this.m_referenceAngle=def.referenceAngle;this.m_impulse.SetZero();this.m_mass=new b2Mat33();};b2WeldJoint.prototype.InitVelocityConstraints=function(step){var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var rAX=this.m_localAnchorA.x-bA.m_sweep.localCenter.x;var rAY=this.m_localAnchorA.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rAX+tMat.col2.x*rAY;rAY=tMat.col1.y*rAX+tMat.col2.y*rAY;rAX=tX;tMat=bB.m_xf.R;var rBX=this.m_localAnchorB.x-bB.m_sweep.localCenter.x;var rBY=this.m_localAnchorB.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rBX+tMat.col2.x*rBY;rBY=tMat.col1.y*rBX+tMat.col2.y*rBY;rBX=tX;var mA=bA.m_invMass;var mB=bB.m_invMass;var iA=bA.m_invI;var iB=bB.m_invI;this.m_mass.col1.x=mA+mB+rAY*rAY*iA+rBY*rBY*iB;this.m_mass.col2.x=-rAY*rAX*iA-rBY*rBX*iB;this.m_mass.col3.x=-rAY*iA-rBY*iB;this.m_mass.col1.y=this.m_mass.col2.x;this.m_mass.col2.y=mA+mB+rAX*rAX*iA+rBX*rBX*iB;this.m_mass.col3.y=rAX*iA+rBX*iB;this.m_mass.col1.z=this.m_mass.col3.x;this.m_mass.col2.z=this.m_mass.col3.y;this.m_mass.col3.z=iA+iB;if(step.warmStarting){this.m_impulse.x*=step.dtRatio;this.m_impulse.y*=step.dtRatio;this.m_impulse.z*=step.dtRatio;bA.m_linearVelocity.x-=mA*this.m_impulse.x;bA.m_linearVelocity.y-=mA*this.m_impulse.y;bA.m_angularVelocity-=iA*(rAX*this.m_impulse.y-rAY*this.m_impulse.x+this.m_impulse.z);bB.m_linearVelocity.x+=mB*this.m_impulse.x;bB.m_linearVelocity.y+=mB*this.m_impulse.y;bB.m_angularVelocity+=iB*(rBX*this.m_impulse.y-rBY*this.m_impulse.x+this.m_impulse.z);}else{this.m_impulse.SetZero();}};b2WeldJoint.prototype.SolveVelocityConstraints=function(step){var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;var vA=bA.m_linearVelocity;var wA=bA.m_angularVelocity;var vB=bB.m_linearVelocity;var wB=bB.m_angularVelocity;var mA=bA.m_invMass;var mB=bB.m_invMass;var iA=bA.m_invI;var iB=bB.m_invI;tMat=bA.m_xf.R;var rAX=this.m_localAnchorA.x-bA.m_sweep.localCenter.x;var rAY=this.m_localAnchorA.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rAX+tMat.col2.x*rAY;rAY=tMat.col1.y*rAX+tMat.col2.y*rAY;rAX=tX;tMat=bB.m_xf.R;var rBX=this.m_localAnchorB.x-bB.m_sweep.localCenter.x;var rBY=this.m_localAnchorB.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rBX+tMat.col2.x*rBY;rBY=tMat.col1.y*rBX+tMat.col2.y*rBY;rBX=tX;var Cdot1X=vB.x-wB*rBY-vA.x+wA*rAY;var Cdot1Y=vB.y+wB*rBX-vA.y-wA*rAX;var Cdot2=wB-wA;var impulse=new b2Vec3();this.m_mass.Solve33(impulse,-Cdot1X,-Cdot1Y,-Cdot2);this.m_impulse.Add(impulse);vA.x-=mA*impulse.x;vA.y-=mA*impulse.y;wA-=iA*(rAX*impulse.y-rAY*impulse.x+impulse.z);vB.x+=mB*impulse.x;vB.y+=mB*impulse.y;wB+=iB*(rBX*impulse.y-rBY*impulse.x+impulse.z);bA.m_angularVelocity=wA;bB.m_angularVelocity=wB;};b2WeldJoint.prototype.SolvePositionConstraints=function(baumgarte){if(baumgarte===undefined)baumgarte=0;var tMat;var tX=0;var bA=this.m_bodyA;var bB=this.m_bodyB;tMat=bA.m_xf.R;var rAX=this.m_localAnchorA.x-bA.m_sweep.localCenter.x;var rAY=this.m_localAnchorA.y-bA.m_sweep.localCenter.y;tX=tMat.col1.x*rAX+tMat.col2.x*rAY;rAY=tMat.col1.y*rAX+tMat.col2.y*rAY;rAX=tX;tMat=bB.m_xf.R;var rBX=this.m_localAnchorB.x-bB.m_sweep.localCenter.x;var rBY=this.m_localAnchorB.y-bB.m_sweep.localCenter.y;tX=tMat.col1.x*rBX+tMat.col2.x*rBY;rBY=tMat.col1.y*rBX+tMat.col2.y*rBY;rBX=tX;var mA=bA.m_invMass;var mB=bB.m_invMass;var iA=bA.m_invI;var iB=bB.m_invI;var C1X=bB.m_sweep.c.x+rBX-bA.m_sweep.c.x-rAX;var C1Y=bB.m_sweep.c.y+rBY-bA.m_sweep.c.y-rAY;var C2=bB.m_sweep.a-bA.m_sweep.a-this.m_referenceAngle;var k_allowedStretch=10.0*b2Settings.b2_linearSlop;var positionError=Math.sqrt(C1X*C1X+C1Y*C1Y);var angularError=b2Math.Abs(C2);if(positionError>k_allowedStretch){iA*=1.0;iB*=1.0;}this.m_mass.col1.x=mA+mB+rAY*rAY*iA+rBY*rBY*iB;this.m_mass.col2.x=-rAY*rAX*iA-rBY*rBX*iB;this.m_mass.col3.x=-rAY*iA-rBY*iB;this.m_mass.col1.y=this.m_mass.col2.x;this.m_mass.col2.y=mA+mB+rAX*rAX*iA+rBX*rBX*iB;this.m_mass.col3.y=rAX*iA+rBX*iB;this.m_mass.col1.z=this.m_mass.col3.x;this.m_mass.col2.z=this.m_mass.col3.y;this.m_mass.col3.z=iA+iB;var impulse=new b2Vec3();this.m_mass.Solve33(impulse,-C1X,-C1Y,-C2);bA.m_sweep.c.x-=mA*impulse.x;bA.m_sweep.c.y-=mA*impulse.y;bA.m_sweep.a-=iA*(rAX*impulse.y-rAY*impulse.x+impulse.z);bB.m_sweep.c.x+=mB*impulse.x;bB.m_sweep.c.y+=mB*impulse.y;bB.m_sweep.a+=iB*(rBX*impulse.y-rBY*impulse.x+impulse.z);bA.SynchronizeTransform();bB.SynchronizeTransform();return positionError<=b2Settings.b2_linearSlop&&angularError<=b2Settings.b2_angularSlop;};Box2D.inherit(b2WeldJointDef,Box2D.Dynamics.Joints.b2JointDef);b2WeldJointDef.prototype.__super=Box2D.Dynamics.Joints.b2JointDef.prototype;b2WeldJointDef.b2WeldJointDef=function(){Box2D.Dynamics.Joints.b2JointDef.b2JointDef.apply(this,arguments);this.localAnchorA=new b2Vec2();this.localAnchorB=new b2Vec2();};b2WeldJointDef.prototype.b2WeldJointDef=function(){this.__super.b2JointDef.call(this);this.type=b2Joint.e_weldJoint;this.referenceAngle=0.0;};b2WeldJointDef.prototype.Initialize=function(bA,bB,anchor){this.bodyA=bA;this.bodyB=bB;this.localAnchorA.SetV(this.bodyA.GetLocalPoint(anchor));this.localAnchorB.SetV(this.bodyB.GetLocalPoint(anchor));this.referenceAngle=this.bodyB.GetAngle()-this.bodyA.GetAngle();};})();(function(){var b2DebugDraw=Box2D.Dynamics.b2DebugDraw;b2DebugDraw.b2DebugDraw=function(){this.m_drawScale=1.0;this.m_lineThickness=1.0;this.m_alpha=1.0;this.m_fillAlpha=1.0;this.m_xformScale=1.0;var __this=this;//#WORKAROUND
	this.m_sprite={graphics:{clear:function clear(){__this.m_ctx.clearRect(0,0,__this.m_ctx.canvas.width,__this.m_ctx.canvas.height);}}};};b2DebugDraw.prototype._color=function(color,alpha){return"rgba("+((color&0xFF0000)>>16)+","+((color&0xFF00)>>8)+","+(color&0xFF)+","+alpha+")";};b2DebugDraw.prototype.b2DebugDraw=function(){this.m_drawFlags=0;};b2DebugDraw.prototype.SetFlags=function(flags){if(flags===undefined)flags=0;this.m_drawFlags=flags;};b2DebugDraw.prototype.GetFlags=function(){return this.m_drawFlags;};b2DebugDraw.prototype.AppendFlags=function(flags){if(flags===undefined)flags=0;this.m_drawFlags|=flags;};b2DebugDraw.prototype.ClearFlags=function(flags){if(flags===undefined)flags=0;this.m_drawFlags&=~flags;};b2DebugDraw.prototype.SetSprite=function(sprite){this.m_ctx=sprite;};b2DebugDraw.prototype.GetSprite=function(){return this.m_ctx;};b2DebugDraw.prototype.SetDrawScale=function(drawScale){if(drawScale===undefined)drawScale=0;this.m_drawScale=drawScale;};b2DebugDraw.prototype.GetDrawScale=function(){return this.m_drawScale;};b2DebugDraw.prototype.SetLineThickness=function(lineThickness){if(lineThickness===undefined)lineThickness=0;this.m_lineThickness=lineThickness;this.m_ctx.strokeWidth=lineThickness;};b2DebugDraw.prototype.GetLineThickness=function(){return this.m_lineThickness;};b2DebugDraw.prototype.SetAlpha=function(alpha){if(alpha===undefined)alpha=0;this.m_alpha=alpha;};b2DebugDraw.prototype.GetAlpha=function(){return this.m_alpha;};b2DebugDraw.prototype.SetFillAlpha=function(alpha){if(alpha===undefined)alpha=0;this.m_fillAlpha=alpha;};b2DebugDraw.prototype.GetFillAlpha=function(){return this.m_fillAlpha;};b2DebugDraw.prototype.SetXFormScale=function(xformScale){if(xformScale===undefined)xformScale=0;this.m_xformScale=xformScale;};b2DebugDraw.prototype.GetXFormScale=function(){return this.m_xformScale;};b2DebugDraw.prototype.DrawPolygon=function(vertices,vertexCount,color){if(!vertexCount)return;var s=this.m_ctx;var drawScale=this.m_drawScale;s.beginPath();s.strokeStyle=this._color(color.color,this.m_alpha);s.moveTo(vertices[0].x*drawScale,vertices[0].y*drawScale);for(var i=1;i<vertexCount;i++){s.lineTo(vertices[i].x*drawScale,vertices[i].y*drawScale);}s.lineTo(vertices[0].x*drawScale,vertices[0].y*drawScale);s.closePath();s.stroke();};b2DebugDraw.prototype.DrawSolidPolygon=function(vertices,vertexCount,color){if(!vertexCount)return;var s=this.m_ctx;var drawScale=this.m_drawScale;s.beginPath();s.strokeStyle=this._color(color.color,this.m_alpha);s.fillStyle=this._color(color.color,this.m_fillAlpha);s.moveTo(vertices[0].x*drawScale,vertices[0].y*drawScale);for(var i=1;i<vertexCount;i++){s.lineTo(vertices[i].x*drawScale,vertices[i].y*drawScale);}s.lineTo(vertices[0].x*drawScale,vertices[0].y*drawScale);s.closePath();s.fill();s.stroke();};b2DebugDraw.prototype.DrawCircle=function(center,radius,color){if(!radius)return;var s=this.m_ctx;var drawScale=this.m_drawScale;s.beginPath();s.strokeStyle=this._color(color.color,this.m_alpha);s.arc(center.x*drawScale,center.y*drawScale,radius*drawScale,0,Math.PI*2,true);s.closePath();s.stroke();};b2DebugDraw.prototype.DrawSolidCircle=function(center,radius,axis,color){if(!radius)return;var s=this.m_ctx,drawScale=this.m_drawScale,cx=center.x*drawScale,cy=center.y*drawScale;s.moveTo(0,0);s.beginPath();s.strokeStyle=this._color(color.color,this.m_alpha);s.fillStyle=this._color(color.color,this.m_fillAlpha);s.arc(cx,cy,radius*drawScale,0,Math.PI*2,true);s.moveTo(cx,cy);s.lineTo((center.x+axis.x*radius)*drawScale,(center.y+axis.y*radius)*drawScale);s.closePath();s.fill();s.stroke();};b2DebugDraw.prototype.DrawSegment=function(p1,p2,color){var s=this.m_ctx,drawScale=this.m_drawScale;s.strokeStyle=this._color(color.color,this.m_alpha);s.beginPath();s.moveTo(p1.x*drawScale,p1.y*drawScale);s.lineTo(p2.x*drawScale,p2.y*drawScale);s.closePath();s.stroke();};b2DebugDraw.prototype.DrawTransform=function(xf){var s=this.m_ctx,drawScale=this.m_drawScale;s.beginPath();s.strokeStyle=this._color(0xff0000,this.m_alpha);s.moveTo(xf.position.x*drawScale,xf.position.y*drawScale);s.lineTo((xf.position.x+this.m_xformScale*xf.R.col1.x)*drawScale,(xf.position.y+this.m_xformScale*xf.R.col1.y)*drawScale);s.strokeStyle=this._color(0xff00,this.m_alpha);s.moveTo(xf.position.x*drawScale,xf.position.y*drawScale);s.lineTo((xf.position.x+this.m_xformScale*xf.R.col2.x)*drawScale,(xf.position.y+this.m_xformScale*xf.R.col2.y)*drawScale);s.closePath();s.stroke();};})();//post-definitions
	var i;for(i=0;i<Box2D.postDefs.length;++i){Box2D.postDefs[i]();}delete Box2D.postDefs;

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";// rev 452
	/********************************************************************************
	 *                                                                              *
	 * Author    :  Angus Johnson                                                   *
	 * Version   :  6.1.3a                                                          *
	 * Date      :  22 January 2014                                                 *
	 * Website   :  http://www.angusj.com                                           *
	 * Copyright :  Angus Johnson 2010-2014                                         *
	 *                                                                              *
	 * License:                                                                     *
	 * Use, modification & distribution is subject to Boost Software License Ver 1. *
	 * http://www.boost.org/LICENSE_1_0.txt                                         *
	 *                                                                              *
	 * Attributions:                                                                *
	 * The code in this library is an extension of Bala Vatti's clipping algorithm: *
	 * "A generic solution to polygon clipping"                                     *
	 * Communications of the ACM, Vol 35, Issue 7 (July 1992) pp 56-63.             *
	 * http://portal.acm.org/citation.cfm?id=129906                                 *
	 *                                                                              *
	 * Computer graphics and geometric modeling: implementation and algorithms      *
	 * By Max K. Agoston                                                            *
	 * Springer; 1 edition (January 4, 2005)                                        *
	 * http://books.google.com/books?q=vatti+clipping+agoston                       *
	 *                                                                              *
	 * See also:                                                                    *
	 * "Polygon Offsetting by Computing Winding Numbers"                            *
	 * Paper no. DETC2005-85513 pp. 565-575                                         *
	 * ASME 2005 International Design Engineering Technical Conferences             *
	 * and Computers and Information in Engineering Conference (IDETC/CIE2005)      *
	 * September 24-28, 2005 , Long Beach, California, USA                          *
	 * http://www.me.berkeley.edu/~mcmains/pubs/DAC05OffsetPolygon.pdf              *
	 *                                                                              *
	 *******************************************************************************//*******************************************************************************
	 *                                                                              *
	 * Author    :  Timo                                                            *
	 * Version   :  6.1.3.2                                                         *
	 * Date      :  1 February 2014                                                 *
	 *                                                                              *
	 * This is a translation of the C# Clipper library to Javascript.               *
	 * Int128 struct of C# is implemented using JSBN of Tom Wu.                     *
	 * Because Javascript lacks support for 64-bit integers, the space              *
	 * is a little more restricted than in C# version.                              *
	 *                                                                              *
	 * C# version has support for coordinate space:                                 *
	 * +-4611686018427387903 ( sqrt(2^127 -1)/2 )                                   *
	 * while Javascript version has support for space:                              *
	 * +-4503599627370495 ( sqrt(2^106 -1)/2 )                                      *
	 *                                                                              *
	 * Tom Wu's JSBN proved to be the fastest big integer library:                  *
	 * http://jsperf.com/big-integer-library-test                                   *
	 *                                                                              *
	 * This class can be made simpler when (if ever) 64-bit integer support comes.  *
	 *                                                                              *
	 *******************************************************************************//*******************************************************************************
	 *                                                                              *
	 * Basic JavaScript BN library - subset useful for RSA encryption.              *
	 * http://www-cs-students.stanford.edu/~tjw/jsbn/                               *
	 * Copyright (c) 2005  Tom Wu                                                   *
	 * All Rights Reserved.                                                         *
	 * See "LICENSE" for details:                                                   *
	 * http://www-cs-students.stanford.edu/~tjw/jsbn/LICENSE                        *
	 *                                                                              *
	 *******************************************************************************/(function(){"use strict";//use_int32: When enabled 32bit ints are used instead of 64bit ints. This
	//improve performance but coordinate values are limited to the range +/- 46340
	var use_int32=false;//use_xyz: adds a Z member to IntPoint. Adds a minor cost to performance.
	var use_xyz=false;//UseLines: Enables line clipping. Adds a very minor cost to performance.
	var use_lines=true;//use_deprecated: Enables support for the obsolete OffsetPaths() function
	//which has been replace with the ClipperOffset class.
	var use_deprecated=false;var ClipperLib={};var isNode=false;if(typeof module!=='undefined'&&module.exports){module.exports=ClipperLib;isNode=true;}else{if(typeof document!=="undefined")window.ClipperLib=ClipperLib;else self['ClipperLib']=ClipperLib;}var navigator_appName;if(!isNode){var nav=navigator.userAgent.toString().toLowerCase();navigator_appName=navigator.appName;}else{var nav="chrome";// Node.js uses Chrome's V8 engine
	navigator_appName="Netscape";// Firefox, Chrome and Safari returns "Netscape", so Node.js should also
	}// Browser test to speedup performance critical functions
	var browser={};if(nav.indexOf("chrome")!=-1&&nav.indexOf("chromium")==-1)browser.chrome=1;else browser.chrome=0;if(nav.indexOf("chromium")!=-1)browser.chromium=1;else browser.chromium=0;if(nav.indexOf("safari")!=-1&&nav.indexOf("chrome")==-1&&nav.indexOf("chromium")==-1)browser.safari=1;else browser.safari=0;if(nav.indexOf("firefox")!=-1)browser.firefox=1;else browser.firefox=0;if(nav.indexOf("firefox/17")!=-1)browser.firefox17=1;else browser.firefox17=0;if(nav.indexOf("firefox/15")!=-1)browser.firefox15=1;else browser.firefox15=0;if(nav.indexOf("firefox/3")!=-1)browser.firefox3=1;else browser.firefox3=0;if(nav.indexOf("opera")!=-1)browser.opera=1;else browser.opera=0;if(nav.indexOf("msie 10")!=-1)browser.msie10=1;else browser.msie10=0;if(nav.indexOf("msie 9")!=-1)browser.msie9=1;else browser.msie9=0;if(nav.indexOf("msie 8")!=-1)browser.msie8=1;else browser.msie8=0;if(nav.indexOf("msie 7")!=-1)browser.msie7=1;else browser.msie7=0;if(nav.indexOf("msie ")!=-1)browser.msie=1;else browser.msie=0;ClipperLib.biginteger_used=null;// Copyright (c) 2005  Tom Wu
	// All Rights Reserved.
	// See "LICENSE" for details.
	// Basic JavaScript BN library - subset useful for RSA encryption.
	// Bits per digit
	var dbits;// JavaScript engine analysis
	var canary=0xdeadbeefcafe;var j_lm=(canary&0xffffff)==0xefcafe;// (public) Constructor
	function BigInteger(a,b,c){// This test variable can be removed,
	// but at least for performance tests it is useful piece of knowledge
	// This is the only ClipperLib related variable in BigInteger library
	ClipperLib.biginteger_used=1;if(a!=null)if("number"==typeof a&&"undefined"==typeof b)this.fromInt(a);// faster conversion
	else if("number"==typeof a)this.fromNumber(a,b,c);else if(b==null&&"string"!=typeof a)this.fromString(a,256);else this.fromString(a,b);}// return new, unset BigInteger
	function nbi(){return new BigInteger(null);}// am: Compute w_j += (x*this_i), propagate carries,
	// c is initial carry, returns final carry.
	// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
	// We need to select the fastest one that works in this environment.
	// am1: use a single mult and divide to get the high bits,
	// max digit bits should be 26 because
	// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
	function am1(i,x,w,j,c,n){while(--n>=0){var v=x*this[i++]+w[j]+c;c=Math.floor(v/0x4000000);w[j++]=v&0x3ffffff;}return c;}// am2 avoids a big mult-and-extract completely.
	// Max digit bits should be <= 30 because we do bitwise ops
	// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
	function am2(i,x,w,j,c,n){var xl=x&0x7fff,xh=x>>15;while(--n>=0){var l=this[i]&0x7fff;var h=this[i++]>>15;var m=xh*l+h*xl;l=xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);c=(l>>>30)+(m>>>15)+xh*h+(c>>>30);w[j++]=l&0x3fffffff;}return c;}// Alternately, set max digit bits to 28 since some
	// browsers slow down when dealing with 32-bit numbers.
	function am3(i,x,w,j,c,n){var xl=x&0x3fff,xh=x>>14;while(--n>=0){var l=this[i]&0x3fff;var h=this[i++]>>14;var m=xh*l+h*xl;l=xl*l+((m&0x3fff)<<14)+w[j]+c;c=(l>>28)+(m>>14)+xh*h;w[j++]=l&0xfffffff;}return c;}if(j_lm&&navigator_appName=="Microsoft Internet Explorer"){BigInteger.prototype.am=am2;dbits=30;}else if(j_lm&&navigator_appName!="Netscape"){BigInteger.prototype.am=am1;dbits=26;}else{// Mozilla/Netscape seems to prefer am3
	BigInteger.prototype.am=am3;dbits=28;}BigInteger.prototype.DB=dbits;BigInteger.prototype.DM=(1<<dbits)-1;BigInteger.prototype.DV=1<<dbits;var BI_FP=52;BigInteger.prototype.FV=Math.pow(2,BI_FP);BigInteger.prototype.F1=BI_FP-dbits;BigInteger.prototype.F2=2*dbits-BI_FP;// Digit conversions
	var BI_RM="0123456789abcdefghijklmnopqrstuvwxyz";var BI_RC=new Array();var rr,vv;rr="0".charCodeAt(0);for(vv=0;vv<=9;++vv){BI_RC[rr++]=vv;}rr="a".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv;}rr="A".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv;}function int2char(n){return BI_RM.charAt(n);}function intAt(s,i){var c=BI_RC[s.charCodeAt(i)];return c==null?-1:c;}// (protected) copy this to r
	function bnpCopyTo(r){for(var i=this.t-1;i>=0;--i){r[i]=this[i];}r.t=this.t;r.s=this.s;}// (protected) set from integer value x, -DV <= x < DV
	function bnpFromInt(x){this.t=1;this.s=x<0?-1:0;if(x>0)this[0]=x;else if(x<-1)this[0]=x+this.DV;else this.t=0;}// return bigint initialized to value
	function nbv(i){var r=nbi();r.fromInt(i);return r;}// (protected) set from string and radix
	function bnpFromString(s,b){var k;if(b==16)k=4;else if(b==8)k=3;else if(b==256)k=8;// byte array
	else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else{this.fromRadix(s,b);return;}this.t=0;this.s=0;var i=s.length,mi=false,sh=0;while(--i>=0){var x=k==8?s[i]&0xff:intAt(s,i);if(x<0){if(s.charAt(i)=="-")mi=true;continue;}mi=false;if(sh==0)this[this.t++]=x;else if(sh+k>this.DB){this[this.t-1]|=(x&(1<<this.DB-sh)-1)<<sh;this[this.t++]=x>>this.DB-sh;}else this[this.t-1]|=x<<sh;sh+=k;if(sh>=this.DB)sh-=this.DB;}if(k==8&&(s[0]&0x80)!=0){this.s=-1;if(sh>0)this[this.t-1]|=(1<<this.DB-sh)-1<<sh;}this.clamp();if(mi)BigInteger.ZERO.subTo(this,this);}// (protected) clamp off excess high words
	function bnpClamp(){var c=this.s&this.DM;while(this.t>0&&this[this.t-1]==c){--this.t;}}// (public) return string representation in given radix
	function bnToString(b){if(this.s<0)return"-"+this.negate().toString(b);var k;if(b==16)k=4;else if(b==8)k=3;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else return this.toRadix(b);var km=(1<<k)-1,d,m=false,r="",i=this.t;var p=this.DB-i*this.DB%k;if(i-->0){if(p<this.DB&&(d=this[i]>>p)>0){m=true;r=int2char(d);}while(i>=0){if(p<k){d=(this[i]&(1<<p)-1)<<k-p;d|=this[--i]>>(p+=this.DB-k);}else{d=this[i]>>(p-=k)&km;if(p<=0){p+=this.DB;--i;}}if(d>0)m=true;if(m)r+=int2char(d);}}return m?r:"0";}// (public) -this
	function bnNegate(){var r=nbi();BigInteger.ZERO.subTo(this,r);return r;}// (public) |this|
	function bnAbs(){return this.s<0?this.negate():this;}// (public) return + if this > a, - if this < a, 0 if equal
	function bnCompareTo(a){var r=this.s-a.s;if(r!=0)return r;var i=this.t;r=i-a.t;if(r!=0)return this.s<0?-r:r;while(--i>=0){if((r=this[i]-a[i])!=0)return r;}return 0;}// returns bit length of the integer x
	function nbits(x){var r=1,t;if((t=x>>>16)!=0){x=t;r+=16;}if((t=x>>8)!=0){x=t;r+=8;}if((t=x>>4)!=0){x=t;r+=4;}if((t=x>>2)!=0){x=t;r+=2;}if((t=x>>1)!=0){x=t;r+=1;}return r;}// (public) return the number of bits in "this"
	function bnBitLength(){if(this.t<=0)return 0;return this.DB*(this.t-1)+nbits(this[this.t-1]^this.s&this.DM);}// (protected) r = this << n*DB
	function bnpDLShiftTo(n,r){var i;for(i=this.t-1;i>=0;--i){r[i+n]=this[i];}for(i=n-1;i>=0;--i){r[i]=0;}r.t=this.t+n;r.s=this.s;}// (protected) r = this >> n*DB
	function bnpDRShiftTo(n,r){for(var i=n;i<this.t;++i){r[i-n]=this[i];}r.t=Math.max(this.t-n,0);r.s=this.s;}// (protected) r = this << n
	function bnpLShiftTo(n,r){var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<cbs)-1;var ds=Math.floor(n/this.DB),c=this.s<<bs&this.DM,i;for(i=this.t-1;i>=0;--i){r[i+ds+1]=this[i]>>cbs|c;c=(this[i]&bm)<<bs;}for(i=ds-1;i>=0;--i){r[i]=0;}r[ds]=c;r.t=this.t+ds+1;r.s=this.s;r.clamp();}// (protected) r = this >> n
	function bnpRShiftTo(n,r){r.s=this.s;var ds=Math.floor(n/this.DB);if(ds>=this.t){r.t=0;return;}var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<bs)-1;r[0]=this[ds]>>bs;for(var i=ds+1;i<this.t;++i){r[i-ds-1]|=(this[i]&bm)<<cbs;r[i-ds]=this[i]>>bs;}if(bs>0)r[this.t-ds-1]|=(this.s&bm)<<cbs;r.t=this.t-ds;r.clamp();}// (protected) r = this - a
	function bnpSubTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]-a[i];r[i++]=c&this.DM;c>>=this.DB;}if(a.t<this.t){c-=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}c+=this.s;}else{c+=this.s;while(i<a.t){c-=a[i];r[i++]=c&this.DM;c>>=this.DB;}c-=a.s;}r.s=c<0?-1:0;if(c<-1)r[i++]=this.DV+c;else if(c>0)r[i++]=c;r.t=i;r.clamp();}// (protected) r = this * a, r != this,a (HAC 14.12)
	// "this" should be the larger one if appropriate.
	function bnpMultiplyTo(a,r){var x=this.abs(),y=a.abs();var i=x.t;r.t=i+y.t;while(--i>=0){r[i]=0;}for(i=0;i<y.t;++i){r[i+x.t]=x.am(0,y[i],r,i,0,x.t);}r.s=0;r.clamp();if(this.s!=a.s)BigInteger.ZERO.subTo(r,r);}// (protected) r = this^2, r != this (HAC 14.16)
	function bnpSquareTo(r){var x=this.abs();var i=r.t=2*x.t;while(--i>=0){r[i]=0;}for(i=0;i<x.t-1;++i){var c=x.am(i,x[i],r,2*i,0,1);if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1))>=x.DV){r[i+x.t]-=x.DV;r[i+x.t+1]=1;}}if(r.t>0)r[r.t-1]+=x.am(i,x[i],r,2*i,0,1);r.s=0;r.clamp();}// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
	// r != q, this != m.  q or r may be null.
	function bnpDivRemTo(m,q,r){var pm=m.abs();if(pm.t<=0)return;var pt=this.abs();if(pt.t<pm.t){if(q!=null)q.fromInt(0);if(r!=null)this.copyTo(r);return;}if(r==null)r=nbi();var y=nbi(),ts=this.s,ms=m.s;var nsh=this.DB-nbits(pm[pm.t-1]);// normalize modulus
	if(nsh>0){pm.lShiftTo(nsh,y);pt.lShiftTo(nsh,r);}else{pm.copyTo(y);pt.copyTo(r);}var ys=y.t;var y0=y[ys-1];if(y0==0)return;var yt=y0*(1<<this.F1)+(ys>1?y[ys-2]>>this.F2:0);var d1=this.FV/yt,d2=(1<<this.F1)/yt,e=1<<this.F2;var i=r.t,j=i-ys,t=q==null?nbi():q;y.dlShiftTo(j,t);if(r.compareTo(t)>=0){r[r.t++]=1;r.subTo(t,r);}BigInteger.ONE.dlShiftTo(ys,t);t.subTo(y,y);// "negative" y so we can replace sub with am later
	while(y.t<ys){y[y.t++]=0;}while(--j>=0){// Estimate quotient digit
	var qd=r[--i]==y0?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);if((r[i]+=y.am(0,qd,r,j,0,ys))<qd){// Try it out
	y.dlShiftTo(j,t);r.subTo(t,r);while(r[i]<--qd){r.subTo(t,r);}}}if(q!=null){r.drShiftTo(ys,q);if(ts!=ms)BigInteger.ZERO.subTo(q,q);}r.t=ys;r.clamp();if(nsh>0)r.rShiftTo(nsh,r);// Denormalize remainder
	if(ts<0)BigInteger.ZERO.subTo(r,r);}// (public) this mod a
	function bnMod(a){var r=nbi();this.abs().divRemTo(a,null,r);if(this.s<0&&r.compareTo(BigInteger.ZERO)>0)a.subTo(r,r);return r;}// Modular reduction using "classic" algorithm
	function Classic(m){this.m=m;}function cConvert(x){if(x.s<0||x.compareTo(this.m)>=0)return x.mod(this.m);else return x;}function cRevert(x){return x;}function cReduce(x){x.divRemTo(this.m,null,x);}function cMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}function cSqrTo(x,r){x.squareTo(r);this.reduce(r);}Classic.prototype.convert=cConvert;Classic.prototype.revert=cRevert;Classic.prototype.reduce=cReduce;Classic.prototype.mulTo=cMulTo;Classic.prototype.sqrTo=cSqrTo;// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
	// justification:
	//         xy == 1 (mod m)
	//         xy =  1+km
	//   xy(2-xy) = (1+km)(1-km)
	// x[y(2-xy)] = 1-k^2m^2
	// x[y(2-xy)] == 1 (mod m^2)
	// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
	// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
	// JS multiply "overflows" differently from C/C++, so care is needed here.
	function bnpInvDigit(){if(this.t<1)return 0;var x=this[0];if((x&1)==0)return 0;var y=x&3;// y == 1/x mod 2^2
	y=y*(2-(x&0xf)*y)&0xf;// y == 1/x mod 2^4
	y=y*(2-(x&0xff)*y)&0xff;// y == 1/x mod 2^8
	y=y*(2-((x&0xffff)*y&0xffff))&0xffff;// y == 1/x mod 2^16
	// last step - calculate inverse mod DV directly;
	// assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	y=y*(2-x*y%this.DV)%this.DV;// y == 1/x mod 2^dbits
	// we really want the negative inverse, and -DV < y < DV
	return y>0?this.DV-y:-y;}// Montgomery reduction
	function Montgomery(m){this.m=m;this.mp=m.invDigit();this.mpl=this.mp&0x7fff;this.mph=this.mp>>15;this.um=(1<<m.DB-15)-1;this.mt2=2*m.t;}// xR mod m
	function montConvert(x){var r=nbi();x.abs().dlShiftTo(this.m.t,r);r.divRemTo(this.m,null,r);if(x.s<0&&r.compareTo(BigInteger.ZERO)>0)this.m.subTo(r,r);return r;}// x/R mod m
	function montRevert(x){var r=nbi();x.copyTo(r);this.reduce(r);return r;}// x = x/R mod m (HAC 14.32)
	function montReduce(x){while(x.t<=this.mt2){// pad x so am has enough room later
	x[x.t++]=0;}for(var i=0;i<this.m.t;++i){// faster way of calculating u0 = x[i]*mp mod DV
	var j=x[i]&0x7fff;var u0=j*this.mpl+((j*this.mph+(x[i]>>15)*this.mpl&this.um)<<15)&x.DM;// use am to combine the multiply-shift-add into one call
	j=i+this.m.t;x[j]+=this.m.am(0,u0,x,i,0,this.m.t);// propagate carry
	while(x[j]>=x.DV){x[j]-=x.DV;x[++j]++;}}x.clamp();x.drShiftTo(this.m.t,x);if(x.compareTo(this.m)>=0)x.subTo(this.m,x);}// r = "x^2/R mod m"; x != r
	function montSqrTo(x,r){x.squareTo(r);this.reduce(r);}// r = "xy/R mod m"; x,y != r
	function montMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}Montgomery.prototype.convert=montConvert;Montgomery.prototype.revert=montRevert;Montgomery.prototype.reduce=montReduce;Montgomery.prototype.mulTo=montMulTo;Montgomery.prototype.sqrTo=montSqrTo;// (protected) true iff this is even
	function bnpIsEven(){return(this.t>0?this[0]&1:this.s)==0;}// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
	function bnpExp(e,z){if(e>0xffffffff||e<1)return BigInteger.ONE;var r=nbi(),r2=nbi(),g=z.convert(this),i=nbits(e)-1;g.copyTo(r);while(--i>=0){z.sqrTo(r,r2);if((e&1<<i)>0)z.mulTo(r2,g,r);else{var t=r;r=r2;r2=t;}}return z.revert(r);}// (public) this^e % m, 0 <= e < 2^32
	function bnModPowInt(e,m){var z;if(e<256||m.isEven())z=new Classic(m);else z=new Montgomery(m);return this.exp(e,z);}// protected
	BigInteger.prototype.copyTo=bnpCopyTo;BigInteger.prototype.fromInt=bnpFromInt;BigInteger.prototype.fromString=bnpFromString;BigInteger.prototype.clamp=bnpClamp;BigInteger.prototype.dlShiftTo=bnpDLShiftTo;BigInteger.prototype.drShiftTo=bnpDRShiftTo;BigInteger.prototype.lShiftTo=bnpLShiftTo;BigInteger.prototype.rShiftTo=bnpRShiftTo;BigInteger.prototype.subTo=bnpSubTo;BigInteger.prototype.multiplyTo=bnpMultiplyTo;BigInteger.prototype.squareTo=bnpSquareTo;BigInteger.prototype.divRemTo=bnpDivRemTo;BigInteger.prototype.invDigit=bnpInvDigit;BigInteger.prototype.isEven=bnpIsEven;BigInteger.prototype.exp=bnpExp;// public
	BigInteger.prototype.toString=bnToString;BigInteger.prototype.negate=bnNegate;BigInteger.prototype.abs=bnAbs;BigInteger.prototype.compareTo=bnCompareTo;BigInteger.prototype.bitLength=bnBitLength;BigInteger.prototype.mod=bnMod;BigInteger.prototype.modPowInt=bnModPowInt;// "constants"
	BigInteger.ZERO=nbv(0);BigInteger.ONE=nbv(1);// Copyright (c) 2005-2009  Tom Wu
	// All Rights Reserved.
	// See "LICENSE" for details.
	// Extended JavaScript BN functions, required for RSA private ops.
	// Version 1.1: new BigInteger("0", 10) returns "proper" zero
	// Version 1.2: square() API, isProbablePrime fix
	// (public)
	function bnClone(){var r=nbi();this.copyTo(r);return r;}// (public) return value as integer
	function bnIntValue(){if(this.s<0){if(this.t==1)return this[0]-this.DV;else if(this.t==0)return-1;}else if(this.t==1)return this[0];else if(this.t==0)return 0;// assumes 16 < DB < 32
	return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0];}// (public) return value as byte
	function bnByteValue(){return this.t==0?this.s:this[0]<<24>>24;}// (public) return value as short (assumes DB>=16)
	function bnShortValue(){return this.t==0?this.s:this[0]<<16>>16;}// (protected) return x s.t. r^x < DV
	function bnpChunkSize(r){return Math.floor(Math.LN2*this.DB/Math.log(r));}// (public) 0 if this == 0, 1 if this > 0
	function bnSigNum(){if(this.s<0)return-1;else if(this.t<=0||this.t==1&&this[0]<=0)return 0;else return 1;}// (protected) convert to radix string
	function bnpToRadix(b){if(b==null)b=10;if(this.signum()==0||b<2||b>36)return"0";var cs=this.chunkSize(b);var a=Math.pow(b,cs);var d=nbv(a),y=nbi(),z=nbi(),r="";this.divRemTo(d,y,z);while(y.signum()>0){r=(a+z.intValue()).toString(b).substr(1)+r;y.divRemTo(d,y,z);}return z.intValue().toString(b)+r;}// (protected) convert from radix string
	function bnpFromRadix(s,b){this.fromInt(0);if(b==null)b=10;var cs=this.chunkSize(b);var d=Math.pow(b,cs),mi=false,j=0,w=0;for(var i=0;i<s.length;++i){var x=intAt(s,i);if(x<0){if(s.charAt(i)=="-"&&this.signum()==0)mi=true;continue;}w=b*w+x;if(++j>=cs){this.dMultiply(d);this.dAddOffset(w,0);j=0;w=0;}}if(j>0){this.dMultiply(Math.pow(b,j));this.dAddOffset(w,0);}if(mi)BigInteger.ZERO.subTo(this,this);}// (protected) alternate constructor
	function bnpFromNumber(a,b,c){if("number"==typeof b){// new BigInteger(int,int,RNG)
	if(a<2)this.fromInt(1);else{this.fromNumber(a,c);if(!this.testBit(a-1))// force MSB set
	this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);if(this.isEven())this.dAddOffset(1,0);// force odd
	while(!this.isProbablePrime(b)){this.dAddOffset(2,0);if(this.bitLength()>a)this.subTo(BigInteger.ONE.shiftLeft(a-1),this);}}}else{// new BigInteger(int,RNG)
	var x=new Array(),t=a&7;x.length=(a>>3)+1;b.nextBytes(x);if(t>0)x[0]&=(1<<t)-1;else x[0]=0;this.fromString(x,256);}}// (public) convert to bigendian byte array
	function bnToByteArray(){var i=this.t,r=new Array();r[0]=this.s;var p=this.DB-i*this.DB%8,d,k=0;if(i-->0){if(p<this.DB&&(d=this[i]>>p)!=(this.s&this.DM)>>p)r[k++]=d|this.s<<this.DB-p;while(i>=0){if(p<8){d=(this[i]&(1<<p)-1)<<8-p;d|=this[--i]>>(p+=this.DB-8);}else{d=this[i]>>(p-=8)&0xff;if(p<=0){p+=this.DB;--i;}}if((d&0x80)!=0)d|=-256;if(k==0&&(this.s&0x80)!=(d&0x80))++k;if(k>0||d!=this.s)r[k++]=d;}}return r;}function bnEquals(a){return this.compareTo(a)==0;}function bnMin(a){return this.compareTo(a)<0?this:a;}function bnMax(a){return this.compareTo(a)>0?this:a;}// (protected) r = this op a (bitwise)
	function bnpBitwiseTo(a,op,r){var i,f,m=Math.min(a.t,this.t);for(i=0;i<m;++i){r[i]=op(this[i],a[i]);}if(a.t<this.t){f=a.s&this.DM;for(i=m;i<this.t;++i){r[i]=op(this[i],f);}r.t=this.t;}else{f=this.s&this.DM;for(i=m;i<a.t;++i){r[i]=op(f,a[i]);}r.t=a.t;}r.s=op(this.s,a.s);r.clamp();}// (public) this & a
	function op_and(x,y){return x&y;}function bnAnd(a){var r=nbi();this.bitwiseTo(a,op_and,r);return r;}// (public) this | a
	function op_or(x,y){return x|y;}function bnOr(a){var r=nbi();this.bitwiseTo(a,op_or,r);return r;}// (public) this ^ a
	function op_xor(x,y){return x^y;}function bnXor(a){var r=nbi();this.bitwiseTo(a,op_xor,r);return r;}// (public) this & ~a
	function op_andnot(x,y){return x&~y;}function bnAndNot(a){var r=nbi();this.bitwiseTo(a,op_andnot,r);return r;}// (public) ~this
	function bnNot(){var r=nbi();for(var i=0;i<this.t;++i){r[i]=this.DM&~this[i];}r.t=this.t;r.s=~this.s;return r;}// (public) this << n
	function bnShiftLeft(n){var r=nbi();if(n<0)this.rShiftTo(-n,r);else this.lShiftTo(n,r);return r;}// (public) this >> n
	function bnShiftRight(n){var r=nbi();if(n<0)this.lShiftTo(-n,r);else this.rShiftTo(n,r);return r;}// return index of lowest 1-bit in x, x < 2^31
	function lbit(x){if(x==0)return-1;var r=0;if((x&0xffff)==0){x>>=16;r+=16;}if((x&0xff)==0){x>>=8;r+=8;}if((x&0xf)==0){x>>=4;r+=4;}if((x&3)==0){x>>=2;r+=2;}if((x&1)==0)++r;return r;}// (public) returns index of lowest 1-bit (or -1 if none)
	function bnGetLowestSetBit(){for(var i=0;i<this.t;++i){if(this[i]!=0)return i*this.DB+lbit(this[i]);}if(this.s<0)return this.t*this.DB;return-1;}// return number of 1 bits in x
	function cbit(x){var r=0;while(x!=0){x&=x-1;++r;}return r;}// (public) return number of set bits
	function bnBitCount(){var r=0,x=this.s&this.DM;for(var i=0;i<this.t;++i){r+=cbit(this[i]^x);}return r;}// (public) true iff nth bit is set
	function bnTestBit(n){var j=Math.floor(n/this.DB);if(j>=this.t)return this.s!=0;return(this[j]&1<<n%this.DB)!=0;}// (protected) this op (1<<n)
	function bnpChangeBit(n,op){var r=BigInteger.ONE.shiftLeft(n);this.bitwiseTo(r,op,r);return r;}// (public) this | (1<<n)
	function bnSetBit(n){return this.changeBit(n,op_or);}// (public) this & ~(1<<n)
	function bnClearBit(n){return this.changeBit(n,op_andnot);}// (public) this ^ (1<<n)
	function bnFlipBit(n){return this.changeBit(n,op_xor);}// (protected) r = this + a
	function bnpAddTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]+a[i];r[i++]=c&this.DM;c>>=this.DB;}if(a.t<this.t){c+=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}c+=this.s;}else{c+=this.s;while(i<a.t){c+=a[i];r[i++]=c&this.DM;c>>=this.DB;}c+=a.s;}r.s=c<0?-1:0;if(c>0)r[i++]=c;else if(c<-1)r[i++]=this.DV+c;r.t=i;r.clamp();}// (public) this + a
	function bnAdd(a){var r=nbi();this.addTo(a,r);return r;}// (public) this - a
	function bnSubtract(a){var r=nbi();this.subTo(a,r);return r;}// (public) this * a
	function bnMultiply(a){var r=nbi();this.multiplyTo(a,r);return r;}// (public) this^2
	function bnSquare(){var r=nbi();this.squareTo(r);return r;}// (public) this / a
	function bnDivide(a){var r=nbi();this.divRemTo(a,r,null);return r;}// (public) this % a
	function bnRemainder(a){var r=nbi();this.divRemTo(a,null,r);return r;}// (public) [this/a,this%a]
	function bnDivideAndRemainder(a){var q=nbi(),r=nbi();this.divRemTo(a,q,r);return new Array(q,r);}// (protected) this *= n, this >= 0, 1 < n < DV
	function bnpDMultiply(n){this[this.t]=this.am(0,n-1,this,0,0,this.t);++this.t;this.clamp();}// (protected) this += n << w words, this >= 0
	function bnpDAddOffset(n,w){if(n==0)return;while(this.t<=w){this[this.t++]=0;}this[w]+=n;while(this[w]>=this.DV){this[w]-=this.DV;if(++w>=this.t)this[this.t++]=0;++this[w];}}// A "null" reducer
	function NullExp(){}function nNop(x){return x;}function nMulTo(x,y,r){x.multiplyTo(y,r);}function nSqrTo(x,r){x.squareTo(r);}NullExp.prototype.convert=nNop;NullExp.prototype.revert=nNop;NullExp.prototype.mulTo=nMulTo;NullExp.prototype.sqrTo=nSqrTo;// (public) this^e
	function bnPow(e){return this.exp(e,new NullExp());}// (protected) r = lower n words of "this * a", a.t <= n
	// "this" should be the larger one if appropriate.
	function bnpMultiplyLowerTo(a,n,r){var i=Math.min(this.t+a.t,n);r.s=0;// assumes a,this >= 0
	r.t=i;while(i>0){r[--i]=0;}var j;for(j=r.t-this.t;i<j;++i){r[i+this.t]=this.am(0,a[i],r,i,0,this.t);}for(j=Math.min(a.t,n);i<j;++i){this.am(0,a[i],r,i,0,n-i);}r.clamp();}// (protected) r = "this * a" without lower n words, n > 0
	// "this" should be the larger one if appropriate.
	function bnpMultiplyUpperTo(a,n,r){--n;var i=r.t=this.t+a.t-n;r.s=0;// assumes a,this >= 0
	while(--i>=0){r[i]=0;}for(i=Math.max(n-this.t,0);i<a.t;++i){r[this.t+i-n]=this.am(n-i,a[i],r,0,0,this.t+i-n);}r.clamp();r.drShiftTo(1,r);}// Barrett modular reduction
	function Barrett(m){// setup Barrett
	this.r2=nbi();this.q3=nbi();BigInteger.ONE.dlShiftTo(2*m.t,this.r2);this.mu=this.r2.divide(m);this.m=m;}function barrettConvert(x){if(x.s<0||x.t>2*this.m.t)return x.mod(this.m);else if(x.compareTo(this.m)<0)return x;else{var r=nbi();x.copyTo(r);this.reduce(r);return r;}}function barrettRevert(x){return x;}// x = x mod m (HAC 14.42)
	function barrettReduce(x){x.drShiftTo(this.m.t-1,this.r2);if(x.t>this.m.t+1){x.t=this.m.t+1;x.clamp();}this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);while(x.compareTo(this.r2)<0){x.dAddOffset(1,this.m.t+1);}x.subTo(this.r2,x);while(x.compareTo(this.m)>=0){x.subTo(this.m,x);}}// r = x^2 mod m; x != r
	function barrettSqrTo(x,r){x.squareTo(r);this.reduce(r);}// r = x*y mod m; x,y != r
	function barrettMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}Barrett.prototype.convert=barrettConvert;Barrett.prototype.revert=barrettRevert;Barrett.prototype.reduce=barrettReduce;Barrett.prototype.mulTo=barrettMulTo;Barrett.prototype.sqrTo=barrettSqrTo;// (public) this^e % m (HAC 14.85)
	function bnModPow(e,m){var i=e.bitLength(),k,r=nbv(1),z;if(i<=0)return r;else if(i<18)k=1;else if(i<48)k=3;else if(i<144)k=4;else if(i<768)k=5;else k=6;if(i<8)z=new Classic(m);else if(m.isEven())z=new Barrett(m);else z=new Montgomery(m);// precomputation
	var g=new Array(),n=3,k1=k-1,km=(1<<k)-1;g[1]=z.convert(this);if(k>1){var g2=nbi();z.sqrTo(g[1],g2);while(n<=km){g[n]=nbi();z.mulTo(g2,g[n-2],g[n]);n+=2;}}var j=e.t-1,w,is1=true,r2=nbi(),t;i=nbits(e[j])-1;while(j>=0){if(i>=k1)w=e[j]>>i-k1&km;else{w=(e[j]&(1<<i+1)-1)<<k1-i;if(j>0)w|=e[j-1]>>this.DB+i-k1;}n=k;while((w&1)==0){w>>=1;--n;}if((i-=n)<0){i+=this.DB;--j;}if(is1){// ret == 1, don't bother squaring or multiplying it
	g[w].copyTo(r);is1=false;}else{while(n>1){z.sqrTo(r,r2);z.sqrTo(r2,r);n-=2;}if(n>0)z.sqrTo(r,r2);else{t=r;r=r2;r2=t;}z.mulTo(r2,g[w],r);}while(j>=0&&(e[j]&1<<i)==0){z.sqrTo(r,r2);t=r;r=r2;r2=t;if(--i<0){i=this.DB-1;--j;}}}return z.revert(r);}// (public) gcd(this,a) (HAC 14.54)
	function bnGCD(a){var x=this.s<0?this.negate():this.clone();var y=a.s<0?a.negate():a.clone();if(x.compareTo(y)<0){var t=x;x=y;y=t;}var i=x.getLowestSetBit(),g=y.getLowestSetBit();if(g<0)return x;if(i<g)g=i;if(g>0){x.rShiftTo(g,x);y.rShiftTo(g,y);}while(x.signum()>0){if((i=x.getLowestSetBit())>0)x.rShiftTo(i,x);if((i=y.getLowestSetBit())>0)y.rShiftTo(i,y);if(x.compareTo(y)>=0){x.subTo(y,x);x.rShiftTo(1,x);}else{y.subTo(x,y);y.rShiftTo(1,y);}}if(g>0)y.lShiftTo(g,y);return y;}// (protected) this % n, n < 2^26
	function bnpModInt(n){if(n<=0)return 0;var d=this.DV%n,r=this.s<0?n-1:0;if(this.t>0)if(d==0)r=this[0]%n;else for(var i=this.t-1;i>=0;--i){r=(d*r+this[i])%n;}return r;}// (public) 1/this % m (HAC 14.61)
	function bnModInverse(m){var ac=m.isEven();if(this.isEven()&&ac||m.signum()==0)return BigInteger.ZERO;var u=m.clone(),v=this.clone();var a=nbv(1),b=nbv(0),c=nbv(0),d=nbv(1);while(u.signum()!=0){while(u.isEven()){u.rShiftTo(1,u);if(ac){if(!a.isEven()||!b.isEven()){a.addTo(this,a);b.subTo(m,b);}a.rShiftTo(1,a);}else if(!b.isEven())b.subTo(m,b);b.rShiftTo(1,b);}while(v.isEven()){v.rShiftTo(1,v);if(ac){if(!c.isEven()||!d.isEven()){c.addTo(this,c);d.subTo(m,d);}c.rShiftTo(1,c);}else if(!d.isEven())d.subTo(m,d);d.rShiftTo(1,d);}if(u.compareTo(v)>=0){u.subTo(v,u);if(ac)a.subTo(c,a);b.subTo(d,b);}else{v.subTo(u,v);if(ac)c.subTo(a,c);d.subTo(b,d);}}if(v.compareTo(BigInteger.ONE)!=0)return BigInteger.ZERO;if(d.compareTo(m)>=0)return d.subtract(m);if(d.signum()<0)d.addTo(m,d);else return d;if(d.signum()<0)return d.add(m);else return d;}var lowprimes=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];var lplim=(1<<26)/lowprimes[lowprimes.length-1];// (public) test primality with certainty >= 1-.5^t
	function bnIsProbablePrime(t){var i,x=this.abs();if(x.t==1&&x[0]<=lowprimes[lowprimes.length-1]){for(i=0;i<lowprimes.length;++i){if(x[0]==lowprimes[i])return true;}return false;}if(x.isEven())return false;i=1;while(i<lowprimes.length){var m=lowprimes[i],j=i+1;while(j<lowprimes.length&&m<lplim){m*=lowprimes[j++];}m=x.modInt(m);while(i<j){if(m%lowprimes[i++]==0)return false;}}return x.millerRabin(t);}// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
	function bnpMillerRabin(t){var n1=this.subtract(BigInteger.ONE);var k=n1.getLowestSetBit();if(k<=0)return false;var r=n1.shiftRight(k);t=t+1>>1;if(t>lowprimes.length)t=lowprimes.length;var a=nbi();for(var i=0;i<t;++i){//Pick bases at random, instead of starting at 2
	a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);var y=a.modPow(r,this);if(y.compareTo(BigInteger.ONE)!=0&&y.compareTo(n1)!=0){var j=1;while(j++<k&&y.compareTo(n1)!=0){y=y.modPowInt(2,this);if(y.compareTo(BigInteger.ONE)==0)return false;}if(y.compareTo(n1)!=0)return false;}}return true;}// protected
	BigInteger.prototype.chunkSize=bnpChunkSize;BigInteger.prototype.toRadix=bnpToRadix;BigInteger.prototype.fromRadix=bnpFromRadix;BigInteger.prototype.fromNumber=bnpFromNumber;BigInteger.prototype.bitwiseTo=bnpBitwiseTo;BigInteger.prototype.changeBit=bnpChangeBit;BigInteger.prototype.addTo=bnpAddTo;BigInteger.prototype.dMultiply=bnpDMultiply;BigInteger.prototype.dAddOffset=bnpDAddOffset;BigInteger.prototype.multiplyLowerTo=bnpMultiplyLowerTo;BigInteger.prototype.multiplyUpperTo=bnpMultiplyUpperTo;BigInteger.prototype.modInt=bnpModInt;BigInteger.prototype.millerRabin=bnpMillerRabin;// public
	BigInteger.prototype.clone=bnClone;BigInteger.prototype.intValue=bnIntValue;BigInteger.prototype.byteValue=bnByteValue;BigInteger.prototype.shortValue=bnShortValue;BigInteger.prototype.signum=bnSigNum;BigInteger.prototype.toByteArray=bnToByteArray;BigInteger.prototype.equals=bnEquals;BigInteger.prototype.min=bnMin;BigInteger.prototype.max=bnMax;BigInteger.prototype.and=bnAnd;BigInteger.prototype.or=bnOr;BigInteger.prototype.xor=bnXor;BigInteger.prototype.andNot=bnAndNot;BigInteger.prototype.not=bnNot;BigInteger.prototype.shiftLeft=bnShiftLeft;BigInteger.prototype.shiftRight=bnShiftRight;BigInteger.prototype.getLowestSetBit=bnGetLowestSetBit;BigInteger.prototype.bitCount=bnBitCount;BigInteger.prototype.testBit=bnTestBit;BigInteger.prototype.setBit=bnSetBit;BigInteger.prototype.clearBit=bnClearBit;BigInteger.prototype.flipBit=bnFlipBit;BigInteger.prototype.add=bnAdd;BigInteger.prototype.subtract=bnSubtract;BigInteger.prototype.multiply=bnMultiply;BigInteger.prototype.divide=bnDivide;BigInteger.prototype.remainder=bnRemainder;BigInteger.prototype.divideAndRemainder=bnDivideAndRemainder;BigInteger.prototype.modPow=bnModPow;BigInteger.prototype.modInverse=bnModInverse;BigInteger.prototype.pow=bnPow;BigInteger.prototype.gcd=bnGCD;BigInteger.prototype.isProbablePrime=bnIsProbablePrime;// JSBN-specific extension
	BigInteger.prototype.square=bnSquare;var Int128=BigInteger;// BigInteger interfaces not implemented in jsbn:
	// BigInteger(int signum, byte[] magnitude)
	// double doubleValue()
	// float floatValue()
	// int hashCode()
	// long longValue()
	// static BigInteger valueOf(long val)
	// Helper functions to make BigInteger functions callable with two parameters
	// as in original C# Clipper
	Int128.prototype.IsNegative=function(){if(this.compareTo(Int128.ZERO)==-1)return true;else return false;};Int128.op_Equality=function(val1,val2){if(val1.compareTo(val2)==0)return true;else return false;};Int128.op_Inequality=function(val1,val2){if(val1.compareTo(val2)!=0)return true;else return false;};Int128.op_GreaterThan=function(val1,val2){if(val1.compareTo(val2)>0)return true;else return false;};Int128.op_LessThan=function(val1,val2){if(val1.compareTo(val2)<0)return true;else return false;};Int128.op_Addition=function(lhs,rhs){return new Int128(lhs).add(new Int128(rhs));};Int128.op_Subtraction=function(lhs,rhs){return new Int128(lhs).subtract(new Int128(rhs));};Int128.Int128Mul=function(lhs,rhs){return new Int128(lhs).multiply(new Int128(rhs));};Int128.op_Division=function(lhs,rhs){return lhs.divide(rhs);};Int128.prototype.ToDouble=function(){return parseFloat(this.toString());// This could be something faster
	};// end of Int128 section
	/*
	  // Uncomment the following two lines if you want to use Int128 outside ClipperLib
	  if (typeof(document) !== "undefined") window.Int128 = Int128;
	  else self.Int128 = Int128;
	  */// ---------------------------------------------
	// Here starts the actual Clipper library:
	// Helper function to support Inheritance in Javascript
	if(typeof Inherit=='undefined'){var Inherit=function Inherit(ce,ce2){var p;if(typeof Object.getOwnPropertyNames=='undefined'){for(p in ce2.prototype){if(typeof ce.prototype[p]=='undefined'||ce.prototype[p]==Object.prototype[p])ce.prototype[p]=ce2.prototype[p];}for(p in ce2){if(typeof ce[p]=='undefined')ce[p]=ce2[p];}ce.$baseCtor=ce2;}else{var props=Object.getOwnPropertyNames(ce2.prototype);for(var i=0;i<props.length;i++){if(typeof Object.getOwnPropertyDescriptor(ce.prototype,props[i])=='undefined')Object.defineProperty(ce.prototype,props[i],Object.getOwnPropertyDescriptor(ce2.prototype,props[i]));}for(p in ce2){if(typeof ce[p]=='undefined')ce[p]=ce2[p];}ce.$baseCtor=ce2;}};}ClipperLib.Path=function(){return[];};ClipperLib.Paths=function(){return[];// Was previously [[]], but caused problems when pushed
	};// Preserves the calling way of original C# Clipper
	// Is essential due to compatibility, because DoublePoint is public class in original C# version
	ClipperLib.DoublePoint=function(){var a=arguments;this.X=0;this.Y=0;// public DoublePoint(DoublePoint dp)
	// public DoublePoint(IntPoint ip)
	if(a.length==1){this.X=a[0].X;this.Y=a[0].Y;}else if(a.length==2){this.X=a[0];this.Y=a[1];}};// This is internal faster function when called without arguments
	ClipperLib.DoublePoint0=function(){this.X=0;this.Y=0;};// This is internal faster function when called with 1 argument (dp or ip)
	ClipperLib.DoublePoint1=function(dp){this.X=dp.X;this.Y=dp.Y;};// This is internal faster function when called with 2 arguments (x and y)
	ClipperLib.DoublePoint2=function(x,y){this.X=x;this.Y=y;};// PolyTree & PolyNode start
	// -------------------------------
	ClipperLib.PolyNode=function(){this.m_Parent=null;this.m_polygon=new ClipperLib.Path();this.m_Index=0;this.m_jointype=0;this.m_endtype=0;this.m_Childs=[];this.IsOpen=false;};ClipperLib.PolyNode.prototype.IsHoleNode=function(){var result=true;var node=this.m_Parent;while(node!==null){result=!result;node=node.m_Parent;}return result;};ClipperLib.PolyNode.prototype.ChildCount=function(){return this.m_Childs.length;};ClipperLib.PolyNode.prototype.Contour=function(){return this.m_polygon;};ClipperLib.PolyNode.prototype.AddChild=function(Child){var cnt=this.m_Childs.length;this.m_Childs.push(Child);Child.m_Parent=this;Child.m_Index=cnt;};ClipperLib.PolyNode.prototype.GetNext=function(){if(this.m_Childs.length>0)return this.m_Childs[0];else return this.GetNextSiblingUp();};ClipperLib.PolyNode.prototype.GetNextSiblingUp=function(){if(this.m_Parent===null)return null;else if(this.m_Index==this.m_Parent.m_Childs.length-1)return this.m_Parent.GetNextSiblingUp();else return this.m_Parent.m_Childs[this.m_Index+1];};ClipperLib.PolyNode.prototype.Childs=function(){return this.m_Childs;};ClipperLib.PolyNode.prototype.Parent=function(){return this.m_Parent;};ClipperLib.PolyNode.prototype.IsHole=function(){return this.IsHoleNode();};// PolyTree : PolyNode
	ClipperLib.PolyTree=function(){this.m_AllPolys=[];ClipperLib.PolyNode.call(this);};ClipperLib.PolyTree.prototype.Clear=function(){for(var i=0,ilen=this.m_AllPolys.length;i<ilen;i++){this.m_AllPolys[i]=null;}this.m_AllPolys.length=0;this.m_Childs.length=0;};ClipperLib.PolyTree.prototype.GetFirst=function(){if(this.m_Childs.length>0)return this.m_Childs[0];else return null;};ClipperLib.PolyTree.prototype.Total=function(){return this.m_AllPolys.length;};Inherit(ClipperLib.PolyTree,ClipperLib.PolyNode);// -------------------------------
	// PolyTree & PolyNode end
	ClipperLib.Math_Abs_Int64=ClipperLib.Math_Abs_Int32=ClipperLib.Math_Abs_Double=function(a){return Math.abs(a);};ClipperLib.Math_Max_Int32_Int32=function(a,b){return Math.max(a,b);};/*
	  -----------------------------------
	  cast_32 speedtest: http://jsperf.com/truncate-float-to-integer/2
	  -----------------------------------
	  */if(browser.msie||browser.opera||browser.safari)ClipperLib.Cast_Int32=function(a){return a|0;};else ClipperLib.Cast_Int32=function(a){// eg. browser.chrome || browser.chromium || browser.firefox
	return~~a;};/*
	  --------------------------
	  cast_64 speedtests: http://jsperf.com/truncate-float-to-integer
	  Chrome: bitwise_not_floor
	  Firefox17: toInteger (typeof test)
	  IE9: bitwise_or_floor
	  IE7 and IE8: to_parseint
	  Chromium: to_floor_or_ceil
	  Firefox3: to_floor_or_ceil
	  Firefox15: to_floor_or_ceil
	  Opera: to_floor_or_ceil
	  Safari: to_floor_or_ceil
	  --------------------------
	  */if(browser.chrome)ClipperLib.Cast_Int64=function(a){if(a<-2147483648||a>2147483647)return a<0?Math.ceil(a):Math.floor(a);else return~~a;};else if(browser.firefox&&typeof Number.toInteger=="function")ClipperLib.Cast_Int64=function(a){return Number.toInteger(a);};else if(browser.msie7||browser.msie8)ClipperLib.Cast_Int64=function(a){return parseInt(a,10);};else if(browser.msie)ClipperLib.Cast_Int64=function(a){if(a<-2147483648||a>2147483647)return a<0?Math.ceil(a):Math.floor(a);return a|0;};// eg. browser.chromium || browser.firefox || browser.opera || browser.safari
	else ClipperLib.Cast_Int64=function(a){return a<0?Math.ceil(a):Math.floor(a);};ClipperLib.Clear=function(a){a.length=0;};//ClipperLib.MaxSteps = 64; // How many steps at maximum in arc in BuildArc() function
	ClipperLib.PI=3.141592653589793;ClipperLib.PI2=2*3.141592653589793;ClipperLib.IntPoint=function(){var a=arguments,alen=a.length;this.X=0;this.Y=0;if(use_xyz){this.Z=0;if(alen==3)// public IntPoint(cInt x, cInt y, cInt z = 0)
	{this.X=a[0];this.Y=a[1];this.Z=a[2];}else if(alen==2)// public IntPoint(cInt x, cInt y)
	{this.X=a[0];this.Y=a[1];this.Z=0;}else if(alen==1){if(a[0]instanceof ClipperLib.DoublePoint)// public IntPoint(DoublePoint dp)
	{var dp=a[0];this.X=ClipperLib.Clipper.Round(dp.X);this.Y=ClipperLib.Clipper.Round(dp.Y);this.Z=0;}else// public IntPoint(IntPoint pt)
	{var pt=a[0];if(typeof pt.Z=="undefined")pt.Z=0;this.X=pt.X;this.Y=pt.Y;this.Z=pt.Z;}}else// public IntPoint()
	{this.X=0;this.Y=0;this.Z=0;}}else// if (!use_xyz)
	{if(alen==2)// public IntPoint(cInt X, cInt Y)
	{this.X=a[0];this.Y=a[1];}else if(alen==1){if(a[0]instanceof ClipperLib.DoublePoint)// public IntPoint(DoublePoint dp)
	{var dp=a[0];this.X=ClipperLib.Clipper.Round(dp.X);this.Y=ClipperLib.Clipper.Round(dp.Y);}else// public IntPoint(IntPoint pt)
	{var pt=a[0];this.X=pt.X;this.Y=pt.Y;}}else// public IntPoint(IntPoint pt)
	{this.X=0;this.Y=0;}}};ClipperLib.IntPoint.op_Equality=function(a,b){//return a == b;
	return a.X==b.X&&a.Y==b.Y;};ClipperLib.IntPoint.op_Inequality=function(a,b){//return a != b;
	return a.X!=b.X||a.Y!=b.Y;};/*
	  ClipperLib.IntPoint.prototype.Equals = function (obj)
	  {
	    if (obj === null)
	        return false;
	    if (obj instanceof ClipperLib.IntPoint)
	    {
	        var a = Cast(obj, ClipperLib.IntPoint);
	        return (this.X == a.X) && (this.Y == a.Y);
	    }
	    else
	        return false;
	  };
	*/if(use_xyz){ClipperLib.IntPoint0=function(){this.X=0;this.Y=0;this.Z=0;};ClipperLib.IntPoint1=function(pt){this.X=pt.X;this.Y=pt.Y;this.Z=pt.Z;};ClipperLib.IntPoint1dp=function(dp){this.X=ClipperLib.Clipper.Round(dp.X);this.Y=ClipperLib.Clipper.Round(dp.Y);this.Z=0;};ClipperLib.IntPoint2=function(x,y){this.X=x;this.Y=y;this.Z=0;};ClipperLib.IntPoint3=function(x,y,z){this.X=x;this.Y=y;this.Z=z;};}else// if (!use_xyz)
	{ClipperLib.IntPoint0=function(){this.X=0;this.Y=0;};ClipperLib.IntPoint1=function(pt){this.X=pt.X;this.Y=pt.Y;};ClipperLib.IntPoint1dp=function(dp){this.X=ClipperLib.Clipper.Round(dp.X);this.Y=ClipperLib.Clipper.Round(dp.Y);};ClipperLib.IntPoint2=function(x,y){this.X=x;this.Y=y;};}ClipperLib.IntRect=function(){var a=arguments,alen=a.length;if(alen==4)// function (l, t, r, b)
	{this.left=a[0];this.top=a[1];this.right=a[2];this.bottom=a[3];}else if(alen==1)// function (ir)
	{this.left=ir.left;this.top=ir.top;this.right=ir.right;this.bottom=ir.bottom;}else// function ()
	{this.left=0;this.top=0;this.right=0;this.bottom=0;}};ClipperLib.IntRect0=function(){this.left=0;this.top=0;this.right=0;this.bottom=0;};ClipperLib.IntRect1=function(ir){this.left=ir.left;this.top=ir.top;this.right=ir.right;this.bottom=ir.bottom;};ClipperLib.IntRect4=function(l,t,r,b){this.left=l;this.top=t;this.right=r;this.bottom=b;};ClipperLib.ClipType={ctIntersection:0,ctUnion:1,ctDifference:2,ctXor:3};ClipperLib.PolyType={ptSubject:0,ptClip:1};ClipperLib.PolyFillType={pftEvenOdd:0,pftNonZero:1,pftPositive:2,pftNegative:3};ClipperLib.JoinType={jtSquare:0,jtRound:1,jtMiter:2};ClipperLib.EndType={etOpenSquare:0,etOpenRound:1,etOpenButt:2,etClosedLine:3,etClosedPolygon:4};if(use_deprecated)ClipperLib.EndType_={etSquare:0,etRound:1,etButt:2,etClosed:3};ClipperLib.EdgeSide={esLeft:0,esRight:1};ClipperLib.Direction={dRightToLeft:0,dLeftToRight:1};ClipperLib.TEdge=function(){this.Bot=new ClipperLib.IntPoint();this.Curr=new ClipperLib.IntPoint();this.Top=new ClipperLib.IntPoint();this.Delta=new ClipperLib.IntPoint();this.Dx=0;this.PolyTyp=ClipperLib.PolyType.ptSubject;this.Side=ClipperLib.EdgeSide.esLeft;this.WindDelta=0;this.WindCnt=0;this.WindCnt2=0;this.OutIdx=0;this.Next=null;this.Prev=null;this.NextInLML=null;this.NextInAEL=null;this.PrevInAEL=null;this.NextInSEL=null;this.PrevInSEL=null;};ClipperLib.IntersectNode=function(){this.Edge1=null;this.Edge2=null;this.Pt=new ClipperLib.IntPoint();};ClipperLib.MyIntersectNodeSort=function(){};ClipperLib.MyIntersectNodeSort.Compare=function(node1,node2){return node2.Pt.Y-node1.Pt.Y;};ClipperLib.LocalMinima=function(){this.Y=0;this.LeftBound=null;this.RightBound=null;this.Next=null;};ClipperLib.Scanbeam=function(){this.Y=0;this.Next=null;};ClipperLib.OutRec=function(){this.Idx=0;this.IsHole=false;this.IsOpen=false;this.FirstLeft=null;this.Pts=null;this.BottomPt=null;this.PolyNode=null;};ClipperLib.OutPt=function(){this.Idx=0;this.Pt=new ClipperLib.IntPoint();this.Next=null;this.Prev=null;};ClipperLib.Join=function(){this.OutPt1=null;this.OutPt2=null;this.OffPt=new ClipperLib.IntPoint();};ClipperLib.ClipperBase=function(){this.m_MinimaList=null;this.m_CurrentLM=null;this.m_edges=new Array();this.m_UseFullRange=false;this.m_HasOpenPaths=false;this.PreserveCollinear=false;this.m_MinimaList=null;this.m_CurrentLM=null;this.m_UseFullRange=false;this.m_HasOpenPaths=false;};// Ranges are in original C# too high for Javascript (in current state 2013 september):
	// protected const double horizontal = -3.4E+38;
	// internal const cInt loRange = 0x3FFFFFFF; // = 1073741823 = sqrt(2^63 -1)/2
	// internal const cInt hiRange = 0x3FFFFFFFFFFFFFFFL; // = 4611686018427387903 = sqrt(2^127 -1)/2
	// So had to adjust them to more suitable for Javascript.
	// If JS some day supports truly 64-bit integers, then these ranges can be as in C#
	// and biginteger library can be more simpler (as then 128bit can be represented as two 64bit numbers)
	ClipperLib.ClipperBase.horizontal=-9007199254740992;//-2^53
	ClipperLib.ClipperBase.Skip=-2;ClipperLib.ClipperBase.Unassigned=-1;ClipperLib.ClipperBase.tolerance=1E-20;if(use_int32){ClipperLib.ClipperBase.loRange=46340;ClipperLib.ClipperBase.hiRange=46340;}else{ClipperLib.ClipperBase.loRange=47453132;// sqrt(2^53 -1)/2
	ClipperLib.ClipperBase.hiRange=4503599627370495;// sqrt(2^106 -1)/2
	}ClipperLib.ClipperBase.near_zero=function(val){return val>-ClipperLib.ClipperBase.tolerance&&val<ClipperLib.ClipperBase.tolerance;};ClipperLib.ClipperBase.IsHorizontal=function(e){return e.Delta.Y===0;};ClipperLib.ClipperBase.prototype.PointIsVertex=function(pt,pp){var pp2=pp;do{if(ClipperLib.IntPoint.op_Equality(pp2.Pt,pt))return true;pp2=pp2.Next;}while(pp2!=pp);return false;};ClipperLib.ClipperBase.prototype.PointOnLineSegment=function(pt,linePt1,linePt2,UseFullRange){if(UseFullRange)return pt.X==linePt1.X&&pt.Y==linePt1.Y||pt.X==linePt2.X&&pt.Y==linePt2.Y||pt.X>linePt1.X==pt.X<linePt2.X&&pt.Y>linePt1.Y==pt.Y<linePt2.Y&&Int128.op_Equality(Int128.Int128Mul(pt.X-linePt1.X,linePt2.Y-linePt1.Y),Int128.Int128Mul(linePt2.X-linePt1.X,pt.Y-linePt1.Y));else return pt.X==linePt1.X&&pt.Y==linePt1.Y||pt.X==linePt2.X&&pt.Y==linePt2.Y||pt.X>linePt1.X==pt.X<linePt2.X&&pt.Y>linePt1.Y==pt.Y<linePt2.Y&&(pt.X-linePt1.X)*(linePt2.Y-linePt1.Y)==(linePt2.X-linePt1.X)*(pt.Y-linePt1.Y);};ClipperLib.ClipperBase.prototype.PointOnPolygon=function(pt,pp,UseFullRange){var pp2=pp;while(true){if(this.PointOnLineSegment(pt,pp2.Pt,pp2.Next.Pt,UseFullRange))return true;pp2=pp2.Next;if(pp2==pp)break;}return false;};ClipperLib.ClipperBase.prototype.SlopesEqual=ClipperLib.ClipperBase.SlopesEqual=function(){var a=arguments,alen=a.length;var e1,e2,pt1,pt2,pt3,pt4,UseFullRange;if(alen==3)// function (e1, e2, UseFullRange)
	{e1=a[0];e2=a[1];UseFullRange=a[2];if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y,e2.Delta.X),Int128.Int128Mul(e1.Delta.X,e2.Delta.Y));else return ClipperLib.Cast_Int64(e1.Delta.Y*e2.Delta.X)==ClipperLib.Cast_Int64(e1.Delta.X*e2.Delta.Y);}else if(alen==4)// function (pt1, pt2, pt3, UseFullRange)
	{pt1=a[0];pt2=a[1];pt3=a[2];UseFullRange=a[3];if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(pt1.Y-pt2.Y,pt2.X-pt3.X),Int128.Int128Mul(pt1.X-pt2.X,pt2.Y-pt3.Y));else return ClipperLib.Cast_Int64((pt1.Y-pt2.Y)*(pt2.X-pt3.X))-ClipperLib.Cast_Int64((pt1.X-pt2.X)*(pt2.Y-pt3.Y))===0;}else// function (pt1, pt2, pt3, pt4, UseFullRange)
	{pt1=a[0];pt2=a[1];pt3=a[2];pt4=a[3];UseFullRange=a[4];if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(pt1.Y-pt2.Y,pt3.X-pt4.X),Int128.Int128Mul(pt1.X-pt2.X,pt3.Y-pt4.Y));else return ClipperLib.Cast_Int64((pt1.Y-pt2.Y)*(pt3.X-pt4.X))-ClipperLib.Cast_Int64((pt1.X-pt2.X)*(pt3.Y-pt4.Y))===0;}};ClipperLib.ClipperBase.SlopesEqual3=function(e1,e2,UseFullRange){if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y,e2.Delta.X),Int128.Int128Mul(e1.Delta.X,e2.Delta.Y));else return ClipperLib.Cast_Int64(e1.Delta.Y*e2.Delta.X)==ClipperLib.Cast_Int64(e1.Delta.X*e2.Delta.Y);};ClipperLib.ClipperBase.SlopesEqual4=function(pt1,pt2,pt3,UseFullRange){if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(pt1.Y-pt2.Y,pt2.X-pt3.X),Int128.Int128Mul(pt1.X-pt2.X,pt2.Y-pt3.Y));else return ClipperLib.Cast_Int64((pt1.Y-pt2.Y)*(pt2.X-pt3.X))-ClipperLib.Cast_Int64((pt1.X-pt2.X)*(pt2.Y-pt3.Y))===0;};ClipperLib.ClipperBase.SlopesEqual5=function(pt1,pt2,pt3,pt4,UseFullRange){if(UseFullRange)return Int128.op_Equality(Int128.Int128Mul(pt1.Y-pt2.Y,pt3.X-pt4.X),Int128.Int128Mul(pt1.X-pt2.X,pt3.Y-pt4.Y));else return ClipperLib.Cast_Int64((pt1.Y-pt2.Y)*(pt3.X-pt4.X))-ClipperLib.Cast_Int64((pt1.X-pt2.X)*(pt3.Y-pt4.Y))===0;};ClipperLib.ClipperBase.prototype.Clear=function(){this.DisposeLocalMinimaList();for(var i=0,ilen=this.m_edges.length;i<ilen;++i){for(var j=0,jlen=this.m_edges[i].length;j<jlen;++j){this.m_edges[i][j]=null;}ClipperLib.Clear(this.m_edges[i]);}ClipperLib.Clear(this.m_edges);this.m_UseFullRange=false;this.m_HasOpenPaths=false;};ClipperLib.ClipperBase.prototype.DisposeLocalMinimaList=function(){while(this.m_MinimaList!==null){var tmpLm=this.m_MinimaList.Next;this.m_MinimaList=null;this.m_MinimaList=tmpLm;}this.m_CurrentLM=null;};ClipperLib.ClipperBase.prototype.RangeTest=function(Pt,useFullRange){if(useFullRange.Value){if(Pt.X>ClipperLib.ClipperBase.hiRange||Pt.Y>ClipperLib.ClipperBase.hiRange||-Pt.X>ClipperLib.ClipperBase.hiRange||-Pt.Y>ClipperLib.ClipperBase.hiRange)ClipperLib.Error("Coordinate outside allowed range in RangeTest().");}else if(Pt.X>ClipperLib.ClipperBase.loRange||Pt.Y>ClipperLib.ClipperBase.loRange||-Pt.X>ClipperLib.ClipperBase.loRange||-Pt.Y>ClipperLib.ClipperBase.loRange){useFullRange.Value=true;this.RangeTest(Pt,useFullRange);}};ClipperLib.ClipperBase.prototype.InitEdge=function(e,eNext,ePrev,pt){e.Next=eNext;e.Prev=ePrev;//e.Curr = pt;
	e.Curr.X=pt.X;e.Curr.Y=pt.Y;e.OutIdx=-1;};ClipperLib.ClipperBase.prototype.InitEdge2=function(e,polyType){if(e.Curr.Y>=e.Next.Curr.Y){//e.Bot = e.Curr;
	e.Bot.X=e.Curr.X;e.Bot.Y=e.Curr.Y;//e.Top = e.Next.Curr;
	e.Top.X=e.Next.Curr.X;e.Top.Y=e.Next.Curr.Y;}else{//e.Top = e.Curr;
	e.Top.X=e.Curr.X;e.Top.Y=e.Curr.Y;//e.Bot = e.Next.Curr;
	e.Bot.X=e.Next.Curr.X;e.Bot.Y=e.Next.Curr.Y;}this.SetDx(e);e.PolyTyp=polyType;};ClipperLib.ClipperBase.prototype.FindNextLocMin=function(E){var E2;for(;;){while(ClipperLib.IntPoint.op_Inequality(E.Bot,E.Prev.Bot)||ClipperLib.IntPoint.op_Equality(E.Curr,E.Top)){E=E.Next;}if(E.Dx!=ClipperLib.ClipperBase.horizontal&&E.Prev.Dx!=ClipperLib.ClipperBase.horizontal)break;while(E.Prev.Dx==ClipperLib.ClipperBase.horizontal){E=E.Prev;}E2=E;while(E.Dx==ClipperLib.ClipperBase.horizontal){E=E.Next;}if(E.Top.Y==E.Prev.Bot.Y)continue;//ie just an intermediate horz.
	if(E2.Prev.Bot.X<E.Bot.X)E=E2;break;}return E;};ClipperLib.ClipperBase.prototype.ProcessBound=function(E,IsClockwise){var EStart=E,Result=E;var Horz;var StartX;if(E.Dx==ClipperLib.ClipperBase.horizontal){//it's possible for adjacent overlapping horz edges to start heading left
	//before finishing right, so ...
	if(IsClockwise)StartX=E.Prev.Bot.X;else StartX=E.Next.Bot.X;if(E.Bot.X!=StartX)this.ReverseHorizontal(E);}if(Result.OutIdx!=ClipperLib.ClipperBase.Skip){if(IsClockwise){while(Result.Top.Y==Result.Next.Bot.Y&&Result.Next.OutIdx!=ClipperLib.ClipperBase.Skip){Result=Result.Next;}if(Result.Dx==ClipperLib.ClipperBase.horizontal&&Result.Next.OutIdx!=ClipperLib.ClipperBase.Skip){//nb: at the top of a bound, horizontals are added to the bound
	//only when the preceding edge attaches to the horizontal's left vertex
	//unless a Skip edge is encountered when that becomes the top divide
	Horz=Result;while(Horz.Prev.Dx==ClipperLib.ClipperBase.horizontal){Horz=Horz.Prev;}if(Horz.Prev.Top.X==Result.Next.Top.X){if(!IsClockwise)Result=Horz.Prev;}else if(Horz.Prev.Top.X>Result.Next.Top.X)Result=Horz.Prev;}while(E!=Result){E.NextInLML=E.Next;if(E.Dx==ClipperLib.ClipperBase.horizontal&&E!=EStart&&E.Bot.X!=E.Prev.Top.X)this.ReverseHorizontal(E);E=E.Next;}if(E.Dx==ClipperLib.ClipperBase.horizontal&&E!=EStart&&E.Bot.X!=E.Prev.Top.X)this.ReverseHorizontal(E);Result=Result.Next;//move to the edge just beyond current bound
	}else{while(Result.Top.Y==Result.Prev.Bot.Y&&Result.Prev.OutIdx!=ClipperLib.ClipperBase.Skip){Result=Result.Prev;}if(Result.Dx==ClipperLib.ClipperBase.horizontal&&Result.Prev.OutIdx!=ClipperLib.ClipperBase.Skip){Horz=Result;while(Horz.Next.Dx==ClipperLib.ClipperBase.horizontal){Horz=Horz.Next;}if(Horz.Next.Top.X==Result.Prev.Top.X){if(!IsClockwise)Result=Horz.Next;}else if(Horz.Next.Top.X>Result.Prev.Top.X)Result=Horz.Next;}while(E!=Result){E.NextInLML=E.Prev;if(E.Dx==ClipperLib.ClipperBase.horizontal&&E!=EStart&&E.Bot.X!=E.Next.Top.X)this.ReverseHorizontal(E);E=E.Prev;}if(E.Dx==ClipperLib.ClipperBase.horizontal&&E!=EStart&&E.Bot.X!=E.Next.Top.X)this.ReverseHorizontal(E);Result=Result.Prev;//move to the edge just beyond current bound
	}}if(Result.OutIdx==ClipperLib.ClipperBase.Skip){//if edges still remain in the current bound beyond the skip edge then
	//create another LocMin and call ProcessBound once more
	E=Result;if(IsClockwise){while(E.Top.Y==E.Next.Bot.Y){E=E.Next;}//don't include top horizontals when parsing a bound a second time,
	//they will be contained in the opposite bound ...
	while(E!=Result&&E.Dx==ClipperLib.ClipperBase.horizontal){E=E.Prev;}}else{while(E.Top.Y==E.Prev.Bot.Y){E=E.Prev;}while(E!=Result&&E.Dx==ClipperLib.ClipperBase.horizontal){E=E.Next;}}if(E==Result){if(IsClockwise)Result=E.Next;else Result=E.Prev;}else{//there are more edges in the bound beyond result starting with E
	if(IsClockwise)E=Result.Next;else E=Result.Prev;var locMin=new ClipperLib.LocalMinima();locMin.Next=null;locMin.Y=E.Bot.Y;locMin.LeftBound=null;locMin.RightBound=E;locMin.RightBound.WindDelta=0;Result=this.ProcessBound(locMin.RightBound,IsClockwise);this.InsertLocalMinima(locMin);}}return Result;};ClipperLib.ClipperBase.prototype.AddPath=function(pg,polyType,Closed){if(use_lines){if(!Closed&&polyType==ClipperLib.PolyType.ptClip)ClipperLib.Error("AddPath: Open paths must be subject.");}else{if(!Closed)ClipperLib.Error("AddPath: Open paths have been disabled.");}var highI=pg.length-1;if(Closed)while(highI>0&&ClipperLib.IntPoint.op_Equality(pg[highI],pg[0])){--highI;}while(highI>0&&ClipperLib.IntPoint.op_Equality(pg[highI],pg[highI-1])){--highI;}if(Closed&&highI<2||!Closed&&highI<1)return false;//create a new edge array ...
	var edges=new Array();for(var i=0;i<=highI;i++){edges.push(new ClipperLib.TEdge());}var IsFlat=true;//1. Basic (first) edge initialization ...
	//edges[1].Curr = pg[1];
	edges[1].Curr.X=pg[1].X;edges[1].Curr.Y=pg[1].Y;var $1={Value:this.m_UseFullRange};this.RangeTest(pg[0],$1);this.m_UseFullRange=$1.Value;$1.Value=this.m_UseFullRange;this.RangeTest(pg[highI],$1);this.m_UseFullRange=$1.Value;this.InitEdge(edges[0],edges[1],edges[highI],pg[0]);this.InitEdge(edges[highI],edges[0],edges[highI-1],pg[highI]);for(var i=highI-1;i>=1;--i){$1.Value=this.m_UseFullRange;this.RangeTest(pg[i],$1);this.m_UseFullRange=$1.Value;this.InitEdge(edges[i],edges[i+1],edges[i-1],pg[i]);}var eStart=edges[0];//2. Remove duplicate vertices, and (when closed) collinear edges ...
	var E=eStart,eLoopStop=eStart;for(;;){if(ClipperLib.IntPoint.op_Equality(E.Curr,E.Next.Curr)){if(E==E.Next)break;if(E==eStart)eStart=E.Next;E=this.RemoveEdge(E);eLoopStop=E;continue;}if(E.Prev==E.Next)break;else if(Closed&&ClipperLib.ClipperBase.SlopesEqual(E.Prev.Curr,E.Curr,E.Next.Curr,this.m_UseFullRange)&&(!this.PreserveCollinear||!this.Pt2IsBetweenPt1AndPt3(E.Prev.Curr,E.Curr,E.Next.Curr))){//Collinear edges are allowed for open paths but in closed paths
	//the default is to merge adjacent collinear edges into a single edge.
	//However, if the PreserveCollinear property is enabled, only overlapping
	//collinear edges (ie spikes) will be removed from closed paths.
	if(E==eStart)eStart=E.Next;E=this.RemoveEdge(E);E=E.Prev;eLoopStop=E;continue;}E=E.Next;if(E==eLoopStop)break;}if(!Closed&&E==E.Next||Closed&&E.Prev==E.Next)return false;if(!Closed){this.m_HasOpenPaths=true;eStart.Prev.OutIdx=ClipperLib.ClipperBase.Skip;}//3. Do second stage of edge initialization ...
	var eHighest=eStart;E=eStart;do{this.InitEdge2(E,polyType);E=E.Next;if(IsFlat&&E.Curr.Y!=eStart.Curr.Y)IsFlat=false;}while(E!=eStart);//4. Finally, add edge bounds to LocalMinima list ...
	//Totally flat paths must be handled differently when adding them
	//to LocalMinima list to avoid endless loops etc ...
	if(IsFlat){if(Closed)return false;E.Prev.OutIdx=ClipperLib.ClipperBase.Skip;if(E.Prev.Bot.X<E.Prev.Top.X)this.ReverseHorizontal(E.Prev);var locMin=new ClipperLib.LocalMinima();locMin.Next=null;locMin.Y=E.Bot.Y;locMin.LeftBound=null;locMin.RightBound=E;locMin.RightBound.Side=ClipperLib.EdgeSide.esRight;locMin.RightBound.WindDelta=0;while(E.Next.OutIdx!=ClipperLib.ClipperBase.Skip){E.NextInLML=E.Next;if(E.Bot.X!=E.Prev.Top.X)this.ReverseHorizontal(E);E=E.Next;}this.InsertLocalMinima(locMin);this.m_edges.push(edges);return true;}this.m_edges.push(edges);var clockwise;var EMin=null;for(;;){E=this.FindNextLocMin(E);if(E==EMin)break;else if(EMin==null)EMin=E;//E and E.Prev now share a local minima (left aligned if horizontal).
	//Compare their slopes to find which starts which bound ...
	var locMin=new ClipperLib.LocalMinima();locMin.Next=null;locMin.Y=E.Bot.Y;if(E.Dx<E.Prev.Dx){locMin.LeftBound=E.Prev;locMin.RightBound=E;clockwise=false;//Q.nextInLML = Q.prev
	}else{locMin.LeftBound=E;locMin.RightBound=E.Prev;clockwise=true;//Q.nextInLML = Q.next
	}locMin.LeftBound.Side=ClipperLib.EdgeSide.esLeft;locMin.RightBound.Side=ClipperLib.EdgeSide.esRight;if(!Closed)locMin.LeftBound.WindDelta=0;else if(locMin.LeftBound.Next==locMin.RightBound)locMin.LeftBound.WindDelta=-1;else locMin.LeftBound.WindDelta=1;locMin.RightBound.WindDelta=-locMin.LeftBound.WindDelta;E=this.ProcessBound(locMin.LeftBound,clockwise);var E2=this.ProcessBound(locMin.RightBound,!clockwise);if(locMin.LeftBound.OutIdx==ClipperLib.ClipperBase.Skip)locMin.LeftBound=null;else if(locMin.RightBound.OutIdx==ClipperLib.ClipperBase.Skip)locMin.RightBound=null;this.InsertLocalMinima(locMin);if(!clockwise)E=E2;}return true;};ClipperLib.ClipperBase.prototype.AddPaths=function(ppg,polyType,closed){//  console.log("-------------------------------------------");
	//  console.log(JSON.stringify(ppg));
	var result=false;for(var i=0,ilen=ppg.length;i<ilen;++i){if(this.AddPath(ppg[i],polyType,closed))result=true;}return result;};//------------------------------------------------------------------------------
	ClipperLib.ClipperBase.prototype.Pt2IsBetweenPt1AndPt3=function(pt1,pt2,pt3){if(ClipperLib.IntPoint.op_Equality(pt1,pt3)||ClipperLib.IntPoint.op_Equality(pt1,pt2)||ClipperLib.IntPoint.op_Equality(pt3,pt2))return false;else if(pt1.X!=pt3.X)return pt2.X>pt1.X==pt2.X<pt3.X;else return pt2.Y>pt1.Y==pt2.Y<pt3.Y;};ClipperLib.ClipperBase.prototype.RemoveEdge=function(e){//removes e from double_linked_list (but without removing from memory)
	e.Prev.Next=e.Next;e.Next.Prev=e.Prev;var result=e.Next;e.Prev=null;//flag as removed (see ClipperBase.Clear)
	return result;};ClipperLib.ClipperBase.prototype.SetDx=function(e){e.Delta.X=e.Top.X-e.Bot.X;e.Delta.Y=e.Top.Y-e.Bot.Y;if(e.Delta.Y===0)e.Dx=ClipperLib.ClipperBase.horizontal;else e.Dx=e.Delta.X/e.Delta.Y;};ClipperLib.ClipperBase.prototype.InsertLocalMinima=function(newLm){if(this.m_MinimaList===null){this.m_MinimaList=newLm;}else if(newLm.Y>=this.m_MinimaList.Y){newLm.Next=this.m_MinimaList;this.m_MinimaList=newLm;}else{var tmpLm=this.m_MinimaList;while(tmpLm.Next!==null&&newLm.Y<tmpLm.Next.Y){tmpLm=tmpLm.Next;}newLm.Next=tmpLm.Next;tmpLm.Next=newLm;}};ClipperLib.ClipperBase.prototype.PopLocalMinima=function(){if(this.m_CurrentLM===null)return;this.m_CurrentLM=this.m_CurrentLM.Next;};ClipperLib.ClipperBase.prototype.ReverseHorizontal=function(e){//swap horizontal edges' top and bottom x's so they follow the natural
	//progression of the bounds - ie so their xbots will align with the
	//adjoining lower edge. [Helpful in the ProcessHorizontal() method.]
	var tmp=e.Top.X;e.Top.X=e.Bot.X;e.Bot.X=tmp;if(use_xyz){tmp=e.Top.Z;e.Top.Z=e.Bot.Z;e.Bot.Z=tmp;}};ClipperLib.ClipperBase.prototype.Reset=function(){this.m_CurrentLM=this.m_MinimaList;if(this.m_CurrentLM==null)return;//ie nothing to process
	//reset all edges ...
	var lm=this.m_MinimaList;while(lm!=null){var e=lm.LeftBound;if(e!=null){//e.Curr = e.Bot;
	e.Curr.X=e.Bot.X;e.Curr.Y=e.Bot.Y;e.Side=ClipperLib.EdgeSide.esLeft;e.OutIdx=ClipperLib.ClipperBase.Unassigned;}e=lm.RightBound;if(e!=null){//e.Curr = e.Bot;
	e.Curr.X=e.Bot.X;e.Curr.Y=e.Bot.Y;e.Side=ClipperLib.EdgeSide.esRight;e.OutIdx=ClipperLib.ClipperBase.Unassigned;}lm=lm.Next;}};ClipperLib.Clipper=function(InitOptions)// public Clipper(int InitOptions = 0)
	{if(typeof InitOptions=="undefined")InitOptions=0;this.m_PolyOuts=null;this.m_ClipType=ClipperLib.ClipType.ctIntersection;this.m_Scanbeam=null;this.m_ActiveEdges=null;this.m_SortedEdges=null;this.m_IntersectList=null;this.m_IntersectNodeComparer=null;this.m_ExecuteLocked=false;this.m_ClipFillType=ClipperLib.PolyFillType.pftEvenOdd;this.m_SubjFillType=ClipperLib.PolyFillType.pftEvenOdd;this.m_Joins=null;this.m_GhostJoins=null;this.m_UsingPolyTree=false;this.ReverseSolution=false;this.StrictlySimple=false;ClipperLib.ClipperBase.call(this);this.m_Scanbeam=null;this.m_ActiveEdges=null;this.m_SortedEdges=null;this.m_IntersectList=new Array();this.m_IntersectNodeComparer=ClipperLib.MyIntersectNodeSort.Compare;this.m_ExecuteLocked=false;this.m_UsingPolyTree=false;this.m_PolyOuts=new Array();this.m_Joins=new Array();this.m_GhostJoins=new Array();this.ReverseSolution=(1&InitOptions)!==0;this.StrictlySimple=(2&InitOptions)!==0;this.PreserveCollinear=(4&InitOptions)!==0;if(use_xyz){this.ZFillFunction=null;// function (IntPoint vert1, IntPoint vert2, ref IntPoint intersectPt);
	}};ClipperLib.Clipper.ioReverseSolution=1;ClipperLib.Clipper.ioStrictlySimple=2;ClipperLib.Clipper.ioPreserveCollinear=4;ClipperLib.Clipper.prototype.Clear=function(){if(this.m_edges.length===0)return;//avoids problems with ClipperBase destructor
	this.DisposeAllPolyPts();ClipperLib.ClipperBase.prototype.Clear.call(this);};ClipperLib.Clipper.prototype.DisposeScanbeamList=function(){while(this.m_Scanbeam!==null){var sb2=this.m_Scanbeam.Next;this.m_Scanbeam=null;this.m_Scanbeam=sb2;}};ClipperLib.Clipper.prototype.Reset=function(){ClipperLib.ClipperBase.prototype.Reset.call(this);this.m_Scanbeam=null;this.m_ActiveEdges=null;this.m_SortedEdges=null;var lm=this.m_MinimaList;while(lm!==null){this.InsertScanbeam(lm.Y);lm=lm.Next;}};ClipperLib.Clipper.prototype.InsertScanbeam=function(Y){if(this.m_Scanbeam===null){this.m_Scanbeam=new ClipperLib.Scanbeam();this.m_Scanbeam.Next=null;this.m_Scanbeam.Y=Y;}else if(Y>this.m_Scanbeam.Y){var newSb=new ClipperLib.Scanbeam();newSb.Y=Y;newSb.Next=this.m_Scanbeam;this.m_Scanbeam=newSb;}else{var sb2=this.m_Scanbeam;while(sb2.Next!==null&&Y<=sb2.Next.Y){sb2=sb2.Next;}if(Y==sb2.Y)return;//ie ignores duplicates
	var newSb=new ClipperLib.Scanbeam();newSb.Y=Y;newSb.Next=sb2.Next;sb2.Next=newSb;}};// ************************************
	ClipperLib.Clipper.prototype.Execute=function(){var a=arguments,alen=a.length,ispolytree=a[1]instanceof ClipperLib.PolyTree;if(alen==4&&!ispolytree)// function (clipType, solution, subjFillType, clipFillType)
	{var clipType=a[0],solution=a[1],subjFillType=a[2],clipFillType=a[3];if(this.m_ExecuteLocked)return false;if(this.m_HasOpenPaths)ClipperLib.Error("Error: PolyTree struct is need for open path clipping.");this.m_ExecuteLocked=true;ClipperLib.Clear(solution);this.m_SubjFillType=subjFillType;this.m_ClipFillType=clipFillType;this.m_ClipType=clipType;this.m_UsingPolyTree=false;try{var succeeded=this.ExecuteInternal();//build the return polygons ...
	if(succeeded)this.BuildResult(solution);}finally{this.DisposeAllPolyPts();this.m_ExecuteLocked=false;}return succeeded;}else if(alen==4&&ispolytree)// function (clipType, polytree, subjFillType, clipFillType)
	{var clipType=a[0],polytree=a[1],subjFillType=a[2],clipFillType=a[3];if(this.m_ExecuteLocked)return false;this.m_ExecuteLocked=true;this.m_SubjFillType=subjFillType;this.m_ClipFillType=clipFillType;this.m_ClipType=clipType;this.m_UsingPolyTree=true;try{var succeeded=this.ExecuteInternal();//build the return polygons ...
	if(succeeded)this.BuildResult2(polytree);}finally{this.DisposeAllPolyPts();this.m_ExecuteLocked=false;}return succeeded;}else if(alen==2&&!ispolytree)// function (clipType, solution)
	{var clipType=a[0],solution=a[1];return this.Execute(clipType,solution,ClipperLib.PolyFillType.pftEvenOdd,ClipperLib.PolyFillType.pftEvenOdd);}else if(alen==2&&ispolytree)// function (clipType, polytree)
	{var clipType=a[0],polytree=a[1];return this.Execute(clipType,polytree,ClipperLib.PolyFillType.pftEvenOdd,ClipperLib.PolyFillType.pftEvenOdd);}};ClipperLib.Clipper.prototype.FixHoleLinkage=function(outRec){//skip if an outermost polygon or
	//already already points to the correct FirstLeft ...
	if(outRec.FirstLeft===null||outRec.IsHole!=outRec.FirstLeft.IsHole&&outRec.FirstLeft.Pts!==null)return;var orfl=outRec.FirstLeft;while(orfl!==null&&(orfl.IsHole==outRec.IsHole||orfl.Pts===null)){orfl=orfl.FirstLeft;}outRec.FirstLeft=orfl;};ClipperLib.Clipper.prototype.ExecuteInternal=function(){try{this.Reset();if(this.m_CurrentLM===null)return false;var botY=this.PopScanbeam();do{this.InsertLocalMinimaIntoAEL(botY);ClipperLib.Clear(this.m_GhostJoins);this.ProcessHorizontals(false);if(this.m_Scanbeam===null)break;var topY=this.PopScanbeam();//console.log("botY:" + botY + ", topY:" + topY);
	if(!this.ProcessIntersections(botY,topY))return false;this.ProcessEdgesAtTopOfScanbeam(topY);botY=topY;}while(this.m_Scanbeam!==null||this.m_CurrentLM!==null);//fix orientations ...
	for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];if(outRec.Pts===null||outRec.IsOpen)continue;if((outRec.IsHole^this.ReverseSolution)==this.Area(outRec)>0)this.ReversePolyPtLinks(outRec.Pts);}this.JoinCommonEdges();for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];if(outRec.Pts!==null&&!outRec.IsOpen)this.FixupOutPolygon(outRec);}if(this.StrictlySimple)this.DoSimplePolygons();return true;}finally{ClipperLib.Clear(this.m_Joins);ClipperLib.Clear(this.m_GhostJoins);}};ClipperLib.Clipper.prototype.PopScanbeam=function(){var Y=this.m_Scanbeam.Y;var sb2=this.m_Scanbeam;this.m_Scanbeam=this.m_Scanbeam.Next;sb2=null;return Y;};ClipperLib.Clipper.prototype.DisposeAllPolyPts=function(){for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;++i){this.DisposeOutRec(i);}ClipperLib.Clear(this.m_PolyOuts);};ClipperLib.Clipper.prototype.DisposeOutRec=function(index){var outRec=this.m_PolyOuts[index];if(outRec.Pts!==null)this.DisposeOutPts(outRec.Pts);outRec=null;this.m_PolyOuts[index]=null;};ClipperLib.Clipper.prototype.DisposeOutPts=function(pp){if(pp===null)return;var tmpPp=null;pp.Prev.Next=null;while(pp!==null){tmpPp=pp;pp=pp.Next;tmpPp=null;}};ClipperLib.Clipper.prototype.AddJoin=function(Op1,Op2,OffPt){var j=new ClipperLib.Join();j.OutPt1=Op1;j.OutPt2=Op2;//j.OffPt = OffPt;
	j.OffPt.X=OffPt.X;j.OffPt.Y=OffPt.Y;this.m_Joins.push(j);};ClipperLib.Clipper.prototype.AddGhostJoin=function(Op,OffPt){var j=new ClipperLib.Join();j.OutPt1=Op;//j.OffPt = OffPt;
	j.OffPt.X=OffPt.X;j.OffPt.Y=OffPt.Y;this.m_GhostJoins.push(j);};if(use_xyz){ClipperLib.Clipper.prototype.SetZ=function(pt,e){pt.Z=0;if(this.ZFillFunction!==null){//put the 'preferred' point as first parameter ...
	if(e.OutIdx<0)this.ZFillFunction(e.Bot,e.Top,pt);//outside a path so presume entering
	else this.ZFillFunction(e.Top,e.Bot,pt);//inside a path so presume exiting
	}};//------------------------------------------------------------------------------
	}ClipperLib.Clipper.prototype.InsertLocalMinimaIntoAEL=function(botY){while(this.m_CurrentLM!==null&&this.m_CurrentLM.Y==botY){var lb=this.m_CurrentLM.LeftBound;var rb=this.m_CurrentLM.RightBound;this.PopLocalMinima();var Op1=null;if(lb===null){this.InsertEdgeIntoAEL(rb,null);this.SetWindingCount(rb);if(this.IsContributing(rb))Op1=this.AddOutPt(rb,rb.Bot);}else if(rb==null){this.InsertEdgeIntoAEL(lb,null);this.SetWindingCount(lb);if(this.IsContributing(lb))Op1=this.AddOutPt(lb,lb.Bot);this.InsertScanbeam(lb.Top.Y);}else{this.InsertEdgeIntoAEL(lb,null);this.InsertEdgeIntoAEL(rb,lb);this.SetWindingCount(lb);rb.WindCnt=lb.WindCnt;rb.WindCnt2=lb.WindCnt2;if(this.IsContributing(lb))Op1=this.AddLocalMinPoly(lb,rb,lb.Bot);this.InsertScanbeam(lb.Top.Y);}if(rb!=null){if(ClipperLib.ClipperBase.IsHorizontal(rb))this.AddEdgeToSEL(rb);else this.InsertScanbeam(rb.Top.Y);}if(lb==null||rb==null)continue;//if output polygons share an Edge with a horizontal rb, they'll need joining later ...
	if(Op1!==null&&ClipperLib.ClipperBase.IsHorizontal(rb)&&this.m_GhostJoins.length>0&&rb.WindDelta!==0){for(var i=0,ilen=this.m_GhostJoins.length;i<ilen;i++){//if the horizontal Rb and a 'ghost' horizontal overlap, then convert
	//the 'ghost' join to a real join ready for later ...
	var j=this.m_GhostJoins[i];if(this.HorzSegmentsOverlap(j.OutPt1.Pt,j.OffPt,rb.Bot,rb.Top))this.AddJoin(j.OutPt1,Op1,j.OffPt);}}if(lb.OutIdx>=0&&lb.PrevInAEL!==null&&lb.PrevInAEL.Curr.X==lb.Bot.X&&lb.PrevInAEL.OutIdx>=0&&ClipperLib.ClipperBase.SlopesEqual(lb.PrevInAEL,lb,this.m_UseFullRange)&&lb.WindDelta!==0&&lb.PrevInAEL.WindDelta!==0){var Op2=this.AddOutPt(lb.PrevInAEL,lb.Bot);this.AddJoin(Op1,Op2,lb.Top);}if(lb.NextInAEL!=rb){if(rb.OutIdx>=0&&rb.PrevInAEL.OutIdx>=0&&ClipperLib.ClipperBase.SlopesEqual(rb.PrevInAEL,rb,this.m_UseFullRange)&&rb.WindDelta!==0&&rb.PrevInAEL.WindDelta!==0){var Op2=this.AddOutPt(rb.PrevInAEL,rb.Bot);this.AddJoin(Op1,Op2,rb.Top);}var e=lb.NextInAEL;if(e!==null)while(e!=rb){//nb: For calculating winding counts etc, IntersectEdges() assumes
	//that param1 will be to the right of param2 ABOVE the intersection ...
	this.IntersectEdges(rb,e,lb.Curr,false);//order important here
	e=e.NextInAEL;}}}};ClipperLib.Clipper.prototype.InsertEdgeIntoAEL=function(edge,startEdge){if(this.m_ActiveEdges===null){edge.PrevInAEL=null;edge.NextInAEL=null;this.m_ActiveEdges=edge;}else if(startEdge===null&&this.E2InsertsBeforeE1(this.m_ActiveEdges,edge)){edge.PrevInAEL=null;edge.NextInAEL=this.m_ActiveEdges;this.m_ActiveEdges.PrevInAEL=edge;this.m_ActiveEdges=edge;}else{if(startEdge===null)startEdge=this.m_ActiveEdges;while(startEdge.NextInAEL!==null&&!this.E2InsertsBeforeE1(startEdge.NextInAEL,edge)){startEdge=startEdge.NextInAEL;}edge.NextInAEL=startEdge.NextInAEL;if(startEdge.NextInAEL!==null)startEdge.NextInAEL.PrevInAEL=edge;edge.PrevInAEL=startEdge;startEdge.NextInAEL=edge;}};ClipperLib.Clipper.prototype.E2InsertsBeforeE1=function(e1,e2){if(e2.Curr.X==e1.Curr.X){if(e2.Top.Y>e1.Top.Y)return e2.Top.X<ClipperLib.Clipper.TopX(e1,e2.Top.Y);else return e1.Top.X>ClipperLib.Clipper.TopX(e2,e1.Top.Y);}else return e2.Curr.X<e1.Curr.X;};ClipperLib.Clipper.prototype.IsEvenOddFillType=function(edge){if(edge.PolyTyp==ClipperLib.PolyType.ptSubject)return this.m_SubjFillType==ClipperLib.PolyFillType.pftEvenOdd;else return this.m_ClipFillType==ClipperLib.PolyFillType.pftEvenOdd;};ClipperLib.Clipper.prototype.IsEvenOddAltFillType=function(edge){if(edge.PolyTyp==ClipperLib.PolyType.ptSubject)return this.m_ClipFillType==ClipperLib.PolyFillType.pftEvenOdd;else return this.m_SubjFillType==ClipperLib.PolyFillType.pftEvenOdd;};ClipperLib.Clipper.prototype.IsContributing=function(edge){var pft,pft2;if(edge.PolyTyp==ClipperLib.PolyType.ptSubject){pft=this.m_SubjFillType;pft2=this.m_ClipFillType;}else{pft=this.m_ClipFillType;pft2=this.m_SubjFillType;}switch(pft){case ClipperLib.PolyFillType.pftEvenOdd:if(edge.WindDelta===0&&edge.WindCnt!=1)return false;break;case ClipperLib.PolyFillType.pftNonZero:if(Math.abs(edge.WindCnt)!=1)return false;break;case ClipperLib.PolyFillType.pftPositive:if(edge.WindCnt!=1)return false;break;default:if(edge.WindCnt!=-1)return false;break;}switch(this.m_ClipType){case ClipperLib.ClipType.ctIntersection:switch(pft2){case ClipperLib.PolyFillType.pftEvenOdd:case ClipperLib.PolyFillType.pftNonZero:return edge.WindCnt2!==0;case ClipperLib.PolyFillType.pftPositive:return edge.WindCnt2>0;default:return edge.WindCnt2<0;}case ClipperLib.ClipType.ctUnion:switch(pft2){case ClipperLib.PolyFillType.pftEvenOdd:case ClipperLib.PolyFillType.pftNonZero:return edge.WindCnt2===0;case ClipperLib.PolyFillType.pftPositive:return edge.WindCnt2<=0;default:return edge.WindCnt2>=0;}case ClipperLib.ClipType.ctDifference:if(edge.PolyTyp==ClipperLib.PolyType.ptSubject)switch(pft2){case ClipperLib.PolyFillType.pftEvenOdd:case ClipperLib.PolyFillType.pftNonZero:return edge.WindCnt2===0;case ClipperLib.PolyFillType.pftPositive:return edge.WindCnt2<=0;default:return edge.WindCnt2>=0;}else switch(pft2){case ClipperLib.PolyFillType.pftEvenOdd:case ClipperLib.PolyFillType.pftNonZero:return edge.WindCnt2!==0;case ClipperLib.PolyFillType.pftPositive:return edge.WindCnt2>0;default:return edge.WindCnt2<0;}case ClipperLib.ClipType.ctXor:if(edge.WindDelta===0)switch(pft2){case ClipperLib.PolyFillType.pftEvenOdd:case ClipperLib.PolyFillType.pftNonZero:return edge.WindCnt2===0;case ClipperLib.PolyFillType.pftPositive:return edge.WindCnt2<=0;default:return edge.WindCnt2>=0;}else return true;}return true;};ClipperLib.Clipper.prototype.SetWindingCount=function(edge){var e=edge.PrevInAEL;//find the edge of the same polytype that immediately preceeds 'edge' in AEL
	while(e!==null&&(e.PolyTyp!=edge.PolyTyp||e.WindDelta===0)){e=e.PrevInAEL;}if(e===null){edge.WindCnt=edge.WindDelta===0?1:edge.WindDelta;edge.WindCnt2=0;e=this.m_ActiveEdges;//ie get ready to calc WindCnt2
	}else if(edge.WindDelta===0&&this.m_ClipType!=ClipperLib.ClipType.ctUnion){edge.WindCnt=1;edge.WindCnt2=e.WindCnt2;e=e.NextInAEL;//ie get ready to calc WindCnt2
	}else if(this.IsEvenOddFillType(edge)){//EvenOdd filling ...
	if(edge.WindDelta===0){//are we inside a subj polygon ...
	var Inside=true;var e2=e.PrevInAEL;while(e2!==null){if(e2.PolyTyp==e.PolyTyp&&e2.WindDelta!==0)Inside=!Inside;e2=e2.PrevInAEL;}edge.WindCnt=Inside?0:1;}else{edge.WindCnt=edge.WindDelta;}edge.WindCnt2=e.WindCnt2;e=e.NextInAEL;//ie get ready to calc WindCnt2
	}else{//nonZero, Positive or Negative filling ...
	if(e.WindCnt*e.WindDelta<0){//prev edge is 'decreasing' WindCount (WC) toward zero
	//so we're outside the previous polygon ...
	if(Math.abs(e.WindCnt)>1){//outside prev poly but still inside another.
	//when reversing direction of prev poly use the same WC
	if(e.WindDelta*edge.WindDelta<0)edge.WindCnt=e.WindCnt;else edge.WindCnt=e.WindCnt+edge.WindDelta;}else edge.WindCnt=edge.WindDelta===0?1:edge.WindDelta;}else{//prev edge is 'increasing' WindCount (WC) away from zero
	//so we're inside the previous polygon ...
	if(edge.WindDelta===0)edge.WindCnt=e.WindCnt<0?e.WindCnt-1:e.WindCnt+1;else if(e.WindDelta*edge.WindDelta<0)edge.WindCnt=e.WindCnt;else edge.WindCnt=e.WindCnt+edge.WindDelta;}edge.WindCnt2=e.WindCnt2;e=e.NextInAEL;//ie get ready to calc WindCnt2
	}//update WindCnt2 ...
	if(this.IsEvenOddAltFillType(edge)){//EvenOdd filling ...
	while(e!=edge){if(e.WindDelta!==0)edge.WindCnt2=edge.WindCnt2===0?1:0;e=e.NextInAEL;}}else{//nonZero, Positive or Negative filling ...
	while(e!=edge){edge.WindCnt2+=e.WindDelta;e=e.NextInAEL;}}};ClipperLib.Clipper.prototype.AddEdgeToSEL=function(edge){//SEL pointers in PEdge are reused to build a list of horizontal edges.
	//However, we don't need to worry about order with horizontal edge processing.
	if(this.m_SortedEdges===null){this.m_SortedEdges=edge;edge.PrevInSEL=null;edge.NextInSEL=null;}else{edge.NextInSEL=this.m_SortedEdges;edge.PrevInSEL=null;this.m_SortedEdges.PrevInSEL=edge;this.m_SortedEdges=edge;}};ClipperLib.Clipper.prototype.CopyAELToSEL=function(){var e=this.m_ActiveEdges;this.m_SortedEdges=e;while(e!==null){e.PrevInSEL=e.PrevInAEL;e.NextInSEL=e.NextInAEL;e=e.NextInAEL;}};ClipperLib.Clipper.prototype.SwapPositionsInAEL=function(edge1,edge2){//check that one or other edge hasn't already been removed from AEL ...
	if(edge1.NextInAEL==edge1.PrevInAEL||edge2.NextInAEL==edge2.PrevInAEL)return;if(edge1.NextInAEL==edge2){var next=edge2.NextInAEL;if(next!==null)next.PrevInAEL=edge1;var prev=edge1.PrevInAEL;if(prev!==null)prev.NextInAEL=edge2;edge2.PrevInAEL=prev;edge2.NextInAEL=edge1;edge1.PrevInAEL=edge2;edge1.NextInAEL=next;}else if(edge2.NextInAEL==edge1){var next=edge1.NextInAEL;if(next!==null)next.PrevInAEL=edge2;var prev=edge2.PrevInAEL;if(prev!==null)prev.NextInAEL=edge1;edge1.PrevInAEL=prev;edge1.NextInAEL=edge2;edge2.PrevInAEL=edge1;edge2.NextInAEL=next;}else{var next=edge1.NextInAEL;var prev=edge1.PrevInAEL;edge1.NextInAEL=edge2.NextInAEL;if(edge1.NextInAEL!==null)edge1.NextInAEL.PrevInAEL=edge1;edge1.PrevInAEL=edge2.PrevInAEL;if(edge1.PrevInAEL!==null)edge1.PrevInAEL.NextInAEL=edge1;edge2.NextInAEL=next;if(edge2.NextInAEL!==null)edge2.NextInAEL.PrevInAEL=edge2;edge2.PrevInAEL=prev;if(edge2.PrevInAEL!==null)edge2.PrevInAEL.NextInAEL=edge2;}if(edge1.PrevInAEL===null)this.m_ActiveEdges=edge1;else if(edge2.PrevInAEL===null)this.m_ActiveEdges=edge2;};ClipperLib.Clipper.prototype.SwapPositionsInSEL=function(edge1,edge2){if(edge1.NextInSEL===null&&edge1.PrevInSEL===null)return;if(edge2.NextInSEL===null&&edge2.PrevInSEL===null)return;if(edge1.NextInSEL==edge2){var next=edge2.NextInSEL;if(next!==null)next.PrevInSEL=edge1;var prev=edge1.PrevInSEL;if(prev!==null)prev.NextInSEL=edge2;edge2.PrevInSEL=prev;edge2.NextInSEL=edge1;edge1.PrevInSEL=edge2;edge1.NextInSEL=next;}else if(edge2.NextInSEL==edge1){var next=edge1.NextInSEL;if(next!==null)next.PrevInSEL=edge2;var prev=edge2.PrevInSEL;if(prev!==null)prev.NextInSEL=edge1;edge1.PrevInSEL=prev;edge1.NextInSEL=edge2;edge2.PrevInSEL=edge1;edge2.NextInSEL=next;}else{var next=edge1.NextInSEL;var prev=edge1.PrevInSEL;edge1.NextInSEL=edge2.NextInSEL;if(edge1.NextInSEL!==null)edge1.NextInSEL.PrevInSEL=edge1;edge1.PrevInSEL=edge2.PrevInSEL;if(edge1.PrevInSEL!==null)edge1.PrevInSEL.NextInSEL=edge1;edge2.NextInSEL=next;if(edge2.NextInSEL!==null)edge2.NextInSEL.PrevInSEL=edge2;edge2.PrevInSEL=prev;if(edge2.PrevInSEL!==null)edge2.PrevInSEL.NextInSEL=edge2;}if(edge1.PrevInSEL===null)this.m_SortedEdges=edge1;else if(edge2.PrevInSEL===null)this.m_SortedEdges=edge2;};ClipperLib.Clipper.prototype.AddLocalMaxPoly=function(e1,e2,pt){this.AddOutPt(e1,pt);if(e2.WindDelta==0)this.AddOutPt(e2,pt);if(e1.OutIdx==e2.OutIdx){e1.OutIdx=-1;e2.OutIdx=-1;}else if(e1.OutIdx<e2.OutIdx)this.AppendPolygon(e1,e2);else this.AppendPolygon(e2,e1);};ClipperLib.Clipper.prototype.AddLocalMinPoly=function(e1,e2,pt){var result;var e,prevE;if(ClipperLib.ClipperBase.IsHorizontal(e2)||e1.Dx>e2.Dx){result=this.AddOutPt(e1,pt);e2.OutIdx=e1.OutIdx;e1.Side=ClipperLib.EdgeSide.esLeft;e2.Side=ClipperLib.EdgeSide.esRight;e=e1;if(e.PrevInAEL==e2)prevE=e2.PrevInAEL;else prevE=e.PrevInAEL;}else{result=this.AddOutPt(e2,pt);e1.OutIdx=e2.OutIdx;e1.Side=ClipperLib.EdgeSide.esRight;e2.Side=ClipperLib.EdgeSide.esLeft;e=e2;if(e.PrevInAEL==e1)prevE=e1.PrevInAEL;else prevE=e.PrevInAEL;}if(prevE!==null&&prevE.OutIdx>=0&&ClipperLib.Clipper.TopX(prevE,pt.Y)==ClipperLib.Clipper.TopX(e,pt.Y)&&ClipperLib.ClipperBase.SlopesEqual(e,prevE,this.m_UseFullRange)&&e.WindDelta!==0&&prevE.WindDelta!==0){var outPt=this.AddOutPt(prevE,pt);this.AddJoin(result,outPt,e.Top);}return result;};ClipperLib.Clipper.prototype.CreateOutRec=function(){var result=new ClipperLib.OutRec();result.Idx=-1;result.IsHole=false;result.IsOpen=false;result.FirstLeft=null;result.Pts=null;result.BottomPt=null;result.PolyNode=null;this.m_PolyOuts.push(result);result.Idx=this.m_PolyOuts.length-1;return result;};ClipperLib.Clipper.prototype.AddOutPt=function(e,pt){var ToFront=e.Side==ClipperLib.EdgeSide.esLeft;if(e.OutIdx<0){var outRec=this.CreateOutRec();outRec.IsOpen=e.WindDelta===0;var newOp=new ClipperLib.OutPt();outRec.Pts=newOp;newOp.Idx=outRec.Idx;//newOp.Pt = pt;
	newOp.Pt.X=pt.X;newOp.Pt.Y=pt.Y;newOp.Next=newOp;newOp.Prev=newOp;if(!outRec.IsOpen)this.SetHoleState(e,outRec);if(use_xyz){if(ClipperLib.IntPoint.op_Equality(pt,e.Bot)){//newOp.Pt = e.Bot;
	newOp.Pt.X=e.Bot.X;newOp.Pt.Y=e.Bot.Y;newOp.Pt.Z=e.Bot.Z;}else if(ClipperLib.IntPoint.op_Equality(pt,e.Top)){//newOp.Pt = e.Top;
	newOp.Pt.X=e.Top.X;newOp.Pt.Y=e.Top.Y;newOp.Pt.Z=e.Top.Z;}else this.SetZ(newOp.Pt,e);}e.OutIdx=outRec.Idx;//nb: do this after SetZ !
	return newOp;}else{var outRec=this.m_PolyOuts[e.OutIdx];//OutRec.Pts is the 'Left-most' point & OutRec.Pts.Prev is the 'Right-most'
	var op=outRec.Pts;if(ToFront&&ClipperLib.IntPoint.op_Equality(pt,op.Pt))return op;else if(!ToFront&&ClipperLib.IntPoint.op_Equality(pt,op.Prev.Pt))return op.Prev;var newOp=new ClipperLib.OutPt();newOp.Idx=outRec.Idx;//newOp.Pt = pt;
	newOp.Pt.X=pt.X;newOp.Pt.Y=pt.Y;newOp.Next=op;newOp.Prev=op.Prev;newOp.Prev.Next=newOp;op.Prev=newOp;if(ToFront)outRec.Pts=newOp;if(use_xyz){if(ClipperLib.IntPoint.op_Equality(pt,e.Bot)){//newOp.Pt = e.Bot;
	newOp.Pt.X=e.Bot.X;newOp.Pt.Y=e.Bot.Y;newOp.Pt.Z=e.Bot.Z;}else if(ClipperLib.IntPoint.op_Equality(pt,e.Top)){//newOp.Pt = e.Top;
	newOp.Pt.X=e.Top.X;newOp.Pt.Y=e.Top.Y;newOp.Pt.Z=e.Top.Z;}else this.SetZ(newOp.Pt,e);}return newOp;}};ClipperLib.Clipper.prototype.SwapPoints=function(pt1,pt2){var tmp=new ClipperLib.IntPoint(pt1.Value);//pt1.Value = pt2.Value;
	pt1.Value.X=pt2.Value.X;pt1.Value.Y=pt2.Value.Y;//pt2.Value = tmp;
	pt2.Value.X=tmp.X;pt2.Value.Y=tmp.Y;};ClipperLib.Clipper.prototype.HorzSegmentsOverlap=function(Pt1a,Pt1b,Pt2a,Pt2b){//precondition: both segments are horizontal
	if(Pt1a.X>Pt2a.X==Pt1a.X<Pt2b.X)return true;else if(Pt1b.X>Pt2a.X==Pt1b.X<Pt2b.X)return true;else if(Pt2a.X>Pt1a.X==Pt2a.X<Pt1b.X)return true;else if(Pt2b.X>Pt1a.X==Pt2b.X<Pt1b.X)return true;else if(Pt1a.X==Pt2a.X&&Pt1b.X==Pt2b.X)return true;else if(Pt1a.X==Pt2b.X&&Pt1b.X==Pt2a.X)return true;else return false;};ClipperLib.Clipper.prototype.InsertPolyPtBetween=function(p1,p2,pt){var result=new ClipperLib.OutPt();//result.Pt = pt;
	result.Pt.X=pt.X;result.Pt.Y=pt.Y;if(p2==p1.Next){p1.Next=result;p2.Prev=result;result.Next=p2;result.Prev=p1;}else{p2.Next=result;p1.Prev=result;result.Next=p1;result.Prev=p2;}return result;};ClipperLib.Clipper.prototype.SetHoleState=function(e,outRec){var isHole=false;var e2=e.PrevInAEL;while(e2!==null){if(e2.OutIdx>=0&&e2.WindDelta!=0){isHole=!isHole;if(outRec.FirstLeft===null)outRec.FirstLeft=this.m_PolyOuts[e2.OutIdx];}e2=e2.PrevInAEL;}if(isHole)outRec.IsHole=true;};ClipperLib.Clipper.prototype.GetDx=function(pt1,pt2){if(pt1.Y==pt2.Y)return ClipperLib.ClipperBase.horizontal;else return(pt2.X-pt1.X)/(pt2.Y-pt1.Y);};ClipperLib.Clipper.prototype.FirstIsBottomPt=function(btmPt1,btmPt2){var p=btmPt1.Prev;while(ClipperLib.IntPoint.op_Equality(p.Pt,btmPt1.Pt)&&p!=btmPt1){p=p.Prev;}var dx1p=Math.abs(this.GetDx(btmPt1.Pt,p.Pt));p=btmPt1.Next;while(ClipperLib.IntPoint.op_Equality(p.Pt,btmPt1.Pt)&&p!=btmPt1){p=p.Next;}var dx1n=Math.abs(this.GetDx(btmPt1.Pt,p.Pt));p=btmPt2.Prev;while(ClipperLib.IntPoint.op_Equality(p.Pt,btmPt2.Pt)&&p!=btmPt2){p=p.Prev;}var dx2p=Math.abs(this.GetDx(btmPt2.Pt,p.Pt));p=btmPt2.Next;while(ClipperLib.IntPoint.op_Equality(p.Pt,btmPt2.Pt)&&p!=btmPt2){p=p.Next;}var dx2n=Math.abs(this.GetDx(btmPt2.Pt,p.Pt));return dx1p>=dx2p&&dx1p>=dx2n||dx1n>=dx2p&&dx1n>=dx2n;};ClipperLib.Clipper.prototype.GetBottomPt=function(pp){var dups=null;var p=pp.Next;while(p!=pp){if(p.Pt.Y>pp.Pt.Y){pp=p;dups=null;}else if(p.Pt.Y==pp.Pt.Y&&p.Pt.X<=pp.Pt.X){if(p.Pt.X<pp.Pt.X){dups=null;pp=p;}else{if(p.Next!=pp&&p.Prev!=pp)dups=p;}}p=p.Next;}if(dups!==null){//there appears to be at least 2 vertices at bottomPt so ...
	while(dups!=p){if(!this.FirstIsBottomPt(p,dups))pp=dups;dups=dups.Next;while(ClipperLib.IntPoint.op_Inequality(dups.Pt,pp.Pt)){dups=dups.Next;}}}return pp;};ClipperLib.Clipper.prototype.GetLowermostRec=function(outRec1,outRec2){//work out which polygon fragment has the correct hole state ...
	if(outRec1.BottomPt===null)outRec1.BottomPt=this.GetBottomPt(outRec1.Pts);if(outRec2.BottomPt===null)outRec2.BottomPt=this.GetBottomPt(outRec2.Pts);var bPt1=outRec1.BottomPt;var bPt2=outRec2.BottomPt;if(bPt1.Pt.Y>bPt2.Pt.Y)return outRec1;else if(bPt1.Pt.Y<bPt2.Pt.Y)return outRec2;else if(bPt1.Pt.X<bPt2.Pt.X)return outRec1;else if(bPt1.Pt.X>bPt2.Pt.X)return outRec2;else if(bPt1.Next==bPt1)return outRec2;else if(bPt2.Next==bPt2)return outRec1;else if(this.FirstIsBottomPt(bPt1,bPt2))return outRec1;else return outRec2;};ClipperLib.Clipper.prototype.Param1RightOfParam2=function(outRec1,outRec2){do{outRec1=outRec1.FirstLeft;if(outRec1==outRec2)return true;}while(outRec1!==null);return false;};ClipperLib.Clipper.prototype.GetOutRec=function(idx){var outrec=this.m_PolyOuts[idx];while(outrec!=this.m_PolyOuts[outrec.Idx]){outrec=this.m_PolyOuts[outrec.Idx];}return outrec;};ClipperLib.Clipper.prototype.AppendPolygon=function(e1,e2){//get the start and ends of both output polygons ...
	var outRec1=this.m_PolyOuts[e1.OutIdx];var outRec2=this.m_PolyOuts[e2.OutIdx];var holeStateRec;if(this.Param1RightOfParam2(outRec1,outRec2))holeStateRec=outRec2;else if(this.Param1RightOfParam2(outRec2,outRec1))holeStateRec=outRec1;else holeStateRec=this.GetLowermostRec(outRec1,outRec2);var p1_lft=outRec1.Pts;var p1_rt=p1_lft.Prev;var p2_lft=outRec2.Pts;var p2_rt=p2_lft.Prev;var side;//join e2 poly onto e1 poly and delete pointers to e2 ...
	if(e1.Side==ClipperLib.EdgeSide.esLeft){if(e2.Side==ClipperLib.EdgeSide.esLeft){//z y x a b c
	this.ReversePolyPtLinks(p2_lft);p2_lft.Next=p1_lft;p1_lft.Prev=p2_lft;p1_rt.Next=p2_rt;p2_rt.Prev=p1_rt;outRec1.Pts=p2_rt;}else{//x y z a b c
	p2_rt.Next=p1_lft;p1_lft.Prev=p2_rt;p2_lft.Prev=p1_rt;p1_rt.Next=p2_lft;outRec1.Pts=p2_lft;}side=ClipperLib.EdgeSide.esLeft;}else{if(e2.Side==ClipperLib.EdgeSide.esRight){//a b c z y x
	this.ReversePolyPtLinks(p2_lft);p1_rt.Next=p2_rt;p2_rt.Prev=p1_rt;p2_lft.Next=p1_lft;p1_lft.Prev=p2_lft;}else{//a b c x y z
	p1_rt.Next=p2_lft;p2_lft.Prev=p1_rt;p1_lft.Prev=p2_rt;p2_rt.Next=p1_lft;}side=ClipperLib.EdgeSide.esRight;}outRec1.BottomPt=null;if(holeStateRec==outRec2){if(outRec2.FirstLeft!=outRec1)outRec1.FirstLeft=outRec2.FirstLeft;outRec1.IsHole=outRec2.IsHole;}outRec2.Pts=null;outRec2.BottomPt=null;outRec2.FirstLeft=outRec1;var OKIdx=e1.OutIdx;var ObsoleteIdx=e2.OutIdx;e1.OutIdx=-1;//nb: safe because we only get here via AddLocalMaxPoly
	e2.OutIdx=-1;var e=this.m_ActiveEdges;while(e!==null){if(e.OutIdx==ObsoleteIdx){e.OutIdx=OKIdx;e.Side=side;break;}e=e.NextInAEL;}outRec2.Idx=outRec1.Idx;};ClipperLib.Clipper.prototype.ReversePolyPtLinks=function(pp){if(pp===null)return;var pp1;var pp2;pp1=pp;do{pp2=pp1.Next;pp1.Next=pp1.Prev;pp1.Prev=pp2;pp1=pp2;}while(pp1!=pp);};ClipperLib.Clipper.SwapSides=function(edge1,edge2){var side=edge1.Side;edge1.Side=edge2.Side;edge2.Side=side;};ClipperLib.Clipper.SwapPolyIndexes=function(edge1,edge2){var outIdx=edge1.OutIdx;edge1.OutIdx=edge2.OutIdx;edge2.OutIdx=outIdx;};ClipperLib.Clipper.prototype.IntersectEdges=function(e1,e2,pt,protect){//e1 will be to the left of e2 BELOW the intersection. Therefore e1 is before
	//e2 in AEL except when e1 is being inserted at the intersection point ...
	var e1stops=!protect&&e1.NextInLML===null&&e1.Top.X==pt.X&&e1.Top.Y==pt.Y;var e2stops=!protect&&e2.NextInLML===null&&e2.Top.X==pt.X&&e2.Top.Y==pt.Y;var e1Contributing=e1.OutIdx>=0;var e2Contributing=e2.OutIdx>=0;if(use_lines){//if either edge is on an OPEN path ...
	if(e1.WindDelta===0||e2.WindDelta===0){//ignore subject-subject open path intersections UNLESS they
	//are both open paths, AND they are both 'contributing maximas' ...
	if(e1.WindDelta===0&&e2.WindDelta===0){if((e1stops||e2stops)&&e1Contributing&&e2Contributing)this.AddLocalMaxPoly(e1,e2,pt);}//if intersecting a subj line with a subj poly ...
	else if(e1.PolyTyp==e2.PolyTyp&&e1.WindDelta!=e2.WindDelta&&this.m_ClipType==ClipperLib.ClipType.ctUnion){if(e1.WindDelta===0){if(e2Contributing){this.AddOutPt(e1,pt);if(e1Contributing)e1.OutIdx=-1;}}else{if(e1Contributing){this.AddOutPt(e2,pt);if(e2Contributing)e2.OutIdx=-1;}}}else if(e1.PolyTyp!=e2.PolyTyp){if(e1.WindDelta===0&&Math.abs(e2.WindCnt)==1&&(this.m_ClipType!=ClipperLib.ClipType.ctUnion||e2.WindCnt2===0)){this.AddOutPt(e1,pt);if(e1Contributing)e1.OutIdx=-1;}else if(e2.WindDelta===0&&Math.abs(e1.WindCnt)==1&&(this.m_ClipType!=ClipperLib.ClipType.ctUnion||e1.WindCnt2===0)){this.AddOutPt(e2,pt);if(e2Contributing)e2.OutIdx=-1;}}if(e1stops)if(e1.OutIdx<0)this.DeleteFromAEL(e1);else ClipperLib.Error("Error intersecting polylines");if(e2stops)if(e2.OutIdx<0)this.DeleteFromAEL(e2);else ClipperLib.Error("Error intersecting polylines");return;}}//update winding counts...
	//assumes that e1 will be to the Right of e2 ABOVE the intersection
	if(e1.PolyTyp==e2.PolyTyp){if(this.IsEvenOddFillType(e1)){var oldE1WindCnt=e1.WindCnt;e1.WindCnt=e2.WindCnt;e2.WindCnt=oldE1WindCnt;}else{if(e1.WindCnt+e2.WindDelta===0)e1.WindCnt=-e1.WindCnt;else e1.WindCnt+=e2.WindDelta;if(e2.WindCnt-e1.WindDelta===0)e2.WindCnt=-e2.WindCnt;else e2.WindCnt-=e1.WindDelta;}}else{if(!this.IsEvenOddFillType(e2))e1.WindCnt2+=e2.WindDelta;else e1.WindCnt2=e1.WindCnt2===0?1:0;if(!this.IsEvenOddFillType(e1))e2.WindCnt2-=e1.WindDelta;else e2.WindCnt2=e2.WindCnt2===0?1:0;}var e1FillType,e2FillType,e1FillType2,e2FillType2;if(e1.PolyTyp==ClipperLib.PolyType.ptSubject){e1FillType=this.m_SubjFillType;e1FillType2=this.m_ClipFillType;}else{e1FillType=this.m_ClipFillType;e1FillType2=this.m_SubjFillType;}if(e2.PolyTyp==ClipperLib.PolyType.ptSubject){e2FillType=this.m_SubjFillType;e2FillType2=this.m_ClipFillType;}else{e2FillType=this.m_ClipFillType;e2FillType2=this.m_SubjFillType;}var e1Wc,e2Wc;switch(e1FillType){case ClipperLib.PolyFillType.pftPositive:e1Wc=e1.WindCnt;break;case ClipperLib.PolyFillType.pftNegative:e1Wc=-e1.WindCnt;break;default:e1Wc=Math.abs(e1.WindCnt);break;}switch(e2FillType){case ClipperLib.PolyFillType.pftPositive:e2Wc=e2.WindCnt;break;case ClipperLib.PolyFillType.pftNegative:e2Wc=-e2.WindCnt;break;default:e2Wc=Math.abs(e2.WindCnt);break;}if(e1Contributing&&e2Contributing){if(e1stops||e2stops||e1Wc!==0&&e1Wc!=1||e2Wc!==0&&e2Wc!=1||e1.PolyTyp!=e2.PolyTyp&&this.m_ClipType!=ClipperLib.ClipType.ctXor)this.AddLocalMaxPoly(e1,e2,pt);else{this.AddOutPt(e1,pt);this.AddOutPt(e2,pt);ClipperLib.Clipper.SwapSides(e1,e2);ClipperLib.Clipper.SwapPolyIndexes(e1,e2);}}else if(e1Contributing){if(e2Wc===0||e2Wc==1){this.AddOutPt(e1,pt);ClipperLib.Clipper.SwapSides(e1,e2);ClipperLib.Clipper.SwapPolyIndexes(e1,e2);}}else if(e2Contributing){if(e1Wc===0||e1Wc==1){this.AddOutPt(e2,pt);ClipperLib.Clipper.SwapSides(e1,e2);ClipperLib.Clipper.SwapPolyIndexes(e1,e2);}}else if((e1Wc===0||e1Wc==1)&&(e2Wc===0||e2Wc==1)&&!e1stops&&!e2stops){//neither edge is currently contributing ...
	var e1Wc2,e2Wc2;switch(e1FillType2){case ClipperLib.PolyFillType.pftPositive:e1Wc2=e1.WindCnt2;break;case ClipperLib.PolyFillType.pftNegative:e1Wc2=-e1.WindCnt2;break;default:e1Wc2=Math.abs(e1.WindCnt2);break;}switch(e2FillType2){case ClipperLib.PolyFillType.pftPositive:e2Wc2=e2.WindCnt2;break;case ClipperLib.PolyFillType.pftNegative:e2Wc2=-e2.WindCnt2;break;default:e2Wc2=Math.abs(e2.WindCnt2);break;}if(e1.PolyTyp!=e2.PolyTyp)this.AddLocalMinPoly(e1,e2,pt);else if(e1Wc==1&&e2Wc==1)switch(this.m_ClipType){case ClipperLib.ClipType.ctIntersection:if(e1Wc2>0&&e2Wc2>0)this.AddLocalMinPoly(e1,e2,pt);break;case ClipperLib.ClipType.ctUnion:if(e1Wc2<=0&&e2Wc2<=0)this.AddLocalMinPoly(e1,e2,pt);break;case ClipperLib.ClipType.ctDifference:if(e1.PolyTyp==ClipperLib.PolyType.ptClip&&e1Wc2>0&&e2Wc2>0||e1.PolyTyp==ClipperLib.PolyType.ptSubject&&e1Wc2<=0&&e2Wc2<=0)this.AddLocalMinPoly(e1,e2,pt);break;case ClipperLib.ClipType.ctXor:this.AddLocalMinPoly(e1,e2,pt);break;}else ClipperLib.Clipper.SwapSides(e1,e2);}if(e1stops!=e2stops&&(e1stops&&e1.OutIdx>=0||e2stops&&e2.OutIdx>=0)){ClipperLib.Clipper.SwapSides(e1,e2);ClipperLib.Clipper.SwapPolyIndexes(e1,e2);}//finally, delete any non-contributing maxima edges  ...
	if(e1stops)this.DeleteFromAEL(e1);if(e2stops)this.DeleteFromAEL(e2);};ClipperLib.Clipper.prototype.DeleteFromAEL=function(e){var AelPrev=e.PrevInAEL;var AelNext=e.NextInAEL;if(AelPrev===null&&AelNext===null&&e!=this.m_ActiveEdges)return;//already deleted
	if(AelPrev!==null)AelPrev.NextInAEL=AelNext;else this.m_ActiveEdges=AelNext;if(AelNext!==null)AelNext.PrevInAEL=AelPrev;e.NextInAEL=null;e.PrevInAEL=null;};ClipperLib.Clipper.prototype.DeleteFromSEL=function(e){var SelPrev=e.PrevInSEL;var SelNext=e.NextInSEL;if(SelPrev===null&&SelNext===null&&e!=this.m_SortedEdges)return;//already deleted
	if(SelPrev!==null)SelPrev.NextInSEL=SelNext;else this.m_SortedEdges=SelNext;if(SelNext!==null)SelNext.PrevInSEL=SelPrev;e.NextInSEL=null;e.PrevInSEL=null;};ClipperLib.Clipper.prototype.UpdateEdgeIntoAEL=function(e){if(e.NextInLML===null)ClipperLib.Error("UpdateEdgeIntoAEL: invalid call");var AelPrev=e.PrevInAEL;var AelNext=e.NextInAEL;e.NextInLML.OutIdx=e.OutIdx;if(AelPrev!==null)AelPrev.NextInAEL=e.NextInLML;else this.m_ActiveEdges=e.NextInLML;if(AelNext!==null)AelNext.PrevInAEL=e.NextInLML;e.NextInLML.Side=e.Side;e.NextInLML.WindDelta=e.WindDelta;e.NextInLML.WindCnt=e.WindCnt;e.NextInLML.WindCnt2=e.WindCnt2;e=e.NextInLML;//    e.Curr = e.Bot;
	e.Curr.X=e.Bot.X;e.Curr.Y=e.Bot.Y;e.PrevInAEL=AelPrev;e.NextInAEL=AelNext;if(!ClipperLib.ClipperBase.IsHorizontal(e))this.InsertScanbeam(e.Top.Y);return e;};ClipperLib.Clipper.prototype.ProcessHorizontals=function(isTopOfScanbeam){var horzEdge=this.m_SortedEdges;while(horzEdge!==null){this.DeleteFromSEL(horzEdge);this.ProcessHorizontal(horzEdge,isTopOfScanbeam);horzEdge=this.m_SortedEdges;}};ClipperLib.Clipper.prototype.GetHorzDirection=function(HorzEdge,$var){if(HorzEdge.Bot.X<HorzEdge.Top.X){$var.Left=HorzEdge.Bot.X;$var.Right=HorzEdge.Top.X;$var.Dir=ClipperLib.Direction.dLeftToRight;}else{$var.Left=HorzEdge.Top.X;$var.Right=HorzEdge.Bot.X;$var.Dir=ClipperLib.Direction.dRightToLeft;}};ClipperLib.Clipper.prototype.PrepareHorzJoins=function(horzEdge,isTopOfScanbeam){//get the last Op for this horizontal edge
	//the point may be anywhere along the horizontal ...
	var outPt=this.m_PolyOuts[horzEdge.OutIdx].Pts;if(horzEdge.Side!=ClipperLib.EdgeSide.esLeft)outPt=outPt.Prev;//First, match up overlapping horizontal edges (eg when one polygon's
	//intermediate horz edge overlaps an intermediate horz edge of another, or
	//when one polygon sits on top of another) ...
	//for (var i = 0, ilen = this.m_GhostJoins.length; i < ilen; ++i) {
	//  var j = this.m_GhostJoins[i];
	//  if (this.HorzSegmentsOverlap(j.OutPt1.Pt, j.OffPt, horzEdge.Bot, horzEdge.Top))
	//    this.AddJoin(j.OutPt1, outPt, j.OffPt);
	//}
	//Also, since horizontal edges at the top of one SB are often removed from
	//the AEL before we process the horizontal edges at the bottom of the next,
	//we need to create 'ghost' Join records of 'contrubuting' horizontals that
	//we can compare with horizontals at the bottom of the next SB.
	if(isTopOfScanbeam)if(ClipperLib.IntPoint.op_Equality(outPt.Pt,horzEdge.Top))this.AddGhostJoin(outPt,horzEdge.Bot);else this.AddGhostJoin(outPt,horzEdge.Top);};ClipperLib.Clipper.prototype.ProcessHorizontal=function(horzEdge,isTopOfScanbeam){var $var={Dir:null,Left:null,Right:null};this.GetHorzDirection(horzEdge,$var);var dir=$var.Dir;var horzLeft=$var.Left;var horzRight=$var.Right;var eLastHorz=horzEdge,eMaxPair=null;while(eLastHorz.NextInLML!==null&&ClipperLib.ClipperBase.IsHorizontal(eLastHorz.NextInLML)){eLastHorz=eLastHorz.NextInLML;}if(eLastHorz.NextInLML===null)eMaxPair=this.GetMaximaPair(eLastHorz);for(;;){var IsLastHorz=horzEdge==eLastHorz;var e=this.GetNextInAEL(horzEdge,dir);while(e!==null){//Break if we've got to the end of an intermediate horizontal edge ...
	//nb: Smaller Dx's are to the right of larger Dx's ABOVE the horizontal.
	if(e.Curr.X==horzEdge.Top.X&&horzEdge.NextInLML!==null&&e.Dx<horzEdge.NextInLML.Dx)break;var eNext=this.GetNextInAEL(e,dir);//saves eNext for later
	if(dir==ClipperLib.Direction.dLeftToRight&&e.Curr.X<=horzRight||dir==ClipperLib.Direction.dRightToLeft&&e.Curr.X>=horzLeft){if(horzEdge.OutIdx>=0&&horzEdge.WindDelta!=0)this.PrepareHorzJoins(horzEdge,isTopOfScanbeam);//so far we're still in range of the horizontal Edge  but make sure
	//we're at the last of consec. horizontals when matching with eMaxPair
	if(e==eMaxPair&&IsLastHorz){if(dir==ClipperLib.Direction.dLeftToRight)this.IntersectEdges(horzEdge,e,e.Top,false);else this.IntersectEdges(e,horzEdge,e.Top,false);if(eMaxPair.OutIdx>=0)ClipperLib.Error("ProcessHorizontal error");return;}else if(dir==ClipperLib.Direction.dLeftToRight){var Pt=new ClipperLib.IntPoint(e.Curr.X,horzEdge.Curr.Y);this.IntersectEdges(horzEdge,e,Pt,true);}else{var Pt=new ClipperLib.IntPoint(e.Curr.X,horzEdge.Curr.Y);this.IntersectEdges(e,horzEdge,Pt,true);}this.SwapPositionsInAEL(horzEdge,e);}else if(dir==ClipperLib.Direction.dLeftToRight&&e.Curr.X>=horzRight||dir==ClipperLib.Direction.dRightToLeft&&e.Curr.X<=horzLeft)break;e=eNext;}//end while
	if(horzEdge.OutIdx>=0&&horzEdge.WindDelta!==0)this.PrepareHorzJoins(horzEdge,isTopOfScanbeam);if(horzEdge.NextInLML!==null&&ClipperLib.ClipperBase.IsHorizontal(horzEdge.NextInLML)){horzEdge=this.UpdateEdgeIntoAEL(horzEdge);if(horzEdge.OutIdx>=0)this.AddOutPt(horzEdge,horzEdge.Bot);var $var={Dir:dir,Left:horzLeft,Right:horzRight};this.GetHorzDirection(horzEdge,$var);dir=$var.Dir;horzLeft=$var.Left;horzRight=$var.Right;}else break;}//end for (;;)
	if(horzEdge.NextInLML!==null){if(horzEdge.OutIdx>=0){var op1=this.AddOutPt(horzEdge,horzEdge.Top);horzEdge=this.UpdateEdgeIntoAEL(horzEdge);if(horzEdge.WindDelta===0)return;//nb: HorzEdge is no longer horizontal here
	var ePrev=horzEdge.PrevInAEL;var eNext=horzEdge.NextInAEL;if(ePrev!==null&&ePrev.Curr.X==horzEdge.Bot.X&&ePrev.Curr.Y==horzEdge.Bot.Y&&ePrev.WindDelta!==0&&ePrev.OutIdx>=0&&ePrev.Curr.Y>ePrev.Top.Y&&ClipperLib.ClipperBase.SlopesEqual(horzEdge,ePrev,this.m_UseFullRange)){var op2=this.AddOutPt(ePrev,horzEdge.Bot);this.AddJoin(op1,op2,horzEdge.Top);}else if(eNext!==null&&eNext.Curr.X==horzEdge.Bot.X&&eNext.Curr.Y==horzEdge.Bot.Y&&eNext.WindDelta!==0&&eNext.OutIdx>=0&&eNext.Curr.Y>eNext.Top.Y&&ClipperLib.ClipperBase.SlopesEqual(horzEdge,eNext,this.m_UseFullRange)){var op2=this.AddOutPt(eNext,horzEdge.Bot);this.AddJoin(op1,op2,horzEdge.Top);}}else horzEdge=this.UpdateEdgeIntoAEL(horzEdge);}else if(eMaxPair!==null){if(eMaxPair.OutIdx>=0){if(dir==ClipperLib.Direction.dLeftToRight)this.IntersectEdges(horzEdge,eMaxPair,horzEdge.Top,false);else this.IntersectEdges(eMaxPair,horzEdge,horzEdge.Top,false);if(eMaxPair.OutIdx>=0)ClipperLib.Error("ProcessHorizontal error");}else{this.DeleteFromAEL(horzEdge);this.DeleteFromAEL(eMaxPair);}}else{if(horzEdge.OutIdx>=0)this.AddOutPt(horzEdge,horzEdge.Top);this.DeleteFromAEL(horzEdge);}};ClipperLib.Clipper.prototype.GetNextInAEL=function(e,Direction){return Direction==ClipperLib.Direction.dLeftToRight?e.NextInAEL:e.PrevInAEL;};ClipperLib.Clipper.prototype.IsMinima=function(e){return e!==null&&e.Prev.NextInLML!=e&&e.Next.NextInLML!=e;};ClipperLib.Clipper.prototype.IsMaxima=function(e,Y){return e!==null&&e.Top.Y==Y&&e.NextInLML===null;};ClipperLib.Clipper.prototype.IsIntermediate=function(e,Y){return e.Top.Y==Y&&e.NextInLML!==null;};ClipperLib.Clipper.prototype.GetMaximaPair=function(e){var result=null;if(ClipperLib.IntPoint.op_Equality(e.Next.Top,e.Top)&&e.Next.NextInLML===null)result=e.Next;else if(ClipperLib.IntPoint.op_Equality(e.Prev.Top,e.Top)&&e.Prev.NextInLML===null)result=e.Prev;if(result!==null&&(result.OutIdx==-2||result.NextInAEL==result.PrevInAEL&&!ClipperLib.ClipperBase.IsHorizontal(result)))return null;return result;};ClipperLib.Clipper.prototype.ProcessIntersections=function(botY,topY){if(this.m_ActiveEdges==null)return true;try{this.BuildIntersectList(botY,topY);if(this.m_IntersectList.length==0)return true;if(this.m_IntersectList.length==1||this.FixupIntersectionOrder())this.ProcessIntersectList();else return false;}catch($$e2){this.m_SortedEdges=null;this.m_IntersectList.length=0;ClipperLib.Error("ProcessIntersections error");}this.m_SortedEdges=null;return true;};ClipperLib.Clipper.prototype.BuildIntersectList=function(botY,topY){if(this.m_ActiveEdges===null)return;//prepare for sorting ...
	var e=this.m_ActiveEdges;//console.log(JSON.stringify(JSON.decycle( e )));
	this.m_SortedEdges=e;while(e!==null){e.PrevInSEL=e.PrevInAEL;e.NextInSEL=e.NextInAEL;e.Curr.X=ClipperLib.Clipper.TopX(e,topY);e=e.NextInAEL;}//bubblesort ...
	var isModified=true;while(isModified&&this.m_SortedEdges!==null){isModified=false;e=this.m_SortedEdges;while(e.NextInSEL!==null){var eNext=e.NextInSEL;var pt=new ClipperLib.IntPoint();//console.log("e.Curr.X: " + e.Curr.X + " eNext.Curr.X" + eNext.Curr.X);
	if(e.Curr.X>eNext.Curr.X){if(!this.IntersectPoint(e,eNext,pt)&&e.Curr.X>eNext.Curr.X+1){//console.log("e.Curr.X: "+JSON.stringify(JSON.decycle( e.Curr.X )));
	//console.log("eNext.Curr.X+1: "+JSON.stringify(JSON.decycle( eNext.Curr.X+1)));
	ClipperLib.Error("Intersection error");}if(pt.Y>botY){pt.Y=botY;if(Math.abs(e.Dx)>Math.abs(eNext.Dx))pt.X=ClipperLib.Clipper.TopX(eNext,botY);else pt.X=ClipperLib.Clipper.TopX(e,botY);}var newNode=new ClipperLib.IntersectNode();newNode.Edge1=e;newNode.Edge2=eNext;//newNode.Pt = pt;
	newNode.Pt.X=pt.X;newNode.Pt.Y=pt.Y;this.m_IntersectList.push(newNode);this.SwapPositionsInSEL(e,eNext);isModified=true;}else e=eNext;}if(e.PrevInSEL!==null)e.PrevInSEL.NextInSEL=null;else break;}this.m_SortedEdges=null;};ClipperLib.Clipper.prototype.EdgesAdjacent=function(inode){return inode.Edge1.NextInSEL==inode.Edge2||inode.Edge1.PrevInSEL==inode.Edge2;};ClipperLib.Clipper.IntersectNodeSort=function(node1,node2){//the following typecast is safe because the differences in Pt.Y will
	//be limited to the height of the scanbeam.
	return node2.Pt.Y-node1.Pt.Y;};ClipperLib.Clipper.prototype.FixupIntersectionOrder=function(){//pre-condition: intersections are sorted bottom-most first.
	//Now it's crucial that intersections are made only between adjacent edges,
	//so to ensure this the order of intersections may need adjusting ...
	this.m_IntersectList.sort(this.m_IntersectNodeComparer);this.CopyAELToSEL();var cnt=this.m_IntersectList.length;for(var i=0;i<cnt;i++){if(!this.EdgesAdjacent(this.m_IntersectList[i])){var j=i+1;while(j<cnt&&!this.EdgesAdjacent(this.m_IntersectList[j])){j++;}if(j==cnt)return false;var tmp=this.m_IntersectList[i];this.m_IntersectList[i]=this.m_IntersectList[j];this.m_IntersectList[j]=tmp;}this.SwapPositionsInSEL(this.m_IntersectList[i].Edge1,this.m_IntersectList[i].Edge2);}return true;};ClipperLib.Clipper.prototype.ProcessIntersectList=function(){for(var i=0,ilen=this.m_IntersectList.length;i<ilen;i++){var iNode=this.m_IntersectList[i];this.IntersectEdges(iNode.Edge1,iNode.Edge2,iNode.Pt,true);this.SwapPositionsInAEL(iNode.Edge1,iNode.Edge2);}this.m_IntersectList.length=0;};/*
	  --------------------------------
	  Round speedtest: http://jsperf.com/fastest-round
	  --------------------------------
	  */var R1=function R1(a){return a<0?Math.ceil(a-0.5):Math.round(a);};var R2=function R2(a){return a<0?Math.ceil(a-0.5):Math.floor(a+0.5);};var R3=function R3(a){return a<0?-Math.round(Math.abs(a)):Math.round(a);};var R4=function R4(a){if(a<0){a-=0.5;return a<-2147483648?Math.ceil(a):a|0;}else{a+=0.5;return a>2147483647?Math.floor(a):a|0;}};if(browser.msie)ClipperLib.Clipper.Round=R1;else if(browser.chromium)ClipperLib.Clipper.Round=R3;else if(browser.safari)ClipperLib.Clipper.Round=R4;else ClipperLib.Clipper.Round=R2;// eg. browser.chrome || browser.firefox || browser.opera
	ClipperLib.Clipper.TopX=function(edge,currentY){//if (edge.Bot == edge.Curr) alert ("edge.Bot = edge.Curr");
	//if (edge.Bot == edge.Top) alert ("edge.Bot = edge.Top");
	if(currentY==edge.Top.Y)return edge.Top.X;return edge.Bot.X+ClipperLib.Clipper.Round(edge.Dx*(currentY-edge.Bot.Y));};ClipperLib.Clipper.prototype.IntersectPoint=function(edge1,edge2,ip){ip.X=0;ip.Y=0;var b1,b2;//nb: with very large coordinate values, it's possible for SlopesEqual() to
	//return false but for the edge.Dx value be equal due to double precision rounding.
	if(ClipperLib.ClipperBase.SlopesEqual(edge1,edge2,this.m_UseFullRange)||edge1.Dx==edge2.Dx){if(edge2.Bot.Y>edge1.Bot.Y){ip.X=edge2.Bot.X;ip.Y=edge2.Bot.Y;}else{ip.X=edge1.Bot.X;ip.Y=edge1.Bot.Y;}return false;}else if(edge1.Delta.X===0){ip.X=edge1.Bot.X;if(ClipperLib.ClipperBase.IsHorizontal(edge2)){ip.Y=edge2.Bot.Y;}else{b2=edge2.Bot.Y-edge2.Bot.X/edge2.Dx;ip.Y=ClipperLib.Clipper.Round(ip.X/edge2.Dx+b2);}}else if(edge2.Delta.X===0){ip.X=edge2.Bot.X;if(ClipperLib.ClipperBase.IsHorizontal(edge1)){ip.Y=edge1.Bot.Y;}else{b1=edge1.Bot.Y-edge1.Bot.X/edge1.Dx;ip.Y=ClipperLib.Clipper.Round(ip.X/edge1.Dx+b1);}}else{b1=edge1.Bot.X-edge1.Bot.Y*edge1.Dx;b2=edge2.Bot.X-edge2.Bot.Y*edge2.Dx;var q=(b2-b1)/(edge1.Dx-edge2.Dx);ip.Y=ClipperLib.Clipper.Round(q);if(Math.abs(edge1.Dx)<Math.abs(edge2.Dx))ip.X=ClipperLib.Clipper.Round(edge1.Dx*q+b1);else ip.X=ClipperLib.Clipper.Round(edge2.Dx*q+b2);}if(ip.Y<edge1.Top.Y||ip.Y<edge2.Top.Y){if(edge1.Top.Y>edge2.Top.Y){ip.Y=edge1.Top.Y;ip.X=ClipperLib.Clipper.TopX(edge2,edge1.Top.Y);return ip.X<edge1.Top.X;}else ip.Y=edge2.Top.Y;if(Math.abs(edge1.Dx)<Math.abs(edge2.Dx))ip.X=ClipperLib.Clipper.TopX(edge1,ip.Y);else ip.X=ClipperLib.Clipper.TopX(edge2,ip.Y);}return true;};ClipperLib.Clipper.prototype.ProcessEdgesAtTopOfScanbeam=function(topY){var e=this.m_ActiveEdges;while(e!==null){//1. process maxima, treating them as if they're 'bent' horizontal edges,
	//   but exclude maxima with horizontal edges. nb: e can't be a horizontal.
	var IsMaximaEdge=this.IsMaxima(e,topY);if(IsMaximaEdge){var eMaxPair=this.GetMaximaPair(e);IsMaximaEdge=eMaxPair===null||!ClipperLib.ClipperBase.IsHorizontal(eMaxPair);}if(IsMaximaEdge){var ePrev=e.PrevInAEL;this.DoMaxima(e);if(ePrev===null)e=this.m_ActiveEdges;else e=ePrev.NextInAEL;}else{//2. promote horizontal edges, otherwise update Curr.X and Curr.Y ...
	if(this.IsIntermediate(e,topY)&&ClipperLib.ClipperBase.IsHorizontal(e.NextInLML)){e=this.UpdateEdgeIntoAEL(e);if(e.OutIdx>=0)this.AddOutPt(e,e.Bot);this.AddEdgeToSEL(e);}else{e.Curr.X=ClipperLib.Clipper.TopX(e,topY);e.Curr.Y=topY;}if(this.StrictlySimple){var ePrev=e.PrevInAEL;if(e.OutIdx>=0&&e.WindDelta!==0&&ePrev!==null&&ePrev.OutIdx>=0&&ePrev.Curr.X==e.Curr.X&&ePrev.WindDelta!==0){var op=this.AddOutPt(ePrev,e.Curr);var op2=this.AddOutPt(e,e.Curr);this.AddJoin(op,op2,e.Curr);//StrictlySimple (type-3) join
	}}e=e.NextInAEL;}}//3. Process horizontals at the Top of the scanbeam ...
	this.ProcessHorizontals(true);//4. Promote intermediate vertices ...
	e=this.m_ActiveEdges;while(e!==null){if(this.IsIntermediate(e,topY)){var op=null;if(e.OutIdx>=0)op=this.AddOutPt(e,e.Top);e=this.UpdateEdgeIntoAEL(e);//if output polygons share an edge, they'll need joining later ...
	var ePrev=e.PrevInAEL;var eNext=e.NextInAEL;if(ePrev!==null&&ePrev.Curr.X==e.Bot.X&&ePrev.Curr.Y==e.Bot.Y&&op!==null&&ePrev.OutIdx>=0&&ePrev.Curr.Y>ePrev.Top.Y&&ClipperLib.ClipperBase.SlopesEqual(e,ePrev,this.m_UseFullRange)&&e.WindDelta!==0&&ePrev.WindDelta!==0){var op2=this.AddOutPt(ePrev,e.Bot);this.AddJoin(op,op2,e.Top);}else if(eNext!==null&&eNext.Curr.X==e.Bot.X&&eNext.Curr.Y==e.Bot.Y&&op!==null&&eNext.OutIdx>=0&&eNext.Curr.Y>eNext.Top.Y&&ClipperLib.ClipperBase.SlopesEqual(e,eNext,this.m_UseFullRange)&&e.WindDelta!==0&&eNext.WindDelta!==0){var op2=this.AddOutPt(eNext,e.Bot);this.AddJoin(op,op2,e.Top);}}e=e.NextInAEL;}};ClipperLib.Clipper.prototype.DoMaxima=function(e){var eMaxPair=this.GetMaximaPair(e);if(eMaxPair===null){if(e.OutIdx>=0)this.AddOutPt(e,e.Top);this.DeleteFromAEL(e);return;}var eNext=e.NextInAEL;var use_lines=true;while(eNext!==null&&eNext!=eMaxPair){this.IntersectEdges(e,eNext,e.Top,true);this.SwapPositionsInAEL(e,eNext);eNext=e.NextInAEL;}if(e.OutIdx==-1&&eMaxPair.OutIdx==-1){this.DeleteFromAEL(e);this.DeleteFromAEL(eMaxPair);}else if(e.OutIdx>=0&&eMaxPair.OutIdx>=0){this.IntersectEdges(e,eMaxPair,e.Top,false);}else if(use_lines&&e.WindDelta===0){if(e.OutIdx>=0){this.AddOutPt(e,e.Top);e.OutIdx=-1;}this.DeleteFromAEL(e);if(eMaxPair.OutIdx>=0){this.AddOutPt(eMaxPair,e.Top);eMaxPair.OutIdx=-1;}this.DeleteFromAEL(eMaxPair);}else ClipperLib.Error("DoMaxima error");};ClipperLib.Clipper.ReversePaths=function(polys){for(var i=0,len=polys.length;i<len;i++){polys[i].reverse();}};ClipperLib.Clipper.Orientation=function(poly){return ClipperLib.Clipper.Area(poly)>=0;};ClipperLib.Clipper.prototype.PointCount=function(pts){if(pts===null)return 0;var result=0;var p=pts;do{result++;p=p.Next;}while(p!=pts);return result;};ClipperLib.Clipper.prototype.BuildResult=function(polyg){ClipperLib.Clear(polyg);for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];if(outRec.Pts===null)continue;var p=outRec.Pts.Prev;var cnt=this.PointCount(p);if(cnt<2)continue;var pg=new Array(cnt);for(var j=0;j<cnt;j++){pg[j]=p.Pt;p=p.Prev;}polyg.push(pg);}};ClipperLib.Clipper.prototype.BuildResult2=function(polytree){polytree.Clear();//add each output polygon/contour to polytree ...
	//polytree.m_AllPolys.set_Capacity(this.m_PolyOuts.length);
	for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];var cnt=this.PointCount(outRec.Pts);if(outRec.IsOpen&&cnt<2||!outRec.IsOpen&&cnt<3)continue;this.FixHoleLinkage(outRec);var pn=new ClipperLib.PolyNode();polytree.m_AllPolys.push(pn);outRec.PolyNode=pn;pn.m_polygon.length=cnt;var op=outRec.Pts.Prev;for(var j=0;j<cnt;j++){pn.m_polygon[j]=op.Pt;op=op.Prev;}}//fixup PolyNode links etc ...
	//polytree.m_Childs.set_Capacity(this.m_PolyOuts.length);
	for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];if(outRec.PolyNode===null)continue;else if(outRec.IsOpen){outRec.PolyNode.IsOpen=true;polytree.AddChild(outRec.PolyNode);}else if(outRec.FirstLeft!==null&&outRec.FirstLeft.PolyNode!=null)outRec.FirstLeft.PolyNode.AddChild(outRec.PolyNode);else polytree.AddChild(outRec.PolyNode);}};ClipperLib.Clipper.prototype.FixupOutPolygon=function(outRec){//FixupOutPolygon() - removes duplicate points and simplifies consecutive
	//parallel edges by removing the middle vertex.
	var lastOK=null;outRec.BottomPt=null;var pp=outRec.Pts;for(;;){if(pp.Prev==pp||pp.Prev==pp.Next){this.DisposeOutPts(pp);outRec.Pts=null;return;}//test for duplicate points and collinear edges ...
	if(ClipperLib.IntPoint.op_Equality(pp.Pt,pp.Next.Pt)||ClipperLib.IntPoint.op_Equality(pp.Pt,pp.Prev.Pt)||ClipperLib.ClipperBase.SlopesEqual(pp.Prev.Pt,pp.Pt,pp.Next.Pt,this.m_UseFullRange)&&(!this.PreserveCollinear||!this.Pt2IsBetweenPt1AndPt3(pp.Prev.Pt,pp.Pt,pp.Next.Pt))){lastOK=null;var tmp=pp;pp.Prev.Next=pp.Next;pp.Next.Prev=pp.Prev;pp=pp.Prev;tmp=null;}else if(pp==lastOK)break;else{if(lastOK===null)lastOK=pp;pp=pp.Next;}}outRec.Pts=pp;};ClipperLib.Clipper.prototype.DupOutPt=function(outPt,InsertAfter){var result=new ClipperLib.OutPt();//result.Pt = outPt.Pt;
	result.Pt.X=outPt.Pt.X;result.Pt.Y=outPt.Pt.Y;result.Idx=outPt.Idx;if(InsertAfter){result.Next=outPt.Next;result.Prev=outPt;outPt.Next.Prev=result;outPt.Next=result;}else{result.Prev=outPt.Prev;result.Next=outPt;outPt.Prev.Next=result;outPt.Prev=result;}return result;};ClipperLib.Clipper.prototype.GetOverlap=function(a1,a2,b1,b2,$val){if(a1<a2){if(b1<b2){$val.Left=Math.max(a1,b1);$val.Right=Math.min(a2,b2);}else{$val.Left=Math.max(a1,b2);$val.Right=Math.min(a2,b1);}}else{if(b1<b2){$val.Left=Math.max(a2,b1);$val.Right=Math.min(a1,b2);}else{$val.Left=Math.max(a2,b2);$val.Right=Math.min(a1,b1);}}return $val.Left<$val.Right;};ClipperLib.Clipper.prototype.JoinHorz=function(op1,op1b,op2,op2b,Pt,DiscardLeft){var Dir1=op1.Pt.X>op1b.Pt.X?ClipperLib.Direction.dRightToLeft:ClipperLib.Direction.dLeftToRight;var Dir2=op2.Pt.X>op2b.Pt.X?ClipperLib.Direction.dRightToLeft:ClipperLib.Direction.dLeftToRight;if(Dir1==Dir2)return false;//When DiscardLeft, we want Op1b to be on the Left of Op1, otherwise we
	//want Op1b to be on the Right. (And likewise with Op2 and Op2b.)
	//So, to facilitate this while inserting Op1b and Op2b ...
	//when DiscardLeft, make sure we're AT or RIGHT of Pt before adding Op1b,
	//otherwise make sure we're AT or LEFT of Pt. (Likewise with Op2b.)
	if(Dir1==ClipperLib.Direction.dLeftToRight){while(op1.Next.Pt.X<=Pt.X&&op1.Next.Pt.X>=op1.Pt.X&&op1.Next.Pt.Y==Pt.Y){op1=op1.Next;}if(DiscardLeft&&op1.Pt.X!=Pt.X)op1=op1.Next;op1b=this.DupOutPt(op1,!DiscardLeft);if(ClipperLib.IntPoint.op_Inequality(op1b.Pt,Pt)){op1=op1b;//op1.Pt = Pt;
	op1.Pt.X=Pt.X;op1.Pt.Y=Pt.Y;op1b=this.DupOutPt(op1,!DiscardLeft);}}else{while(op1.Next.Pt.X>=Pt.X&&op1.Next.Pt.X<=op1.Pt.X&&op1.Next.Pt.Y==Pt.Y){op1=op1.Next;}if(!DiscardLeft&&op1.Pt.X!=Pt.X)op1=op1.Next;op1b=this.DupOutPt(op1,DiscardLeft);if(ClipperLib.IntPoint.op_Inequality(op1b.Pt,Pt)){op1=op1b;//op1.Pt = Pt;
	op1.Pt.X=Pt.X;op1.Pt.Y=Pt.Y;op1b=this.DupOutPt(op1,DiscardLeft);}}if(Dir2==ClipperLib.Direction.dLeftToRight){while(op2.Next.Pt.X<=Pt.X&&op2.Next.Pt.X>=op2.Pt.X&&op2.Next.Pt.Y==Pt.Y){op2=op2.Next;}if(DiscardLeft&&op2.Pt.X!=Pt.X)op2=op2.Next;op2b=this.DupOutPt(op2,!DiscardLeft);if(ClipperLib.IntPoint.op_Inequality(op2b.Pt,Pt)){op2=op2b;//op2.Pt = Pt;
	op2.Pt.X=Pt.X;op2.Pt.Y=Pt.Y;op2b=this.DupOutPt(op2,!DiscardLeft);}}else{while(op2.Next.Pt.X>=Pt.X&&op2.Next.Pt.X<=op2.Pt.X&&op2.Next.Pt.Y==Pt.Y){op2=op2.Next;}if(!DiscardLeft&&op2.Pt.X!=Pt.X)op2=op2.Next;op2b=this.DupOutPt(op2,DiscardLeft);if(ClipperLib.IntPoint.op_Inequality(op2b.Pt,Pt)){op2=op2b;//op2.Pt = Pt;
	op2.Pt.X=Pt.X;op2.Pt.Y=Pt.Y;op2b=this.DupOutPt(op2,DiscardLeft);}}if(Dir1==ClipperLib.Direction.dLeftToRight==DiscardLeft){op1.Prev=op2;op2.Next=op1;op1b.Next=op2b;op2b.Prev=op1b;}else{op1.Next=op2;op2.Prev=op1;op1b.Prev=op2b;op2b.Next=op1b;}return true;};ClipperLib.Clipper.prototype.JoinPoints=function(j,outRec1,outRec2){var op1=j.OutPt1,op1b=new ClipperLib.OutPt();var op2=j.OutPt2,op2b=new ClipperLib.OutPt();//There are 3 kinds of joins for output polygons ...
	//1. Horizontal joins where Join.OutPt1 & Join.OutPt2 are a vertices anywhere
	//along (horizontal) collinear edges (& Join.OffPt is on the same horizontal).
	//2. Non-horizontal joins where Join.OutPt1 & Join.OutPt2 are at the same
	//location at the Bottom of the overlapping segment (& Join.OffPt is above).
	//3. StrictlySimple joins where edges touch but are not collinear and where
	//Join.OutPt1, Join.OutPt2 & Join.OffPt all share the same point.
	var isHorizontal=j.OutPt1.Pt.Y==j.OffPt.Y;if(isHorizontal&&ClipperLib.IntPoint.op_Equality(j.OffPt,j.OutPt1.Pt)&&ClipperLib.IntPoint.op_Equality(j.OffPt,j.OutPt2.Pt)){//Strictly Simple join ...
	op1b=j.OutPt1.Next;while(op1b!=op1&&ClipperLib.IntPoint.op_Equality(op1b.Pt,j.OffPt)){op1b=op1b.Next;}var reverse1=op1b.Pt.Y>j.OffPt.Y;op2b=j.OutPt2.Next;while(op2b!=op2&&ClipperLib.IntPoint.op_Equality(op2b.Pt,j.OffPt)){op2b=op2b.Next;}var reverse2=op2b.Pt.Y>j.OffPt.Y;if(reverse1==reverse2)return false;if(reverse1){op1b=this.DupOutPt(op1,false);op2b=this.DupOutPt(op2,true);op1.Prev=op2;op2.Next=op1;op1b.Next=op2b;op2b.Prev=op1b;j.OutPt1=op1;j.OutPt2=op1b;return true;}else{op1b=this.DupOutPt(op1,true);op2b=this.DupOutPt(op2,false);op1.Next=op2;op2.Prev=op1;op1b.Prev=op2b;op2b.Next=op1b;j.OutPt1=op1;j.OutPt2=op1b;return true;}}else if(isHorizontal){//treat horizontal joins differently to non-horizontal joins since with
	//them we're not yet sure where the overlapping is. OutPt1.Pt & OutPt2.Pt
	//may be anywhere along the horizontal edge.
	op1b=op1;while(op1.Prev.Pt.Y==op1.Pt.Y&&op1.Prev!=op1b&&op1.Prev!=op2){op1=op1.Prev;}while(op1b.Next.Pt.Y==op1b.Pt.Y&&op1b.Next!=op1&&op1b.Next!=op2){op1b=op1b.Next;}if(op1b.Next==op1||op1b.Next==op2)return false;//a flat 'polygon'
	op2b=op2;while(op2.Prev.Pt.Y==op2.Pt.Y&&op2.Prev!=op2b&&op2.Prev!=op1b){op2=op2.Prev;}while(op2b.Next.Pt.Y==op2b.Pt.Y&&op2b.Next!=op2&&op2b.Next!=op1){op2b=op2b.Next;}if(op2b.Next==op2||op2b.Next==op1)return false;//a flat 'polygon'
	//Op1 -. Op1b & Op2 -. Op2b are the extremites of the horizontal edges
	var $val={Left:null,Right:null};if(!this.GetOverlap(op1.Pt.X,op1b.Pt.X,op2.Pt.X,op2b.Pt.X,$val))return false;var Left=$val.Left;var Right=$val.Right;//DiscardLeftSide: when overlapping edges are joined, a spike will created
	//which needs to be cleaned up. However, we don't want Op1 or Op2 caught up
	//on the discard Side as either may still be needed for other joins ...
	var Pt=new ClipperLib.IntPoint();var DiscardLeftSide;if(op1.Pt.X>=Left&&op1.Pt.X<=Right){//Pt = op1.Pt;
	Pt.X=op1.Pt.X;Pt.Y=op1.Pt.Y;DiscardLeftSide=op1.Pt.X>op1b.Pt.X;}else if(op2.Pt.X>=Left&&op2.Pt.X<=Right){//Pt = op2.Pt;
	Pt.X=op2.Pt.X;Pt.Y=op2.Pt.Y;DiscardLeftSide=op2.Pt.X>op2b.Pt.X;}else if(op1b.Pt.X>=Left&&op1b.Pt.X<=Right){//Pt = op1b.Pt;
	Pt.X=op1b.Pt.X;Pt.Y=op1b.Pt.Y;DiscardLeftSide=op1b.Pt.X>op1.Pt.X;}else{//Pt = op2b.Pt;
	Pt.X=op2b.Pt.X;Pt.Y=op2b.Pt.Y;DiscardLeftSide=op2b.Pt.X>op2.Pt.X;}j.OutPt1=op1;j.OutPt2=op2;return this.JoinHorz(op1,op1b,op2,op2b,Pt,DiscardLeftSide);}else{//nb: For non-horizontal joins ...
	//    1. Jr.OutPt1.Pt.Y == Jr.OutPt2.Pt.Y
	//    2. Jr.OutPt1.Pt > Jr.OffPt.Y
	//make sure the polygons are correctly oriented ...
	op1b=op1.Next;while(ClipperLib.IntPoint.op_Equality(op1b.Pt,op1.Pt)&&op1b!=op1){op1b=op1b.Next;}var Reverse1=op1b.Pt.Y>op1.Pt.Y||!ClipperLib.ClipperBase.SlopesEqual(op1.Pt,op1b.Pt,j.OffPt,this.m_UseFullRange);if(Reverse1){op1b=op1.Prev;while(ClipperLib.IntPoint.op_Equality(op1b.Pt,op1.Pt)&&op1b!=op1){op1b=op1b.Prev;}if(op1b.Pt.Y>op1.Pt.Y||!ClipperLib.ClipperBase.SlopesEqual(op1.Pt,op1b.Pt,j.OffPt,this.m_UseFullRange))return false;}op2b=op2.Next;while(ClipperLib.IntPoint.op_Equality(op2b.Pt,op2.Pt)&&op2b!=op2){op2b=op2b.Next;}var Reverse2=op2b.Pt.Y>op2.Pt.Y||!ClipperLib.ClipperBase.SlopesEqual(op2.Pt,op2b.Pt,j.OffPt,this.m_UseFullRange);if(Reverse2){op2b=op2.Prev;while(ClipperLib.IntPoint.op_Equality(op2b.Pt,op2.Pt)&&op2b!=op2){op2b=op2b.Prev;}if(op2b.Pt.Y>op2.Pt.Y||!ClipperLib.ClipperBase.SlopesEqual(op2.Pt,op2b.Pt,j.OffPt,this.m_UseFullRange))return false;}if(op1b==op1||op2b==op2||op1b==op2b||outRec1==outRec2&&Reverse1==Reverse2)return false;if(Reverse1){op1b=this.DupOutPt(op1,false);op2b=this.DupOutPt(op2,true);op1.Prev=op2;op2.Next=op1;op1b.Next=op2b;op2b.Prev=op1b;j.OutPt1=op1;j.OutPt2=op1b;return true;}else{op1b=this.DupOutPt(op1,true);op2b=this.DupOutPt(op2,false);op1.Next=op2;op2.Prev=op1;op1b.Prev=op2b;op2b.Next=op1b;j.OutPt1=op1;j.OutPt2=op1b;return true;}}};ClipperLib.Clipper.GetBounds=function(paths){var i=0,cnt=paths.length;while(i<cnt&&paths[i].length==0){i++;}if(i==cnt)return new ClipperLib.IntRect(0,0,0,0);var result=new ClipperLib.IntRect();result.left=paths[i][0].X;result.right=result.left;result.top=paths[i][0].Y;result.bottom=result.top;for(;i<cnt;i++){for(var j=0,jlen=paths[i].length;j<jlen;j++){if(paths[i][j].X<result.left)result.left=paths[i][j].X;else if(paths[i][j].X>result.right)result.right=paths[i][j].X;if(paths[i][j].Y<result.top)result.top=paths[i][j].Y;else if(paths[i][j].Y>result.bottom)result.bottom=paths[i][j].Y;}}return result;};ClipperLib.Clipper.prototype.GetBounds2=function(ops){var opStart=ops;var result=new ClipperLib.IntRect();result.left=ops.Pt.X;result.right=ops.Pt.X;result.top=ops.Pt.Y;result.bottom=ops.Pt.Y;ops=ops.Next;while(ops!=opStart){if(ops.Pt.X<result.left)result.left=ops.Pt.X;if(ops.Pt.X>result.right)result.right=ops.Pt.X;if(ops.Pt.Y<result.top)result.top=ops.Pt.Y;if(ops.Pt.Y>result.bottom)result.bottom=ops.Pt.Y;ops=ops.Next;}return result;};ClipperLib.Clipper.PointInPolygon=function(pt,path){//returns 0 if false, +1 if true, -1 if pt ON polygon boundary
	//http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.88.5498&rep=rep1&type=pdf
	var result=0,cnt=path.length;if(cnt<3)return 0;var ip=path[0];for(var i=1;i<=cnt;++i){var ipNext=i==cnt?path[0]:path[i];if(ipNext.Y==pt.Y){if(ipNext.X==pt.X||ip.Y==pt.Y&&ipNext.X>pt.X==ip.X<pt.X)return-1;}if(ip.Y<pt.Y!=ipNext.Y<pt.Y){if(ip.X>=pt.X){if(ipNext.X>pt.X)result=1-result;else{var d=(ip.X-pt.X)*(ipNext.Y-pt.Y)-(ipNext.X-pt.X)*(ip.Y-pt.Y);if(d==0)return-1;else if(d>0==ipNext.Y>ip.Y)result=1-result;}}else{if(ipNext.X>pt.X){var d=(ip.X-pt.X)*(ipNext.Y-pt.Y)-(ipNext.X-pt.X)*(ip.Y-pt.Y);if(d==0)return-1;else if(d>0==ipNext.Y>ip.Y)result=1-result;}}}ip=ipNext;}return result;};ClipperLib.Clipper.prototype.PointInPolygon=function(pt,op){//returns 0 if false, +1 if true, -1 if pt ON polygon boundary
	//http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.88.5498&rep=rep1&type=pdf
	var result=0;var startOp=op;for(;;){var poly0x=op.Pt.X,poly0y=op.Pt.Y;var poly1x=op.Next.Pt.X,poly1y=op.Next.Pt.Y;if(poly1y==pt.Y){if(poly1x==pt.X||poly0y==pt.Y&&poly1x>pt.X==poly0x<pt.X)return-1;}if(poly0y<pt.Y!=poly1y<pt.Y){if(poly0x>=pt.X){if(poly1x>pt.X)result=1-result;else{var d=(poly0x-pt.X)*(poly1y-pt.Y)-(poly1x-pt.X)*(poly0y-pt.Y);if(d==0)return-1;if(d>0==poly1y>poly0y)result=1-result;}}else{if(poly1x>pt.X){var d=(poly0x-pt.X)*(poly1y-pt.Y)-(poly1x-pt.X)*(poly0y-pt.Y);if(d==0)return-1;if(d>0==poly1y>poly0y)result=1-result;}}}op=op.Next;if(startOp==op)break;}return result;};ClipperLib.Clipper.prototype.Poly2ContainsPoly1=function(outPt1,outPt2){var op=outPt1;do{var res=this.PointInPolygon(op.Pt,outPt2);if(res>=0)return res!=0;op=op.Next;}while(op!=outPt1);return true;};ClipperLib.Clipper.prototype.FixupFirstLefts1=function(OldOutRec,NewOutRec){for(var i=0,ilen=this.m_PolyOuts.length;i<ilen;i++){var outRec=this.m_PolyOuts[i];if(outRec.Pts!==null&&outRec.FirstLeft==OldOutRec){if(this.Poly2ContainsPoly1(outRec.Pts,NewOutRec.Pts))outRec.FirstLeft=NewOutRec;}}};ClipperLib.Clipper.prototype.FixupFirstLefts2=function(OldOutRec,NewOutRec){for(var $i2=0,$t2=this.m_PolyOuts,$l2=$t2.length,outRec=$t2[$i2];$i2<$l2;$i2++,outRec=$t2[$i2]){if(outRec.FirstLeft==OldOutRec)outRec.FirstLeft=NewOutRec;}};ClipperLib.Clipper.ParseFirstLeft=function(FirstLeft){while(FirstLeft!=null&&FirstLeft.Pts==null){FirstLeft=FirstLeft.FirstLeft;}return FirstLeft;};ClipperLib.Clipper.prototype.JoinCommonEdges=function(){for(var i=0,ilen=this.m_Joins.length;i<ilen;i++){var join=this.m_Joins[i];var outRec1=this.GetOutRec(join.OutPt1.Idx);var outRec2=this.GetOutRec(join.OutPt2.Idx);if(outRec1.Pts==null||outRec2.Pts==null)continue;//get the polygon fragment with the correct hole state (FirstLeft)
	//before calling JoinPoints() ...
	var holeStateRec;if(outRec1==outRec2)holeStateRec=outRec1;else if(this.Param1RightOfParam2(outRec1,outRec2))holeStateRec=outRec2;else if(this.Param1RightOfParam2(outRec2,outRec1))holeStateRec=outRec1;else holeStateRec=this.GetLowermostRec(outRec1,outRec2);if(!this.JoinPoints(join,outRec1,outRec2))continue;if(outRec1==outRec2){//instead of joining two polygons, we've just created a new one by
	//splitting one polygon into two.
	outRec1.Pts=join.OutPt1;outRec1.BottomPt=null;outRec2=this.CreateOutRec();outRec2.Pts=join.OutPt2;//update all OutRec2.Pts Idx's ...
	this.UpdateOutPtIdxs(outRec2);//We now need to check every OutRec.FirstLeft pointer. If it points
	//to OutRec1 it may need to point to OutRec2 instead ...
	if(this.m_UsingPolyTree)for(var j=0,jlen=this.m_PolyOuts.length;j<jlen-1;j++){var oRec=this.m_PolyOuts[j];if(oRec.Pts==null||ClipperLib.Clipper.ParseFirstLeft(oRec.FirstLeft)!=outRec1||oRec.IsHole==outRec1.IsHole)continue;if(this.Poly2ContainsPoly1(oRec.Pts,join.OutPt2))oRec.FirstLeft=outRec2;}if(this.Poly2ContainsPoly1(outRec2.Pts,outRec1.Pts)){//outRec2 is contained by outRec1 ...
	outRec2.IsHole=!outRec1.IsHole;outRec2.FirstLeft=outRec1;//fixup FirstLeft pointers that may need reassigning to OutRec1
	if(this.m_UsingPolyTree)this.FixupFirstLefts2(outRec2,outRec1);if((outRec2.IsHole^this.ReverseSolution)==this.Area(outRec2)>0)this.ReversePolyPtLinks(outRec2.Pts);}else if(this.Poly2ContainsPoly1(outRec1.Pts,outRec2.Pts)){//outRec1 is contained by outRec2 ...
	outRec2.IsHole=outRec1.IsHole;outRec1.IsHole=!outRec2.IsHole;outRec2.FirstLeft=outRec1.FirstLeft;outRec1.FirstLeft=outRec2;//fixup FirstLeft pointers that may need reassigning to OutRec1
	if(this.m_UsingPolyTree)this.FixupFirstLefts2(outRec1,outRec2);if((outRec1.IsHole^this.ReverseSolution)==this.Area(outRec1)>0)this.ReversePolyPtLinks(outRec1.Pts);}else{//the 2 polygons are completely separate ...
	outRec2.IsHole=outRec1.IsHole;outRec2.FirstLeft=outRec1.FirstLeft;//fixup FirstLeft pointers that may need reassigning to OutRec2
	if(this.m_UsingPolyTree)this.FixupFirstLefts1(outRec1,outRec2);}}else{//joined 2 polygons together ...
	outRec2.Pts=null;outRec2.BottomPt=null;outRec2.Idx=outRec1.Idx;outRec1.IsHole=holeStateRec.IsHole;if(holeStateRec==outRec2)outRec1.FirstLeft=outRec2.FirstLeft;outRec2.FirstLeft=outRec1;//fixup FirstLeft pointers that may need reassigning to OutRec1
	if(this.m_UsingPolyTree)this.FixupFirstLefts2(outRec2,outRec1);}}};ClipperLib.Clipper.prototype.UpdateOutPtIdxs=function(outrec){var op=outrec.Pts;do{op.Idx=outrec.Idx;op=op.Prev;}while(op!=outrec.Pts);};ClipperLib.Clipper.prototype.DoSimplePolygons=function(){var i=0;while(i<this.m_PolyOuts.length){var outrec=this.m_PolyOuts[i++];var op=outrec.Pts;if(op===null)continue;do//for each Pt in Polygon until duplicate found do ...
	{var op2=op.Next;while(op2!=outrec.Pts){if(ClipperLib.IntPoint.op_Equality(op.Pt,op2.Pt)&&op2.Next!=op&&op2.Prev!=op){//split the polygon into two ...
	var op3=op.Prev;var op4=op2.Prev;op.Prev=op4;op4.Next=op;op2.Prev=op3;op3.Next=op2;outrec.Pts=op;var outrec2=this.CreateOutRec();outrec2.Pts=op2;this.UpdateOutPtIdxs(outrec2);if(this.Poly2ContainsPoly1(outrec2.Pts,outrec.Pts)){//OutRec2 is contained by OutRec1 ...
	outrec2.IsHole=!outrec.IsHole;outrec2.FirstLeft=outrec;}else if(this.Poly2ContainsPoly1(outrec.Pts,outrec2.Pts)){//OutRec1 is contained by OutRec2 ...
	outrec2.IsHole=outrec.IsHole;outrec.IsHole=!outrec2.IsHole;outrec2.FirstLeft=outrec.FirstLeft;outrec.FirstLeft=outrec2;}else{//the 2 polygons are separate ...
	outrec2.IsHole=outrec.IsHole;outrec2.FirstLeft=outrec.FirstLeft;}op2=op;//ie get ready for the next iteration
	}op2=op2.Next;}op=op.Next;}while(op!=outrec.Pts);}};ClipperLib.Clipper.Area=function(poly){var cnt=poly.length;if(cnt<3)return 0;var a=0;for(var i=0,j=cnt-1;i<cnt;++i){a+=(poly[j].X+poly[i].X)*(poly[j].Y-poly[i].Y);j=i;}return-a*0.5;};ClipperLib.Clipper.prototype.Area=function(outRec){var op=outRec.Pts;if(op==null)return 0;var a=0;do{a=a+(op.Prev.Pt.X+op.Pt.X)*(op.Prev.Pt.Y-op.Pt.Y);op=op.Next;}while(op!=outRec.Pts);return a*0.5;};if(use_deprecated){ClipperLib.Clipper.OffsetPaths=function(polys,delta,jointype,endtype,MiterLimit){var result=new ClipperLib.Paths();var co=new ClipperLib.ClipperOffset(MiterLimit,MiterLimit);co.AddPaths(polys,jointype,endtype);co.Execute(result,delta);return result;};}ClipperLib.Clipper.SimplifyPolygon=function(poly,fillType){var result=new Array();var c=new ClipperLib.Clipper(0);c.StrictlySimple=true;c.AddPath(poly,ClipperLib.PolyType.ptSubject,true);c.Execute(ClipperLib.ClipType.ctUnion,result,fillType,fillType);return result;};ClipperLib.Clipper.SimplifyPolygons=function(polys,fillType){if(typeof fillType=="undefined")fillType=ClipperLib.PolyFillType.pftEvenOdd;var result=new Array();var c=new ClipperLib.Clipper(0);c.StrictlySimple=true;c.AddPaths(polys,ClipperLib.PolyType.ptSubject,true);c.Execute(ClipperLib.ClipType.ctUnion,result,fillType,fillType);return result;};ClipperLib.Clipper.DistanceSqrd=function(pt1,pt2){var dx=pt1.X-pt2.X;var dy=pt1.Y-pt2.Y;return dx*dx+dy*dy;};ClipperLib.Clipper.DistanceFromLineSqrd=function(pt,ln1,ln2){//The equation of a line in general form (Ax + By + C = 0)
	//given 2 points (x¹,y¹) & (x²,y²) is ...
	//(y¹ - y²)x + (x² - x¹)y + (y² - y¹)x¹ - (x² - x¹)y¹ = 0
	//A = (y¹ - y²); B = (x² - x¹); C = (y² - y¹)x¹ - (x² - x¹)y¹
	//perpendicular distance of point (x³,y³) = (Ax³ + By³ + C)/Sqrt(A² + B²)
	//see http://en.wikipedia.org/wiki/Perpendicular_distance
	var A=ln1.Y-ln2.Y;var B=ln2.X-ln1.X;var C=A*ln1.X+B*ln1.Y;C=A*pt.X+B*pt.Y-C;return C*C/(A*A+B*B);};ClipperLib.Clipper.SlopesNearCollinear=function(pt1,pt2,pt3,distSqrd){return ClipperLib.Clipper.DistanceFromLineSqrd(pt2,pt1,pt3)<distSqrd;};ClipperLib.Clipper.PointsAreClose=function(pt1,pt2,distSqrd){var dx=pt1.X-pt2.X;var dy=pt1.Y-pt2.Y;return dx*dx+dy*dy<=distSqrd;};//------------------------------------------------------------------------------
	ClipperLib.Clipper.ExcludeOp=function(op){var result=op.Prev;result.Next=op.Next;op.Next.Prev=result;result.Idx=0;return result;};ClipperLib.Clipper.CleanPolygon=function(path,distance){if(typeof distance=="undefined")distance=1.415;//distance = proximity in units/pixels below which vertices will be stripped.
	//Default ~= sqrt(2) so when adjacent vertices or semi-adjacent vertices have
	//both x & y coords within 1 unit, then the second vertex will be stripped.
	var cnt=path.length;if(cnt==0)return new Array();var outPts=new Array(cnt);for(var i=0;i<cnt;++i){outPts[i]=new ClipperLib.OutPt();}for(var i=0;i<cnt;++i){outPts[i].Pt=path[i];outPts[i].Next=outPts[(i+1)%cnt];outPts[i].Next.Prev=outPts[i];outPts[i].Idx=0;}var distSqrd=distance*distance;var op=outPts[0];while(op.Idx==0&&op.Next!=op.Prev){if(ClipperLib.Clipper.PointsAreClose(op.Pt,op.Prev.Pt,distSqrd)){op=ClipperLib.Clipper.ExcludeOp(op);cnt--;}else if(ClipperLib.Clipper.PointsAreClose(op.Prev.Pt,op.Next.Pt,distSqrd)){ClipperLib.Clipper.ExcludeOp(op.Next);op=ClipperLib.Clipper.ExcludeOp(op);cnt-=2;}else if(ClipperLib.Clipper.SlopesNearCollinear(op.Prev.Pt,op.Pt,op.Next.Pt,distSqrd)){op=ClipperLib.Clipper.ExcludeOp(op);cnt--;}else{op.Idx=1;op=op.Next;}}if(cnt<3)cnt=0;var result=new Array(cnt);for(var i=0;i<cnt;++i){result[i]=new ClipperLib.IntPoint(op.Pt);op=op.Next;}outPts=null;return result;};ClipperLib.Clipper.CleanPolygons=function(polys,distance){var result=new Array(polys.length);for(var i=0,ilen=polys.length;i<ilen;i++){result[i]=ClipperLib.Clipper.CleanPolygon(polys[i],distance);}return result;};ClipperLib.Clipper.Minkowski=function(pattern,path,IsSum,IsClosed){var delta=IsClosed?1:0;var polyCnt=pattern.length;var pathCnt=path.length;var result=new Array();if(IsSum)for(var i=0;i<pathCnt;i++){var p=new Array(polyCnt);for(var j=0,jlen=pattern.length,ip=pattern[j];j<jlen;j++,ip=pattern[j]){p[j]=new ClipperLib.IntPoint(path[i].X+ip.X,path[i].Y+ip.Y);}result.push(p);}else for(var i=0;i<pathCnt;i++){var p=new Array(polyCnt);for(var j=0,jlen=pattern.length,ip=pattern[j];j<jlen;j++,ip=pattern[j]){p[j]=new ClipperLib.IntPoint(path[i].X-ip.X,path[i].Y-ip.Y);}result.push(p);}var quads=new Array();for(var i=0;i<pathCnt-1+delta;i++){for(var j=0;j<polyCnt;j++){var quad=new Array();quad.push(result[i%pathCnt][j%polyCnt]);quad.push(result[(i+1)%pathCnt][j%polyCnt]);quad.push(result[(i+1)%pathCnt][(j+1)%polyCnt]);quad.push(result[i%pathCnt][(j+1)%polyCnt]);if(!ClipperLib.Clipper.Orientation(quad))quad.reverse();quads.push(quad);}}var c=new ClipperLib.Clipper(0);c.AddPaths(quads,ClipperLib.PolyType.ptSubject,true);c.Execute(ClipperLib.ClipType.ctUnion,result,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);return result;};ClipperLib.Clipper.MinkowskiSum=function(){var a=arguments,alen=a.length;if(alen==3)// MinkowskiSum(Path pattern, path, pathIsClosed)
	{var pattern=a[0],path=a[1],pathIsClosed=a[2];return ClipperLib.Clipper.Minkowski(pattern,path,true,pathIsClosed);}else if(alen==4)// MinkowskiSum(pattern, paths, pathFillType, pathIsClosed)
	{var pattern=a[0],paths=a[1],pathFillType=a[2],pathIsClosed=a[3];var c=new ClipperLib.Clipper(),tmp;for(var i=0,ilen=paths.length;i<ilen;++i){var tmp=ClipperLib.Clipper.Minkowski(pattern,paths[i],true,pathIsClosed);c.AddPaths(tmp,ClipperLib.PolyType.ptSubject,true);}if(pathIsClosed)c.AddPaths(paths,ClipperLib.PolyType.ptClip,true);var solution=new ClipperLib.Paths();c.Execute(ClipperLib.ClipType.ctUnion,solution,pathFillType,pathFillType);return solution;}};ClipperLib.Clipper.MinkowskiDiff=function(pattern,path,pathIsClosed){return ClipperLib.Clipper.Minkowski(pattern,path,false,pathIsClosed);};ClipperLib.Clipper.PolyTreeToPaths=function(polytree){var result=new Array();//result.set_Capacity(polytree.get_Total());
	ClipperLib.Clipper.AddPolyNodeToPaths(polytree,ClipperLib.Clipper.NodeType.ntAny,result);return result;};ClipperLib.Clipper.AddPolyNodeToPaths=function(polynode,nt,paths){var match=true;switch(nt){case ClipperLib.Clipper.NodeType.ntOpen:return;case ClipperLib.Clipper.NodeType.ntClosed:match=!polynode.IsOpen;break;default:break;}if(polynode.m_polygon.length>0&&match)paths.push(polynode.m_polygon);for(var $i3=0,$t3=polynode.Childs(),$l3=$t3.length,pn=$t3[$i3];$i3<$l3;$i3++,pn=$t3[$i3]){ClipperLib.Clipper.AddPolyNodeToPaths(pn,nt,paths);}};ClipperLib.Clipper.OpenPathsFromPolyTree=function(polytree){var result=new ClipperLib.Paths();//result.set_Capacity(polytree.ChildCount());
	for(var i=0,ilen=polytree.ChildCount();i<ilen;i++){if(polytree.Childs()[i].IsOpen)result.push(polytree.Childs()[i].m_polygon);}return result;};ClipperLib.Clipper.ClosedPathsFromPolyTree=function(polytree){var result=new ClipperLib.Paths();//result.set_Capacity(polytree.Total());
	ClipperLib.Clipper.AddPolyNodeToPaths(polytree,ClipperLib.Clipper.NodeType.ntClosed,result);return result;};Inherit(ClipperLib.Clipper,ClipperLib.ClipperBase);ClipperLib.Clipper.NodeType={ntAny:0,ntOpen:1,ntClosed:2};ClipperLib.ClipperOffset=function(miterLimit,arcTolerance){if(typeof miterLimit=="undefined")miterLimit=2;if(typeof arcTolerance=="undefined")arcTolerance=ClipperLib.ClipperOffset.def_arc_tolerance;this.m_destPolys=new ClipperLib.Paths();this.m_srcPoly=new ClipperLib.Path();this.m_destPoly=new ClipperLib.Path();this.m_normals=new Array();this.m_delta=0;this.m_sinA=0;this.m_sin=0;this.m_cos=0;this.m_miterLim=0;this.m_StepsPerRad=0;this.m_lowest=new ClipperLib.IntPoint();this.m_polyNodes=new ClipperLib.PolyNode();this.MiterLimit=miterLimit;this.ArcTolerance=arcTolerance;this.m_lowest.X=-1;};ClipperLib.ClipperOffset.two_pi=6.28318530717959;ClipperLib.ClipperOffset.def_arc_tolerance=0.25;ClipperLib.ClipperOffset.prototype.Clear=function(){ClipperLib.Clear(this.m_polyNodes.Childs());this.m_lowest.X=-1;};ClipperLib.ClipperOffset.Round=ClipperLib.Clipper.Round;ClipperLib.ClipperOffset.prototype.AddPath=function(path,joinType,endType){var highI=path.length-1;if(highI<0)return;var newNode=new ClipperLib.PolyNode();newNode.m_jointype=joinType;newNode.m_endtype=endType;//strip duplicate points from path and also get index to the lowest point ...
	if(endType==ClipperLib.EndType.etClosedLine||endType==ClipperLib.EndType.etClosedPolygon)while(highI>0&&ClipperLib.IntPoint.op_Equality(path[0],path[highI])){highI--;}//newNode.m_polygon.set_Capacity(highI + 1);
	newNode.m_polygon.push(path[0]);var j=0,k=0;for(var i=1;i<=highI;i++){if(ClipperLib.IntPoint.op_Inequality(newNode.m_polygon[j],path[i])){j++;newNode.m_polygon.push(path[i]);if(path[i].Y>newNode.m_polygon[k].Y||path[i].Y==newNode.m_polygon[k].Y&&path[i].X<newNode.m_polygon[k].X)k=j;}}if(endType==ClipperLib.EndType.etClosedPolygon&&j<2||endType!=ClipperLib.EndType.etClosedPolygon&&j<0)return;this.m_polyNodes.AddChild(newNode);//if this path's lowest pt is lower than all the others then update m_lowest
	if(endType!=ClipperLib.EndType.etClosedPolygon)return;if(this.m_lowest.X<0)this.m_lowest=new ClipperLib.IntPoint(0,k);else{var ip=this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon[this.m_lowest.Y];if(newNode.m_polygon[k].Y>ip.Y||newNode.m_polygon[k].Y==ip.Y&&newNode.m_polygon[k].X<ip.X)this.m_lowest=new ClipperLib.IntPoint(this.m_polyNodes.ChildCount()-1,k);}};ClipperLib.ClipperOffset.prototype.AddPaths=function(paths,joinType,endType){for(var i=0,ilen=paths.length;i<ilen;i++){this.AddPath(paths[i],joinType,endType);}};ClipperLib.ClipperOffset.prototype.FixOrientations=function(){//fixup orientations of all closed paths if the orientation of the
	//closed path with the lowermost vertex is wrong ...
	if(this.m_lowest.X>=0&&!ClipperLib.Clipper.Orientation(this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon)){for(var i=0;i<this.m_polyNodes.ChildCount();i++){var node=this.m_polyNodes.Childs()[i];if(node.m_endtype==ClipperLib.EndType.etClosedPolygon||node.m_endtype==ClipperLib.EndType.etClosedLine&&ClipperLib.Clipper.Orientation(node.m_polygon))node.m_polygon.reverse();}}else{for(var i=0;i<this.m_polyNodes.ChildCount();i++){var node=this.m_polyNodes.Childs()[i];if(node.m_endtype==ClipperLib.EndType.etClosedLine&&!ClipperLib.Clipper.Orientation(node.m_polygon))node.m_polygon.reverse();}}};ClipperLib.ClipperOffset.GetUnitNormal=function(pt1,pt2){var dx=pt2.X-pt1.X;var dy=pt2.Y-pt1.Y;if(dx==0&&dy==0)return new ClipperLib.DoublePoint(0,0);var f=1/Math.sqrt(dx*dx+dy*dy);dx*=f;dy*=f;return new ClipperLib.DoublePoint(dy,-dx);};ClipperLib.ClipperOffset.prototype.DoOffset=function(delta){this.m_destPolys=new Array();this.m_delta=delta;//if Zero offset, just copy any CLOSED polygons to m_p and return ...
	if(ClipperLib.ClipperBase.near_zero(delta)){//this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount);
	for(var i=0;i<this.m_polyNodes.ChildCount();i++){var node=this.m_polyNodes.Childs()[i];if(node.m_endtype==ClipperLib.EndType.etClosedPolygon)this.m_destPolys.push(node.m_polygon);}return;}//see offset_triginometry3.svg in the documentation folder ...
	if(this.MiterLimit>2)this.m_miterLim=2/(this.MiterLimit*this.MiterLimit);else this.m_miterLim=0.5;var y;if(this.ArcTolerance<=0)y=ClipperLib.ClipperOffset.def_arc_tolerance;else if(this.ArcTolerance>Math.abs(delta)*ClipperLib.ClipperOffset.def_arc_tolerance)y=Math.abs(delta)*ClipperLib.ClipperOffset.def_arc_tolerance;else y=this.ArcTolerance;//see offset_triginometry2.svg in the documentation folder ...
	var steps=3.14159265358979/Math.acos(1-y/Math.abs(delta));this.m_sin=Math.sin(ClipperLib.ClipperOffset.two_pi/steps);this.m_cos=Math.cos(ClipperLib.ClipperOffset.two_pi/steps);this.m_StepsPerRad=steps/ClipperLib.ClipperOffset.two_pi;if(delta<0)this.m_sin=-this.m_sin;//this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount * 2);
	for(var i=0;i<this.m_polyNodes.ChildCount();i++){var node=this.m_polyNodes.Childs()[i];this.m_srcPoly=node.m_polygon;var len=this.m_srcPoly.length;if(len==0||delta<=0&&(len<3||node.m_endtype!=ClipperLib.EndType.etClosedPolygon))continue;this.m_destPoly=new Array();if(len==1){if(node.m_jointype==ClipperLib.JoinType.jtRound){var X=1,Y=0;for(var j=1;j<=steps;j++){this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X+X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y+Y*delta)));var X2=X;X=X*this.m_cos-this.m_sin*Y;Y=X2*this.m_sin+Y*this.m_cos;}}else{var X=-1,Y=-1;for(var j=0;j<4;++j){this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X+X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y+Y*delta)));if(X<0)X=1;else if(Y<0)Y=1;else X=-1;}}this.m_destPolys.push(this.m_destPoly);continue;}//build m_normals ...
	this.m_normals.length=0;//this.m_normals.set_Capacity(len);
	for(var j=0;j<len-1;j++){this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[j],this.m_srcPoly[j+1]));}if(node.m_endtype==ClipperLib.EndType.etClosedLine||node.m_endtype==ClipperLib.EndType.etClosedPolygon)this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[len-1],this.m_srcPoly[0]));else this.m_normals.push(new ClipperLib.DoublePoint(this.m_normals[len-2]));if(node.m_endtype==ClipperLib.EndType.etClosedPolygon){var k=len-1;for(var j=0;j<len;j++){k=this.OffsetPoint(j,k,node.m_jointype);}this.m_destPolys.push(this.m_destPoly);}else if(node.m_endtype==ClipperLib.EndType.etClosedLine){var k=len-1;for(var j=0;j<len;j++){k=this.OffsetPoint(j,k,node.m_jointype);}this.m_destPolys.push(this.m_destPoly);this.m_destPoly=new Array();//re-build m_normals ...
	var n=this.m_normals[len-1];for(var j=len-1;j>0;j--){this.m_normals[j]=new ClipperLib.DoublePoint(-this.m_normals[j-1].X,-this.m_normals[j-1].Y);}this.m_normals[0]=new ClipperLib.DoublePoint(-n.X,-n.Y);k=0;for(var j=len-1;j>=0;j--){k=this.OffsetPoint(j,k,node.m_jointype);}this.m_destPolys.push(this.m_destPoly);}else{var k=0;for(var j=1;j<len-1;++j){k=this.OffsetPoint(j,k,node.m_jointype);}var pt1;if(node.m_endtype==ClipperLib.EndType.etOpenButt){var j=len-1;pt1=new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_normals[j].X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_normals[j].Y*delta));this.m_destPoly.push(pt1);pt1=new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X-this.m_normals[j].X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y-this.m_normals[j].Y*delta));this.m_destPoly.push(pt1);}else{var j=len-1;k=len-2;this.m_sinA=0;this.m_normals[j]=new ClipperLib.DoublePoint(-this.m_normals[j].X,-this.m_normals[j].Y);if(node.m_endtype==ClipperLib.EndType.etOpenSquare)this.DoSquare(j,k);else this.DoRound(j,k);}//re-build m_normals ...
	for(var j=len-1;j>0;j--){this.m_normals[j]=new ClipperLib.DoublePoint(-this.m_normals[j-1].X,-this.m_normals[j-1].Y);}this.m_normals[0]=new ClipperLib.DoublePoint(-this.m_normals[1].X,-this.m_normals[1].Y);k=len-1;for(var j=k-1;j>0;--j){k=this.OffsetPoint(j,k,node.m_jointype);}if(node.m_endtype==ClipperLib.EndType.etOpenButt){pt1=new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X-this.m_normals[0].X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y-this.m_normals[0].Y*delta));this.m_destPoly.push(pt1);pt1=new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X+this.m_normals[0].X*delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y+this.m_normals[0].Y*delta));this.m_destPoly.push(pt1);}else{k=1;this.m_sinA=0;if(node.m_endtype==ClipperLib.EndType.etOpenSquare)this.DoSquare(0,1);else this.DoRound(0,1);}this.m_destPolys.push(this.m_destPoly);}}};ClipperLib.ClipperOffset.prototype.Execute=function(){var a=arguments,ispolytree=a[0]instanceof ClipperLib.PolyTree;if(!ispolytree)// function (solution, delta)
	{var solution=a[0],delta=a[1];ClipperLib.Clear(solution);this.FixOrientations();this.DoOffset(delta);//now clean up 'corners' ...
	var clpr=new ClipperLib.Clipper(0);clpr.AddPaths(this.m_destPolys,ClipperLib.PolyType.ptSubject,true);if(delta>0){clpr.Execute(ClipperLib.ClipType.ctUnion,solution,ClipperLib.PolyFillType.pftPositive,ClipperLib.PolyFillType.pftPositive);}else{var r=ClipperLib.Clipper.GetBounds(this.m_destPolys);var outer=new ClipperLib.Path();outer.push(new ClipperLib.IntPoint(r.left-10,r.bottom+10));outer.push(new ClipperLib.IntPoint(r.right+10,r.bottom+10));outer.push(new ClipperLib.IntPoint(r.right+10,r.top-10));outer.push(new ClipperLib.IntPoint(r.left-10,r.top-10));clpr.AddPath(outer,ClipperLib.PolyType.ptSubject,true);clpr.ReverseSolution=true;clpr.Execute(ClipperLib.ClipType.ctUnion,solution,ClipperLib.PolyFillType.pftNegative,ClipperLib.PolyFillType.pftNegative);if(solution.length>0)solution.splice(0,1);}//console.log(JSON.stringify(solution));
	}else// function (polytree, delta)
	{var solution=a[0],delta=a[1];solution.Clear();this.FixOrientations();this.DoOffset(delta);//now clean up 'corners' ...
	var clpr=new ClipperLib.Clipper(0);clpr.AddPaths(this.m_destPolys,ClipperLib.PolyType.ptSubject,true);if(delta>0){clpr.Execute(ClipperLib.ClipType.ctUnion,solution,ClipperLib.PolyFillType.pftPositive,ClipperLib.PolyFillType.pftPositive);}else{var r=ClipperLib.Clipper.GetBounds(this.m_destPolys);var outer=new ClipperLib.Path();outer.push(new ClipperLib.IntPoint(r.left-10,r.bottom+10));outer.push(new ClipperLib.IntPoint(r.right+10,r.bottom+10));outer.push(new ClipperLib.IntPoint(r.right+10,r.top-10));outer.push(new ClipperLib.IntPoint(r.left-10,r.top-10));clpr.AddPath(outer,ClipperLib.PolyType.ptSubject,true);clpr.ReverseSolution=true;clpr.Execute(ClipperLib.ClipType.ctUnion,solution,ClipperLib.PolyFillType.pftNegative,ClipperLib.PolyFillType.pftNegative);//remove the outer PolyNode rectangle ...
	if(solution.ChildCount()==1&&solution.Childs()[0].ChildCount()>0){var outerNode=solution.Childs()[0];//solution.Childs.set_Capacity(outerNode.ChildCount);
	solution.Childs()[0]=outerNode.Childs()[0];for(var i=1;i<outerNode.ChildCount();i++){solution.AddChild(outerNode.Childs()[i]);}}else solution.Clear();}}};ClipperLib.ClipperOffset.prototype.OffsetPoint=function(j,k,jointype){this.m_sinA=this.m_normals[k].X*this.m_normals[j].Y-this.m_normals[j].X*this.m_normals[k].Y;if(this.m_sinA<0.00005&&this.m_sinA>-0.00005)return k;else if(this.m_sinA>1)this.m_sinA=1.0;else if(this.m_sinA<-1)this.m_sinA=-1.0;if(this.m_sinA*this.m_delta<0){this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_normals[k].X*this.m_delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_normals[k].Y*this.m_delta)));this.m_destPoly.push(new ClipperLib.IntPoint(this.m_srcPoly[j]));this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_normals[j].X*this.m_delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_normals[j].Y*this.m_delta)));}else switch(jointype){case ClipperLib.JoinType.jtMiter:{var r=1+(this.m_normals[j].X*this.m_normals[k].X+this.m_normals[j].Y*this.m_normals[k].Y);if(r>=this.m_miterLim)this.DoMiter(j,k,r);else this.DoSquare(j,k);break;}case ClipperLib.JoinType.jtSquare:this.DoSquare(j,k);break;case ClipperLib.JoinType.jtRound:this.DoRound(j,k);break;}k=j;return k;};ClipperLib.ClipperOffset.prototype.DoSquare=function(j,k){var dx=Math.tan(Math.atan2(this.m_sinA,this.m_normals[k].X*this.m_normals[j].X+this.m_normals[k].Y*this.m_normals[j].Y)/4);this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_delta*(this.m_normals[k].X-this.m_normals[k].Y*dx)),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_delta*(this.m_normals[k].Y+this.m_normals[k].X*dx))));this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_delta*(this.m_normals[j].X+this.m_normals[j].Y*dx)),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_delta*(this.m_normals[j].Y-this.m_normals[j].X*dx))));};ClipperLib.ClipperOffset.prototype.DoMiter=function(j,k,r){var q=this.m_delta/r;this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+(this.m_normals[k].X+this.m_normals[j].X)*q),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+(this.m_normals[k].Y+this.m_normals[j].Y)*q)));};ClipperLib.ClipperOffset.prototype.DoRound=function(j,k){var a=Math.atan2(this.m_sinA,this.m_normals[k].X*this.m_normals[j].X+this.m_normals[k].Y*this.m_normals[j].Y);var steps=ClipperLib.Cast_Int32(ClipperLib.ClipperOffset.Round(this.m_StepsPerRad*Math.abs(a)));var X=this.m_normals[k].X,Y=this.m_normals[k].Y,X2;for(var i=0;i<steps;++i){this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+X*this.m_delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+Y*this.m_delta)));X2=X;X=X*this.m_cos-this.m_sin*Y;Y=X2*this.m_sin+Y*this.m_cos;}this.m_destPoly.push(new ClipperLib.IntPoint(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X+this.m_normals[j].X*this.m_delta),ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y+this.m_normals[j].Y*this.m_delta)));};ClipperLib.Error=function(message){try{throw new Error(message);}catch(err){alert(err.message);}};// ---------------------------------
	// JS extension by Timo 2013
	ClipperLib.JS={};ClipperLib.JS.AreaOfPolygon=function(poly,scale){if(!scale)scale=1;return ClipperLib.Clipper.Area(poly)/(scale*scale);};ClipperLib.JS.AreaOfPolygons=function(poly,scale){if(!scale)scale=1;var area=0;for(var i=0;i<poly.length;i++){area+=ClipperLib.Clipper.Area(poly[i]);}return area/(scale*scale);};ClipperLib.JS.BoundsOfPath=function(path,scale){return ClipperLib.JS.BoundsOfPaths([path],scale);};ClipperLib.JS.BoundsOfPaths=function(paths,scale){if(!scale)scale=1;var bounds=ClipperLib.Clipper.GetBounds(paths);bounds.left/=scale;bounds.bottom/=scale;bounds.right/=scale;bounds.top/=scale;return bounds;};// Clean() joins vertices that are too near each other
	// and causes distortion to offsetted polygons without cleaning
	ClipperLib.JS.Clean=function(polygon,delta){if(!(polygon instanceof Array))return[];var isPolygons=polygon[0]instanceof Array;var polygon=ClipperLib.JS.Clone(polygon);if(typeof delta!="number"||delta===null){ClipperLib.Error("Delta is not a number in Clean().");return polygon;}if(polygon.length===0||polygon.length==1&&polygon[0].length===0||delta<0)return polygon;if(!isPolygons)polygon=[polygon];var k_length=polygon.length;var len,poly,result,d,p,j,i;var results=[];for(var k=0;k<k_length;k++){poly=polygon[k];len=poly.length;if(len===0)continue;else if(len<3){result=poly;results.push(result);continue;}result=poly;d=delta*delta;//d = Math.floor(c_delta * c_delta);
	p=poly[0];j=1;for(i=1;i<len;i++){if((poly[i].X-p.X)*(poly[i].X-p.X)+(poly[i].Y-p.Y)*(poly[i].Y-p.Y)<=d)continue;result[j]=poly[i];p=poly[i];j++;}p=poly[j-1];if((poly[0].X-p.X)*(poly[0].X-p.X)+(poly[0].Y-p.Y)*(poly[0].Y-p.Y)<=d)j--;if(j<len)result.splice(j,len-j);if(result.length)results.push(result);}if(!isPolygons&&results.length)results=results[0];else if(!isPolygons&&results.length===0)results=[];else if(isPolygons&&results.length===0)results=[[]];return results;};// Make deep copy of Polygons or Polygon
	// so that also IntPoint objects are cloned and not only referenced
	// This should be the fastest way
	ClipperLib.JS.Clone=function(polygon){if(!(polygon instanceof Array))return[];if(polygon.length===0)return[];else if(polygon.length==1&&polygon[0].length===0)return[[]];var isPolygons=polygon[0]instanceof Array;if(!isPolygons)polygon=[polygon];var len=polygon.length,plen,i,j,result;var results=new Array(len);for(i=0;i<len;i++){plen=polygon[i].length;result=new Array(plen);for(j=0;j<plen;j++){result[j]={X:polygon[i][j].X,Y:polygon[i][j].Y};}results[i]=result;}if(!isPolygons)results=results[0];return results;};// Removes points that doesn't affect much to the visual appearance.
	// If middle point is at or under certain distance (tolerance) of the line segment between
	// start and end point, the middle point is removed.
	ClipperLib.JS.Lighten=function(polygon,tolerance){if(!(polygon instanceof Array))return[];if(typeof tolerance!="number"||tolerance===null){ClipperLib.Error("Tolerance is not a number in Lighten().");return ClipperLib.JS.Clone(polygon);}if(polygon.length===0||polygon.length==1&&polygon[0].length===0||tolerance<0){return ClipperLib.JS.Clone(polygon);}if(!(polygon[0]instanceof Array))polygon=[polygon];var i,j,poly,k,poly2,plen,A,B,P,d,rem,addlast;var bxax,byay,l,ax,ay;var len=polygon.length;var toleranceSq=tolerance*tolerance;var results=[];for(i=0;i<len;i++){poly=polygon[i];plen=poly.length;if(plen==0)continue;for(k=0;k<1000000;k++)// could be forever loop, but wiser to restrict max repeat count
	{poly2=[];plen=poly.length;// the first have to added to the end, if first and last are not the same
	// this way we ensure that also the actual last point can be removed if needed
	if(poly[plen-1].X!=poly[0].X||poly[plen-1].Y!=poly[0].Y){addlast=1;poly.push({X:poly[0].X,Y:poly[0].Y});plen=poly.length;}else addlast=0;rem=[];// Indexes of removed points
	for(j=0;j<plen-2;j++){A=poly[j];// Start point of line segment
	P=poly[j+1];// Middle point. This is the one to be removed.
	B=poly[j+2];// End point of line segment
	ax=A.X;ay=A.Y;bxax=B.X-ax;byay=B.Y-ay;if(bxax!==0||byay!==0)// To avoid Nan, when A==P && P==B. And to avoid peaks (A==B && A!=P), which have lenght, but not area.
	{l=((P.X-ax)*bxax+(P.Y-ay)*byay)/(bxax*bxax+byay*byay);if(l>1){ax=B.X;ay=B.Y;}else if(l>0){ax+=bxax*l;ay+=byay*l;}}bxax=P.X-ax;byay=P.Y-ay;d=bxax*bxax+byay*byay;if(d<=toleranceSq){rem[j+1]=1;j++;// when removed, transfer the pointer to the next one
	}}// add all unremoved points to poly2
	poly2.push({X:poly[0].X,Y:poly[0].Y});for(j=1;j<plen-1;j++){if(!rem[j])poly2.push({X:poly[j].X,Y:poly[j].Y});}poly2.push({X:poly[plen-1].X,Y:poly[plen-1].Y});// if the first point was added to the end, remove it
	if(addlast)poly.pop();// break, if there was not anymore removed points
	if(!rem.length)break;// else continue looping using poly2, to check if there are points to remove
	else poly=poly2;}plen=poly2.length;// remove duplicate from end, if needed
	if(poly2[plen-1].X==poly2[0].X&&poly2[plen-1].Y==poly2[0].Y){poly2.pop();}if(poly2.length>2)// to avoid two-point-polygons
	results.push(poly2);}if(!polygon[0]instanceof Array)results=results[0];if(typeof results=="undefined")results=[[]];return results;};ClipperLib.JS.PerimeterOfPath=function(path,closed,scale){if(typeof path=="undefined")return 0;var sqrt=Math.sqrt;var perimeter=0.0;var p1,p2,p1x=0.0,p1y=0.0,p2x=0.0,p2y=0.0;var j=path.length;if(j<2)return 0;if(closed){path[j]=path[0];j++;}while(--j){p1=path[j];p1x=p1.X;p1y=p1.Y;p2=path[j-1];p2x=p2.X;p2y=p2.Y;perimeter+=sqrt((p1x-p2x)*(p1x-p2x)+(p1y-p2y)*(p1y-p2y));}if(closed)path.pop();return perimeter/scale;};ClipperLib.JS.PerimeterOfPaths=function(paths,closed,scale){if(!scale)scale=1;var perimeter=0;for(var i=0;i<paths.length;i++){perimeter+=ClipperLib.JS.PerimeterOfPath(paths[i],closed,scale);}return perimeter;};ClipperLib.JS.ScaleDownPath=function(path,scale){var i,p;if(!scale)scale=1;i=path.length;while(i--){p=path[i];p.X=p.X/scale;p.Y=p.Y/scale;}};ClipperLib.JS.ScaleDownPaths=function(paths,scale){var i,j,p,round=Math.round;if(!scale)scale=1;i=paths.length;while(i--){j=paths[i].length;while(j--){p=paths[i][j];p.X=p.X/scale;p.Y=p.Y/scale;}}};ClipperLib.JS.ScaleUpPath=function(path,scale){var i,p,round=Math.round;if(!scale)scale=1;i=path.length;while(i--){p=path[i];p.X=round(p.X*scale);p.Y=round(p.Y*scale);}};ClipperLib.JS.ScaleUpPaths=function(paths,scale){var i,j,p,round=Math.round;if(!scale)scale=1;i=paths.length;while(i--){j=paths[i].length;while(j--){p=paths[i][j];p.X=round(p.X*scale);p.Y=round(p.Y*scale);}}};ClipperLib.ExPolygons=function(){return[];};ClipperLib.ExPolygon=function(){this.outer=null;this.holes=null;};ClipperLib.JS.AddOuterPolyNodeToExPolygons=function(polynode,expolygons){var ep=new ClipperLib.ExPolygon();ep.outer=polynode.Contour();var childs=polynode.Childs();var ilen=childs.length;ep.holes=new Array(ilen);var node,n,i,j,childs2,jlen;for(i=0;i<ilen;i++){node=childs[i];ep.holes[i]=node.Contour();//Add outer polygons contained by (nested within) holes ...
	for(j=0,childs2=node.Childs(),jlen=childs2.length;j<jlen;j++){n=childs2[j];ClipperLib.JS.AddOuterPolyNodeToExPolygons(n,expolygons);}}expolygons.push(ep);};ClipperLib.JS.ExPolygonsToPaths=function(expolygons){var a,i,alen,ilen;var paths=new ClipperLib.Paths();for(a=0,alen=expolygons.length;a<alen;a++){paths.push(expolygons[a].outer);for(i=0,ilen=expolygons[a].holes.length;i<ilen;i++){paths.push(expolygons[a].holes[i]);}}return paths;};ClipperLib.JS.PolyTreeToExPolygons=function(polytree){var expolygons=new ClipperLib.ExPolygons();var node,i,childs,ilen;for(i=0,childs=polytree.Childs(),ilen=childs.length;i<ilen;i++){node=childs[i];ClipperLib.JS.AddOuterPolyNodeToExPolygons(node,expolygons);}return expolygons;};})();

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** vendors.031b23808b9e9968b0f9.js
 **/